webpackJsonp([1],{

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return required; });
/* unused harmony export maxLength */
/* unused harmony export maxLength5 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isNumber; });
/* unused harmony export minValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return minValue1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alphaNumeric; });
/* unused harmony export password */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return noSpaces; });
/* unused harmony export noLeadingOrTrailingSpaces */
var required = function (value) {
    if (!value || value.trim() === '') {
        return 'Required';
    }
    return undefined;
};
var maxLength = function (max) { return function (value) {
    return value && value.length > max ? "Must be " + max + " characters or less" : undefined;
}; };
var maxLength5 = maxLength(5);
var isNumber = function (value) { return value && isNaN(Number(value)) ? 'Must be a number' : undefined; };
var minValue = function (min) { return function (value) {
    return value && value < min ? "Must be at least " + min : undefined;
}; };
var minValue1 = minValue(1);
var email = function (value) {
    return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
        'Invalid email address' : undefined;
};
var noSpaces = function (value) {
    return value && !/^\S+$/i.test(value) ?
        'Space is an invalid character.' : undefined;
};
// For foreign postal codes.  For example, Canadian zip codes are usually input like this: M1R 0E9.  So allow spaces in the middle.
var noLeadingOrTrailingSpaces = function (value) {
    return value && !/^\S.+\S$/i.test(value) ?
        'Leading and trailing spaces are not allowed.' : undefined;
};
var password = function (value) {
    return value && !/^(?=.*\d).{8,}$/i.test(value) ?
        'Invalid password' : undefined;
};
var alphaNumeric = function (value) {
    return value && /[^a-zA-Z0-9 ]/i.test(value) ?
        'Alphanumeric characters only' : undefined;
};



/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VIEW_ALL_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VIEW_ALL_GIFTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return VIEW_ALL_UNREDEEMED_GIFTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VIEW_ALL_SUBS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LEFT_NAV_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AGE_CHECK_PASSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGIN_ACCOUNT_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGIN_POSTAL_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IDP_ACCOUNT_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return actionCreators; });
var VIEW_ALL_ORDERS = 'VIEW_ALL_ORDERS';
var VIEW_ALL_GIFTS = 'VIEW_ALL_GIFTS';
var VIEW_ALL_UNREDEEMED_GIFTS = 'VIEW_ALL_UNREDEEMED_GIFTS';
var VIEW_ALL_SUBS = 'VIEW_ALL_SUBS';
var LEFT_NAV_OPEN = 'LEFT_NAV_OPEN';
var AGE_CHECK_PASSED = 'AGE_CHECK_PASSED';
var LOGIN_ACCOUNT_NUMBER = 'LOGIN_ACCOUNT_NUMBER';
var LOGIN_POSTAL_CODE = 'LOGIN_POSTAL_CODE';
var IDP_ACCOUNT_INFO = 'IDP_ACCOUNT_INFO';
var actionCreators = {
    viewAllOrders: function (payload) { return ({
        type: VIEW_ALL_ORDERS,
        payload: payload,
    }); },
    viewAllGifts: function (payload) { return ({
        type: VIEW_ALL_GIFTS,
        payload: payload,
    }); },
    viewAllUnredeemedGifts: function (payload) { return ({
        type: VIEW_ALL_UNREDEEMED_GIFTS,
        payload: payload,
    }); },
    viewAllSubs: function (payload) { return ({
        type: VIEW_ALL_SUBS,
        payload: payload,
    }); },
    leftNavOpen: function (payload) { return ({
        type: LEFT_NAV_OPEN,
        payload: payload,
    }); },
    ageCheckPassed: function (payload) { return ({
        type: AGE_CHECK_PASSED,
        payload: payload,
    }); },
    loginAccountNumber: function (payload) { return ({
        type: LOGIN_ACCOUNT_NUMBER,
        payload: payload,
    }); },
    loginPostalCode: function (payload) { return ({
        type: LOGIN_POSTAL_CODE,
        payload: payload,
    }); },
    idpAccountInfo: function (payload) { return ({
        type: IDP_ACCOUNT_INFO,
        payload: payload,
    }); },
};


/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INTELLISEL_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INTELLISEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INTELLISEL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INTELLISEL_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return actionCreators; });
var INTELLISEL_START = 'INTELLISEL_START';
var INTELLISEL_SUCCESS = 'INTELLISEL_SUCCESS';
var INTELLISEL_ERROR = 'INTELLISEL_ERROR';
var INTELLISEL_LOADING = 'INTELLISEL_LOADING';
// Action Creators
var actionCreators = {
    intelliselStart: function (payload) { return ({
        type: INTELLISEL_START,
        payload: payload,
    }); },
    intelliselError: function (payload) { return ({
        type: INTELLISEL_ERROR,
        payload: payload,
    }); },
    intelliselSuccess: function (payload) { return ({
        type: INTELLISEL_SUCCESS,
        payload: payload,
    }); },
    intelliselLoading: function (payload) { return ({
        type: INTELLISEL_LOADING,
        payload: payload,
    }); },
};


/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SEND_CUSTSERV_EMAIL_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEND_CUSTSERV_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEND_CUSTSERV_EMAIL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEND_CUSTSERV_EMAIL_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEND_CUSTSERV_EMAIL_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SEND_EXCEPTION_EMAIL_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SEND_EXCEPTION_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SEND_EXCEPTION_EMAIL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SEND_EXCEPTION_EMAIL_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SEND_EXCEPTION_EMAIL_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return actionCreators; });
var SEND_CUSTSERV_EMAIL_START = 'SEND_CUSTSERV_EMAIL_START';
var SEND_CUSTSERV_EMAIL_SUCCESS = 'SEND_CUSTSERV_EMAIL_SUCCESS';
var SEND_CUSTSERV_EMAIL_ERROR = 'SEND_CUSTSERV_EMAIL_ERROR';
var SEND_CUSTSERV_EMAIL_LOADING = 'SEND_CUSTSERV_EMAIL_LOADING';
var SEND_CUSTSERV_EMAIL_CANCEL = 'SEND_CUSTSERV_EMAIL_CANCEL';
var SEND_EXCEPTION_EMAIL_START = 'SEND_EXCEPTION_EMAIL_START';
var SEND_EXCEPTION_EMAIL_SUCCESS = 'SEND_EXCEPTION_EMAIL_SUCCESS';
var SEND_EXCEPTION_EMAIL_ERROR = 'SEND_EXCEPTION_EMAIL_ERROR';
var SEND_EXCEPTION_EMAIL_LOADING = 'SEND_EXCEPTION_EMAIL_LOADING';
var SEND_EXCEPTION_EMAIL_CANCEL = 'SEND_EXCEPTION_EMAIL_CANCEL';
// Action Creators
var actionCreators = {
    sendCustservEmailStart: function (payload) { return ({
        type: SEND_CUSTSERV_EMAIL_START,
        payload: payload,
    }); },
    sendCustservEmailError: function (payload) {
        return ({ type: SEND_CUSTSERV_EMAIL_ERROR, payload: payload });
    },
    sendCustservEmailSuccess: function (payload) { return ({
        type: SEND_CUSTSERV_EMAIL_SUCCESS,
        payload: payload,
    }); },
    sendCustservEmailLoading: function (payload) { return ({
        type: SEND_CUSTSERV_EMAIL_LOADING,
        payload: payload,
    }); },
    sendCustservEmailCancel: function (payload) { return ({
        type: SEND_CUSTSERV_EMAIL_CANCEL,
        payload: payload,
    }); },
    sendExceptionEmailStart: function (payload) { return ({
        type: SEND_EXCEPTION_EMAIL_START,
        payload: payload,
    }); },
    sendExceptionEmailError: function (payload) {
        return ({ type: SEND_EXCEPTION_EMAIL_ERROR, payload: payload });
    },
    sendExceptionEmailSuccess: function (payload) { return ({
        type: SEND_EXCEPTION_EMAIL_SUCCESS,
        payload: payload,
    }); },
    sendExceptionEmailLoading: function (payload) { return ({
        type: SEND_EXCEPTION_EMAIL_LOADING,
        payload: payload,
    }); },
    sendExceptionEmailCancel: function (payload) { return ({
        type: SEND_EXCEPTION_EMAIL_CANCEL,
        payload: payload,
    }); },
};


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configEpic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_main_actions__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_dom_ajax__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_dom_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_dom_ajax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);





function configEpic(action$) {
    var adminUrl = "https://api.ba-cloud.buysub.com/gc" + "/serviceDiscovery";
    return action$.ofType(__WEBPACK_IMPORTED_MODULE_0__src_app_main_actions__["d" /* GET_CLIENT_CONFIG */]).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["f" /* mergeMap */])(function () {
        var loading = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_0__src_app_main_actions__["e" /* actionCreators */].clientConfigLoading(true));
        var request = __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_dom_ajax__["ajax"].getJSON(adminUrl).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["d" /* flatMap */])(function (response) {
            return __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_dom_ajax__["ajax"]
                .getJSON(response.url + '/AdminConfig?globalCode=' + encodeURIComponent(response.globalCode))
                .pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["e" /* map */])(function (res) {
                return __WEBPACK_IMPORTED_MODULE_0__src_app_main_actions__["e" /* actionCreators */].clientConfigSuccess({
                    clientConfig: response,
                    adminConfig: res,
                });
            }));
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_0__src_app_main_actions__["e" /* actionCreators */].clientConfigFailure(err));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, request);
    }));
}


/***/ }),

/***/ 1352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearAWSCreds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_persistedStorage__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_header_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__);








var clearAWSCreds = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_3__src_app_header_actions__["a" /* USER_LOGOUT */]), Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["f" /* mergeMap */])(function () {
        if (__WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].credentials) {
            __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].credentials.accessKeyId = '';
            __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].credentials.secretAccessKey = '';
            __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].credentials.sessionToken = '';
        }
        // remove next line after adding complete persistence
        Object(__WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_persistedStorage__["a" /* clearSessionState */])();
        __WEBPACK_IMPORTED_MODULE_4__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({ category: 'Logout', action: 'Successful', label: state$.value.clientConfig.clientConfig.magCode, });
        __WEBPACK_IMPORTED_MODULE_3__src_app_header_actions__["b" /* actionCreators */].userLogoutSuccessNotification();
        return Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_3__src_app_header_actions__["b" /* actionCreators */].userLogoutSuccess());
    }));
};


/***/ }),

/***/ 1353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary_epics__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_preferences_epics__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_accounts_issues_epics__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_accounts_suspend_epics__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_resume_epics__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_series_update_epics__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_accounts_stopcharge_epics__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_accounts_customer_service_epics__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_updatepayment_epics__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_accounts_stopautorenew_epics__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_accounts_startautorenew_epics__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_accounts_orders_epics__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_app_accounts_payments_epics__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_app_accounts_refundstorecredit_epics__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_app_accounts_resin_order_epics__ = __webpack_require__(1369);
















var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(__WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_preferences_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_3__src_app_accounts_issues_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_4__src_app_accounts_suspend_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_resume_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_8__src_app_accounts_customer_service_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_series_update_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_7__src_app_accounts_stopcharge_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_updatepayment_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_10__src_app_accounts_stopautorenew_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_11__src_app_accounts_startautorenew_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_12__src_app_accounts_orders_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_13__src_app_accounts_payments_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_14__src_app_accounts_refundstorecredit_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_15__src_app_accounts_resin_order_epics__["a" /* epics */]);


/***/ }),

/***/ 1354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_accounts_preferences__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_observable_concat__);









var translatePermissions = function (oldPayload) {
    var newPayload = {};
    var newPermissions = oldPayload.newPermissions;
    var currentPermissions = oldPayload.currentPermissions;
    for (var key in newPermissions) {
        if (key) {
            var newValue = newPermissions[key];
            var currentValue = currentPermissions[key];
            if (key === 'emailUseAnywherePerm' || key === 'emailUseForCompanyPerm') {
                // new and current value of these two permissions MUST be different
                // or SERV errors
                if ((!newValue && currentValue === 'N') || (newValue && currentValue === 'Y')) {
                    continue;
                }
            }
            if (key !== 'accountNumber' && key !== 'prodIdAlias' && key !== 'email') {
                newPayload[key] = newValue ? 'Y' : 'N';
            }
            else {
                newPayload[key] = newValue;
            }
        }
    }
    return newPayload;
};
var saveAccountPermissions = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__src_app_accounts_preferences__["a" /* SAVE_PREFERENCES_START */]), Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        __WEBPACK_IMPORTED_MODULE_3_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_3_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var loading = Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_4__src_app_accounts_preferences__["b" /* actionCreators */].savePreferencesLoading(true));
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        if (!__WEBPACK_IMPORTED_MODULE_3_aws_sdk_global__["config"].region) {
            __WEBPACK_IMPORTED_MODULE_3_aws_sdk_global__["config"].region = clientConfig.Region;
        }
        var postBody = translatePermissions(payload);
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_3_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: '/cofp',
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: postBody,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.success) === 'true';
            if (isSuccess) {
                __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload.selectedProdIdAlias
                });
                __WEBPACK_IMPORTED_MODULE_4__src_app_accounts_preferences__["b" /* actionCreators */].savePreferencesSuccessNotification();
                return __WEBPACK_IMPORTED_MODULE_4__src_app_accounts_preferences__["b" /* actionCreators */].savePreferencesSuccess({
                    success: true,
                    response: payload.newPermissions,
                });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload.selectedProdIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_4__src_app_accounts_preferences__["b" /* actionCreators */].savePreferencesError({
                    success: false,
                    message: 'Error on Change Permissions',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload.selectedProdIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_4__src_app_accounts_preferences__["b" /* actionCreators */].savePreferencesError({
                success: false,
                message: err,
            }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_8_rxjs_observable_concat__["concat"])(loading, source$);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(saveAccountPermissions);


/***/ }),

/***/ 1355:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_preferences_actions__ = __webpack_require__(261);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_preferences_actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_preferences_actions__["c"]; });



/***/ }),

/***/ 1356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_intellisel_actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__);











var AWS = __webpack_require__(27);
var ENTITLED_ISSUES_PATH = '/entitledissues';
var SUBSCRIPTION_EXTENSION_PATH = '/orderupdate';
var REPLACEMENT_ISSUE_PATH = '/cofp';
var getEntitledIssues = function (action$, state$) {
    // action$.ofType(GET_ENTITLED_ISSUES_START).mergeMap(({ payload }) => {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["c" /* GET_ENTITLED_ISSUES_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].getEntitledIssuesLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: ENTITLED_ISSUES_PATH,
            region: clientConfig.Region,
            requestmethod: 'GET',
            requestbody: {},
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
                queryParams: {
                    magCode: payload.currentOrder.prodIdAlias,
                    accountNumber: payload.currentOrder.orderItems[0].shipToAccountNumber,
                    lastIssue: payload.currentOrder.orderItems[0].lastIssue,
                }
            },
        };
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var $source = Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.isSuccess) === 'true';
            if (isSuccess) {
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].getEntitledIssuesSuccess(answer);
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].getEntitledIssuesError(answer);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].getEntitledIssuesError({
                success: false,
                message: err,
            }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, $source);
    }));
};
var subscriptionExtension = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["m" /* SUBSCRIPTION_EXTENSION_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].subscriptionExtensionLoading(true));
        if (!AWS.config.credentials) {
            var creds = state$.value.auth.omsAuth.credentials;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(creds);
        }
        var body = {
            'prodIdAlias': payload.subscriptionExtensionPayload.prodIdAlias,
            'accountNumber': payload.subscriptionExtensionPayload.accountNumber,
            'order': {
                'subscriptionEnd': payload.subscriptionExtensionPayload.subscriptionEnd,
                'reasonCode': payload.subscriptionExtensionPayload.reasonCode,
            }
        };
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: SUBSCRIPTION_EXTENSION_PATH,
            region: clientConfig.Region,
            requestmethod: 'PUT',
            requestbody: body,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var $source = Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.success) === 'true';
            if (isSuccess) {
                __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.subscriptionExtensionPayload.googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload.subscriptionExtensionPayload.prodIdAlias,
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].subscriptionExtensionSuccess(answer);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.subscriptionExtensionPayload.googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload.subscriptionExtensionPayload.prodIdAlias,
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].subscriptionExtensionError(answer);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.subscriptionExtensionPayload.googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload.subscriptionExtensionPayload.prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].getEntitledIssuesError({
                success: false,
                message: err,
            }));
        }));
        var refetchCustomerPayload = {
            accountNumber: payload.subscriptionExtensionPayload.accountNumber,
            postalCode: payload.subscriptionExtensionPayload.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        if (payload.subscriptionExtensionPayload.intelliselPayload) {
            var intelliselAcceptOffer = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_9__src_app_intellisel_actions__["e" /* actionCreators */].intelliselStart(payload.subscriptionExtensionPayload.intelliselPayload));
            return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, $source, intelliselAcceptOffer, reloadCust);
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, $source, reloadCust);
        }
    }));
};
var replacementIssue = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["h" /* REPLACEMENT_ISSUE_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].replacementIssueLoading(true));
        if (!AWS.config.credentials) {
            var creds = state$.value.auth.omsAuth.credentials;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(creds);
        }
        var body = {
            'prodIdAlias': payload.replacementIssuePayload.prodIdAlias,
            'accountNumber': payload.replacementIssuePayload.accountNumber,
            'numberOfCopies': payload.replacementIssuePayload.numberOfCopies,
            'reasonCode': payload.replacementIssuePayload.reasonCode,
            'requestIssue': payload.replacementIssuePayload.requestIssue,
        };
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: REPLACEMENT_ISSUE_PATH,
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: body,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var $source = Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.success) === 'true';
            if (isSuccess) {
                __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.replacementIssuePayload.googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload.replacementIssuePayload.prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].replacementIssueSuccess(answer);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.replacementIssuePayload.googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload.replacementIssuePayload.prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].replacementIssueError([answer]);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.replacementIssuePayload.googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload.replacementIssuePayload.prodIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_actions__["o" /* actionCreators */].getEntitledIssuesError({
                success: false,
                message: err,
            }));
        }));
        var refetchCustomerPayload = {
            accountNumber: payload.replacementIssuePayload.accountNumber,
            postalCode: payload.replacementIssuePayload.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, $source, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(getEntitledIssues, subscriptionExtension, replacementIssue);


/***/ }),

/***/ 1357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__);












var AWS = __webpack_require__(27);
var ISSUES_PATH = '/issue';
var SERV_SUSPEND_PATH = '/cofp';
var PF_SUSPEND_PATH = '/series';
var getSuspendsSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successResponses = responses.filter(function (item) {
        return item.success === true;
    });
    return successResponses;
};
var getIssuesSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successResponses = responses.filter(function (item) {
        return JSON.parse(item).isSuccess === 'true';
    });
    return successResponses;
};
var formatPostbody = function (suspend) {
    var postBody;
    if (suspend.systemCode === 'SERV') {
        if (!suspend.resume) {
            postBody = {
                prodIdAlias: suspend.prodIdAlias,
                accountNumber: suspend.accountNumber,
                suspend: suspend.suspend,
                reasonCode: suspend.reasonCode ? suspend.reasonCode : '',
                currentMagSwitch: 'X',
            };
        }
        else if (suspend.resume && suspend.resume === 'I') {
            postBody = {
                prodIdAlias: suspend.prodIdAlias,
                accountNumber: suspend.accountNumber,
                suspend: suspend.suspend,
                reasonCode: suspend.reasonCode ? suspend.reasonCode : '',
                currentMagSwitch: 'X',
            };
        }
        else {
            postBody = {
                prodIdAlias: suspend.prodIdAlias,
                accountNumber: suspend.accountNumber,
                suspend: suspend.suspend,
                reasonCode: suspend.reasonCode ? suspend.reasonCode : '',
                resumeIssue: suspend.resume,
                currentMagSwitch: 'X',
            };
        }
    }
    else { // PF Series suspend/resume
        postBody = {
            prodIdAlias: suspend.prodIdAlias,
            accountNumber: suspend.accountNumber,
            updateType: 'suspendresume',
            suspendSwitch: suspend.suspend,
            planCode: suspend.planCode ? suspend.planCode : '',
            recipAccountNumber: suspend.recipAccountNumber,
            resumeServiceDate: suspend.resume ? suspend.resume : '',
            shipFrequency: suspend.shipFrequency ? suspend.shipFrequency : '',
        };
    }
    return postBody;
};
var getIssues = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["c" /* GET_ISSUES_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["j" /* actionCreators */].getIssuesLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var promises = payload.orders.map(function (order) {
            var orderAcctNumber = order.isGift ? order.orderItems[0].shipToAccountNumber : order.billToAccountNumber;
            var customer = payload.customers.find(function (cust) {
                return cust.accountNumber === orderAcctNumber
                    && cust.prodIdAlias === order.prodIdAlias;
            });
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: ISSUES_PATH,
                region: clientConfig.Region,
                requestmethod: 'GET',
                requestbody: {},
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                    queryParams: {
                        magCode: order.prodIdAlias,
                        issueNumberStart: customer.lastIssueNumber === '' ? 1 : parseInt(customer.lastIssueNumber, 10) + 1,
                        issueNumberEnd: customer.expireIssueNumber
                    }
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__["forkJoin"])(promises, getIssuesSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (responses) {
            var orderCount = payload.orders.length;
            if (orderCount === responses.length) {
                var jsonResponse = JSON.parse('[' + responses.join(',') + ']');
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["j" /* actionCreators */].getIssuesSuccess(jsonResponse);
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["j" /* actionCreators */].getIssuesError({
                    success: false,
                    message: 'Error on Issue Lookup',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            console.log(err);
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["j" /* actionCreators */].getIssuesError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$);
    }));
};
var suspendSubs = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["h" /* SUSPEND_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["j" /* actionCreators */].suspendLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var promises = payload.map(function (suspend) {
            var path = '';
            var requestMethod = '';
            if (suspend.systemCode === 'SERV') { // suspend Serv Subscription
                path = SERV_SUSPEND_PATH;
                requestMethod = 'POST';
            }
            else { // call series epic to suspend PF series
                path = PF_SUSPEND_PATH;
                requestMethod = 'PUT';
            }
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: path,
                region: clientConfig.Region,
                requestmethod: requestMethod,
                requestbody: formatPostbody(suspend),
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__["forkJoin"])(promises, getSuspendsSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (responses) {
            var suspendCount = payload.length;
            if (suspendCount === responses.length) {
                payload.forEach(function (suspendPayload) {
                    __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: suspendPayload.googleAnalyticsCategory,
                        action: 'Successful',
                        label: suspendPayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["j" /* actionCreators */].suspendSuccess({ payload: payload, responses: responses, success: true });
            }
            else {
                payload.forEach(function (suspendPayload) {
                    __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: suspendPayload.googleAnalyticsCategory,
                        action: 'Unsuccessful',
                        label: suspendPayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["j" /* actionCreators */].suspendError({
                    success: false,
                    message: 'Error on Suspend',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_suspend_actions__["j" /* actionCreators */].suspendError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(getIssues, suspendSubs);


/***/ }),

/***/ 1358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resume_actions__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__);












var AWS = __webpack_require__(27);
var SERV_RESUME_PATH = '/cofp';
var PF_RESUME_PATH = '/series';
var getResumesSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successResponses = responses.filter(function (item) {
        return item.success === true;
    });
    return successResponses;
};
var resumeSubs = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resume_actions__["d" /* RESUME_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resume_actions__["f" /* actionCreators */].resumeLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var promises = payload.map(function (resume) {
            var postBody = {
                prodIdAlias: '',
                accountNumber: '',
            };
            var path = '';
            var requestMethod = '';
            if (resume.systemCode === 'SERV') {
                postBody = {
                    prodIdAlias: resume.prodIdAlias,
                    accountNumber: resume.accountNumber,
                    resume: 'Y',
                    currentMagSwitch: 'X'
                };
                path = SERV_RESUME_PATH;
                requestMethod = 'POST';
            }
            else if (resume.systemCode === 'SERVPF') {
                postBody = {
                    prodIdAlias: resume.prodIdAlias,
                    accountNumber: resume.accountNumber,
                    suspendSwitch: 'N',
                    recipAccountNumber: resume.recipAccountNumber,
                    updateType: 'suspendresume',
                    planCode: resume.planCode,
                    shipFrequency: resume.shipFrequency,
                };
                path = PF_RESUME_PATH;
                requestMethod = 'PUT';
            }
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: path,
                region: clientConfig.Region,
                requestmethod: requestMethod,
                requestbody: postBody,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__["forkJoin"])(promises, getResumesSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (responses) {
            var resumeCount = payload.length;
            if (resumeCount === responses.length) {
                payload.forEach(function (resumePayload) {
                    __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: resumePayload.googleAnalyticsCategory,
                        action: 'Successful',
                        label: resumePayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resume_actions__["f" /* actionCreators */].resumeSuccess({ payload: payload, responses: responses, success: true });
            }
            else {
                payload.forEach(function (resumePayload) {
                    __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: resumePayload.googleAnalyticsCategory,
                        action: 'Unsuccessful',
                        label: resumePayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resume_actions__["f" /* actionCreators */].resumeError({
                    success: false,
                    message: 'Error on Resume',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resume_actions__["f" /* actionCreators */].resumeError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(resumeSubs);


/***/ }),

/***/ 1359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_series_update_actions__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__);












var AWS = __webpack_require__(27);
var SERIES_PATH = '/series';
var getSeriesUpdateSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successResponses = responses.filter(function (item) {
        return item.success === true;
    });
    return successResponses;
};
var updateSeries = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_series_update_actions__["d" /* SERIES_UPDATE_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_series_update_actions__["f" /* actionCreators */].seriesUpdateLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var gaEventCategory;
        var promises = payload.map(function (seriesUpdate) {
            gaEventCategory = seriesUpdate.googleAnalyticsCategory;
            var putBody;
            putBody = {
                prodIdAlias: seriesUpdate.prodIdAlias,
                accountNumber: seriesUpdate.accountNumber,
                recipAccountNumber: seriesUpdate.recipAccountNumber,
                updateType: seriesUpdate.updateType,
                suspendSwitch: seriesUpdate.suspendSwitch,
                planCode: seriesUpdate.planCode,
                planStatus: seriesUpdate.planStatus,
                shipFrequency: seriesUpdate.shipFrequency,
                shipQuantity: seriesUpdate.shipQuantity,
            };
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: SERIES_PATH,
                region: clientConfig.Region,
                requestmethod: 'PUT',
                requestbody: putBody,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__["forkJoin"])(promises, getSeriesUpdateSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (responses) {
            var resumeCount = payload.length;
            if (resumeCount === responses.length) {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: gaEventCategory,
                    action: 'Successful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_series_update_actions__["f" /* actionCreators */].seriesUpdateSuccess({ payload: payload, responses: responses, success: true });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: gaEventCategory,
                    action: 'Unsuccessful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_series_update_actions__["f" /* actionCreators */].seriesUpdateError({
                    success: false,
                    message: 'Error on ' + gaEventCategory,
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: gaEventCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_series_update_actions__["f" /* actionCreators */].seriesUpdateError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(updateSeries);


/***/ }),

/***/ 1360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopcharge_actions__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__);












var AWS = __webpack_require__(27);
var STOPCHARGE_PATH = '/orderupdate';
var getSeriesUpdateSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successResponses = responses.filter(function (item) {
        return item.success === true;
    });
    return successResponses;
};
var formatBody = function (stopChargePayload) {
    var body = {};
    if (stopChargePayload.systemCode === 'RESIN') {
        body = {
            prodIdAlias: stopChargePayload.prodIdAlias,
            accountNumber: stopChargePayload.accountNumber,
            systemCode: stopChargePayload.systemCode,
            resinClientId: stopChargePayload.resinClientId,
            order: {
                resinSubscriptionId: stopChargePayload.resinSubscriptionId,
                resinAutoRenew: stopChargePayload.resinAutoRenew,
                reasonCode: stopChargePayload.reasonCode,
            }
        };
    }
    else {
        body = {
            prodIdAlias: stopChargePayload.prodIdAlias,
            accountNumber: stopChargePayload.accountNumber,
            systemCode: stopChargePayload.systemCode,
            order: {
                digital: 'Y',
                stopRecurringCharge: 'Y',
                orderNumber: stopChargePayload.orderNumber,
                packageTransaction: stopChargePayload.packageTransaction,
                reasonCode: '1'
            }
        };
    }
    return body;
};
function stopCharge(action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopcharge_actions__["d" /* STOPCHARGE_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopcharge_actions__["f" /* actionCreators */].stopChargeLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var promises = payload.map(function (stopChargePayload) {
            var body = formatBody(stopChargePayload);
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: STOPCHARGE_PATH,
                region: clientConfig.Region,
                requestmethod: 'PUT',
                requestbody: body,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__["forkJoin"])(promises, getSeriesUpdateSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (responses) {
            var resumeCount = payload.length;
            if (resumeCount === responses.length) {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopcharge_actions__["f" /* actionCreators */].stopChargeSuccess({ payload: payload, responses: responses, success: true });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopcharge_actions__["f" /* actionCreators */].stopChargeError({
                    success: false,
                    message: 'Error on Stop Charge',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopcharge_actions__["f" /* actionCreators */].stopChargeError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
}
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(stopCharge);


/***/ }),

/***/ 1361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sendCustservEmail */
/* unused harmony export sendExceptionEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_global_utility_sendEmailUtils__ = __webpack_require__(1362);









var AWS = __webpack_require__(27);
var TEST_EMAIL = 'GCTesting@cds-global.com';
var EMAIL_TYPE_CUST_SERV = 'Send Custserv Email';
var EMAIL_TYPE_PAID_CANCEL = 'Cancel Paid Order';
var formatCustServEmailBody = function (payload) {
    var emailBody = '';
    if (payload.fromLogin) {
        emailBody += 'Originated from: Global Care Login Help' + '\n\n';
    }
    else {
        emailBody += 'Originated from: Global Care' + '\n\n';
    }
    if (payload.customer) {
        emailBody += 'Product Code: ' + payload.selectedProdIdAlias + '\n\n';
        // emailBody += 'Product Code: ' + payload.customer.prodIdAlias + '\n';
    }
    else {
        emailBody += 'Product: ' + payload.prodIdAlias + '\n';
    }
    if (payload.selectedProductName) {
        emailBody += 'Product/Plan Name: ' + payload.selectedProductName + '\n\n';
    }
    if (payload.customer) {
        emailBody += 'Account Number: ' + payload.customer.accountNumber + '\n';
    }
    emailBody += 'Customer Email: ' + payload.customerEmailAddress + '\n';
    if (payload.customer) {
        emailBody += 'Name: ' + payload.customer.address.name + '\n';
        emailBody += 'Address 1: ' + payload.customer.address.address1 + '\n';
    }
    if (payload.customer && payload.customer.address.address2.length > 0) {
        emailBody += 'Address 2: ' + payload.customer.address.address2 + '\n'; // hide if empty
    }
    if (payload.customer && payload.customer.address.address3.length > 0) {
        emailBody += 'Address 3: ' + payload.customer.address.address3 + '\n'; // hide if empty
    }
    if (payload.customer) {
        emailBody += 'City/State: ' + payload.customer.address.city + ',' + payload.customer.address.state + '\n';
        emailBody += 'ZIP/Postal Code: ' + payload.customer.address.postalCode + '\n';
    }
    emailBody += 'Additional Information: ' + payload.emailContent.emailAdditionalInfo + '\n';
    return emailBody;
};
var formatPaidCancelEmailBody = function (payload) {
    var emailBody = '';
    emailBody += 'Originated from: Global Care' + '\n';
    emailBody += '\rCustomer Info: \n';
    emailBody += 'Product: ' + payload.customer.prodIdAlias + '\n';
    emailBody += 'Account Number: ' + payload.customer.accountNumber + '\n';
    emailBody += 'Cancellation Reason: ' + payload.reason + '\n';
    emailBody += 'Customer Email: ' + payload.customerEmailAddress + '\n';
    emailBody += 'Name: ' + payload.customer.address.name + '\n';
    emailBody += 'Address 1: ' + payload.customer.address.address1 + '\n';
    if (payload.customer.address.address2.length > 0) {
        emailBody += 'Address 2: ' + payload.customer.address.address2 + '\n'; // hide if empty
    }
    if (payload.customer.address.address3.length > 0) {
        emailBody += 'Address 3: ' + payload.customer.address.address3 + '\n'; // hide if empty
    }
    emailBody += 'City/State: ' + payload.customer.address.city + ',' + payload.customer.address.state + '\n';
    emailBody += 'Zip/Postal: ' + payload.customer.address.postalCode + '\n';
    emailBody += '\rOrder Info: \n';
    emailBody += 'Order Number: ' + payload.orderNumber + '\n';
    if (payload.invoiceNumber.length > 0) {
        emailBody += 'Invoice Number: ' + payload.invoiceNumber + '\n';
    }
    emailBody += 'Order Date: ' + payload.orderDate + '\n';
    payload.nonGiftOrderItems.forEach(function (orderItem) {
        emailBody += 'Order Item Description: ' + orderItem.productDesc + '\n';
        emailBody += 'Order Item Value: $' + orderItem.itemValue + '\n';
    });
    if (payload.lastPaymentDate.length > 0) {
        emailBody += 'Last Payment Date: ' + payload.lastPaymentDate + '\n';
    }
    if (payload.lastPaymentAmount.length > 0) {
        emailBody += 'Last Payment Amt: $' + payload.lastPaymentAmount + '\n';
    }
    if (payload.paymentMethod.length > 0) {
        emailBody += 'Last Payment Method: ' + payload.paymentMethod + '\n';
    }
    if (payload.isRecipient) {
        payload.recipOrderItems.forEach(function (recip) {
            if (recip.isContinuity) {
                emailBody += 'Plan Description: ' + recip.subscriptionName + '\n';
            }
            else {
                emailBody += 'Order Item Description: ' + recip.productDesc + '\n';
            }
        });
    }
    emailBody += '\r Cancel Info: \n';
    if (payload.nonGiftOrderItems.length > 0) {
        emailBody += 'Non Gift(s): \n';
        payload.nonGiftOrderItems.forEach(function (nonGiftOrderItem) {
            emailBody += '\tName: ' + payload.customer.address.name + '\n';
            emailBody += '\tAccount Number: ' + nonGiftOrderItem.shipToAccountNumber + '\n';
            if (nonGiftOrderItem.isContinuity) {
                emailBody += '\tPlan Description: ' + nonGiftOrderItem.subscriptionName + '\n';
            }
            else {
                emailBody += '\tOrder Item Description: ' + nonGiftOrderItem.productDesc + '\n';
            }
            emailBody += '\tOrder Item Value: $' + nonGiftOrderItem.itemValue + '\n';
        });
    }
    if (payload.recipOrderItems.length > 0) {
        emailBody += 'Gift Recipient(s): \n';
        payload.recipOrderItems.forEach(function (recipOrderItem) {
            emailBody += '\tRecipient Name: ' + (payload.isRecipient ? payload.customer.address.name : recipOrderItem.recipientName) + '\n';
            emailBody += '\tRecipient Account Number: ' + recipOrderItem.shipToAccountNumber + '\n';
            if (recipOrderItem.isContinuity) {
                emailBody += '\tPlan Description: ' + recipOrderItem.subscriptionName + '\n';
            }
            else {
                emailBody += '\tOrder Item Description: ' + recipOrderItem.productDesc + '\n';
            }
            emailBody += '\tOrder Item Value: $' + recipOrderItem.itemValue + '\n';
        });
    }
    return emailBody;
};
var sendCustservEmail = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["d" /* SEND_CUSTSERV_EMAIL_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var emailClient = new __WEBPACK_IMPORTED_MODULE_8__src_app_global_utility_sendEmailUtils__["a" /* SendEmailClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendCustservEmailLoading(true));
        var emailMessage = '';
        switch (payload.emailType) {
            case EMAIL_TYPE_CUST_SERV:
                emailMessage = formatCustServEmailBody(payload);
                break;
            case EMAIL_TYPE_PAID_CANCEL:
                emailMessage = formatPaidCancelEmailBody(payload);
                break;
            default:
                emailMessage = '';
        }
        emailMessage += '\rGC Email Session: ' + clientConfig.uuid;
        var credentialsObject = {
            IdentityPoolId: clientConfig.identityPoolId,
            IdentityId: payload.IdentityId,
        };
        if (__WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials) {
            var creds = __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials;
            creds.clearCachedId();
        }
        __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["CognitoIdentityCredentials"](credentialsObject);
        var sendEmailFields = {
            from: payload.custServEmailAddress,
            subject: payload.emailSubject,
            message: emailMessage,
            to: payload.custServEmailAddress,
            replyTo: payload.customerEmailAddress,
            altText: '',
            cc: '',
            bcc: '',
        };
        // console.log('process.env.NODE_ENV : ' + process.env.NODE_ENV);
        if (false) {
            if (!sendEmailFields.from || !sendEmailFields.from.includes('cds-global.com')) {
                sendEmailFields.from = TEST_EMAIL;
            }
            if (!sendEmailFields.to || !sendEmailFields.to.includes('cds-global.com')) {
                sendEmailFields.to = TEST_EMAIL;
            }
            if (!sendEmailFields.replyTo || !sendEmailFields.replyTo.includes('cds-global.com')) {
                sendEmailFields.replyTo = TEST_EMAIL;
            }
        }
        var sendEmailConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials,
            emailFields: sendEmailFields
        };
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise__["fromPromise"])(emailClient.sendEmail(sendEmailConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = answer.$response.httpResponse.statusCode === 200;
            var gaCategory = payload.emailType === 'Cancel Paid Order' ? payload.googleAnalyticsCategory : payload.emailType + ': ' + payload.emailSubject;
            if (isSuccess) {
                __WEBPACK_IMPORTED_MODULE_6__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: gaCategory,
                    action: 'Successful',
                    label: payload.customer.prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendCustservEmailSuccess({
                    success: true,
                    response: answer,
                    payload: payload
                });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_6__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: gaCategory,
                    action: 'Unsuccessful',
                    label: payload.customer.prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendCustservEmailError({
                    success: false,
                    message: 'Error ' + payload.emailType,
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_6__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.emailType,
                action: 'Unknown Error',
                label: payload.customer.prodIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendCustservEmailError({
                success: false,
                message: err,
            }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_concat__["concat"])(loading, source$);
    }));
};
var sendExceptionEmail = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["i" /* SEND_EXCEPTION_EMAIL_START */]), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var emailClient = new __WEBPACK_IMPORTED_MODULE_8__src_app_global_utility_sendEmailUtils__["a" /* SendEmailClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendCustservEmailLoading(true));
        var emailMessage = '';
        emailMessage += 'Product: ' + payload[0].prodIdAlias + '\n';
        emailMessage += 'Account Number: ' + payload[0].accountNumber + '\n';
        var credentialsObject = {
            IdentityPoolId: clientConfig.identityPoolId,
            IdentityId: payload.IdentityId,
        };
        if (__WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials) {
            var creds = __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials;
            creds.clearCachedId();
        }
        __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["CognitoIdentityCredentials"](credentialsObject);
        var sendEmailFields = {
            from: payload[0].exceptionProcessingEmailAddr,
            subject: payload[0].emailSubject,
            message: emailMessage,
            to: payload[0].exceptionProcessingEmailAddr,
            replyTo: payload[0].exceptionProcessingEmailAddr,
            altText: '',
            cc: '',
            bcc: '',
        };
        // console.log('process.env.NODE_ENV : ' + process.env.NODE_ENV);
        if (false) {
            if (!sendEmailFields.from || !sendEmailFields.from.includes('cds-global.com')) {
                sendEmailFields.from = TEST_EMAIL;
            }
            if (!sendEmailFields.to || !sendEmailFields.to.includes('cds-global.com')) {
                sendEmailFields.to = TEST_EMAIL;
            }
            if (!sendEmailFields.replyTo || !sendEmailFields.replyTo.includes('cds-global.com')) {
                sendEmailFields.replyTo = TEST_EMAIL;
            }
        }
        var sendEmailConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials,
            emailFields: sendEmailFields
        };
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise__["fromPromise"])(emailClient.sendEmail(sendEmailConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = answer.$response.httpResponse.statusCode === 200;
            if (isSuccess) {
                __WEBPACK_IMPORTED_MODULE_6__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].emailType + ' : ' + payload.emailSubject,
                    action: 'Successful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendExceptionEmailSuccess({
                    success: true,
                    response: answer,
                });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_6__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].emailType + ' : ' + payload.emailSubject,
                    action: 'Unsuccessful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendExceptionEmailError({
                    success: false,
                    message: 'Error ',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_6__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].emailType + ' : ' + payload.emailSubject,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendExceptionEmailError({
                success: false,
                message: err,
            }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_concat__["concat"])(loading, source$);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(sendCustservEmail, sendExceptionEmail);


/***/ }),

/***/ 1362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SendEmailClient; });
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// import { resolve } from 'url';
var AWS = __webpack_require__(27);
var SendEmailClient = /** @class */ (function () {
    function SendEmailClient() {
        var _this = this;
        this.getSessionStorageValue = function (value) {
            var valueString = sessionStorage.getItem(value);
            if (valueString) {
                return JSON.parse(valueString);
            }
        };
        this.sendEmail = function (config) {
            return new Promise(function (resolve, reject) {
                if (config.creds) {
                    config.creds.get(function (credsErr) { return __awaiter(_this, void 0, void 0, function () {
                        var params, sendPromise;
                        return __generator(this, function (_a) {
                            if (credsErr) {
                                console.log(credsErr);
                                reject(credsErr);
                            }
                            else {
                                AWS.config.update({
                                    accessKey: config.creds.accessKeyId,
                                    secretKey: config.creds.secretAccessKey,
                                    sessionToken: config.creds.sessionToken,
                                });
                                params = {
                                    Destination: {
                                        ToAddresses: [
                                            config.emailFields.to,
                                        ]
                                    },
                                    Message: {
                                        Body: {
                                            Text: {
                                                Charset: 'UTF-8',
                                                Data: config.emailFields.message
                                            }
                                        },
                                        Subject: {
                                            Charset: 'UTF-8',
                                            Data: config.emailFields.subject
                                        }
                                    },
                                    Source: config.emailFields.from,
                                    ReplyToAddresses: [
                                        config.emailFields.replyTo
                                    ],
                                };
                                sendPromise = new AWS.SES({ apiVersion: '2010-12-01' }).sendEmail(params).promise();
                                // Handle promise's fulfilled/rejected states
                                sendPromise.then(function (data) {
                                    var emailUUID = params.Message.Body.Text.Data.slice(params.Message.Body.Text.Data.indexOf('GC Email Session'));
                                    console.error('GC Email SES messageId: ' + data.MessageId);
                                    console.error(emailUUID);
                                    return (data);
                                }).catch(function (err) {
                                    console.error(err, err.stack);
                                    return (err);
                                });
                                resolve(sendPromise);
                            }
                            return [2 /*return*/];
                        });
                    }); });
                }
                else {
                    reject('no config creds');
                }
            });
        };
    }
    return SendEmailClient;
}());



/***/ }),

/***/ 1363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_updatepayment_actions__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__);












var AWS = __webpack_require__(27);
var PF_SERIES_UPDATE_PATH = '/series';
var CARD_UPDATE_PATH = '/cardupdate';
var getSeriesUpdateSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successResponses = responses.filter(function (item) {
        return item.success === true;
    });
    return successResponses;
};
var updatePayment = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_updatepayment_actions__["d" /* UPDATE_PAYMENT_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_updatepayment_actions__["f" /* actionCreators */].updatePaymentLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var promises = payload.map(function (updatePaymentPayload) {
            var wsgBody = {
                prodIdAlias: '',
                accountNumber: '',
                recipAccountNumber: '',
                planCode: '',
                updateType: '',
                orderType: '',
                creditCardExpireMonth: '',
                creditCardExpireYear: '',
                creditCardNumber: '',
                creditCardLastFour: '',
                path: '',
                resinCustomerId: ''
            };
            var path = '';
            if (updatePaymentPayload.systemCode === 'SERV') {
                wsgBody = {
                    prodIdAlias: updatePaymentPayload.prodIdAlias,
                    accountNumber: updatePaymentPayload.accountNumber,
                    name: updatePaymentPayload.name,
                    creditCardType: updatePaymentPayload.creditCardType,
                    creditCardExpireMonth: updatePaymentPayload.creditCardExpireMonth,
                    creditCardExpireYear: updatePaymentPayload.creditCardExpireYear,
                    creditCardNumber: updatePaymentPayload.creditCardNumber,
                    oldCreditCardType: updatePaymentPayload.oldCreditCardType,
                    oldCreditCardExpireMonth: updatePaymentPayload.oldCreditCardExpireMonth,
                    oldCreditCardExpireYear: updatePaymentPayload.oldCreditCardExpireYear,
                    oldCreditCardNumber: updatePaymentPayload.oldCreditCardNumber,
                    transactionNumber: updatePaymentPayload.transactionNumber,
                    creditCardLastFour: updatePaymentPayload.creditCardLastFour,
                };
                path = CARD_UPDATE_PATH;
            }
            else if (updatePaymentPayload.systemCode === 'EHUB') {
                wsgBody = {
                    prodIdAlias: updatePaymentPayload.prodIdAlias,
                    accountNumber: updatePaymentPayload.accountNumber,
                    name: updatePaymentPayload.name,
                    creditCardType: updatePaymentPayload.creditCardType,
                    creditCardExpireMonth: updatePaymentPayload.creditCardExpireMonth,
                    creditCardExpireYear: updatePaymentPayload.creditCardExpireYear,
                    creditCardNumber: updatePaymentPayload.creditCardNumber,
                    cardProfileId: updatePaymentPayload.cardProfileId,
                    creditCardLastFour: updatePaymentPayload.creditCardLastFour,
                };
                path = CARD_UPDATE_PATH;
            }
            else if (updatePaymentPayload.systemCode === 'RESIN') {
                wsgBody = {
                    prodIdAlias: updatePaymentPayload.prodIdAlias,
                    accountNumber: updatePaymentPayload.accountNumber,
                    name: updatePaymentPayload.name,
                    creditCardType: updatePaymentPayload.creditCardType,
                    creditCardExpireMonth: updatePaymentPayload.creditCardExpireMonth,
                    creditCardExpireYear: updatePaymentPayload.creditCardExpireYear,
                    creditCardNumber: updatePaymentPayload.creditCardNumber,
                    cardProfileId: updatePaymentPayload.cardProfileId,
                    creditCardLastFour: updatePaymentPayload.creditCardLastFour,
                    resinClientId: updatePaymentPayload.resinClientId,
                    resinSubscriptionIds: updatePaymentPayload.resinSubscriptionIds,
                    systemCode: updatePaymentPayload.systemCode,
                    resinCustomerId: updatePaymentPayload.resinCustomerId,
                    path: 'payment-instrument'
                };
                path = CARD_UPDATE_PATH;
            }
            else if (updatePaymentPayload.systemCode === 'SERVPF') {
                wsgBody = {
                    prodIdAlias: updatePaymentPayload.prodIdAlias,
                    accountNumber: updatePaymentPayload.accountNumber,
                    recipAccountNumber: updatePaymentPayload.recipAccountNumber,
                    planCode: updatePaymentPayload.planCode,
                    updateType: updatePaymentPayload.updateType,
                    orderType: updatePaymentPayload.orderType,
                    creditCardExpireMonth: updatePaymentPayload.creditCardExpireMonth,
                    creditCardExpireYear: updatePaymentPayload.creditCardExpireYear,
                    creditCardNumber: updatePaymentPayload.creditCardNumber,
                    creditCardType: updatePaymentPayload.creditCardType,
                    shipFrequency: updatePaymentPayload.shipFrequency,
                    creditCardLastFour: updatePaymentPayload.creditCardLastFour,
                };
                path = PF_SERIES_UPDATE_PATH;
            }
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: path,
                region: clientConfig.Region,
                requestmethod: 'PUT',
                requestbody: wsgBody,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__["forkJoin"])(promises, getSeriesUpdateSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (responses) {
            var updateCount = payload.length;
            if (updateCount === responses.length) {
                payload.forEach(function (updatePmtPayload) {
                    __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: updatePmtPayload.googleAnalyticsCategory,
                        action: 'Successful',
                        label: updatePmtPayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_updatepayment_actions__["f" /* actionCreators */].updatePaymentSuccess({ payload: payload, responses: responses, success: true });
            }
            else {
                payload.forEach(function (updatePmtPayload) {
                    __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: updatePmtPayload.googleAnalyticsCategory,
                        action: 'Unsuccessful',
                        label: updatePmtPayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_updatepayment_actions__["f" /* actionCreators */].updatePaymentError({
                    success: false,
                    message: 'Error on ' + payload[0].googleAnalyticsEventCategory,
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].googleAnalyticsEventCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_updatepayment_actions__["f" /* actionCreators */].updatePaymentError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(updatePayment);


/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopautorenew_actions__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__);












var AWS = __webpack_require__(27);
var STOP_AUTO_RENEW_PATH = '/cofp';
var getStopAutoRenewSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successResponses = responses.filter(function (item) {
        return item.success === true;
    });
    return successResponses;
};
var stopAutoRenew = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopautorenew_actions__["d" /* STOP_AUTO_RENEW_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopautorenew_actions__["f" /* actionCreators */].stopAutoRenewLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var promises = payload.map(function (stopAutoRenewal) {
            var putBody;
            putBody = {
                prodIdAlias: stopAutoRenewal.prodIdAlias,
                accountNumber: stopAutoRenewal.accountNumber,
                removeFromCurrentSingleAutoRenewal: stopAutoRenewal.stopSingleAutoRenew,
                allowGiftAutoRenewal: stopAutoRenewal.stopGiftAutoRenew,
            };
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: STOP_AUTO_RENEW_PATH,
                region: clientConfig.Region,
                requestmethod: 'POST',
                requestbody: putBody,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__["forkJoin"])(promises, getStopAutoRenewSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (responses) {
            var payloadCount = payload.length;
            if (payloadCount === responses.length) {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopautorenew_actions__["f" /* actionCreators */].stopAutoRenewSuccess({ payload: payload, responses: responses, success: true });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopautorenew_actions__["f" /* actionCreators */].stopAutoRenewError({
                    success: false,
                    message: 'Error on Stop Auto Renew',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_stopautorenew_actions__["f" /* actionCreators */].stopAutoRenewError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(stopAutoRenew);


/***/ }),

/***/ 1365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_startautorenew_actions__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__);












var AWS = __webpack_require__(27);
var START_AUTO_RENEW_PATH = '/cofp';
var getStartAutoRenewSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successResponses = responses.filter(function (item) {
        return item.success === true;
    });
    return successResponses;
};
var startAutoRenew = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_startautorenew_actions__["d" /* START_AUTO_RENEW_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_startautorenew_actions__["f" /* actionCreators */].startAutoRenewLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var promises = payload.map(function (startAutoRenewal) {
            var putBody;
            putBody = {
                prodIdAlias: startAutoRenewal.prodIdAlias,
                accountNumber: startAutoRenewal.accountNumber,
                startAutoRenewCredit: startAutoRenewal.startAutoRenewCredit,
                startAutoRenewCreditCard: startAutoRenewal.startAutoRenewCreditCard,
                startGiftAutoRenewCreditCard: startAutoRenewal.startGiftAutoRenewCreditCard,
                startGiftAutoRenew: startAutoRenewal.startGiftAutoRenew,
            };
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: START_AUTO_RENEW_PATH,
                region: clientConfig.Region,
                requestmethod: 'POST',
                requestbody: putBody,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__["forkJoin"])(promises, getStartAutoRenewSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (responses) {
            var payloadCount = payload.length;
            if (payloadCount === responses.length) {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_startautorenew_actions__["f" /* actionCreators */].startAutoRenewSuccess({ payload: payload, responses: responses, success: true });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_startautorenew_actions__["f" /* actionCreators */].startAutoRenewError({
                    success: false,
                    message: 'Error on Start Auto Renew',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_startautorenew_actions__["f" /* actionCreators */].startAutoRenewError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(startAutoRenew);


/***/ }),

/***/ 1366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_intellisel_actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_accounts_customer_service_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs__ = __webpack_require__(40);













var AWS = __webpack_require__(27);
var ORDER_UPDATE_PATH = '/orderupdate';
var RESIN_ORDER_UPDATE_PATH = '/resinorderupdate';
var getAllSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successCount = responses.filter(function (item) { return item.success; });
    return successCount.length === responses.length;
};
var orderUpdate = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["d" /* ORDER_UPDATE_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["k" /* actionCreators */].orderUpdateLoading(true));
        if (!AWS.config.credentials) {
            var creds = state$.value.auth.omsAuth.credentials;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(creds);
        }
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var promises = payload.map(function (item) {
            var body = {
                prodIdAlias: item.prodIdAlias,
                accountNumber: item.accountNumber,
                order: {
                    orderNumber: item.orderNumber,
                    invoiceNumber: item.invoiceNumber,
                    orderStatus: item.orderStatus,
                    reasonCode: item.reasonCode,
                    giftSet: item.giftSet,
                    orderItems: item.orderItems,
                    cancel: item.orderStatus === 'cancel' ? 'Y' : '',
                    migration: item.migration,
                    toMagAbbr: item.toMagAbbr,
                    toDocKey: item.toDocKey,
                    moveSw: item.moveSw,
                    toService: item.toService,
                    newTerm: item.newTerm,
                    newValue: item.newValue,
                    changeOffer: item.changeOffer,
                    refundType: item.refundType,
                },
            };
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_11_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: ORDER_UPDATE_PATH,
                region: clientConfig.Region,
                requestmethod: 'PUT',
                requestbody: body,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_12_rxjs__["forkJoin"])(promises, getAllSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (allSucceeded) {
            var gaCategory = payload[0].googleAnalyticsCategory === 'Subscription Transfer'
                ? payload[0].googleAnalyticsCategory + ' to ' + payload[0].toMagAbbr : payload[0].googleAnalyticsCategory;
            if (allSucceeded) {
                __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: gaCategory,
                    action: 'Successful',
                    label: payload[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["k" /* actionCreators */].orderUpdateSuccess({ accountResponse: payload, success: allSucceeded });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: gaCategory,
                    action: 'Unsuccessful',
                    label: payload[0].prodIdAlias
                });
                if (payload[0].refundType && payload[0].refundType === 'R') {
                    return __WEBPACK_IMPORTED_MODULE_10__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendCustservEmailStart(payload[0].custServEmailData);
                }
                else {
                    return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["k" /* actionCreators */].orderUpdateError({
                        success: false,
                        message: 'Error on ' + gaCategory,
                    });
                }
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias
            });
            if (payload[0].refundType && payload[0].refundType === 'R') {
                return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_10__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendCustservEmailStart(payload[0].custServEmailData));
            }
            else {
                return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["k" /* actionCreators */].orderUpdateError({ success: false, message: err }));
            }
        }));
        var refetchCustomerPayload = {
            accountNumber: payload.accountNumber,
            postalCode: payload.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        if (payload[0].intelliselPayload) {
            var intelliselAcceptOffer = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_9__src_app_intellisel_actions__["e" /* actionCreators */].intelliselStart(payload[0].intelliselPayload));
            return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, intelliselAcceptOffer, reloadCust);
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
        }
    }));
};
var resinOrderUpdate = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["i" /* RESIN_ORDER_UPDATE_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["k" /* actionCreators */].resinOrderUpdateLoading(true));
        if (!AWS.config.credentials) {
            var creds = state$.value.auth.omsAuth.credentials;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(creds);
        }
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var body = {
            resinClientId: payload.resinClientId,
            systemCode: payload.systemCode,
            resinGiftRedemptionId: payload.resinGiftRedemptionId,
            resinStoreCredit: payload.resinStoreCredit,
            path: payload.path,
            reasonCode: payload.reasonCode,
            resinRecipientEmail: payload.resinRecipientEmail
        };
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_11_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: RESIN_ORDER_UPDATE_PATH,
            region: clientConfig.Region,
            requestmethod: 'PUT',
            requestbody: body,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.success) === 'true';
            if (isSuccess) {
                if (payload.path === 'cancellation') {
                    __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: payload.googleAnalyticsCategory,
                        action: 'Successful',
                        label: payload.prodIdAlias,
                        value: parseFloat(payload.refundAmount) * 100,
                    });
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: payload.googleAnalyticsCategory,
                        action: 'Successful',
                        label: payload.prodIdAlias,
                    });
                }
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["k" /* actionCreators */].resinOrderUpdateSuccess({ accountResponse: answer, success: isSuccess });
            }
            else {
                if (payload.path === 'cancellation') {
                    __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: payload.googleAnalyticsCategory,
                        action: 'Unsuccessful',
                        label: payload.prodIdAlias,
                        value: parseFloat(payload.refundAmount) * 100,
                    });
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: payload.googleAnalyticsCategory,
                        action: 'Unsuccessful',
                        label: payload.prodIdAlias,
                    });
                }
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["k" /* actionCreators */].resinOrderUpdateError({
                    success: false,
                    message: 'Error on ' + payload.googleAnalyticsCategory,
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload.prodIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_orders_actions__["k" /* actionCreators */].resinOrderUpdateError({ success: false, message: err }));
        }));
        var refetchCustomerPayload = {
            accountNumber: payload.accountNumber,
            postalCode: payload.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(orderUpdate, resinOrderUpdate);


/***/ }),

/***/ 1367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_payments_actions__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs__ = __webpack_require__(40);











var AWS = __webpack_require__(27);
var PAYMENT_PATH = '/payment';
var getAllSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successCount = responses.filter(function (item) { return item.success; });
    return successCount.length === responses.length;
};
var formatPostBody = function (paymentPayload) {
    // add logic for other OMS Payment body values later
    var body = {
        prodIdAlias: paymentPayload.prodIdAlias,
        accountNumber: paymentPayload.accountNumber,
        invoiceNumber: paymentPayload.invoiceNumber,
        amountPaid: paymentPayload.amountPaid,
        effort: paymentPayload.effort,
        paymentOnOrderType: paymentPayload.paymentOnOrderType,
        creditCardExpireMonth: paymentPayload.creditCardExpireMonth,
        creditCardExpireYear: paymentPayload.creditCardExpireYear,
        creditCardLastFour: paymentPayload.creditCardLastFour,
        creditCardType: paymentPayload.creditCardType,
        creditCardNumber: paymentPayload.creditCardNumber,
        paymentType: paymentPayload.paymentType,
        altPayInfo: paymentPayload.altPayInfo,
        authCode: paymentPayload.authCode,
        autoRenewOptin: paymentPayload.autoRenewOptIn,
        systemCode: paymentPayload.systemCode
    };
    if (paymentPayload.systemCode === 'SERVPF') {
        body.errorSwitch = 'O';
    }
    return body;
};
var applyPayment = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_payments_actions__["d" /* PAYMENTS_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_payments_actions__["f" /* actionCreators */].paymentsLoading(true));
        if (!AWS.config.credentials) {
            var creds = state$.value.auth.omsAuth.credentials;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(creds);
        }
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var filteredPayloads = payload.paymentsPayloads.filter(function (pmt) {
            return pmt.systemCode !== 'SERVPF' || (pmt.systemCode === 'SERVPF' && !pmt.updatePayMethodOnly);
        });
        var promises = filteredPayloads.map(function (item) {
            var body = formatPostBody(item);
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_9_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: PAYMENT_PATH,
                region: clientConfig.Region,
                requestmethod: 'POST',
                requestbody: body,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_10_rxjs__["forkJoin"])(promises, getAllSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (allSucceeded) {
            if (allSucceeded) {
                payload.paymentsPayloads.forEach(function (pmtPayload) {
                    __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: pmtPayload.googleAnalyticsCategory,
                        action: 'Successful',
                        value: parseFloat(pmtPayload.amountPaid) * 100,
                        label: pmtPayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_payments_actions__["f" /* actionCreators */].paymentsSuccess({ accountResponse: payload, success: allSucceeded });
            }
            else {
                payload.paymentsPayloads.forEach(function (pmtPayload) {
                    __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: pmtPayload.googleAnalyticsCategory,
                        action: 'Unsuccessful',
                        value: parseFloat(pmtPayload.amountPaid) * 100,
                        label: pmtPayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_payments_actions__["f" /* actionCreators */].paymentsError({
                    success: false,
                    message: 'Error on Payment',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.paymentsPayloads[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload.paymentsPayloads[0].prodIdAlias
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_payments_actions__["f" /* actionCreators */].paymentsError({ success: false, message: err }));
        }));
        var reloadCust = null;
        var refetchCustomerPayload = {
            accountNumber: payload.paymentsPayloads[0].accountNumber,
            postalCode: payload.paymentsPayloads[0].postalCode,
        };
        reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(applyPayment);


/***/ }),

/***/ 1368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_refundstorecredit_actions__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__);












var AWS = __webpack_require__(27);
var REFUND_STORE_CREDIT_PATH = '/payout';
var getStartRefundStoreCreditSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successResponses = responses.filter(function (item) {
        return item.success === true;
    });
    return successResponses;
};
var startRefundStoreCredit = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_refundstorecredit_actions__["d" /* REFUND_STORE_CREDIT_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_refundstorecredit_actions__["f" /* actionCreators */].refundStoreCreditLoading(true));
        __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var promises = payload.map(function (refundStoreCreditPayload) {
            var postBody;
            postBody = {
                resinCustomerId: refundStoreCreditPayload.resinCustomerId,
                resinClientId: refundStoreCreditPayload.resinClientId,
                refundAmount: refundStoreCreditPayload.refundAmount,
                resinPaymentInstrumentId: refundStoreCreditPayload.resinPaymentInstrumentId,
                path: refundStoreCreditPayload.path,
                systemCode: refundStoreCreditPayload.systemCode
            };
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_10_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: REFUND_STORE_CREDIT_PATH,
                region: clientConfig.Region,
                requestmethod: 'POST',
                requestbody: postBody,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_7__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_11_rxjs_observable_forkJoin__["forkJoin"])(promises, getStartRefundStoreCreditSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (responses) {
            var payloadCount = payload.length;
            if (payloadCount === responses.length) {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload[0].prodIdAlias,
                    value: payload[0].refundAmount
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_refundstorecredit_actions__["f" /* actionCreators */].refundStoreCreditSuccess({ payload: payload, responses: responses, success: true });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload[0].googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload[0].prodIdAlias,
                    value: payload[0].refundAmount
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_refundstorecredit_actions__["f" /* actionCreators */].refundStoreCreditError({
                    success: false,
                    message: 'Error on Store Credit Refund',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_8__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias,
                value: payload[0].refundAmount
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_refundstorecredit_actions__["f" /* actionCreators */].refundStoreCreditError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, source$, reloadCust);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(startRefundStoreCredit);


/***/ }),

/***/ 1369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_aws_sdk_global__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};











var AWS = __webpack_require__(27);
var amendmentOrder = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["d" /* RESIN_ORDER_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["j" /* actionCreators */].resinOrderLoading(true));
        if (!AWS.config.credentials) {
            var creds = state$.value.auth.omsAuth.credentials;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(creds);
        }
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_9_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: '/order',
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: payload,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var $source = Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.success) === 'true';
            if (isSuccess) {
                __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload.prodIdAlias,
                });
                var newResponse = __assign({}, answer, { payload: payload });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["j" /* actionCreators */].resinOrderSuccess(newResponse);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload.prodIdAlias,
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["j" /* actionCreators */].resinOrderError(answer);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload.prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["j" /* actionCreators */].resinOrderError({
                success: false,
                message: err,
            }));
        }));
        var refetchCustomerPayload = {
            accountNumber: payload.accountNumber,
            postalCode: payload.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, $source, reloadCust.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["b" /* delay */])(2000)));
    }));
};
var speculativeOrder = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["h" /* RESIN_SPECULATIVE_START */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        AWS.config.region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["j" /* actionCreators */].resinOrderLoading(true));
        if (!AWS.config.credentials) {
            var creds = state$.value.auth.omsAuth.credentials;
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(creds);
        }
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_9_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: '/order',
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: payload,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var $source = Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.success) === 'true';
            if (isSuccess) {
                var newResponse = __assign({}, answer, { payload: payload });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["j" /* actionCreators */].resinSpeculativeSuccess(newResponse);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: 'Speculative Order',
                    action: 'Unsuccessful',
                    label: payload.prodIdAlias,
                });
                return __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["j" /* actionCreators */].resinSpeculativeError(answer);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_7__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: 'Speculative Order',
                action: 'Unknown Error',
                label: payload.prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_6__src_app_accounts_resin_order_actions__["j" /* actionCreators */].resinSpeculativeError({
                success: false,
                message: err,
            }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_concat__["concat"])(loading, $source);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(amendmentOrder, speculativeOrder);


/***/ }),

/***/ 1370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_notification_system_redux__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_notification_system_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_notification_system_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_login_cognito_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__);







var removeAllNotificationsEpic = function (action$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__["d" /* UNAUTH_GET_IAM_KEYS */], __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["a" /* INITIATE_OMS_LOOKUP */], __WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__["a" /* AUTH_IAM_KEYS_SUCCESS */], __WEBPACK_IMPORTED_MODULE_4__src_app_login_cognito_actions__["b" /* COGNITO_SUCCESS */]), Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["f" /* mergeMap */])(function (action, payload) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(Object(__WEBPACK_IMPORTED_MODULE_3_react_notification_system_redux__["removeAll"])());
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(removeAllNotificationsEpic);


/***/ }),

/***/ 1371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_header_actions__ = __webpack_require__(50);










var intelliselEvents = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* INTELLISEL_START */]), Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var loading = Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* actionCreators */].intelliselLoading(true));
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        if (!__WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].region) {
            __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].region = clientConfig.Region;
        }
        var postBody = payload;
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: '/intellisel',
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: postBody,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.success) === 'true';
            if (isSuccess) {
                return __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* actionCreators */].intelliselSuccess({
                    success: true,
                    transactionCode: payload.intellisel.transactionCode,
                    response: answer.intellisels[0].offers,
                });
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* actionCreators */].intelliselError({
                    success: false,
                    message: 'Error on Load of Intellisel',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["a" /* catchError */])(function (err) {
            // if error msg contains "Invalid login token" then fire logout action with different notifcation.
            if (err && err.message.includes('Invalid login token')) {
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Session Timeout');
                return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_9__src_app_header_actions__["b" /* actionCreators */].userLogout());
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Unknown error');
                return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* actionCreators */].intelliselError({
                    success: false,
                    message: err,
                }));
            }
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_concat__["concat"])(loading, source$);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(intelliselEvents);


/***/ }),

/***/ 1372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_cognito_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_user_actions__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__ = __webpack_require__(25);














var AWS = __webpack_require__(27);
var cognitoLoginEpic = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_0__src_app_login_cognito_actions__["b" /* COGNITO_SUCCESS */]), Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["i" /* switchMap */])(function (_a) {
        var _b;
        var payload = _a.payload;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["f" /* actionCreators */].setAuthenticating(true));
        var idToken = payload.idToken;
        var accessToken = payload.accessToken;
        var tokenParts = idToken.jwtToken.split('.');
        var tokenPayload = tokenParts[1];
        var decodedIdToken = atob(tokenPayload);
        var identityPoolId = state$.value.clientConfig.clientConfig.identityPoolId;
        var tokenObject = JSON.parse(decodedIdToken);
        var idProvider = tokenObject.iss.split('//')[1];
        var credentialsObject = {
            IdentityPoolId: identityPoolId,
            Logins: (_b = {},
                _b[idProvider] = idToken.jwtToken,
                _b),
        };
        var idpAccountInfo = {
            sub: tokenObject.sub,
            email: tokenObject.email,
            username: tokenObject.username,
        };
        var saveIdpAccountInfo = Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_4__src_app_user_actions__["j" /* actionCreators */].idpAccountInfo({ payload: idpAccountInfo }));
        var setCreds = Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["f" /* actionCreators */].omsSetCredentials(credentialsObject));
        var clientConfig = state$.value.clientConfig.clientConfig;
        // get the login values from state, these should only be set when using
        // the mylo/continue route
        var loginAccountNumber = state$.value.userState.loginAccountNumber;
        var loginPostalCode = state$.value.userState.loginPostalCode;
        AWS.config.region = clientConfig.Region;
        __WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__["CognitoIdentityCredentials"](credentialsObject);
        if (__WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__["config"].credentials) {
            var creds = __WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__["config"].credentials;
            creds.clearCachedId();
        }
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: '/mylo',
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: {
                myloIdentitySub: tokenObject.sub,
                globalCode: clientConfig.globalCode,
                accessToken: accessToken.jwtToken,
                myloLegacySub: tokenObject.legacy_sub,
            },
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var client = new __WEBPACK_IMPORTED_MODULE_9__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var observableStream = Object(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["e" /* map */])(function (answer) {
            var filteredAccounts;
            if (clientConfig.resinEnabled === 'true') {
                // Get collection of Resion prod ids and client ids for this global code
                var resinProducts_1 = Object(__WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__["p" /* getResinProdIdsForGlobalCodeFromAdminConfig */])(state$.value) || [];
                // filter the subscriptions returned from Mylo /userinfo call and
                // return a collection of account numbers and client ids.
                var resinAccounts = answer.subscriptions.filter(function (item) {
                    return resinProducts_1.find(function (resinProduct) { return resinProduct.prodId === item.prod_id; });
                })
                    .map(function (sub) {
                    var resinProduct = resinProducts_1.find(function (product) { return product.prodId === sub.prod_id; }) || {};
                    return { accountNumber: sub.account_number, clientId: resinProduct.clientId };
                });
                // dedupe the collection of accounts
                filteredAccounts = resinAccounts.filter(function (value, index, self) {
                    return index === self.findIndex(function (t) { return (t.accountNumber === value.accountNumber && t.clientId === value.clientId); });
                });
                // if no accounts from /userinfo call, use the response from the dynamoDB table
                if (filteredAccounts.length === 0) {
                    filteredAccounts = answer.resinAccounts;
                }
            }
            __WEBPACK_IMPORTED_MODULE_3__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: 'Login with Mylo',
                action: 'Successful',
                label: state$.value.clientConfig.clientConfig.magCode,
            });
            var accountNumber = loginAccountNumber || answer.accountId;
            var postalCode = loginPostalCode || answer.postalCode;
            if ((accountNumber && postalCode) || filteredAccounts.length > 0) {
                var productExcludes = Object(__WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__["m" /* getProdIdsForGlobalCodeFromAdminConfig */])(state$.value);
                return __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["f" /* actionCreators */].initiateOmsLookup(accountNumber, postalCode, idToken.jwtToken, idProvider, productExcludes, filteredAccounts, idpAccountInfo);
            }
            else {
                var response = { isSuccess: false, prodId: '', accountsMap: {}, customers: [], orders: [], associatedGiftAccounts: {} };
                return __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(response);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_3__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: 'Login with Mylo',
                action: 'Unsuccessful',
                label: state$.value.clientConfig.clientConfig.magCode,
            });
            var response = { isSuccess: false, prodId: '', accountsMap: {}, customers: [], orders: [], associatedGiftAccounts: {} };
            return Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(response));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_concat__["concat"])(loading, setCreds, saveIdpAccountInfo, observableStream);
    }));
};
var cognitoRefreshCredentials = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_0__src_app_login_cognito_actions__["a" /* COGNITO_REFRESH */]), Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["i" /* switchMap */])(function (_a) {
        var payload = _a.payload;
        __WEBPACK_IMPORTED_MODULE_3__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
            category: 'Continue Session',
            action: 'Successful',
            label: state$.value.clientConfig.clientConfig.magCode,
        });
        var loading = Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["f" /* actionCreators */].setAuthenticating(true));
        var observableStream;
        var oldCreds = __WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__["config"].credentials;
        var credentials;
        if (__WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__["config"].credentials) {
            credentials = __WEBPACK_IMPORTED_MODULE_8_aws_sdk_global__["config"].credentials;
            credentials.refresh(function (error) {
                if (error) {
                    console.error(error);
                }
                else {
                    console.log('Successfully refreshed!');
                }
            });
        }
        observableStream = Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_concat__["concat"])(loading, Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_0__src_app_login_cognito_actions__["c" /* actionCreators */].cognitoRefreshSuccess({ history: payload.history })));
        return observableStream;
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["a" /* combineEpics */])(cognitoLoginEpic, cognitoRefreshCredentials);


/***/ }),

/***/ 1373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_eventLogging__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs__ = __webpack_require__(40);






var EVENTBUSTRANSACTIONTYPE = 'eventBusTransactionType';
var EVENTBUSPOSTBODY = 'eventBusPostBody';
var publishEvent = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_3__src_app_eventLogging__["a" /* EVENTBUS_PUBLISH */]), Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        if (state$.value.auth.omsAuth.credentials) {
            __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        }
        else {
            var credentialsObject = {
                IdentityPoolId: clientConfig.identityPoolId,
                IdentityId: payload.IdentityId,
            };
            __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["CognitoIdentityCredentials"](credentialsObject);
        }
        var newPayload = {};
        var newEventData = {
            'category': payload.category,
            'action': payload.action,
            'label': payload.label ? payload.label : '',
            'value': payload.value ? payload.value : ''
        };
        newPayload[EVENTBUSTRANSACTIONTYPE] = 'PUBLISH';
        newPayload[EVENTBUSPOSTBODY] = newEventData;
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        if (!__WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].region) {
            __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].region = clientConfig.Region;
        }
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_2_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: '/eventbuspublish',
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: newPayload,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        client.callApiGateway(apiConfig);
        return __WEBPACK_IMPORTED_MODULE_5_rxjs__["EMPTY"];
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(publishEvent);


/***/ }),

/***/ 1374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_eventLogging_actions__ = __webpack_require__(371);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_eventLogging_actions__["a"]; });



/***/ }),

/***/ 1381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Main; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_scss__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_main_ErrorView__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_home_Home__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_login_components_Login__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_main_actions__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_global_auth__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_index_scss__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_notification_system_redux__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_notification_system_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_notification_system_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_header_Header__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_footer_Footer__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_ga__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_router_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_app_global_components_Loading__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_app_accounts_customer_service_components_LoginCustomerService__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_app_global_utility_adminConfigUtils__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_app_main_InvalidRoute__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_loadable__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_helmet__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_ga__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_ga4__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_ga4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_app_login_components_Cognito__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_app_login_components_Mylo__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_app_login_components_MyloContinue__ = __webpack_require__(1547);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





//  import AccountsView from '@src/app/accounts/AccountsView';

















var LoadCmp = function (_a) {
    var isLoading = _a.isLoading, error = _a.error;
    if (isLoading) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, "Loading...");
    }
    else {
        return null;
    }
};
var AccountsView = __WEBPACK_IMPORTED_MODULE_18_react_loadable__({
    loader: function () { return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1551)); },
    loading: LoadCmp,
});



var LoginComponent = Object(__WEBPACK_IMPORTED_MODULE_8__src_app_global_auth__["b" /* userIsNotAuthenticatedRedir */])(__WEBPACK_IMPORTED_MODULE_5__src_app_login_components_Login__["a" /* Login */]);
var Protected = Object(__WEBPACK_IMPORTED_MODULE_8__src_app_global_auth__["a" /* userIsAuthenticatedRedir */])(AccountsView);
var HomeComponent = Object(__WEBPACK_IMPORTED_MODULE_8__src_app_global_auth__["a" /* userIsAuthenticatedRedir */])(__WEBPACK_IMPORTED_MODULE_4__src_app_home_Home__["a" /* default */]);
var LoginCustomerServiceComponent = Object(__WEBPACK_IMPORTED_MODULE_8__src_app_global_auth__["b" /* userIsNotAuthenticatedRedir */])(__WEBPACK_IMPORTED_MODULE_15__src_app_accounts_customer_service_components_LoginCustomerService__["a" /* default */]);
var getDomainWithoutSubdomain = function (url) {
    var urlParts = new URL(url).hostname.split('.');
    var domain = urlParts
        .slice(0)
        .slice(-(2))
        .join('.');
    return domain;
};
var MainForm = /** @class */ (function (_super) {
    __extends(MainForm, _super);
    function MainForm(props) {
        return _super.call(this, props) || this;
        // throw new Error('sdf');
    }
    MainForm.prototype.componentWillMount = function () {
        var clientConfig = this.props.clientConfig;
        if (clientConfig && !clientConfig.configLoaded) {
            this.props.getClientConfig();
        }
    };
    MainForm.prototype.renderConfigLoadedView = function () {
        var _a = this.props, clientConfig = _a.clientConfig, adminConfig = _a.adminConfig, notifications = _a.notifications;
        var integrations = Object(__WEBPACK_IMPORTED_MODULE_16__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(adminConfig, clientConfig, 'ThirdPartyIntegrations');
        var primaryAnalyticsId = integrations.Preferences && integrations.Preferences.GoogleAnalyticsId
            ? integrations.Preferences.GoogleAnalyticsId
            : '';
        var secondaryAnalyticsId = integrations.Preferences && integrations.Preferences.SecondaryGoogleAnalyticsId
            ? integrations.Preferences.SecondaryGoogleAnalyticsId
            : '';
        var primaryGA4AnalyticsId = integrations.Preferences && integrations.Preferences.GoogleAnalytics4Id
            ? integrations.Preferences.GoogleAnalytics4Id
            : '';
        var secondaryGA4AnalyticsId = integrations.Preferences && integrations.Preferences.SecondaryGoogleAnalytics4Id
            ? integrations.Preferences.SecondaryGoogleAnalytics4Id
            : '';
        var domain = getDomainWithoutSubdomain(window.location.href);
        __WEBPACK_IMPORTED_MODULE_20_react_ga__["b" /* initialize */]([
            {
                trackingId: primaryAnalyticsId,
                gaOptions: { name: 'CDS_SSP_Primary', cookieDomain: domain },
            },
            {
                trackingId: secondaryAnalyticsId,
                gaOptions: { name: 'CDS_SSP_Secondary', cookieDomain: domain },
            }
        ], { debug: false, alwaysSendToDefaultTracker: true });
        __WEBPACK_IMPORTED_MODULE_21_react_ga4___default.a.initialize([
            {
                trackingId: primaryGA4AnalyticsId,
                gaOptions: { name: 'CDS_SSP_GA4_Primary', cookieDomain: domain, send_page_view: true },
            },
            {
                trackingId: secondaryGA4AnalyticsId,
                gaOptions: { name: 'CDS_SSP_GA4_Secondary', cookieDomain: domain, send_page_view: true },
            }
        ], { testMode: false });
        var signInData = Object(__WEBPACK_IMPORTED_MODULE_16__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(this.props.adminConfig, this.props.clientConfig, 'SignIn');
        var title = signInData.PageTitle;
        var pageDescription = signInData.PageMetaDescription;
        var favicon = signInData.Favicon;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-content" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_react_helmet__["Helmet"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta", { name: "description", content: pageDescription }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title", null, title),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("link", { href: favicon, rel: "shortcut icon" }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("script", { src: clientConfig.clientConfig.paymentCaptureUrl, type: "text/javascript" }),
                clientConfig.clientConfig.pingdomUrl && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("script", { src: clientConfig.clientConfig.pingdomUrl, async: true }))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["BrowserRouter"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_router_ga___default.a, { id: primaryAnalyticsId },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#main", className: "top-skip-to-main" }, "Skip to main content"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__src_app_header_Header__["a" /* default */], null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-body" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Switch"], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { exact: true, path: "/", component: HomeComponent }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { path: "/login", component: LoginComponent }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { path: "/accounts", component: Protected }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { path: "/auth/success", component: __WEBPACK_IMPORTED_MODULE_22__src_app_login_components_Cognito__["c" /* CognitoSuccessComponent */] }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { path: "/auth/login", component: __WEBPACK_IMPORTED_MODULE_23__src_app_login_components_Mylo__["a" /* MyloSuccess */] }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { path: "/mylo/continue", component: __WEBPACK_IMPORTED_MODULE_24__src_app_login_components_MyloContinue__["a" /* MyloContinue */] }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { path: "/auth/logout", component: __WEBPACK_IMPORTED_MODULE_22__src_app_login_components_Cognito__["d" /* MyloLogoutComponent */] }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { path: "/logout", component: __WEBPACK_IMPORTED_MODULE_22__src_app_login_components_Cognito__["b" /* CognitoLogoutComponent */] }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { path: "/loginCS", component: LoginCustomerServiceComponent }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["Route"], { component: __WEBPACK_IMPORTED_MODULE_17__src_app_main_InvalidRoute__["a" /* InvalidRoute */] })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_notification_system_redux___default.a, { notifications: notifications })),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__src_app_footer_Footer__["a" /* default */], null)))));
    };
    MainForm.prototype.renderErrorView = function (errorMessage) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__src_app_main_ErrorView__["a" /* ErrorView */], { errorMessage: errorMessage });
    };
    MainForm.prototype.renderLoadingView = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__src_app_global_components_Loading__["a" /* LoadingView */], { loadingText: "Loading..." });
    };
    MainForm.prototype.render = function () {
        var _a = this.props.clientConfig, configFailure = _a.configFailure, errorMessage = _a.errorMessage, configLoaded = _a.configLoaded;
        var viewToShow;
        if (configLoaded) {
            viewToShow = this.renderConfigLoadedView();
        }
        else if (configFailure) {
            viewToShow = this.renderErrorView(errorMessage);
        }
        else {
            viewToShow = this.renderLoadingView();
        }
        return viewToShow;
    };
    return MainForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state) { return ({
    clientConfig: state.clientConfig,
    adminConfig: state.adminConfig,
    notifications: state.notifications,
}); };
var Main = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, {
    getClientConfig: __WEBPACK_IMPORTED_MODULE_6__src_app_main_actions__["e" /* actionCreators */].getClientConfig,
})(MainForm);


/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1383);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(71)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./main.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./main.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(70)(false);
// imports


// module
exports.push([module.i, ".loading-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 20vh; }\n\n.authenticating-spinner {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0px;\n  bottom: 0px;\n  width: 100%;\n  height: 100%; }\n\n.main-nav > div {\n  margin-left: 1rem; }\n\n.main-body {\n  position: relative; }\n\n@media (min-width: 48em) {\n  .main-header {\n    height: auto;\n    border-bottom: 1px solid #c2c2c2; }\n  .main-body {\n    min-height: calc(100vh - 178px); }\n  .main-footer {\n    height: 75px; } }\n\n@media (max-width: 48em) {\n  .main-body {\n    min-height: calc(100vh - 100px); } }\n\n.error-page-view .header {\n  height: 100px;\n  background-color: #d6d6d6; }\n\n.error-page-view .error-body {\n  height: calc(100vh - 150px); }\n\n.error-page-view .footer {\n  height: 50px;\n  background-color: #d6d6d6; }\n\n.page-intro-ct {\n  margin-bottom: 0.4rem;\n  margin-top: 0.6rem; }\n  .page-intro-ct .page-intro-label {\n    font-size: 1.6rem;\n    font-weight: bold; }\n  .page-intro-ct .page-intro-desc {\n    padding-top: 1rem;\n    font-size: 1rem; }\n\n@media (max-width: 48em) {\n  .page-intro-ct {\n    margin-bottom: 0.4rem; }\n    .page-intro-ct .page-intro-label {\n      font-size: 1.2rem; }\n    .page-intro-ct .page-intro-desc {\n      padding-top: 1rem;\n      font-size: 1rem; } }\n\n.rc-menu {\n  font-size: 1rem;\n  background: white;\n  border: 0 !important; }\n", ""]);

// exports


/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIATE_OMS_LOOKUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OMS_LOOKUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OMS_LOOKUP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OMS_IS_AUTHENTICATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CREDENTIALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_store__ = __webpack_require__(51);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var INITIATE_OMS_LOOKUP = 'INITIATE_OMS_LOOKUP';
var OMS_LOOKUP_SUCCESS = 'OMS_LOOKUP_SUCCESS';
var OMS_LOOKUP_FAILURE = 'OMS_LOOKUP_FAILURE';
var OMS_IS_AUTHENTICATING = 'OMS_IS_AUTHENTICATING';
var SET_CREDENTIALS = 'SET_CREDENTIALS';


var notificationOMSLookupError = {
    title: 'Account Lookup Error',
    message: 'Sorry, we could not find your account',
    position: 'bl',
    autoDismiss: 0,
};
var actionCreators = {
    initiateOmsLookup: function (accountNumber, postalCode, token, idProvider, productExcludes, resinAccounts, idpAccountInfo) { return ({
        type: INITIATE_OMS_LOOKUP,
        payload: {
            accountNumber: accountNumber,
            postalCode: postalCode,
            token: token,
            provider: idProvider,
            productExcludes: productExcludes,
            resinAccounts: resinAccounts,
            idpAccountInfo: idpAccountInfo,
        },
    }); },
    omsLookupSuccess: function (gcResponse) { return ({
        type: OMS_LOOKUP_SUCCESS,
        payload: gcResponse
    }); },
    omsLookupFailure: function (error) { return ({
        type: OMS_LOOKUP_FAILURE,
        payload: error,
    }); },
    omsLookupFailureNotification: function (message) {
        var messageObject = message
            ? __assign({}, notificationOMSLookupError, { message: message }) : notificationOMSLookupError;
        __WEBPACK_IMPORTED_MODULE_1__src_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__["error"])(messageObject));
    },
    omsLookupClearNotifications: function () {
        __WEBPACK_IMPORTED_MODULE_1__src_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__["error"])(notificationOMSLookupError));
    },
    omsSetCredentials: function (credentials) { return ({
        type: SET_CREDENTIALS,
        payload: credentials,
    }); },
    setAuthenticating: function (payload) { return ({
        type: OMS_IS_AUTHENTICATING,
        payload: payload,
    }); },
};


/***/ }),

/***/ 1401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ErrorView = function (props) {
    var errorMessage = props.errorMessage;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-page-view" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header" }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jumbotron text-center pt-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "fa fa-exclamation-triangle" }),
                    " Oops. There appears to be a server error."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "lead" },
                    "The web server is returning the error:",
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null, errorMessage && errorMessage.message
                        ? errorMessage.message
                        : 'Unknown'),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    " The request url which caused the error is :",
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("em", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { id: "display-domain" },
                            ' ',
                            errorMessage && errorMessage.request
                                ? errorMessage.request.url
                                : 'Unknown')),
                    "."),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "javascript:document.location.reload(true);", className: "btn btn-default btn-lg text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "green" }, "Try This Page Again")))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "body-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "row" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "What happened?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "lead" }, "This error status implies there is a problem with the web server's software, or you may not have permission to access this file or page.")),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "col-md-6" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h2", null, "What can I do?"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "lead" }, "If you're a site visitor"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null,
                            ' ',
                            "Nothing you can do at the moment. If you need immediate assistance, please send us an email instead. We apologize for any inconvenience."),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", { className: "lead" }, "If you're the site owner"),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "This error can only be fixed by server admins, please contact your website administrator.")))))));
};


/***/ }),

/***/ 1402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(45);


var Home = function () { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"], { to: "/accounts/summary" })); };
/* harmony default export */ __webpack_exports__["a"] = (Home);


/***/ }),

/***/ 1410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountNumberPostalCodeLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_accountpostalcode_actions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__login_scss__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__login_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__login_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_google_recaptcha__ = __webpack_require__(229);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var imagePath = '/images';



function createMarkup(nodeItem) {
    return { __html: nodeItem };
}
var PopoverEl = function (_a) {
    var toggle = _a.toggle, popoverOpen = _a.popoverOpen;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "account-help" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { onClick: toggle, id: 'Popover-AccountHelp', className: "pointer ml-2 icon-blue fa fa-question-circle fa-1x" })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Popover */], { placement: "top", isOpen: popoverOpen, target: 'Popover-AccountHelp', toggle: toggle, className: "account-number-help" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["m" /* PopoverBody */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { className: "carousel-image", src: imagePath + "/magazine-label.png", alt: " " }))))));
};
var AccountNumberPostalCodeLoginForm = /** @class */ (function (_super) {
    __extends(AccountNumberPostalCodeLoginForm, _super);
    function AccountNumberPostalCodeLoginForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            disableSubmitBtn: true,
            popoverOpen: false,
            emailOptInChecked: true,
        };
        _this.recaptchaSuccess = function (value) {
            // If no value, the reCaptcha has timed out.  Disable the submit button until user rechecks reCaptcha.
            _this.setState({
                disableSubmitBtn: value ? false : true,
            });
        };
        _this.handleOptInClick = function (evt) {
            var isChecked = evt.currentTarget.checked;
            _this.setState({
                emailOptInChecked: isChecked === true,
            });
        };
        return _this;
    }
    AccountNumberPostalCodeLoginForm.prototype.toggle = function () {
        this.setState({
            popoverOpen: !this.state.popoverOpen,
        });
    };
    AccountNumberPostalCodeLoginForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, handleSubmit = _a.handleSubmit, onSubmitHandler = _a.onSubmitHandler, signInData = _a.signInData;
        var formatLabels = function (messId, messDisc, messDefault) {
            var labelText = _this.props.intl.formatMessage({
                id: messId,
                description: messDisc,
                defaultMessage: messDefault,
            });
            return labelText;
        };
        var ANLabelText = formatLabels('app.acntnum', 'account number', 'Account Number*');
        var PCLabelText = formatLabels('app.postal', 'Postal Code', 'ZIP/Postal Code*');
        var OptLabel = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: createMarkup(signInData.EmailOptInText) });
        var disableSubmitBtn = false;
        if (signInData.RecaptchaEnabled) {
            // recaptcha enabled.  Let local state determine if we show the button or not.
            disableSubmitBtn = this.state.disableSubmitBtn;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, signInData.AccountNumberPostalCodeEnabled && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["i" /* Form */], { inline: true, id: "login-form-acct", onSubmit: handleSubmit(onSubmitHandler) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* CardBody */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { className: "mb-2", xs: 12, sm: 12, md: 12, lg: 6 },
                            signInData.FindAccountHelpImage && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PopoverEl, { toggle: function () { return _this.toggle(); }, popoverOpen: this.state.popoverOpen })),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { className: "weak-login-input-field", id: "accountNumber", name: "accountNumber", validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["f" /* required */], __WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["c" /* isNumber */], __WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["e" /* noSpaces */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text", label: ANLabelText })),
                        signInData.FindAccountHelpImage ?
                            (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { className: "account-help-postalcode", xs: 12, sm: 12, md: 12, lg: 6 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "loginPostCode", label: PCLabelText, className: "weak-login-input-field", name: "postalCode", validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["f" /* required */], __WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["e" /* noSpaces */], __WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["a" /* alphaNumeric */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" })))
                            :
                                (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12, lg: 6 },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "loginPostCode", label: PCLabelText, className: "weak-login-input-field", name: "postalCode", validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["f" /* required */], __WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["e" /* noSpaces */], __WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["a" /* alphaNumeric */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" })))))),
            signInData.FindAccountHelpImage && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], null))),
            signInData.CaptureEmail && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* CardBody */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12, lg: 6, className: "weak-login-input-field" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { name: "captureEmail", id: 'captureEmail', className: "capture-email", type: "text", label: 'Email ', validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["b" /* email */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */] }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12, lg: 12, className: "checkbox-col" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { name: "emailOptIn", id: "emailOptIn", className: "checkbox-label", component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["a" /* Checkbox */], checked: this.state.emailOptInChecked, onChange: this.handleOptInClick, label: OptLabel })))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* CardBody */], null,
                    signInData.RecaptchaEnabled &&
                        (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_google_recaptcha__["a" /* default */], { className: "flexContainer mt-3 mb-2 recaptcha", sitekey: "6LcQ14YUAAAAAKsWbAnGKL3Dh7BNEyIbMKUeplOV", onChange: this.recaptchaSuccess })))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-primary", type: "submit", disabled: disableSubmitBtn },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], { id: "app.btnfindacnt", description: "Find account button", defaultMessage: 'Find Your Account' }))))))))));
    };
    return AccountNumberPostalCodeLoginForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var form = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["f" /* reduxForm */])({
    form: 'login-form-acct',
})(AccountNumberPostalCodeLoginForm);
var mapStateToProps = function (state) {
    return {
        initialValues: {
            'emailOptIn': true,
            'captureEmail': '',
            'productExcludes': Object(__WEBPACK_IMPORTED_MODULE_7__src_app_accounts_selectors__["m" /* getProdIdsForGlobalCodeFromAdminConfig */])(state),
        }
    };
};
var AccountNumberPostalCodeLogin = Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, {
    onSubmitHandler: __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_accountpostalcode_actions__["b" /* actionCreators */].accountPostalCodeLogin,
})(form));


/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(70)(false);
// imports


// module
exports.push([module.i, ".form-control + .error {\n  color: #e02619;\n  font-size: 0.625rem;\n  display: flex;\n  margin-top: 0.25rem;\n  -webkit-box-align: center;\n  align-items: center;\n  letter-spacing: 0.02em; }\n\n.error > svg {\n  margin: 0px 0.25rem; }\n\n.select-ct {\n  width: 100%;\n  position: relative; }\n  .select-ct.has-error {\n    height: 4.2rem; }\n  .select-ct .error {\n    position: absolute;\n    bottom: 10px;\n    color: #e02619;\n    font-size: 0.625rem;\n    display: flex;\n    margin-top: 0.25rem;\n    -webkit-box-align: center;\n    align-items: center;\n    letter-spacing: 0.02em; }\n\n.Select-clear {\n  color: #333333; }\n\n.radio-buttons .horizontal {\n  display: flex; }\n  .radio-buttons .horizontal .radio-input {\n    margin-right: 12px; }\n\n.radio-buttons .radio-input {\n  display: flex;\n  align-items: baseline; }\n  .radio-buttons .radio-input input {\n    cursor: pointer; }\n  .radio-buttons .radio-input label {\n    margin-left: 10px;\n    cursor: pointer; }\n", ""]);

// exports


/***/ }),

/***/ 1412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Checkbox = function (_a) {
    var label = _a.label, input = _a.input, id = _a.id, checked = _a.checked, _b = _a.meta, touched = _b.touched, error = _b.error;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "form-check-label", htmlFor: id },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({}, input, { checked: checked ? checked : input.checked, className: "form-check-input", type: "checkbox" })),
            label)));
};
/* unused harmony default export */ var _unused_webpack_default_export = (Checkbox);


/***/ }),

/***/ 1413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioButtons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(61);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var RadioButtons = function (_a) {
    var name = _a.name, options = _a.options, className = _a.className;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "radio-buttons" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_redux_form__["a" /* Field */], { component: function (_a) {
                var input = _a.input, _b = _a.meta, touched = _b.touched, error = _b.error;
                return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: className },
                    options.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: option.id, className: "radio-input " + (option.value === input.value ? 'optionSelected' : '') },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({ id: option.id, type: "radio" }, input, { value: option.value, checked: option.value === input.value })),
                        !option.image && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { htmlFor: option.id },
                            option.label,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                            option.label2),
                        option.image && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { htmlFor: option.id },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img", { src: option.image, alt: option.label }),
                            " ",
                            option.label,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br", null),
                            option.label2))); }),
                    touched && error && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "error" }, error)));
            }, name: name, options: options })));
};


/***/ }),

/***/ 1414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_elements_scss__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_elements_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_elements_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(35);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var select = function (_a) {
    var options = _a.options, labelKey = _a.labelKey, valueKey = _a.valueKey, label = _a.label, input = _a.input, id = _a.id, simpleValue = _a.simpleValue, _b = _a.meta, touched = _b.touched, error = _b.error, initial = _b.initial;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "TextField__FieldWrapper" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "select-ct " + (touched && error && 'has-error') },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], __assign({}, input, { options: options, id: id, "aria-role": "combobox", "aria-owns": id, placeholder: '', valueKey: valueKey, labelKey: labelKey, resetValue: initial, onBlur: function () { return input.onBlur(input.value); }, simpleValue: simpleValue === undefined ? true : simpleValue })),
            label !== '' && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["k" /* Label */], { className: "Label__FloatedLabel", htmlFor: id }, label)),
        touched && error &&
            // tslint:disable-next-line:max-line-length
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "FieldError__ErrorContainer" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", { cx: "12", cy: "12", r: "10" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line", { x1: "12", y1: "16", x2: "12", y2: "16" })),
                " ",
                error)));
};
var SimpleSelect = select;


/***/ }),

/***/ 1416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimplerSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_elements_scss__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_elements_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__form_elements_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(35);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var select = function (_a) {
    var options = _a.options, labelKey = _a.labelKey, valueKey = _a.valueKey, label = _a.label, input = _a.input, id = _a.id, simpleValue = _a.simpleValue, _b = _a.meta, touched = _b.touched, error = _b.error, initial = _b.initial;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "SelectField__FieldWrapper" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "select-ct " + (touched && error && 'has-error') },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], __assign({}, input, { options: options, id: id, "aria-role": "combobox", "aria-owns": id, placeholder: '', valueKey: valueKey, labelKey: labelKey, resetValue: initial, onBlur: function () { return input.onBlur(input.value); }, simpleValue: simpleValue === undefined ? true : simpleValue, clearable: false, searchable: false })),
            label !== '' && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["k" /* Label */], { className: "Label__FloatedLabel", htmlFor: id }, label)),
        touched && error &&
            // tslint:disable-next-line:max-line-length
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "FieldError__ErrorContainer" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", { cx: "12", cy: "12", r: "10" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line", { x1: "12", y1: "16", x2: "12", y2: "16" })),
                " ",
                error)));
};
var SimplerSelect = select;


/***/ }),

/***/ 1417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(35);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var TextInput = function (_a) {
    var label = _a.label, name = _a.name, input = _a.input, type = _a.type, placeholder = _a.placeholder, id = _a.id, _b = _a.meta, touched = _b.touched, error = _b.error;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "TextField__FieldWrapper" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "TextField__LabelWrapper " + (touched && error && 'is-invalid') + " " + (input.value !== '' ? 'selected' : '') },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({ className: "TextInput " + (touched && error && 'is-invalid'), placeholder: placeholder || '', type: type }, input, { id: id })),
            label !== '' && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["k" /* Label */], { className: "Label__FloatedLabel", htmlFor: id }, label)),
        touched && error &&
            // tslint:disable-next-line:max-line-length
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "FieldError__ErrorContainer" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", { cx: "12", cy: "12", r: "10" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line", { x1: "12", y1: "16", x2: "12", y2: "16" })),
                " ",
                error)));
};
/* unused harmony default export */ var _unused_webpack_default_export = (TextInput);


/***/ }),

/***/ 1418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckboxGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Error = function (_a) {
    var _b = _a.meta, touched = _b.touched, error = _b.error;
    return (touched && error ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, error) : null);
};
var CheckboxGroup = function (_a) {
    var name = _a.name, options = _a.options, input = _a.input, meta = _a.meta;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        options.map(function (option, index) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "form-check", key: index },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("label", { className: "form-check-label" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", { type: "checkbox", className: "form-check-input", name: index + '-checkgroup', value: option.name, checked: input.value.indexOf(option.name) !== -1, onChange: function (event) {
                        var newValue = input.value === '' ? [] : input.value.slice();
                        if (event.target.checked) {
                            newValue.push(option.name);
                        }
                        else {
                            newValue.splice(newValue.indexOf(option.name), 1);
                        }
                        return input.onChange(newValue);
                    } }),
                option.name))); }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Error, { meta: meta })));
};


/***/ }),

/***/ 1419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReadOnlyField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var ReadOnlyField = function (_a) {
    var label = _a.label, name = _a.name, input = _a.input, type = _a.type, id = _a.id, _b = _a.meta, touched = _b.touched, error = _b.error;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("input", __assign({ readOnly: true, className: "readonly-input no-border", type: "text" }, input)));
};


/***/ }),

/***/ 1420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(35);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var TextArea = function (_a) {
    var label = _a.label, name = _a.name, input = _a.input, type = _a.type, placeholder = _a.placeholder, id = _a.id, _b = _a.meta, touched = _b.touched, error = _b.error;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["j" /* FormGroup */], null,
        label !== '' && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["k" /* Label */], { htmlFor: id }, label),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", __assign({ id: id, className: "form-control " + (touched && error && 'is-invalid'), placeholder: placeholder || '', rows: 4 }, input)),
        touched && error &&
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "error" }, error)));
};
/* unused harmony default export */ var _unused_webpack_default_export = (TextArea);


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(70)(false);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n:focus {\n  outline: none; }\n\n.week-login-card {\n  margin-bottom: 1rem;\n  width: 100%;\n  padding: 1rem 0 0; }\n  .week-login-card input[type='text'] {\n    width: 100%; }\n  .week-login-card .card {\n    border: none;\n    width: 100%; }\n    .week-login-card .card .card-body {\n      padding: 0; }\n  .week-login-card .btn-primary {\n    margin-top: .5rem; }\n\n.social-btn {\n  background-repeat: no-repeat;\n  background-size: contain; }\n\n.google-button {\n  width: 185px;\n  height: 40px;\n  border: none !important;\n  margin-bottom: 1rem;\n  margin-right: 1rem;\n  background-image: url(/images/siwg_185x40.png); }\n\n.facebook-button {\n  width: 236px;\n  height: 40px;\n  border: none !important;\n  margin-bottom: 1rem;\n  margin-right: 1rem;\n  background-image: url(/images/liwfb_236x40.png); }\n\n.amazon-button {\n  width: 196px;\n  height: 40px;\n  border: none !important;\n  margin-bottom: 1rem;\n  margin-right: 1rem;\n  background-image: url(/images/btnLWA_gold_156x32.png);\n  background-image: url(https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64.png); }\n\n.google-button:focus,\n.facebook-button:focus,\n.amazon-button:focus {\n  box-shadow: 0 0 2pt 2pt #769beb; }\n\n.form-inline label {\n  justify-content: left; }\n\n.checkbox-col {\n  display: flex;\n  justify-content: flex-start;\n  margin-top: .5rem; }\n\n.checkbox-label {\n  margin-top: auto; }\n\nhr {\n  display: block;\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n  margin-left: auto;\n  margin-right: auto;\n  border-style: inset;\n  border-width: 1px; }\n\n.tester {\n  height: 400px;\n  width: 400px;\n  background: url(\"/images/beach.jpg\"); }\n\n.purgatory-view {\n  margin-top: 1.5rem; }\n  .purgatory-view h5 {\n    color: #e02619; }\n\ndiv.flexContainer {\n  flex-direction: row; }\n\n.login-input-label {\n  font-size: 0.9rem;\n  text-align: center;\n  padding: 0;\n  position: relative;\n  display: table-cell;\n  margin: 0;\n  vertical-align: middle; }\n\n.login-selection-tabs {\n  display: table;\n  margin: 0 0 1.5rem;\n  width: 100%; }\n\n.login-input-radio {\n  width: 0;\n  height: 0;\n  opacity: 0; }\n\n.sign-up {\n  margin: 1rem 0; }\n\n.registered-signin,\n.social-signin {\n  margin-top: 1.5rem; }\n\n.livechat-card {\n  position: absolute;\n  right: 11px;\n  bottom: 0px;\n  border-top-left-radius: 0.6rem;\n  border-top-right-radius: 0.6rem;\n  border-bottom: 0px;\n  border-top: 1px solid #8bcfea;\n  border-right: 1px solid #8bcfea;\n  border-left: 1px solid #8bcfea;\n  margin: 0;\n  background: #fff;\n  z-index: 2;\n  cursor: pointer; }\n\n.account-help {\n  font-size: 1.1rem !important;\n  position: absolute;\n  top: 8px;\n  right: 25px;\n  z-index: 10; }\n\nlabel > span > p {\n  margin: 0;\n  display: inline; }\n\n.week-login-card  {\n  margin-bottom: 1rem;\n  width: 100%;\n  padding: 1rem 1rem 0; }\n\n.login-selection-tabs  {\n  display: table;\n  margin: 0 0 1.5rem;\n  width: 100%; }\n\n.login-input-label  {\n  font-size: 0.9rem;\n  text-align: center;\n  padding: 0;\n  position: relative;\n  display: table-cell;\n  margin: 0;\n  cursor: pointer;\n  vertical-align: middle; }\n\n.login-input-label > .login-input-tab {\n  position: relative;\n  left: 0;\n  width: 100%;\n  background: #f9f9f9;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  padding: .5rem 1rem;\n  cursor: pointer;\n  display: inline-block;\n  border: 1px solid #e5e5e5;\n  border-top: 4px solid transparent;\n  border-left: 0;\n  z-index: 5;\n  color: #565656;\n  -webkit-transition: color .3s ease-in-out, background-color .3s ease-in-out;\n  transition: all .3s ease-in-out; }\n  .login-input-label > .login-input-tab:hover {\n    color: #000; }\n\n.login-input-label > .login-input-radio:checked + .login-input-tab {\n  background: white;\n  border: 0;\n  border-bottom: 1px solid transparent;\n  border-top: 4px solid #1d35f8;\n  color: #000; }\n\ninput.login-input-radio  {\n  width: 0;\n  height: 0;\n  opacity: 0; }\n\n@media screen and (-ms-high-contrast: none) {\n  .recaptcha {\n    margin-top: .5rem; } }\n\n@supports (-ms-ime-align: auto) {\n  .recaptcha {\n    margin-top: .5rem; } }\n\n.popover img {\n  width: 100%;\n  max-width: 100%; }\n\n.checkbox-label p {\n  margin: 0; }\n\n@media (max-width: 48em) {\n  .form-inline .checkbox-col .form-check {\n    width: auto;\n    padding-left: 0; }\n    .form-inline .checkbox-col .form-check .form-check-label {\n      align-items: flex-start; }\n    .form-inline .checkbox-col .form-check .form-check-input {\n      position: initial;\n      margin: 5px 5px 0 0; } }\n\n@media (max-width: 30em) {\n  .login-input-tab {\n    min-height: 63px; }\n  div#main {\n    padding-bottom: 35px; } }\n\n#LoginViewSocial {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  text-align: center; }\n\n#LoginViewSocial:before,\n#LoginViewSocial:after {\n  content: '';\n  border-top: 1px solid #cdcdcd;\n  margin: 0 10px 0 0;\n  flex: 1 0 10px; }\n\n#LoginViewSocial:after {\n  margin: 0 0 0 10px; }\n\n.login-view {\n  color: #4a4a4a; }\n\n.recaptcha > div > div {\n  margin: 0 auto; }\n\n.login-selection-type {\n  margin: 0 0 1.5rem; }\n\n.login-selection-type .select-ct {\n  max-width: 260px;\n  margin: 0 auto; }\n\n.login-selection-type .Select-control {\n  height: auto;\n  border: 0 !important;\n  border-bottom: 1px solid #000 !important;\n  border-radius: 0 !important; }\n\n.login-selection-type .Select-arrow {\n  border-color: #000 transparent transparent; }\n\n.login-selection-type .Select.has-value.is-focused .Select-control,\n.login-selection-type .Select.is-focused .Select-control {\n  border: 0 !important;\n  border-bottom: 1px solid #000 !important;\n  border-radius: 0 !important; }\n\n.login-selection-type .Select .Select-option.is-selected,\n.login-selection-type .Select.is-focused.has-value.is-clearable.Select--single > .Select-control .Select-value {\n  border: 0 !important; }\n\n.login-selection-type .Select.is-focused:not(is-open) > .Select-control {\n  box-shadow: none !important; }\n\n.login-selection-type .Select-menu-outer {\n  top: 0;\n  z-index: 190; }\n\n.agecheck-form {\n  max-width: 553px;\n  margin: auto; }\n\n@media (max-width: 30em) {\n  .agecheck-form {\n    padding: .5rem; } }\n", ""]);

// exports


/***/ }),

/***/ 1425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EmailPostalCodeLoginForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailPostalCodeLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_emailpostalcode_actions__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_global_field_validations__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_login_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_reactstrap_lib_CardBody__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_reactstrap_lib_CardBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_reactstrap_lib_CardBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_google_recaptcha__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__ = __webpack_require__(25);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var EmailPostalCodeLoginForm = /** @class */ (function (_super) {
    __extends(EmailPostalCodeLoginForm, _super);
    function EmailPostalCodeLoginForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            disableSubmitBtn: true,
        };
        _this.recaptchaSuccess = function (value) {
            // If no value, the reCaptcha has timed out.  Disable the submit button until user rechecks reCaptcha.
            _this.setState({
                disableSubmitBtn: value ? false : true,
            });
        };
        _this.formatLabels = function (messageId, descriptionm, defaultm, context) {
            return _this.props.intl.formatMessage({
                id: messageId,
                description: descriptionm,
                defaultMessage: defaultm,
            });
        };
        // tslint:disable-next-line:member-ordering
        _this.emailAddLabel = _this.formatLabels('app.emailadd', 'Email address label', 'Email*', _this.context);
        // tslint:disable-next-line:member-ordering
        _this.postLabel = _this.formatLabels('app.postal', 'Postal code label', 'ZIP/Postal Code*', _this.context);
        return _this;
    }
    EmailPostalCodeLoginForm.prototype.componentDidMount = function () {
        this.initializeForm();
    };
    EmailPostalCodeLoginForm.prototype.initializeForm = function () {
        var _a = this.props, socialEmail = _a.socialEmail, productExcludes = _a.productExcludes;
        if (socialEmail) {
            this.props.initialize({ email: socialEmail, productExcludes: productExcludes });
        }
    };
    EmailPostalCodeLoginForm.prototype.render = function () {
        var _a = this.props, handleSubmit = _a.handleSubmit, onSubmitHandler = _a.onSubmitHandler, signInData = _a.signInData;
        var disableSubmitBtn = false;
        if (signInData.RecaptchaEnabled) {
            // recaptcha enabled.  Let local state determine if we show the button or not.
            disableSubmitBtn = this.state.disableSubmitBtn;
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, this.props.signInData.EmailPostalCodeEnabled && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["i" /* Form */], { inline: true, id: "login-form", onSubmit: handleSubmit(onSubmitHandler) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_reactstrap_lib_CardBody___default.a, null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { className: "mb-2", xs: 12, sm: 12, md: 12, lg: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "login-email-add", label: this.emailAddLabel, className: "weak-login-input-field", name: "email", validate: [__WEBPACK_IMPORTED_MODULE_7__src_app_global_field_validations__["f" /* required */], __WEBPACK_IMPORTED_MODULE_7__src_app_global_field_validations__["b" /* email */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12, lg: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "login-pc-b", label: this.postLabel, className: "weak-login-input-field", name: "postalCode", validate: [__WEBPACK_IMPORTED_MODULE_7__src_app_global_field_validations__["f" /* required */], __WEBPACK_IMPORTED_MODULE_7__src_app_global_field_validations__["e" /* noSpaces */], __WEBPACK_IMPORTED_MODULE_7__src_app_global_field_validations__["a" /* alphaNumeric */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_reactstrap_lib_CardBody___default.a, null,
                    signInData.RecaptchaEnabled &&
                        (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_google_recaptcha__["a" /* default */], { className: "flexContainer mt-3 mb-2 recaptcha", sitekey: "6LcQ14YUAAAAAKsWbAnGKL3Dh7BNEyIbMKUeplOV", onChange: this.recaptchaSuccess })))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-primary", type: "submit", disabled: disableSubmitBtn },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], { id: "app.btnfindacnt", defaultMessage: 'Find Your Account' }))))))))));
    };
    return EmailPostalCodeLoginForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var form = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["f" /* reduxForm */])({
    form: 'login-form-email',
})(EmailPostalCodeLoginForm);
var mapStateToProps = function (state) { return ({
    socialEmail: Object(__WEBPACK_IMPORTED_MODULE_8__src_app_login_selectors__["b" /* getSocialEmail */])(state),
    productExcludes: Object(__WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__["m" /* getProdIdsForGlobalCodeFromAdminConfig */])(state),
    initialValues: {
        'productExcludes': Object(__WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__["m" /* getProdIdsForGlobalCodeFromAdminConfig */])(state),
    }
}); };
var EmailPostalCodeLogin = Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, {
    onSubmitHandler: __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_emailpostalcode_actions__["b" /* actionCreators */].emailPostalCodeLogin,
})(form));


/***/ }),

/***/ 1427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NameAddressLoginForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NameAddressLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_nameaddress_actions__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_global_constants__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__login_scss__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__login_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__login_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_google_recaptcha__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(6);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













function createMarkup(nodeItem) {
    return { __html: nodeItem };
}
var validate = function (values) {
    var errors = {};
    if (values.country === 'US') {
        if (!values.state) {
            errors.state = 'Required';
        }
        if (!values.postalCode) {
            errors.postalCode = 'Required';
        }
        if (isNaN(Number(values.postalCode))) {
            errors.postalCode = 'Must be a number';
        }
        if (values.postalCode && values.postalCode.length !== 5) {
            errors.postalCode = 'Must be 5 characters';
        }
    }
    else if (values.country === 'CA') {
        if (!values.state) {
            errors.state = 'Required';
        }
        if (!values.postalCode) {
            errors.postalCode = 'Required';
        }
        if (values.postalCode && values.postalCode.length !== 6) {
            errors.postalCode = 'Must be 6 characters';
        }
        if (!/[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d/.test(values.postalCode)) {
            errors.postalCode = 'Invalid Postal Code';
        }
    }
    else {
        var country = __WEBPACK_IMPORTED_MODULE_7__src_app_global_constants__["c" /* countriesWithNoPostalCodes */].find(function (item) { return item.value === values.country; });
        if (!country && !values.postalCode) {
            errors.postalCode = 'Required';
        }
    }
    return errors;
};
var NameAddressLoginForm = /** @class */ (function (_super) {
    __extends(NameAddressLoginForm, _super);
    function NameAddressLoginForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            disableSubmitBtn: true,
            emailOptInChecked: true,
        };
        _this.recaptchaSuccess = function (value) {
            // If no value, the reCaptcha has timed out.  Disable the submit button until user rechecks reCaptcha.
            _this.setState({
                disableSubmitBtn: value ? false : true,
            });
        };
        _this.handleOptInClick = function (evt) {
            var isChecked = evt.currentTarget.checked;
            _this.setState({
                emailOptInChecked: isChecked === true,
            });
        };
        _this.handleCountryChange = function (event) {
            if (event.value !== 'US' && event.value !== 'CA') {
                _this.props.removeField('login-form-addr', 'state', '');
            }
            return true;
        };
        _this.formatLabels = function (messId, messDisc, messDefault) {
            var labelText = _this.props.intl.formatMessage({
                id: messId,
                description: messDisc,
                defaultMessage: messDefault,
            });
            return labelText;
        };
        _this.handleCountryChange = _this.handleCountryChange.bind(_this);
        return _this;
    }
    NameAddressLoginForm.prototype.render = function () {
        var _a = this.props, handleSubmit = _a.handleSubmit, onSubmitHandler = _a.onSubmitHandler, signInData = _a.signInData, formCountry = _a.formCountry;
        var fName = this.formatLabels('app.firstname', 'First name field', 'First Name *');
        var lName = this.formatLabels('app.lastname', 'Last name field', 'Last Name *');
        var address1 = this.formatLabels('app.address1', 'Address 1 field', 'Address 1 *');
        var address2 = this.formatLabels('app.address2', 'Address 2 field', 'Address 2');
        var lcity = this.formatLabels('app.city', 'City field', 'City *');
        var lstate = this.formatLabels('app.state', 'State field', 'State *');
        var lprovince = this.formatLabels('app.prov', 'Province field', 'Province *');
        var lstateprovince = this.formatLabels('app.stprov', 'State/Province field', 'State/Province *');
        var lzip = this.formatLabels('app.zip', 'zip postal label', 'ZIP/Postal Code *');
        var lcountry = this.formatLabels('app.country', 'Country label', 'Country *');
        var OptLabel = __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: createMarkup(signInData.EmailOptInText) });
        var disableSubmitBtn = false;
        if (signInData.RecaptchaEnabled) {
            // recaptcha enabled.  Let local state determine if we show the button or not.
            disableSubmitBtn = this.state.disableSubmitBtn;
        }
        var stateOptions = [{}];
        if (formCountry === 'CA') {
            stateOptions = __WEBPACK_IMPORTED_MODULE_7__src_app_global_constants__["a" /* canadianProvinces */];
        }
        else {
            stateOptions = __WEBPACK_IMPORTED_MODULE_7__src_app_global_constants__["d" /* usStates */];
        }
        var stateLabel = (formCountry === undefined ? lstateprovince : (formCountry === 'US' ? lstate : lprovince));
        var displayStateProvince = (formCountry === 'US' || formCountry === 'CA' || formCountry === undefined);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, signInData.NameAddressEnabled && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["i" /* Form */], { inline: true, id: "login-form", onSubmit: handleSubmit(onSubmitHandler) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* CardBody */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "login-first-name", label: fName, name: "firstName", validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["f" /* required */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "login-last-name", label: lName, name: "lastName", validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["f" /* required */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "address1-field", label: address1, name: "address1", validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["f" /* required */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "address2-field", label: address2, name: "address2", component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "city-field", label: lcity, name: "city", validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["f" /* required */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" })),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { className: "mb-2", xs: 12, sm: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "country-field", label: lcountry, name: "country", validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["f" /* required */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["c" /* SimpleSelect */], options: __WEBPACK_IMPORTED_MODULE_7__src_app_global_constants__["b" /* countries */], onChange: this.handleCountryChange }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        displayStateProvince && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "state-field", label: stateLabel, name: "state", component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["c" /* SimpleSelect */], options: stateOptions }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { id: "zip-field", label: lzip, name: "postalCode", component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }))))),
            signInData.CaptureEmail && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* CardBody */], null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12, lg: 6, className: "weak-login-input-field" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { name: "captureEmail", id: 'captureEmail', className: "capture-email", type: "text", label: 'Email ', validate: [__WEBPACK_IMPORTED_MODULE_8__src_app_global_field_validations__["b" /* email */]], component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["f" /* TextInput */] }))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12, lg: 12, className: "checkbox-col" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */], { name: "emailOptIn", id: 'emailOptIn', className: "checkbox-label", component: __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements__["a" /* Checkbox */], checked: this.state.emailOptInChecked, onChange: this.handleOptInClick, label: OptLabel })))))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["b" /* Card */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["c" /* CardBody */], null,
                    signInData.RecaptchaEnabled &&
                        (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], null,
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_react_google_recaptcha__["a" /* default */], { className: "flexContainer mt-3 mb-2 recaptcha", sitekey: "6LcQ14YUAAAAAKsWbAnGKL3Dh7BNEyIbMKUeplOV", onChange: this.recaptchaSuccess })))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], null,
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-primary", type: "submit", disabled: disableSubmitBtn },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], { id: "app.btnfindacnt", description: "find account button", defaultMessage: 'Find Your Account' }))))))))));
    };
    return NameAddressLoginForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var nameAddrForm = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["f" /* reduxForm */])({
    form: 'login-form-addr',
    validate: validate,
})(NameAddressLoginForm);
var selector = Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["d" /* formValueSelector */])('login-form-addr');
var mapStateToProps = function (state) {
    return {
        initialValues: {
            'emailOptIn': true,
            'captureEmail': '',
            'productExcludes': Object(__WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__["m" /* getProdIdsForGlobalCodeFromAdminConfig */])(state),
            'state': '',
            'postalCode': '',
        },
        formCountry: selector(state, 'country'),
    };
};
var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({
        onSubmitHandler: __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_nameaddress_actions__["b" /* actionCreators */].nameAddressLogin,
        removeField: function (form, field, newValue) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["c" /* change */])(form, field, newValue)); },
    }, dispatch);
};
var NameAddressLogin = Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(nameAddrForm));


/***/ }),

/***/ 1428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WeakLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_components__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_global_components_form_elements__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_login_types__ = __webpack_require__(420);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var WeakLoginFormOptions = /** @class */ (function (_super) {
    __extends(WeakLoginFormOptions, _super);
    function WeakLoginFormOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            openTab: __WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].accountPostalCode,
            enabledWeakLogins: [],
            weakLoginOptions: [],
            isPurgatory: false,
        };
        _this.LoginTab = function () {
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */], { name: "LoginChoice", component: __WEBPACK_IMPORTED_MODULE_4__src_app_global_components_form_elements__["d" /* SimplerSelect */], options: _this.state.weakLoginOptions, simpleValue: false, onChange: _this.handleOptionChange })));
        };
        _this.handleOptionChange = function (evt) {
            _this.setState({
                openTab: evt.value,
            });
        };
        // tslint:disable-next-line:no-shadowed-variable
        _this.formatTabTitle = function (messageId, descriptionm, defaultm, context) {
            var title = context.intl.formatMessage({
                id: messageId,
                description: descriptionm,
                defaultMessage: defaultm,
            });
            return title;
        };
        return _this;
    }
    WeakLoginFormOptions.prototype.componentWillMount = function () {
        var _a = this.props, signInData = _a.signInData, isPurgatory = _a.isPurgatory;
        var weakLoginOptions = [];
        var enabledWeakLogins = [];
        var firstEnabledWeakLogin = '';
        var openTabIndex = 0;
        weakLoginOptions.push({ label: 'Find your account', value: '' });
        if (signInData.AccountNumberPostalCodeEnabled) {
            enabledWeakLogins.push(__WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].accountPostalCode);
            weakLoginOptions.push({ label: 'Account Number', value: __WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].accountPostalCode });
            openTabIndex = signInData.DefaultLogin === 'AccountNumberPostalCode' ? enabledWeakLogins.length - 1 : openTabIndex;
        }
        if (signInData.EmailPostalCodeEnabled) {
            enabledWeakLogins.push(__WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].emailPostalCode);
            weakLoginOptions.push({ label: 'Email', value: __WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].emailPostalCode });
            openTabIndex = signInData.DefaultLogin === 'EmailPostalCode' ? enabledWeakLogins.length - 1 : openTabIndex;
        }
        if (signInData.NameAddressEnabled) {
            enabledWeakLogins.push(__WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].nameAndAddress);
            weakLoginOptions.push({ label: 'Name and Address', value: __WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].nameAndAddress });
            openTabIndex = signInData.DefaultLogin === 'NameAddress' ? enabledWeakLogins.length - 1 : openTabIndex;
        }
        var defaultIsEnabled = false;
        switch (signInData.DefaultLogin) {
            case 'AccountNumberPostalCode':
                defaultIsEnabled = signInData.AccountNumberPostalCodeEnabled;
                break;
            case 'EmailPostalCode':
                defaultIsEnabled = signInData.EmailPostalCodeEnabled;
                break;
            case 'NameAddress':
                defaultIsEnabled = signInData.NameAddressEnabled;
                break;
            default:
                break;
        }
        if (enabledWeakLogins.length === 1 || defaultIsEnabled) {
            firstEnabledWeakLogin = enabledWeakLogins[openTabIndex];
        }
        else {
            openTabIndex = (isPurgatory ? 0 : -1);
            firstEnabledWeakLogin = enabledWeakLogins[openTabIndex];
        }
        this.setState({ openTab: firstEnabledWeakLogin, enabledWeakLogins: enabledWeakLogins, weakLoginOptions: weakLoginOptions });
        this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["c" /* change */])('login-options', 'LoginChoice', (firstEnabledWeakLogin ? firstEnabledWeakLogin : '')));
    };
    WeakLoginFormOptions.prototype.componentWillReceiveProps = function (_a) {
        var openTab = _a.openTab;
        if (openTab != null && openTab !== this.props.openTab) {
            this.setState({ openTab: openTab });
        }
    };
    WeakLoginFormOptions.prototype.render = function () {
        var _this = this;
        var signInData = this.props.signInData;
        var emailTitle = this.formatTabTitle('app.email', 'email label', 'Email', this.context);
        var accountnum = this.formatTabTitle('app.acntnum', 'account number label', 'Account Number', this.context);
        var nameaddress = this.formatTabTitle('app.nameaddrs', 'name address label', 'Name and Address', this.context);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { tabIndex: 0, className: "week-login-card" },
            (this.state.enabledWeakLogins.length > 1) && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { className: "login-selection-type" }, this.LoginTab())),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_reactstrap__["o" /* Row */], { tabIndex: 0, className: "flexContainer mb-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12 }, (function () {
                    switch (_this.state.openTab) {
                        case __WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].accountPostalCode:
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__src_app_login_components__["a" /* AccountNumberPostalCodeLogin */], { signInData: _this.props.signInData });
                        case __WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].emailPostalCode:
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__src_app_login_components__["b" /* EmailPostalCodeLogin */], { signInData: _this.props.signInData });
                        case __WEBPACK_IMPORTED_MODULE_6__src_app_login_types__["a" /* LoginTabs */].nameAndAddress:
                            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__src_app_login_components__["c" /* NameAddressLogin */], { signInData: _this.props.signInData });
                        default:
                            return null;
                    }
                })()))));
    };
    // tslint:disable-next-line:member-ordering
    WeakLoginFormOptions.contextTypes = {
        intl: __WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* intlShape */],
    };
    return WeakLoginFormOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var WeakLoginForm = Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["f" /* reduxForm */])({
    form: 'login-options',
    forceUnregisterOnUnmount: true,
})(WeakLoginFormOptions);
var WeakLogin = WeakLoginForm;


/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_components_AccountNumberPostalCodeLogin__ = __webpack_require__(1410);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_login_components_AccountNumberPostalCodeLogin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_components_EmailPostalCodeLogin__ = __webpack_require__(1425);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_app_login_components_EmailPostalCodeLogin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_components_NameAddressLogin__ = __webpack_require__(1427);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__src_app_login_components_NameAddressLogin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_login_components_Login__ = __webpack_require__(417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_login_components_WeakLogin__ = __webpack_require__(1428);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__src_app_login_components_WeakLogin__["a"]; });







/***/ }),

/***/ 1435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export userIsAuthenticated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userIsAuthenticatedRedir; });
/* unused harmony export userIsNotAuthenticated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return userIsNotAuthenticatedRedir; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_global_components_AuthenticatingView__ = __webpack_require__(1443);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var locationHelper = __WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper___default()({});
var userIsAuthenticatedDefaults = {
    authenticatedSelector: function (state) { return state.auth.omsAuth.isLoginSuccessful === true; },
    authenticatingSelector: function (state) { return state.auth.omsAuth.authenticating; },
    wrapperDisplayName: 'UserIsAuthenticated',
};
var userIsAuthenticated = __WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper___default()(userIsAuthenticatedDefaults);
var userIsAuthenticatedRedir = Object(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__["connectedRouterRedirect"])(__assign({}, userIsAuthenticatedDefaults, { AuthenticatingComponent: __WEBPACK_IMPORTED_MODULE_3__src_app_global_components_AuthenticatingView__["a" /* AuthenticatingView */], redirectPath: '/login' }));
var userIsNotAuthenticatedDefaults = {
    // Want to redirect the user when they are done loading and authenticated
    authenticatedSelector: function (state) {
        return state.auth.omsAuth.isLoginSuccessful === false &&
            state.auth.omsAuth.authenticating === false;
    },
    wrapperDisplayName: 'UserIsNotAuthenticated',
};
var userIsNotAuthenticated = __WEBPACK_IMPORTED_MODULE_2_redux_auth_wrapper_connectedAuthWrapper___default()(userIsNotAuthenticatedDefaults);
var userIsNotAuthenticatedRedir = Object(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__["connectedRouterRedirect"])(__assign({}, userIsNotAuthenticatedDefaults, { redirectPath: function (state, ownProps) {
        return locationHelper.getRedirectQueryParam(ownProps) || '/accounts/summary/';
    }, allowRedirectBack: false }));


/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getClientConfig */
/* unused harmony export getSocialUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSocialEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMylo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mylo_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mylo_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mylo_js__);


var getClientConfig = function (state) {
    return state.clientConfig;
};
var getSocialUser = function (_a) {
    var auth = _a.auth;
    return auth.socialLogin.user;
};
var getSocialEmail = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getSocialUser], function (socialUser) {
    var email = '';
    if (socialUser) {
        email =
            socialUser.channel === 'google'
                ? socialUser.profileObj.email
                : socialUser.email;
    }
    return email;
});
var getMylo = function (state, redirectPath) {
    var myloConfig = state.clientConfig.clientConfig.myloConfig;
    if (redirectPath) {
        myloConfig.redirectUri = myloConfig.redirectUri.replace('/auth/login', redirectPath);
    }
    return new __WEBPACK_IMPORTED_MODULE_1_mylo_js___default.a(myloConfig);
};


/***/ }),

/***/ 1443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticatingView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var AuthenticatingView = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "authenticating-spinner" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-2" }, 'Authenticating. Just a moment.'),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-spinner fa-spin fa-3x fa-fw" }))));
};


/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1445);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(71)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./index.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1446);
exports = module.exports = __webpack_require__(70)(false);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n/**\nOverrides need to come before the BS imports\n**/\n/**\nImport the components that we need from Bootstrap. this will grow when/if we add more components\n**/\n*,\n*::before,\n*::after {\n  box-sizing: border-box; }\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }\n\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block; }\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: left;\n  background-color: #fff; }\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important; }\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem; }\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem; }\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  text-decoration-skip-ink: none; }\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit; }\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem; }\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0; }\n\ndt {\n  font-weight: 700; }\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; }\n\nblockquote {\n  margin: 0 0 1rem; }\n\nb,\nstrong {\n  font-weight: bolder; }\n\nsmall {\n  font-size: 80%; }\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline; }\n\nsub {\n  bottom: -.25em; }\n\nsup {\n  top: -.5em; }\n\na {\n  color: #337ab7;\n  text-decoration: none;\n  background-color: transparent; }\n  a:hover {\n    color: #22527b;\n    text-decoration: none; }\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none; }\n  a:not([href]):not([class]):hover {\n    color: inherit;\n    text-decoration: none; }\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em; }\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar; }\n\nfigure {\n  margin: 0 0 1rem; }\n\nimg {\n  vertical-align: middle;\n  border-style: none; }\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle; }\n\ntable {\n  border-collapse: collapse; }\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom; }\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent; }\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem; }\n\nbutton {\n  border-radius: 0; }\n\nbutton:focus:not(:focus-visible) {\n  outline: 0; }\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit; }\n\nbutton,\ninput {\n  overflow: visible; }\n\nbutton,\nselect {\n  text-transform: none; }\n\n[role=\"button\"] {\n  cursor: pointer; }\n\nselect {\n  word-wrap: normal; }\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; }\n\nbutton:not(:disabled),\n[type=\"button\"]:not(:disabled),\n[type=\"reset\"]:not(:disabled),\n[type=\"submit\"]:not(:disabled) {\n  cursor: pointer; }\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none; }\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0; }\n\ntextarea {\n  overflow: auto;\n  resize: vertical; }\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0; }\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal; }\n\nprogress {\n  vertical-align: baseline; }\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\n\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none; }\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button; }\n\noutput {\n  display: inline-block; }\n\nsummary {\n  display: list-item;\n  cursor: pointer; }\n\ntemplate {\n  display: none; }\n\n[hidden] {\n  display: none !important; }\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2; }\n\nh1, .h1 {\n  font-size: 2.1875rem; }\n\nh2, .h2 {\n  font-size: 1.75rem; }\n\nh3, .h3 {\n  font-size: 1.53125rem; }\n\nh4, .h4 {\n  font-size: 1.3125rem; }\n\nh5, .h5 {\n  font-size: 1.09375rem; }\n\nh6, .h6 {\n  font-size: 0.875rem; }\n\n.lead {\n  font-size: 1.09375rem;\n  font-weight: 300; }\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2; }\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1); }\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400; }\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3; }\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none; }\n\n.list-inline {\n  padding-left: 0;\n  list-style: none; }\n\n.list-inline-item {\n  display: inline-block; }\n  .list-inline-item:not(:last-child) {\n    margin-right: 0.5rem; }\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase; }\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.09375rem; }\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #6c757d; }\n  .blockquote-footer::before {\n    content: \"\\2014\\A0\"; }\n\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-wrap: break-word; }\n  a > code {\n    color: inherit; }\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.2rem; }\n  kbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700; }\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529; }\n  pre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal; }\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll; }\n\n.container,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto; }\n\n@media (min-width: 576px) {\n  .container, .container-sm {\n    max-width: 540px; } }\n\n@media (min-width: 768px) {\n  .container, .container-sm, .container-md {\n    max-width: 720px; } }\n\n@media (min-width: 992px) {\n  .container, .container-sm, .container-md, .container-lg {\n    max-width: 960px; } }\n\n@media (min-width: 1200px) {\n  .container, .container-sm, .container-md, .container-lg, .container-xl {\n    max-width: 1140px; } }\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px; }\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0; }\n  .no-gutters > .col,\n  .no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0; }\n\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px; }\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%; }\n\n.row-cols-1 > * {\n  flex: 0 0 100%;\n  max-width: 100%; }\n\n.row-cols-2 > * {\n  flex: 0 0 50%;\n  max-width: 50%; }\n\n.row-cols-3 > * {\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%; }\n\n.row-cols-4 > * {\n  flex: 0 0 25%;\n  max-width: 25%; }\n\n.row-cols-5 > * {\n  flex: 0 0 20%;\n  max-width: 20%; }\n\n.row-cols-6 > * {\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%; }\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; }\n\n.col-1 {\n  flex: 0 0 8.33333%;\n  max-width: 8.33333%; }\n\n.col-2 {\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%; }\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%; }\n\n.col-4 {\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%; }\n\n.col-5 {\n  flex: 0 0 41.66667%;\n  max-width: 41.66667%; }\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%; }\n\n.col-7 {\n  flex: 0 0 58.33333%;\n  max-width: 58.33333%; }\n\n.col-8 {\n  flex: 0 0 66.66667%;\n  max-width: 66.66667%; }\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%; }\n\n.col-10 {\n  flex: 0 0 83.33333%;\n  max-width: 83.33333%; }\n\n.col-11 {\n  flex: 0 0 91.66667%;\n  max-width: 91.66667%; }\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%; }\n\n.order-first {\n  order: -1; }\n\n.order-last {\n  order: 13; }\n\n.order-0 {\n  order: 0; }\n\n.order-1 {\n  order: 1; }\n\n.order-2 {\n  order: 2; }\n\n.order-3 {\n  order: 3; }\n\n.order-4 {\n  order: 4; }\n\n.order-5 {\n  order: 5; }\n\n.order-6 {\n  order: 6; }\n\n.order-7 {\n  order: 7; }\n\n.order-8 {\n  order: 8; }\n\n.order-9 {\n  order: 9; }\n\n.order-10 {\n  order: 10; }\n\n.order-11 {\n  order: 11; }\n\n.order-12 {\n  order: 12; }\n\n.offset-1 {\n  margin-left: 8.33333%; }\n\n.offset-2 {\n  margin-left: 16.66667%; }\n\n.offset-3 {\n  margin-left: 25%; }\n\n.offset-4 {\n  margin-left: 33.33333%; }\n\n.offset-5 {\n  margin-left: 41.66667%; }\n\n.offset-6 {\n  margin-left: 50%; }\n\n.offset-7 {\n  margin-left: 58.33333%; }\n\n.offset-8 {\n  margin-left: 66.66667%; }\n\n.offset-9 {\n  margin-left: 75%; }\n\n.offset-10 {\n  margin-left: 83.33333%; }\n\n.offset-11 {\n  margin-left: 91.66667%; }\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .row-cols-sm-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-sm-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-sm-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-sm-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-sm-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-sm-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-sm-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-sm-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-sm-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-sm-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-sm-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-sm-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-sm-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-sm-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-sm-first {\n    order: -1; }\n  .order-sm-last {\n    order: 13; }\n  .order-sm-0 {\n    order: 0; }\n  .order-sm-1 {\n    order: 1; }\n  .order-sm-2 {\n    order: 2; }\n  .order-sm-3 {\n    order: 3; }\n  .order-sm-4 {\n    order: 4; }\n  .order-sm-5 {\n    order: 5; }\n  .order-sm-6 {\n    order: 6; }\n  .order-sm-7 {\n    order: 7; }\n  .order-sm-8 {\n    order: 8; }\n  .order-sm-9 {\n    order: 9; }\n  .order-sm-10 {\n    order: 10; }\n  .order-sm-11 {\n    order: 11; }\n  .order-sm-12 {\n    order: 12; }\n  .offset-sm-0 {\n    margin-left: 0; }\n  .offset-sm-1 {\n    margin-left: 8.33333%; }\n  .offset-sm-2 {\n    margin-left: 16.66667%; }\n  .offset-sm-3 {\n    margin-left: 25%; }\n  .offset-sm-4 {\n    margin-left: 33.33333%; }\n  .offset-sm-5 {\n    margin-left: 41.66667%; }\n  .offset-sm-6 {\n    margin-left: 50%; }\n  .offset-sm-7 {\n    margin-left: 58.33333%; }\n  .offset-sm-8 {\n    margin-left: 66.66667%; }\n  .offset-sm-9 {\n    margin-left: 75%; }\n  .offset-sm-10 {\n    margin-left: 83.33333%; }\n  .offset-sm-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .row-cols-md-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-md-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-md-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-md-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-md-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-md-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-md-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-md-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-md-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-md-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-md-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-md-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-md-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-md-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-md-first {\n    order: -1; }\n  .order-md-last {\n    order: 13; }\n  .order-md-0 {\n    order: 0; }\n  .order-md-1 {\n    order: 1; }\n  .order-md-2 {\n    order: 2; }\n  .order-md-3 {\n    order: 3; }\n  .order-md-4 {\n    order: 4; }\n  .order-md-5 {\n    order: 5; }\n  .order-md-6 {\n    order: 6; }\n  .order-md-7 {\n    order: 7; }\n  .order-md-8 {\n    order: 8; }\n  .order-md-9 {\n    order: 9; }\n  .order-md-10 {\n    order: 10; }\n  .order-md-11 {\n    order: 11; }\n  .order-md-12 {\n    order: 12; }\n  .offset-md-0 {\n    margin-left: 0; }\n  .offset-md-1 {\n    margin-left: 8.33333%; }\n  .offset-md-2 {\n    margin-left: 16.66667%; }\n  .offset-md-3 {\n    margin-left: 25%; }\n  .offset-md-4 {\n    margin-left: 33.33333%; }\n  .offset-md-5 {\n    margin-left: 41.66667%; }\n  .offset-md-6 {\n    margin-left: 50%; }\n  .offset-md-7 {\n    margin-left: 58.33333%; }\n  .offset-md-8 {\n    margin-left: 66.66667%; }\n  .offset-md-9 {\n    margin-left: 75%; }\n  .offset-md-10 {\n    margin-left: 83.33333%; }\n  .offset-md-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .row-cols-lg-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-lg-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-lg-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-lg-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-lg-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-lg-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-lg-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-lg-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-lg-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-lg-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-lg-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-lg-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-lg-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-lg-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-lg-first {\n    order: -1; }\n  .order-lg-last {\n    order: 13; }\n  .order-lg-0 {\n    order: 0; }\n  .order-lg-1 {\n    order: 1; }\n  .order-lg-2 {\n    order: 2; }\n  .order-lg-3 {\n    order: 3; }\n  .order-lg-4 {\n    order: 4; }\n  .order-lg-5 {\n    order: 5; }\n  .order-lg-6 {\n    order: 6; }\n  .order-lg-7 {\n    order: 7; }\n  .order-lg-8 {\n    order: 8; }\n  .order-lg-9 {\n    order: 9; }\n  .order-lg-10 {\n    order: 10; }\n  .order-lg-11 {\n    order: 11; }\n  .order-lg-12 {\n    order: 12; }\n  .offset-lg-0 {\n    margin-left: 0; }\n  .offset-lg-1 {\n    margin-left: 8.33333%; }\n  .offset-lg-2 {\n    margin-left: 16.66667%; }\n  .offset-lg-3 {\n    margin-left: 25%; }\n  .offset-lg-4 {\n    margin-left: 33.33333%; }\n  .offset-lg-5 {\n    margin-left: 41.66667%; }\n  .offset-lg-6 {\n    margin-left: 50%; }\n  .offset-lg-7 {\n    margin-left: 58.33333%; }\n  .offset-lg-8 {\n    margin-left: 66.66667%; }\n  .offset-lg-9 {\n    margin-left: 75%; }\n  .offset-lg-10 {\n    margin-left: 83.33333%; }\n  .offset-lg-11 {\n    margin-left: 91.66667%; } }\n\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%; }\n  .row-cols-xl-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .row-cols-xl-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .row-cols-xl-3 > * {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .row-cols-xl-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .row-cols-xl-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .row-cols-xl-6 > * {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%; }\n  .col-xl-1 {\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%; }\n  .col-xl-2 {\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .col-xl-4 {\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .col-xl-5 {\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%; }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .col-xl-7 {\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%; }\n  .col-xl-8 {\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%; }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%; }\n  .col-xl-10 {\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%; }\n  .col-xl-11 {\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%; }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .order-xl-first {\n    order: -1; }\n  .order-xl-last {\n    order: 13; }\n  .order-xl-0 {\n    order: 0; }\n  .order-xl-1 {\n    order: 1; }\n  .order-xl-2 {\n    order: 2; }\n  .order-xl-3 {\n    order: 3; }\n  .order-xl-4 {\n    order: 4; }\n  .order-xl-5 {\n    order: 5; }\n  .order-xl-6 {\n    order: 6; }\n  .order-xl-7 {\n    order: 7; }\n  .order-xl-8 {\n    order: 8; }\n  .order-xl-9 {\n    order: 9; }\n  .order-xl-10 {\n    order: 10; }\n  .order-xl-11 {\n    order: 11; }\n  .order-xl-12 {\n    order: 12; }\n  .offset-xl-0 {\n    margin-left: 0; }\n  .offset-xl-1 {\n    margin-left: 8.33333%; }\n  .offset-xl-2 {\n    margin-left: 16.66667%; }\n  .offset-xl-3 {\n    margin-left: 25%; }\n  .offset-xl-4 {\n    margin-left: 33.33333%; }\n  .offset-xl-5 {\n    margin-left: 41.66667%; }\n  .offset-xl-6 {\n    margin-left: 50%; }\n  .offset-xl-7 {\n    margin-left: 58.33333%; }\n  .offset-xl-8 {\n    margin-left: 66.66667%; }\n  .offset-xl-9 {\n    margin-left: 75%; }\n  .offset-xl-10 {\n    margin-left: 83.33333%; }\n  .offset-xl-11 {\n    margin-left: 91.66667%; } }\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem; }\n\n.alert-heading {\n  color: inherit; }\n\n.alert-link {\n  font-weight: 700; }\n\n.alert-dismissible {\n  padding-right: 3.8125rem; }\n  .alert-dismissible .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: 0.75rem 1.25rem;\n    color: inherit; }\n\n.alert-primary {\n  color: #0f1c81;\n  background-color: #d2d7fe;\n  border-color: #c0c6fd; }\n  .alert-primary hr {\n    border-top-color: #a7b0fc; }\n  .alert-primary .alert-link {\n    color: #0a1253; }\n\n.alert-secondary {\n  color: #383d41;\n  background-color: #e2e3e5;\n  border-color: #d6d8db; }\n  .alert-secondary hr {\n    border-top-color: #c8cbcf; }\n  .alert-secondary .alert-link {\n    color: #202326; }\n\n.alert-success {\n  color: #1f3d20;\n  background-color: #d8e4d8;\n  border-color: #c8d9c9; }\n  .alert-success hr {\n    border-top-color: #b9cfba; }\n  .alert-success .alert-link {\n    color: #0e1b0e; }\n\n.alert-info {\n  color: #1e465a;\n  background-color: #d8e7ef;\n  border-color: #c8dde8; }\n  .alert-info hr {\n    border-top-color: #b6d2e0; }\n  .alert-info .alert-link {\n    color: #112834; }\n\n.alert-warning {\n  color: #855600;\n  background-color: #ffedcc;\n  border-color: #ffe6b8; }\n  .alert-warning hr {\n    border-top-color: #ffdd9f; }\n  .alert-warning .alert-link {\n    color: #523500; }\n\n.alert-danger {\n  color: #74140d;\n  background-color: #f9d4d1;\n  border-color: #f6c2bf; }\n  .alert-danger hr {\n    border-top-color: #f3ada9; }\n  .alert-danger .alert-link {\n    color: #460c08; }\n\n.alert-light {\n  color: #818182;\n  background-color: #fefefe;\n  border-color: #fdfdfe; }\n  .alert-light hr {\n    border-top-color: #ececf6; }\n  .alert-light .alert-link {\n    color: #686868; }\n\n.alert-dark {\n  color: #1b1e21;\n  background-color: #d6d8d9;\n  border-color: #c6c8ca; }\n  .alert-dark hr {\n    border-top-color: #b9bbbe; }\n  .alert-dark .alert-link {\n    color: #040505; }\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .form-control {\n      transition: none; } }\n  .form-control::-ms-expand {\n    background-color: transparent;\n    border: 0; }\n  .form-control:focus {\n    color: #495057;\n    background-color: #fff;\n    border-color: #99a4fc;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(29, 53, 248, 0.25); }\n  .form-control::placeholder {\n    color: #6c757d;\n    opacity: 1; }\n  .form-control:disabled, .form-control[readonly] {\n    background-color: #e9ecef;\n    opacity: 1; }\n\ninput[type=\"date\"].form-control,\ninput[type=\"time\"].form-control,\ninput[type=\"datetime-local\"].form-control,\ninput[type=\"month\"].form-control {\n  appearance: none; }\n\nselect.form-control:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #495057; }\n\nselect.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff; }\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%; }\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5; }\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.09375rem;\n  line-height: 1.5; }\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.76563rem;\n  line-height: 1.5; }\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #212529;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0; }\n  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n    padding-right: 0;\n    padding-left: 0; }\n\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.76563rem;\n  line-height: 1.5;\n  border-radius: 0.2rem; }\n\n.form-control-lg {\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n  border-radius: 0.3rem; }\n\nselect.form-control[size], select.form-control[multiple] {\n  height: auto; }\n\ntextarea.form-control {\n  height: auto; }\n\n.form-group {\n  margin-bottom: 1rem; }\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem; }\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px; }\n  .form-row > .col,\n  .form-row > [class*=\"col-\"] {\n    padding-right: 5px;\n    padding-left: 5px; }\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem; }\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem; }\n  .form-check-input[disabled] ~ .form-check-label,\n  .form-check-input:disabled ~ .form-check-label {\n    color: #6c757d; }\n\n.form-check-label {\n  margin-bottom: 0; }\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem; }\n  .form-check-inline .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: 0.3125rem;\n    margin-left: 0; }\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #3c763d; }\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.76563rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(60, 118, 61, 0.9);\n  border-radius: 0.25rem; }\n  .form-row > .col > .valid-tooltip,\n  .form-row > [class*=\"col-\"] > .valid-tooltip {\n    left: 5px; }\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block; }\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #3c763d;\n  padding-right: calc(1.5em + 0.75rem) !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%233c763d' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n    border-color: #3c763d;\n    box-shadow: 0 0 0 0.2rem rgba(60, 118, 61, 0.25); }\n\n.was-validated select.form-control:valid, select.form-control.is-valid {\n  padding-right: 3rem !important;\n  background-position: right 1.5rem center; }\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }\n\n.was-validated .custom-select:valid, .custom-select.is-valid {\n  border-color: #3c763d;\n  padding-right: calc(0.75em + 2.3125rem) !important;\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right 0.75rem center/8px 10px no-repeat, #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%233c763d' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat; }\n  .was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {\n    border-color: #3c763d;\n    box-shadow: 0 0 0 0.2rem rgba(60, 118, 61, 0.25); }\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #3c763d; }\n\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #3c763d; }\n  .was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n    border-color: #3c763d; }\n\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  border-color: #4d984e;\n  background-color: #4d984e; }\n\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(60, 118, 61, 0.25); }\n\n.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #3c763d; }\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #3c763d; }\n\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  border-color: #3c763d;\n  box-shadow: 0 0 0 0.2rem rgba(60, 118, 61, 0.25); }\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #e02619; }\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.76563rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(224, 38, 25, 0.9);\n  border-radius: 0.25rem; }\n  .form-row > .col > .invalid-tooltip,\n  .form-row > [class*=\"col-\"] > .invalid-tooltip {\n    left: 5px; }\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block; }\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #e02619;\n  padding-right: calc(1.5em + 0.75rem) !important;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23e02619' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23e02619' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }\n  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n    border-color: #e02619;\n    box-shadow: 0 0 0 0.2rem rgba(224, 38, 25, 0.25); }\n\n.was-validated select.form-control:invalid, select.form-control.is-invalid {\n  padding-right: 3rem !important;\n  background-position: right 1.5rem center; }\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }\n\n.was-validated .custom-select:invalid, .custom-select.is-invalid {\n  border-color: #e02619;\n  padding-right: calc(0.75em + 2.3125rem) !important;\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right 0.75rem center/8px 10px no-repeat, #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23e02619' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23e02619' stroke='none'/%3e%3c/svg%3e\") center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) no-repeat; }\n  .was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {\n    border-color: #e02619;\n    box-shadow: 0 0 0 0.2rem rgba(224, 38, 25, 0.25); }\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #e02619; }\n\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block; }\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #e02619; }\n  .was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n    border-color: #e02619; }\n\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  border-color: #ea4d42;\n  background-color: #ea4d42; }\n\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(224, 38, 25, 0.25); }\n\n.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #e02619; }\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #e02619; }\n\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  border-color: #e02619;\n  box-shadow: 0 0 0 0.2rem rgba(224, 38, 25, 0.25); }\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; }\n  .form-inline .form-check {\n    width: 100%; }\n  @media (min-width: 576px) {\n    .form-inline label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0; }\n    .form-inline .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0; }\n    .form-inline .form-control {\n      display: inline-block;\n      width: auto;\n      vertical-align: middle; }\n    .form-inline .form-control-plaintext {\n      display: inline-block; }\n    .form-inline .input-group,\n    .form-inline .custom-select {\n      width: auto; }\n    .form-inline .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0; }\n    .form-inline .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: 0.25rem;\n      margin-left: 0; }\n    .form-inline .custom-control {\n      align-items: center;\n      justify-content: center; }\n    .form-inline .custom-control-label {\n      margin-bottom: 0; } }\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.6rem; }\n  .card > hr {\n    margin-right: 0;\n    margin-left: 0; }\n  .card > .list-group {\n    border-top: inherit;\n    border-bottom: inherit; }\n    .card > .list-group:first-child {\n      border-top-width: 0;\n      border-top-left-radius: calc(0.6rem - 1px);\n      border-top-right-radius: calc(0.6rem - 1px); }\n    .card > .list-group:last-child {\n      border-bottom-width: 0;\n      border-bottom-right-radius: calc(0.6rem - 1px);\n      border-bottom-left-radius: calc(0.6rem - 1px); }\n  .card > .card-header + .list-group,\n  .card > .list-group + .card-footer {\n    border-top: 0; }\n\n.card-body {\n  flex: 1 1 auto;\n  min-height: 1px;\n  padding: 1.25rem; }\n\n.card-title {\n  margin-bottom: 0.75rem; }\n\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0; }\n\n.card-text:last-child {\n  margin-bottom: 0; }\n\n.card-link:hover {\n  text-decoration: none; }\n\n.card-link + .card-link {\n  margin-left: 1.25rem; }\n\n.card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125); }\n  .card-header:first-child {\n    border-radius: calc(0.6rem - 1px) calc(0.6rem - 1px) 0 0; }\n\n.card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid rgba(0, 0, 0, 0.125); }\n  .card-footer:last-child {\n    border-radius: 0 0 calc(0.6rem - 1px) calc(0.6rem - 1px); }\n\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0; }\n\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem; }\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n  border-radius: calc(0.6rem - 1px); }\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0;\n  width: 100%; }\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.6rem - 1px);\n  border-top-right-radius: calc(0.6rem - 1px); }\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.6rem - 1px);\n  border-bottom-left-radius: calc(0.6rem - 1px); }\n\n.card-deck .card {\n  margin-bottom: 15px; }\n\n@media (min-width: 576px) {\n  .card-deck {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px; }\n    .card-deck .card {\n      flex: 1 0 0%;\n      margin-right: 15px;\n      margin-bottom: 0;\n      margin-left: 15px; } }\n\n.card-group > .card {\n  margin-bottom: 15px; }\n\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap; }\n    .card-group > .card {\n      flex: 1 0 0%;\n      margin-bottom: 0; }\n      .card-group > .card + .card {\n        margin-left: 0;\n        border-left: 0; }\n      .card-group > .card:not(:last-child) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0; }\n        .card-group > .card:not(:last-child) .card-img-top,\n        .card-group > .card:not(:last-child) .card-header {\n          border-top-right-radius: 0; }\n        .card-group > .card:not(:last-child) .card-img-bottom,\n        .card-group > .card:not(:last-child) .card-footer {\n          border-bottom-right-radius: 0; }\n      .card-group > .card:not(:first-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0; }\n        .card-group > .card:not(:first-child) .card-img-top,\n        .card-group > .card:not(:first-child) .card-header {\n          border-top-left-radius: 0; }\n        .card-group > .card:not(:first-child) .card-img-bottom,\n        .card-group > .card:not(:first-child) .card-footer {\n          border-bottom-left-radius: 0; } }\n\n.card-columns .card {\n  margin-bottom: 0.75rem; }\n\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1; }\n    .card-columns .card {\n      display: inline-block;\n      width: 100%; } }\n\n.accordion {\n  overflow-anchor: none; }\n  .accordion > .card {\n    overflow: hidden; }\n    .accordion > .card:not(:last-of-type) {\n      border-bottom: 0;\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 0; }\n    .accordion > .card:not(:first-of-type) {\n      border-top-left-radius: 0;\n      border-top-right-radius: 0; }\n    .accordion > .card > .card-header {\n      border-radius: 0;\n      margin-bottom: -1px; }\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative; }\n\n.dropdown-toggle {\n  white-space: nowrap; }\n  .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0;\n    border-left: 0.3em solid transparent; }\n  .dropdown-toggle:empty::after {\n    margin-left: 0; }\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 0.875rem;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem; }\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0; }\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto; }\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto; } }\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto; } }\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto; } }\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0; }\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto; } }\n\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem; }\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent; }\n\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem; }\n\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid; }\n\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropright .dropdown-toggle::after {\n  vertical-align: 0; }\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem; }\n\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\"; }\n\n.dropleft .dropdown-toggle::after {\n  display: none; }\n\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent; }\n\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0; }\n\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0; }\n\n.dropdown-menu[x-placement^=\"top\"], .dropdown-menu[x-placement^=\"right\"], .dropdown-menu[x-placement^=\"bottom\"], .dropdown-menu[x-placement^=\"left\"] {\n  right: auto;\n  bottom: auto; }\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef; }\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0; }\n  .dropdown-item:hover, .dropdown-item:focus {\n    color: #16181b;\n    text-decoration: none;\n    background-color: #e9ecef; }\n  .dropdown-item.active, .dropdown-item:active {\n    color: #fff;\n    text-decoration: none;\n    background-color: #1d35f8; }\n  .dropdown-item.disabled, .dropdown-item:disabled {\n    color: #adb5bd;\n    pointer-events: none;\n    background-color: transparent; }\n\n.dropdown-menu.show {\n  display: block; }\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.76563rem;\n  color: #6c757d;\n  white-space: nowrap; }\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  color: #212529; }\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #212529;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n  @media (prefers-reduced-motion: reduce) {\n    .btn {\n      transition: none; } }\n  .btn:hover {\n    color: #212529;\n    text-decoration: none; }\n  .btn:focus, .btn.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(29, 53, 248, 0.25); }\n  .btn.disabled, .btn:disabled {\n    opacity: 0.65; }\n  .btn:not(:disabled):not(.disabled) {\n    cursor: pointer; }\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none; }\n\n.btn-primary {\n  color: #fff;\n  background-color: #1d35f8;\n  border-color: #1d35f8; }\n  .btn-primary:hover {\n    color: #fff;\n    background-color: #0720e8;\n    border-color: #071edb; }\n  .btn-primary:focus, .btn-primary.focus {\n    color: #fff;\n    background-color: #0720e8;\n    border-color: #071edb;\n    box-shadow: 0 0 0 0.2rem rgba(63, 83, 249, 0.5); }\n  .btn-primary.disabled, .btn-primary:disabled {\n    color: #fff;\n    background-color: #1d35f8;\n    border-color: #1d35f8; }\n  .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,\n  .show > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #071edb;\n    border-color: #061ccf; }\n    .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-primary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(63, 83, 249, 0.5); }\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d; }\n  .btn-secondary:hover {\n    color: #fff;\n    background-color: #5a6268;\n    border-color: #545b62; }\n  .btn-secondary:focus, .btn-secondary.focus {\n    color: #fff;\n    background-color: #5a6268;\n    border-color: #545b62;\n    box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }\n  .btn-secondary.disabled, .btn-secondary:disabled {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,\n  .show > .btn-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #545b62;\n    border-color: #4e555b; }\n    .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-secondary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5); }\n\n.btn-success {\n  color: #fff;\n  background-color: #3c763d;\n  border-color: #3c763d; }\n  .btn-success:hover {\n    color: #fff;\n    background-color: #2f5d30;\n    border-color: #2b542c; }\n  .btn-success:focus, .btn-success.focus {\n    color: #fff;\n    background-color: #2f5d30;\n    border-color: #2b542c;\n    box-shadow: 0 0 0 0.2rem rgba(89, 139, 90, 0.5); }\n  .btn-success.disabled, .btn-success:disabled {\n    color: #fff;\n    background-color: #3c763d;\n    border-color: #3c763d; }\n  .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,\n  .show > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #2b542c;\n    border-color: #274c27; }\n    .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-success.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(89, 139, 90, 0.5); }\n\n.btn-info {\n  color: #fff;\n  background-color: #3a87ad;\n  border-color: #3a87ad; }\n  .btn-info:hover {\n    color: #fff;\n    background-color: #307190;\n    border-color: #2d6987; }\n  .btn-info:focus, .btn-info.focus {\n    color: #fff;\n    background-color: #307190;\n    border-color: #2d6987;\n    box-shadow: 0 0 0 0.2rem rgba(88, 153, 185, 0.5); }\n  .btn-info.disabled, .btn-info:disabled {\n    color: #fff;\n    background-color: #3a87ad;\n    border-color: #3a87ad; }\n  .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,\n  .show > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #2d6987;\n    border-color: #2a627d; }\n    .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-info.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(88, 153, 185, 0.5); }\n\n.btn-warning {\n  color: #212529;\n  background-color: #ffa500;\n  border-color: #ffa500; }\n  .btn-warning:hover {\n    color: #fff;\n    background-color: #d98c00;\n    border-color: #cc8400; }\n  .btn-warning:focus, .btn-warning.focus {\n    color: #fff;\n    background-color: #d98c00;\n    border-color: #cc8400;\n    box-shadow: 0 0 0 0.2rem rgba(222, 146, 6, 0.5); }\n  .btn-warning.disabled, .btn-warning:disabled {\n    color: #212529;\n    background-color: #ffa500;\n    border-color: #ffa500; }\n  .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,\n  .show > .btn-warning.dropdown-toggle {\n    color: #fff;\n    background-color: #cc8400;\n    border-color: #bf7c00; }\n    .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-warning.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(222, 146, 6, 0.5); }\n\n.btn-danger {\n  color: #fff;\n  background-color: #e02619;\n  border-color: #e02619; }\n  .btn-danger:hover {\n    color: #fff;\n    background-color: #be2015;\n    border-color: #b21e14; }\n  .btn-danger:focus, .btn-danger.focus {\n    color: #fff;\n    background-color: #be2015;\n    border-color: #b21e14;\n    box-shadow: 0 0 0 0.2rem rgba(229, 71, 60, 0.5); }\n  .btn-danger.disabled, .btn-danger:disabled {\n    color: #fff;\n    background-color: #e02619;\n    border-color: #e02619; }\n  .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,\n  .show > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #b21e14;\n    border-color: #a71c13; }\n    .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-danger.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(229, 71, 60, 0.5); }\n\n.btn-light {\n  color: #212529;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa; }\n  .btn-light:hover {\n    color: #212529;\n    background-color: #e2e6ea;\n    border-color: #dae0e5; }\n  .btn-light:focus, .btn-light.focus {\n    color: #212529;\n    background-color: #e2e6ea;\n    border-color: #dae0e5;\n    box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5); }\n  .btn-light.disabled, .btn-light:disabled {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa; }\n  .btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,\n  .show > .btn-light.dropdown-toggle {\n    color: #212529;\n    background-color: #dae0e5;\n    border-color: #d3d9df; }\n    .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-light.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5); }\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40; }\n  .btn-dark:hover {\n    color: #fff;\n    background-color: #23272b;\n    border-color: #1d2124; }\n  .btn-dark:focus, .btn-dark.focus {\n    color: #fff;\n    background-color: #23272b;\n    border-color: #1d2124;\n    box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5); }\n  .btn-dark.disabled, .btn-dark:disabled {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40; }\n  .btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,\n  .show > .btn-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #1d2124;\n    border-color: #171a1d; }\n    .btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-dark.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5); }\n\n.btn-outline-primary {\n  color: #1d35f8;\n  border-color: #1d35f8; }\n  .btn-outline-primary:hover {\n    color: #fff;\n    background-color: #1d35f8;\n    border-color: #1d35f8; }\n  .btn-outline-primary:focus, .btn-outline-primary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(29, 53, 248, 0.5); }\n  .btn-outline-primary.disabled, .btn-outline-primary:disabled {\n    color: #1d35f8;\n    background-color: transparent; }\n  .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #1d35f8;\n    border-color: #1d35f8; }\n    .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-primary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(29, 53, 248, 0.5); }\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d; }\n  .btn-outline-secondary:hover {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n  .btn-outline-secondary:focus, .btn-outline-secondary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n  .btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n    color: #6c757d;\n    background-color: transparent; }\n  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d; }\n    .btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-secondary.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5); }\n\n.btn-outline-success {\n  color: #3c763d;\n  border-color: #3c763d; }\n  .btn-outline-success:hover {\n    color: #fff;\n    background-color: #3c763d;\n    border-color: #3c763d; }\n  .btn-outline-success:focus, .btn-outline-success.focus {\n    box-shadow: 0 0 0 0.2rem rgba(60, 118, 61, 0.5); }\n  .btn-outline-success.disabled, .btn-outline-success:disabled {\n    color: #3c763d;\n    background-color: transparent; }\n  .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-success.dropdown-toggle {\n    color: #fff;\n    background-color: #3c763d;\n    border-color: #3c763d; }\n    .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-success.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(60, 118, 61, 0.5); }\n\n.btn-outline-info {\n  color: #3a87ad;\n  border-color: #3a87ad; }\n  .btn-outline-info:hover {\n    color: #fff;\n    background-color: #3a87ad;\n    border-color: #3a87ad; }\n  .btn-outline-info:focus, .btn-outline-info.focus {\n    box-shadow: 0 0 0 0.2rem rgba(58, 135, 173, 0.5); }\n  .btn-outline-info.disabled, .btn-outline-info:disabled {\n    color: #3a87ad;\n    background-color: transparent; }\n  .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-info.dropdown-toggle {\n    color: #fff;\n    background-color: #3a87ad;\n    border-color: #3a87ad; }\n    .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-info.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(58, 135, 173, 0.5); }\n\n.btn-outline-warning {\n  color: #ffa500;\n  border-color: #ffa500; }\n  .btn-outline-warning:hover {\n    color: #212529;\n    background-color: #ffa500;\n    border-color: #ffa500; }\n  .btn-outline-warning:focus, .btn-outline-warning.focus {\n    box-shadow: 0 0 0 0.2rem rgba(255, 165, 0, 0.5); }\n  .btn-outline-warning.disabled, .btn-outline-warning:disabled {\n    color: #ffa500;\n    background-color: transparent; }\n  .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-warning.dropdown-toggle {\n    color: #212529;\n    background-color: #ffa500;\n    border-color: #ffa500; }\n    .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-warning.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(255, 165, 0, 0.5); }\n\n.btn-outline-danger {\n  color: #e02619;\n  border-color: #e02619; }\n  .btn-outline-danger:hover {\n    color: #fff;\n    background-color: #e02619;\n    border-color: #e02619; }\n  .btn-outline-danger:focus, .btn-outline-danger.focus {\n    box-shadow: 0 0 0 0.2rem rgba(224, 38, 25, 0.5); }\n  .btn-outline-danger.disabled, .btn-outline-danger:disabled {\n    color: #e02619;\n    background-color: transparent; }\n  .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #e02619;\n    border-color: #e02619; }\n    .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-danger.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(224, 38, 25, 0.5); }\n\n.btn-outline-light {\n  color: #f8f9fa;\n  border-color: #f8f9fa; }\n  .btn-outline-light:hover {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa; }\n  .btn-outline-light:focus, .btn-outline-light.focus {\n    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }\n  .btn-outline-light.disabled, .btn-outline-light:disabled {\n    color: #f8f9fa;\n    background-color: transparent; }\n  .btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-light.dropdown-toggle {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa; }\n    .btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-light.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5); }\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40; }\n  .btn-outline-dark:hover {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40; }\n  .btn-outline-dark:focus, .btn-outline-dark.focus {\n    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }\n  .btn-outline-dark.disabled, .btn-outline-dark:disabled {\n    color: #343a40;\n    background-color: transparent; }\n  .btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,\n  .show > .btn-outline-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40; }\n    .btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n    .show > .btn-outline-dark.dropdown-toggle:focus {\n      box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5); }\n\n.btn-link {\n  font-weight: 400;\n  color: #337ab7;\n  text-decoration: none; }\n  .btn-link:hover {\n    color: #22527b;\n    text-decoration: none; }\n  .btn-link:focus, .btn-link.focus {\n    text-decoration: none; }\n  .btn-link:disabled, .btn-link.disabled {\n    color: #6c757d;\n    pointer-events: none; }\n\n.btn-lg {\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n  border-radius: 0.3rem; }\n\n.btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.76563rem;\n  line-height: 1.5;\n  border-radius: 0.2rem; }\n\n.btn-block {\n  display: block;\n  width: 100%; }\n  .btn-block + .btn-block {\n    margin-top: 0.5rem; }\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%; }\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%; }\n  .input-group > .form-control,\n  .input-group > .form-control-plaintext,\n  .input-group > .custom-select,\n  .input-group > .custom-file {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0;\n    margin-bottom: 0; }\n    .input-group > .form-control + .form-control,\n    .input-group > .form-control + .custom-select,\n    .input-group > .form-control + .custom-file,\n    .input-group > .form-control-plaintext + .form-control,\n    .input-group > .form-control-plaintext + .custom-select,\n    .input-group > .form-control-plaintext + .custom-file,\n    .input-group > .custom-select + .form-control,\n    .input-group > .custom-select + .custom-select,\n    .input-group > .custom-select + .custom-file,\n    .input-group > .custom-file + .form-control,\n    .input-group > .custom-file + .custom-select,\n    .input-group > .custom-file + .custom-file {\n      margin-left: -1px; }\n  .input-group > .form-control:focus,\n  .input-group > .custom-select:focus,\n  .input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3; }\n  .input-group > .custom-file .custom-file-input:focus {\n    z-index: 4; }\n  .input-group > .form-control:not(:first-child),\n  .input-group > .custom-select:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .input-group > .custom-file {\n    display: flex;\n    align-items: center; }\n    .input-group > .custom-file:not(:last-child) .custom-file-label,\n    .input-group > .custom-file:not(:last-child) .custom-file-label::after {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0; }\n    .input-group > .custom-file:not(:first-child) .custom-file-label {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0; }\n  .input-group:not(.has-validation) > .form-control:not(:last-child),\n  .input-group:not(.has-validation) > .custom-select:not(:last-child),\n  .input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,\n  .input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .input-group.has-validation > .form-control:nth-last-child(n + 3),\n  .input-group.has-validation > .custom-select:nth-last-child(n + 3),\n  .input-group.has-validation > .custom-file:nth-last-child(n + 3) .custom-file-label,\n  .input-group.has-validation > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n\n.input-group-prepend,\n.input-group-append {\n  display: flex; }\n  .input-group-prepend .btn,\n  .input-group-append .btn {\n    position: relative;\n    z-index: 2; }\n    .input-group-prepend .btn:focus,\n    .input-group-append .btn:focus {\n      z-index: 3; }\n  .input-group-prepend .btn + .btn,\n  .input-group-prepend .btn + .input-group-text,\n  .input-group-prepend .input-group-text + .input-group-text,\n  .input-group-prepend .input-group-text + .btn,\n  .input-group-append .btn + .btn,\n  .input-group-append .btn + .input-group-text,\n  .input-group-append .input-group-text + .input-group-text,\n  .input-group-append .input-group-text + .btn {\n    margin-left: -1px; }\n\n.input-group-prepend {\n  margin-right: -1px; }\n\n.input-group-append {\n  margin-left: -1px; }\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem; }\n  .input-group-text input[type=\"radio\"],\n  .input-group-text input[type=\"checkbox\"] {\n    margin-top: 0; }\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: calc(1.5em + 1rem + 2px); }\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n  border-radius: 0.3rem; }\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: calc(1.5em + 0.5rem + 2px); }\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.76563rem;\n  line-height: 1.5;\n  border-radius: 0.2rem; }\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 1.75rem; }\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.25rem; }\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit; }\n  .list-group-item-action:hover, .list-group-item-action:focus {\n    z-index: 1;\n    color: #495057;\n    text-decoration: none;\n    background-color: #f8f9fa; }\n  .list-group-item-action:active {\n    color: #212529;\n    background-color: #e9ecef; }\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125); }\n  .list-group-item:first-child {\n    border-top-left-radius: inherit;\n    border-top-right-radius: inherit; }\n  .list-group-item:last-child {\n    border-bottom-right-radius: inherit;\n    border-bottom-left-radius: inherit; }\n  .list-group-item.disabled, .list-group-item:disabled {\n    color: #6c757d;\n    pointer-events: none;\n    background-color: #fff; }\n  .list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #1d35f8;\n    border-color: #1d35f8; }\n  .list-group-item + .list-group-item {\n    border-top-width: 0; }\n    .list-group-item + .list-group-item.active {\n      margin-top: -1px;\n      border-top-width: 1px; }\n\n.list-group-horizontal {\n  flex-direction: row; }\n  .list-group-horizontal > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0; }\n  .list-group-horizontal > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0; }\n  .list-group-horizontal > .list-group-item.active {\n    margin-top: 0; }\n  .list-group-horizontal > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0; }\n    .list-group-horizontal > .list-group-item + .list-group-item.active {\n      margin-left: -1px;\n      border-left-width: 1px; }\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row; }\n    .list-group-horizontal-sm > .list-group-item:first-child {\n      border-bottom-left-radius: 0.25rem;\n      border-top-right-radius: 0; }\n    .list-group-horizontal-sm > .list-group-item:last-child {\n      border-top-right-radius: 0.25rem;\n      border-bottom-left-radius: 0; }\n    .list-group-horizontal-sm > .list-group-item.active {\n      margin-top: 0; }\n    .list-group-horizontal-sm > .list-group-item + .list-group-item {\n      border-top-width: 1px;\n      border-left-width: 0; }\n      .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px; } }\n\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row; }\n    .list-group-horizontal-md > .list-group-item:first-child {\n      border-bottom-left-radius: 0.25rem;\n      border-top-right-radius: 0; }\n    .list-group-horizontal-md > .list-group-item:last-child {\n      border-top-right-radius: 0.25rem;\n      border-bottom-left-radius: 0; }\n    .list-group-horizontal-md > .list-group-item.active {\n      margin-top: 0; }\n    .list-group-horizontal-md > .list-group-item + .list-group-item {\n      border-top-width: 1px;\n      border-left-width: 0; }\n      .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px; } }\n\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row; }\n    .list-group-horizontal-lg > .list-group-item:first-child {\n      border-bottom-left-radius: 0.25rem;\n      border-top-right-radius: 0; }\n    .list-group-horizontal-lg > .list-group-item:last-child {\n      border-top-right-radius: 0.25rem;\n      border-bottom-left-radius: 0; }\n    .list-group-horizontal-lg > .list-group-item.active {\n      margin-top: 0; }\n    .list-group-horizontal-lg > .list-group-item + .list-group-item {\n      border-top-width: 1px;\n      border-left-width: 0; }\n      .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px; } }\n\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row; }\n    .list-group-horizontal-xl > .list-group-item:first-child {\n      border-bottom-left-radius: 0.25rem;\n      border-top-right-radius: 0; }\n    .list-group-horizontal-xl > .list-group-item:last-child {\n      border-top-right-radius: 0.25rem;\n      border-bottom-left-radius: 0; }\n    .list-group-horizontal-xl > .list-group-item.active {\n      margin-top: 0; }\n    .list-group-horizontal-xl > .list-group-item + .list-group-item {\n      border-top-width: 1px;\n      border-left-width: 0; }\n      .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n        margin-left: -1px;\n        border-left-width: 1px; } }\n\n.list-group-flush {\n  border-radius: 0; }\n  .list-group-flush > .list-group-item {\n    border-width: 0 0 1px; }\n    .list-group-flush > .list-group-item:last-child {\n      border-bottom-width: 0; }\n\n.list-group-item-primary {\n  color: #0f1c81;\n  background-color: #c0c6fd; }\n  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n    color: #0f1c81;\n    background-color: #a7b0fc; }\n  .list-group-item-primary.list-group-item-action.active {\n    color: #fff;\n    background-color: #0f1c81;\n    border-color: #0f1c81; }\n\n.list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db; }\n  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n    color: #383d41;\n    background-color: #c8cbcf; }\n  .list-group-item-secondary.list-group-item-action.active {\n    color: #fff;\n    background-color: #383d41;\n    border-color: #383d41; }\n\n.list-group-item-success {\n  color: #1f3d20;\n  background-color: #c8d9c9; }\n  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n    color: #1f3d20;\n    background-color: #b9cfba; }\n  .list-group-item-success.list-group-item-action.active {\n    color: #fff;\n    background-color: #1f3d20;\n    border-color: #1f3d20; }\n\n.list-group-item-info {\n  color: #1e465a;\n  background-color: #c8dde8; }\n  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n    color: #1e465a;\n    background-color: #b6d2e0; }\n  .list-group-item-info.list-group-item-action.active {\n    color: #fff;\n    background-color: #1e465a;\n    border-color: #1e465a; }\n\n.list-group-item-warning {\n  color: #855600;\n  background-color: #ffe6b8; }\n  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n    color: #855600;\n    background-color: #ffdd9f; }\n  .list-group-item-warning.list-group-item-action.active {\n    color: #fff;\n    background-color: #855600;\n    border-color: #855600; }\n\n.list-group-item-danger {\n  color: #74140d;\n  background-color: #f6c2bf; }\n  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n    color: #74140d;\n    background-color: #f3ada9; }\n  .list-group-item-danger.list-group-item-action.active {\n    color: #fff;\n    background-color: #74140d;\n    border-color: #74140d; }\n\n.list-group-item-light {\n  color: #818182;\n  background-color: #fdfdfe; }\n  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n    color: #818182;\n    background-color: #ececf6; }\n  .list-group-item-light.list-group-item-action.active {\n    color: #fff;\n    background-color: #818182;\n    border-color: #818182; }\n\n.list-group-item-dark {\n  color: #1b1e21;\n  background-color: #c6c8ca; }\n  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n    color: #1b1e21;\n    background-color: #b9bbbe; }\n  .list-group-item-dark.list-group-item-action.active {\n    color: #fff;\n    background-color: #1b1e21;\n    border-color: #1b1e21; }\n\n.align-baseline {\n  vertical-align: baseline !important; }\n\n.align-top {\n  vertical-align: top !important; }\n\n.align-middle {\n  vertical-align: middle !important; }\n\n.align-bottom {\n  vertical-align: bottom !important; }\n\n.align-text-bottom {\n  vertical-align: text-bottom !important; }\n\n.align-text-top {\n  vertical-align: text-top !important; }\n\n.bg-primary {\n  background-color: #1d35f8 !important; }\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: #071edb !important; }\n\n.bg-secondary {\n  background-color: #6c757d !important; }\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: #545b62 !important; }\n\n.bg-success {\n  background-color: #3c763d !important; }\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: #2b542c !important; }\n\n.bg-info {\n  background-color: #3a87ad !important; }\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: #2d6987 !important; }\n\n.bg-warning {\n  background-color: #ffa500 !important; }\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: #cc8400 !important; }\n\n.bg-danger {\n  background-color: #e02619 !important; }\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: #b21e14 !important; }\n\n.bg-light {\n  background-color: #f8f9fa !important; }\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: #dae0e5 !important; }\n\n.bg-dark {\n  background-color: #343a40 !important; }\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: #1d2124 !important; }\n\n.bg-white {\n  background-color: #fff !important; }\n\n.bg-transparent {\n  background-color: transparent !important; }\n\n.border {\n  border: 1px solid #bbbbbb !important; }\n\n.border-top {\n  border-top: 1px solid #bbbbbb !important; }\n\n.border-right {\n  border-right: 1px solid #bbbbbb !important; }\n\n.border-bottom {\n  border-bottom: 1px solid #bbbbbb !important; }\n\n.border-left {\n  border-left: 1px solid #bbbbbb !important; }\n\n.border-0 {\n  border: 0 !important; }\n\n.border-top-0 {\n  border-top: 0 !important; }\n\n.border-right-0 {\n  border-right: 0 !important; }\n\n.border-bottom-0 {\n  border-bottom: 0 !important; }\n\n.border-left-0 {\n  border-left: 0 !important; }\n\n.border-primary {\n  border-color: #1d35f8 !important; }\n\n.border-secondary {\n  border-color: #6c757d !important; }\n\n.border-success {\n  border-color: #3c763d !important; }\n\n.border-info {\n  border-color: #3a87ad !important; }\n\n.border-warning {\n  border-color: #ffa500 !important; }\n\n.border-danger {\n  border-color: #e02619 !important; }\n\n.border-light {\n  border-color: #f8f9fa !important; }\n\n.border-dark {\n  border-color: #343a40 !important; }\n\n.border-white {\n  border-color: #fff !important; }\n\n.rounded-sm {\n  border-radius: 0.2rem !important; }\n\n.rounded {\n  border-radius: 0.25rem !important; }\n\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important; }\n\n.rounded-right {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important; }\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important; }\n\n.rounded-left {\n  border-top-left-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important; }\n\n.rounded-lg {\n  border-radius: 0.3rem !important; }\n\n.rounded-circle {\n  border-radius: 50% !important; }\n\n.rounded-pill {\n  border-radius: 50rem !important; }\n\n.rounded-0 {\n  border-radius: 0 !important; }\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\"; }\n\n.d-none {\n  display: none !important; }\n\n.d-inline {\n  display: inline !important; }\n\n.d-inline-block {\n  display: inline-block !important; }\n\n.d-block {\n  display: block !important; }\n\n.d-table {\n  display: table !important; }\n\n.d-table-row {\n  display: table-row !important; }\n\n.d-table-cell {\n  display: table-cell !important; }\n\n.d-flex {\n  display: flex !important; }\n\n.d-inline-flex {\n  display: inline-flex !important; }\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important; }\n  .d-sm-inline {\n    display: inline !important; }\n  .d-sm-inline-block {\n    display: inline-block !important; }\n  .d-sm-block {\n    display: block !important; }\n  .d-sm-table {\n    display: table !important; }\n  .d-sm-table-row {\n    display: table-row !important; }\n  .d-sm-table-cell {\n    display: table-cell !important; }\n  .d-sm-flex {\n    display: flex !important; }\n  .d-sm-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important; }\n  .d-md-inline {\n    display: inline !important; }\n  .d-md-inline-block {\n    display: inline-block !important; }\n  .d-md-block {\n    display: block !important; }\n  .d-md-table {\n    display: table !important; }\n  .d-md-table-row {\n    display: table-row !important; }\n  .d-md-table-cell {\n    display: table-cell !important; }\n  .d-md-flex {\n    display: flex !important; }\n  .d-md-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important; }\n  .d-lg-inline {\n    display: inline !important; }\n  .d-lg-inline-block {\n    display: inline-block !important; }\n  .d-lg-block {\n    display: block !important; }\n  .d-lg-table {\n    display: table !important; }\n  .d-lg-table-row {\n    display: table-row !important; }\n  .d-lg-table-cell {\n    display: table-cell !important; }\n  .d-lg-flex {\n    display: flex !important; }\n  .d-lg-inline-flex {\n    display: inline-flex !important; } }\n\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important; }\n  .d-xl-inline {\n    display: inline !important; }\n  .d-xl-inline-block {\n    display: inline-block !important; }\n  .d-xl-block {\n    display: block !important; }\n  .d-xl-table {\n    display: table !important; }\n  .d-xl-table-row {\n    display: table-row !important; }\n  .d-xl-table-cell {\n    display: table-cell !important; }\n  .d-xl-flex {\n    display: flex !important; }\n  .d-xl-inline-flex {\n    display: inline-flex !important; } }\n\n@media print {\n  .d-print-none {\n    display: none !important; }\n  .d-print-inline {\n    display: inline !important; }\n  .d-print-inline-block {\n    display: inline-block !important; }\n  .d-print-block {\n    display: block !important; }\n  .d-print-table {\n    display: table !important; }\n  .d-print-table-row {\n    display: table-row !important; }\n  .d-print-table-cell {\n    display: table-cell !important; }\n  .d-print-flex {\n    display: flex !important; }\n  .d-print-inline-flex {\n    display: inline-flex !important; } }\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden; }\n  .embed-responsive::before {\n    display: block;\n    content: \"\"; }\n  .embed-responsive .embed-responsive-item,\n  .embed-responsive iframe,\n  .embed-responsive embed,\n  .embed-responsive object,\n  .embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0; }\n\n.embed-responsive-21by9::before {\n  padding-top: 42.85714%; }\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%; }\n\n.embed-responsive-4by3::before {\n  padding-top: 75%; }\n\n.embed-responsive-1by1::before {\n  padding-top: 100%; }\n\n.flex-row {\n  flex-direction: row !important; }\n\n.flex-column {\n  flex-direction: column !important; }\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important; }\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important; }\n\n.flex-wrap {\n  flex-wrap: wrap !important; }\n\n.flex-nowrap {\n  flex-wrap: nowrap !important; }\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important; }\n\n.flex-fill {\n  flex: 1 1 auto !important; }\n\n.flex-grow-0 {\n  flex-grow: 0 !important; }\n\n.flex-grow-1 {\n  flex-grow: 1 !important; }\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important; }\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important; }\n\n.justify-content-start {\n  justify-content: flex-start !important; }\n\n.justify-content-end {\n  justify-content: flex-end !important; }\n\n.justify-content-center {\n  justify-content: center !important; }\n\n.justify-content-between {\n  justify-content: space-between !important; }\n\n.justify-content-around {\n  justify-content: space-around !important; }\n\n.align-items-start {\n  align-items: flex-start !important; }\n\n.align-items-end {\n  align-items: flex-end !important; }\n\n.align-items-center {\n  align-items: center !important; }\n\n.align-items-baseline {\n  align-items: baseline !important; }\n\n.align-items-stretch {\n  align-items: stretch !important; }\n\n.align-content-start {\n  align-content: flex-start !important; }\n\n.align-content-end {\n  align-content: flex-end !important; }\n\n.align-content-center {\n  align-content: center !important; }\n\n.align-content-between {\n  align-content: space-between !important; }\n\n.align-content-around {\n  align-content: space-around !important; }\n\n.align-content-stretch {\n  align-content: stretch !important; }\n\n.align-self-auto {\n  align-self: auto !important; }\n\n.align-self-start {\n  align-self: flex-start !important; }\n\n.align-self-end {\n  align-self: flex-end !important; }\n\n.align-self-center {\n  align-self: center !important; }\n\n.align-self-baseline {\n  align-self: baseline !important; }\n\n.align-self-stretch {\n  align-self: stretch !important; }\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important; }\n  .flex-sm-column {\n    flex-direction: column !important; }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important; }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-sm-fill {\n    flex: 1 1 auto !important; }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-sm-start {\n    justify-content: flex-start !important; }\n  .justify-content-sm-end {\n    justify-content: flex-end !important; }\n  .justify-content-sm-center {\n    justify-content: center !important; }\n  .justify-content-sm-between {\n    justify-content: space-between !important; }\n  .justify-content-sm-around {\n    justify-content: space-around !important; }\n  .align-items-sm-start {\n    align-items: flex-start !important; }\n  .align-items-sm-end {\n    align-items: flex-end !important; }\n  .align-items-sm-center {\n    align-items: center !important; }\n  .align-items-sm-baseline {\n    align-items: baseline !important; }\n  .align-items-sm-stretch {\n    align-items: stretch !important; }\n  .align-content-sm-start {\n    align-content: flex-start !important; }\n  .align-content-sm-end {\n    align-content: flex-end !important; }\n  .align-content-sm-center {\n    align-content: center !important; }\n  .align-content-sm-between {\n    align-content: space-between !important; }\n  .align-content-sm-around {\n    align-content: space-around !important; }\n  .align-content-sm-stretch {\n    align-content: stretch !important; }\n  .align-self-sm-auto {\n    align-self: auto !important; }\n  .align-self-sm-start {\n    align-self: flex-start !important; }\n  .align-self-sm-end {\n    align-self: flex-end !important; }\n  .align-self-sm-center {\n    align-self: center !important; }\n  .align-self-sm-baseline {\n    align-self: baseline !important; }\n  .align-self-sm-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important; }\n  .flex-md-column {\n    flex-direction: column !important; }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-md-wrap {\n    flex-wrap: wrap !important; }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-md-fill {\n    flex: 1 1 auto !important; }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-md-start {\n    justify-content: flex-start !important; }\n  .justify-content-md-end {\n    justify-content: flex-end !important; }\n  .justify-content-md-center {\n    justify-content: center !important; }\n  .justify-content-md-between {\n    justify-content: space-between !important; }\n  .justify-content-md-around {\n    justify-content: space-around !important; }\n  .align-items-md-start {\n    align-items: flex-start !important; }\n  .align-items-md-end {\n    align-items: flex-end !important; }\n  .align-items-md-center {\n    align-items: center !important; }\n  .align-items-md-baseline {\n    align-items: baseline !important; }\n  .align-items-md-stretch {\n    align-items: stretch !important; }\n  .align-content-md-start {\n    align-content: flex-start !important; }\n  .align-content-md-end {\n    align-content: flex-end !important; }\n  .align-content-md-center {\n    align-content: center !important; }\n  .align-content-md-between {\n    align-content: space-between !important; }\n  .align-content-md-around {\n    align-content: space-around !important; }\n  .align-content-md-stretch {\n    align-content: stretch !important; }\n  .align-self-md-auto {\n    align-self: auto !important; }\n  .align-self-md-start {\n    align-self: flex-start !important; }\n  .align-self-md-end {\n    align-self: flex-end !important; }\n  .align-self-md-center {\n    align-self: center !important; }\n  .align-self-md-baseline {\n    align-self: baseline !important; }\n  .align-self-md-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important; }\n  .flex-lg-column {\n    flex-direction: column !important; }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important; }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-lg-fill {\n    flex: 1 1 auto !important; }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-lg-start {\n    justify-content: flex-start !important; }\n  .justify-content-lg-end {\n    justify-content: flex-end !important; }\n  .justify-content-lg-center {\n    justify-content: center !important; }\n  .justify-content-lg-between {\n    justify-content: space-between !important; }\n  .justify-content-lg-around {\n    justify-content: space-around !important; }\n  .align-items-lg-start {\n    align-items: flex-start !important; }\n  .align-items-lg-end {\n    align-items: flex-end !important; }\n  .align-items-lg-center {\n    align-items: center !important; }\n  .align-items-lg-baseline {\n    align-items: baseline !important; }\n  .align-items-lg-stretch {\n    align-items: stretch !important; }\n  .align-content-lg-start {\n    align-content: flex-start !important; }\n  .align-content-lg-end {\n    align-content: flex-end !important; }\n  .align-content-lg-center {\n    align-content: center !important; }\n  .align-content-lg-between {\n    align-content: space-between !important; }\n  .align-content-lg-around {\n    align-content: space-around !important; }\n  .align-content-lg-stretch {\n    align-content: stretch !important; }\n  .align-self-lg-auto {\n    align-self: auto !important; }\n  .align-self-lg-start {\n    align-self: flex-start !important; }\n  .align-self-lg-end {\n    align-self: flex-end !important; }\n  .align-self-lg-center {\n    align-self: center !important; }\n  .align-self-lg-baseline {\n    align-self: baseline !important; }\n  .align-self-lg-stretch {\n    align-self: stretch !important; } }\n\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important; }\n  .flex-xl-column {\n    flex-direction: column !important; }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important; }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important; }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important; }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important; }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important; }\n  .flex-xl-fill {\n    flex: 1 1 auto !important; }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important; }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important; }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important; }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important; }\n  .justify-content-xl-start {\n    justify-content: flex-start !important; }\n  .justify-content-xl-end {\n    justify-content: flex-end !important; }\n  .justify-content-xl-center {\n    justify-content: center !important; }\n  .justify-content-xl-between {\n    justify-content: space-between !important; }\n  .justify-content-xl-around {\n    justify-content: space-around !important; }\n  .align-items-xl-start {\n    align-items: flex-start !important; }\n  .align-items-xl-end {\n    align-items: flex-end !important; }\n  .align-items-xl-center {\n    align-items: center !important; }\n  .align-items-xl-baseline {\n    align-items: baseline !important; }\n  .align-items-xl-stretch {\n    align-items: stretch !important; }\n  .align-content-xl-start {\n    align-content: flex-start !important; }\n  .align-content-xl-end {\n    align-content: flex-end !important; }\n  .align-content-xl-center {\n    align-content: center !important; }\n  .align-content-xl-between {\n    align-content: space-between !important; }\n  .align-content-xl-around {\n    align-content: space-around !important; }\n  .align-content-xl-stretch {\n    align-content: stretch !important; }\n  .align-self-xl-auto {\n    align-self: auto !important; }\n  .align-self-xl-start {\n    align-self: flex-start !important; }\n  .align-self-xl-end {\n    align-self: flex-end !important; }\n  .align-self-xl-center {\n    align-self: center !important; }\n  .align-self-xl-baseline {\n    align-self: baseline !important; }\n  .align-self-xl-stretch {\n    align-self: stretch !important; } }\n\n.float-left {\n  float: left !important; }\n\n.float-right {\n  float: right !important; }\n\n.float-none {\n  float: none !important; }\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important; }\n  .float-sm-right {\n    float: right !important; }\n  .float-sm-none {\n    float: none !important; } }\n\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important; }\n  .float-md-right {\n    float: right !important; }\n  .float-md-none {\n    float: none !important; } }\n\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important; }\n  .float-lg-right {\n    float: right !important; }\n  .float-lg-none {\n    float: none !important; } }\n\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important; }\n  .float-xl-right {\n    float: right !important; }\n  .float-xl-none {\n    float: none !important; } }\n\n.user-select-all {\n  user-select: all !important; }\n\n.user-select-auto {\n  user-select: auto !important; }\n\n.user-select-none {\n  user-select: none !important; }\n\n.overflow-auto {\n  overflow: auto !important; }\n\n.overflow-hidden {\n  overflow: hidden !important; }\n\n.position-static {\n  position: static !important; }\n\n.position-relative {\n  position: relative !important; }\n\n.position-absolute {\n  position: absolute !important; }\n\n.position-fixed {\n  position: fixed !important; }\n\n.position-sticky {\n  position: sticky !important; }\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030; }\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030; }\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020; } }\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal; }\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important; }\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important; }\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important; }\n\n.shadow-none {\n  box-shadow: none !important; }\n\n.w-25 {\n  width: 25% !important; }\n\n.w-50 {\n  width: 50% !important; }\n\n.w-75 {\n  width: 75% !important; }\n\n.w-100 {\n  width: 100% !important; }\n\n.w-auto {\n  width: auto !important; }\n\n.h-25 {\n  height: 25% !important; }\n\n.h-50 {\n  height: 50% !important; }\n\n.h-75 {\n  height: 75% !important; }\n\n.h-100 {\n  height: 100% !important; }\n\n.h-auto {\n  height: auto !important; }\n\n.mw-100 {\n  max-width: 100% !important; }\n\n.mh-100 {\n  max-height: 100% !important; }\n\n.min-vw-100 {\n  min-width: 100vw !important; }\n\n.min-vh-100 {\n  min-height: 100vh !important; }\n\n.vw-100 {\n  width: 100vw !important; }\n\n.vh-100 {\n  height: 100vh !important; }\n\n.m-0 {\n  margin: 0 !important; }\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important; }\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important; }\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important; }\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important; }\n\n.m-1 {\n  margin: 0.25rem !important; }\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important; }\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important; }\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important; }\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important; }\n\n.m-2 {\n  margin: 0.5rem !important; }\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important; }\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important; }\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important; }\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important; }\n\n.m-3 {\n  margin: 1rem !important; }\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important; }\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important; }\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important; }\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important; }\n\n.m-4 {\n  margin: 1.5rem !important; }\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important; }\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important; }\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important; }\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important; }\n\n.m-5 {\n  margin: 3rem !important; }\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important; }\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important; }\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important; }\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important; }\n\n.p-0 {\n  padding: 0 !important; }\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important; }\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important; }\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important; }\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important; }\n\n.p-1 {\n  padding: 0.25rem !important; }\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important; }\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important; }\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important; }\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important; }\n\n.p-2 {\n  padding: 0.5rem !important; }\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important; }\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important; }\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important; }\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important; }\n\n.p-3 {\n  padding: 1rem !important; }\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important; }\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important; }\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important; }\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important; }\n\n.p-4 {\n  padding: 1.5rem !important; }\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important; }\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important; }\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important; }\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important; }\n\n.p-5 {\n  padding: 3rem !important; }\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important; }\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important; }\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important; }\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important; }\n\n.m-n1 {\n  margin: -0.25rem !important; }\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important; }\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important; }\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important; }\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important; }\n\n.m-n2 {\n  margin: -0.5rem !important; }\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important; }\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important; }\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important; }\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important; }\n\n.m-n3 {\n  margin: -1rem !important; }\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important; }\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important; }\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important; }\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important; }\n\n.m-n4 {\n  margin: -1.5rem !important; }\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important; }\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important; }\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important; }\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important; }\n\n.m-n5 {\n  margin: -3rem !important; }\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important; }\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important; }\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important; }\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important; }\n\n.m-auto {\n  margin: auto !important; }\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important; }\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important; }\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important; }\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important; }\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important; }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important; }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important; }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important; }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important; }\n  .m-sm-1 {\n    margin: 0.25rem !important; }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important; }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important; }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important; }\n  .m-sm-2 {\n    margin: 0.5rem !important; }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important; }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important; }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important; }\n  .m-sm-3 {\n    margin: 1rem !important; }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important; }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important; }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important; }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important; }\n  .m-sm-4 {\n    margin: 1.5rem !important; }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important; }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important; }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important; }\n  .m-sm-5 {\n    margin: 3rem !important; }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important; }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important; }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important; }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important; }\n  .p-sm-0 {\n    padding: 0 !important; }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important; }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important; }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important; }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important; }\n  .p-sm-1 {\n    padding: 0.25rem !important; }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important; }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important; }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important; }\n  .p-sm-2 {\n    padding: 0.5rem !important; }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important; }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important; }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important; }\n  .p-sm-3 {\n    padding: 1rem !important; }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important; }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important; }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important; }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important; }\n  .p-sm-4 {\n    padding: 1.5rem !important; }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important; }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important; }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important; }\n  .p-sm-5 {\n    padding: 3rem !important; }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important; }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important; }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important; }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important; }\n  .m-sm-n1 {\n    margin: -0.25rem !important; }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important; }\n  .m-sm-n2 {\n    margin: -0.5rem !important; }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important; }\n  .m-sm-n3 {\n    margin: -1rem !important; }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important; }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important; }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important; }\n  .m-sm-n4 {\n    margin: -1.5rem !important; }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important; }\n  .m-sm-n5 {\n    margin: -3rem !important; }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important; }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important; }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important; }\n  .m-sm-auto {\n    margin: auto !important; }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important; }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important; }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important; }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important; }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important; }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important; }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important; }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important; }\n  .m-md-1 {\n    margin: 0.25rem !important; }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important; }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important; }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important; }\n  .m-md-2 {\n    margin: 0.5rem !important; }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important; }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important; }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important; }\n  .m-md-3 {\n    margin: 1rem !important; }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important; }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important; }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important; }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important; }\n  .m-md-4 {\n    margin: 1.5rem !important; }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important; }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important; }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important; }\n  .m-md-5 {\n    margin: 3rem !important; }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important; }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important; }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important; }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important; }\n  .p-md-0 {\n    padding: 0 !important; }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important; }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important; }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important; }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important; }\n  .p-md-1 {\n    padding: 0.25rem !important; }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important; }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important; }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important; }\n  .p-md-2 {\n    padding: 0.5rem !important; }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important; }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important; }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important; }\n  .p-md-3 {\n    padding: 1rem !important; }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important; }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important; }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important; }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important; }\n  .p-md-4 {\n    padding: 1.5rem !important; }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important; }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important; }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important; }\n  .p-md-5 {\n    padding: 3rem !important; }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important; }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important; }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important; }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important; }\n  .m-md-n1 {\n    margin: -0.25rem !important; }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important; }\n  .m-md-n2 {\n    margin: -0.5rem !important; }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important; }\n  .m-md-n3 {\n    margin: -1rem !important; }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important; }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important; }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important; }\n  .m-md-n4 {\n    margin: -1.5rem !important; }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important; }\n  .m-md-n5 {\n    margin: -3rem !important; }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important; }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important; }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important; }\n  .m-md-auto {\n    margin: auto !important; }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important; }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important; }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important; }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important; }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important; }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important; }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important; }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important; }\n  .m-lg-1 {\n    margin: 0.25rem !important; }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important; }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important; }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important; }\n  .m-lg-2 {\n    margin: 0.5rem !important; }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important; }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important; }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important; }\n  .m-lg-3 {\n    margin: 1rem !important; }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important; }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important; }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important; }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important; }\n  .m-lg-4 {\n    margin: 1.5rem !important; }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important; }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important; }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important; }\n  .m-lg-5 {\n    margin: 3rem !important; }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important; }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important; }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important; }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important; }\n  .p-lg-0 {\n    padding: 0 !important; }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important; }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important; }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important; }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important; }\n  .p-lg-1 {\n    padding: 0.25rem !important; }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important; }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important; }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important; }\n  .p-lg-2 {\n    padding: 0.5rem !important; }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important; }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important; }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important; }\n  .p-lg-3 {\n    padding: 1rem !important; }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important; }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important; }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important; }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important; }\n  .p-lg-4 {\n    padding: 1.5rem !important; }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important; }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important; }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important; }\n  .p-lg-5 {\n    padding: 3rem !important; }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important; }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important; }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important; }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important; }\n  .m-lg-n1 {\n    margin: -0.25rem !important; }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important; }\n  .m-lg-n2 {\n    margin: -0.5rem !important; }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important; }\n  .m-lg-n3 {\n    margin: -1rem !important; }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important; }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important; }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important; }\n  .m-lg-n4 {\n    margin: -1.5rem !important; }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important; }\n  .m-lg-n5 {\n    margin: -3rem !important; }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important; }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important; }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important; }\n  .m-lg-auto {\n    margin: auto !important; }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important; }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important; }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important; }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important; } }\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important; }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important; }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important; }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important; }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important; }\n  .m-xl-1 {\n    margin: 0.25rem !important; }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important; }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important; }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important; }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important; }\n  .m-xl-2 {\n    margin: 0.5rem !important; }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important; }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important; }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important; }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important; }\n  .m-xl-3 {\n    margin: 1rem !important; }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important; }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important; }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important; }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important; }\n  .m-xl-4 {\n    margin: 1.5rem !important; }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important; }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important; }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important; }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important; }\n  .m-xl-5 {\n    margin: 3rem !important; }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important; }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important; }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important; }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important; }\n  .p-xl-0 {\n    padding: 0 !important; }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important; }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important; }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important; }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important; }\n  .p-xl-1 {\n    padding: 0.25rem !important; }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important; }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important; }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important; }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important; }\n  .p-xl-2 {\n    padding: 0.5rem !important; }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important; }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important; }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important; }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important; }\n  .p-xl-3 {\n    padding: 1rem !important; }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important; }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important; }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important; }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important; }\n  .p-xl-4 {\n    padding: 1.5rem !important; }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important; }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important; }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important; }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important; }\n  .p-xl-5 {\n    padding: 3rem !important; }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important; }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important; }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important; }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important; }\n  .m-xl-n1 {\n    margin: -0.25rem !important; }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important; }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important; }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important; }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important; }\n  .m-xl-n2 {\n    margin: -0.5rem !important; }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important; }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important; }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important; }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important; }\n  .m-xl-n3 {\n    margin: -1rem !important; }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important; }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important; }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important; }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important; }\n  .m-xl-n4 {\n    margin: -1.5rem !important; }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important; }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important; }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important; }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important; }\n  .m-xl-n5 {\n    margin: -3rem !important; }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important; }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important; }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important; }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important; }\n  .m-xl-auto {\n    margin: auto !important; }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important; }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important; }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important; }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important; } }\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0); }\n\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important; }\n\n.text-justify {\n  text-align: justify !important; }\n\n.text-wrap {\n  white-space: normal !important; }\n\n.text-nowrap {\n  white-space: nowrap !important; }\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.text-left {\n  text-align: left !important; }\n\n.text-right {\n  text-align: right !important; }\n\n.text-center {\n  text-align: center !important; }\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important; }\n  .text-sm-right {\n    text-align: right !important; }\n  .text-sm-center {\n    text-align: center !important; } }\n\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important; }\n  .text-md-right {\n    text-align: right !important; }\n  .text-md-center {\n    text-align: center !important; } }\n\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important; }\n  .text-lg-right {\n    text-align: right !important; }\n  .text-lg-center {\n    text-align: center !important; } }\n\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important; }\n  .text-xl-right {\n    text-align: right !important; }\n  .text-xl-center {\n    text-align: center !important; } }\n\n.text-lowercase {\n  text-transform: lowercase !important; }\n\n.text-uppercase {\n  text-transform: uppercase !important; }\n\n.text-capitalize {\n  text-transform: capitalize !important; }\n\n.font-weight-light {\n  font-weight: 300 !important; }\n\n.font-weight-lighter {\n  font-weight: lighter !important; }\n\n.font-weight-normal {\n  font-weight: 400 !important; }\n\n.font-weight-bold {\n  font-weight: 700 !important; }\n\n.font-weight-bolder {\n  font-weight: bolder !important; }\n\n.font-italic {\n  font-style: italic !important; }\n\n.text-white {\n  color: #fff !important; }\n\n.text-primary {\n  color: #1d35f8 !important; }\n\na.text-primary:hover, a.text-primary:focus {\n  color: #061bc2 !important; }\n\n.text-secondary {\n  color: #6c757d !important; }\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: #494f54 !important; }\n\n.text-success {\n  color: #3c763d !important; }\n\na.text-success:hover, a.text-success:focus {\n  color: #224323 !important; }\n\n.text-info {\n  color: #3a87ad !important; }\n\na.text-info:hover, a.text-info:focus {\n  color: #275a74 !important; }\n\n.text-warning {\n  color: #ffa500 !important; }\n\na.text-warning:hover, a.text-warning:focus {\n  color: #b37400 !important; }\n\n.text-danger {\n  color: #e02619 !important; }\n\na.text-danger:hover, a.text-danger:focus {\n  color: #9b1a11 !important; }\n\n.text-light {\n  color: #f8f9fa !important; }\n\na.text-light:hover, a.text-light:focus {\n  color: #cbd3da !important; }\n\n.text-dark {\n  color: #343a40 !important; }\n\na.text-dark:hover, a.text-dark:focus {\n  color: #121416 !important; }\n\n.text-body {\n  color: #212529 !important; }\n\n.text-muted {\n  color: #6c757d !important; }\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important; }\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important; }\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0; }\n\n.text-decoration-none {\n  text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important;\n  word-wrap: break-word !important; }\n\n.text-reset {\n  color: inherit !important; }\n\n.visible {\n  visibility: visible !important; }\n\n.invisible {\n  visibility: hidden !important; }\n\n.media {\n  display: flex;\n  align-items: flex-start; }\n\n.media-body {\n  flex: 1; }\n\n.fade {\n  transition: opacity 0.15s linear; }\n  @media (prefers-reduced-motion: reduce) {\n    .fade {\n      transition: none; } }\n  .fade:not(.show) {\n    opacity: 0; }\n\n.collapse:not(.show) {\n  display: none; }\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease; }\n  @media (prefers-reduced-motion: reduce) {\n    .collapsing {\n      transition: none; } }\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none; }\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem; }\n  .nav-link:hover, .nav-link:focus {\n    text-decoration: none; }\n  .nav-link.disabled {\n    color: #6c757d;\n    pointer-events: none;\n    cursor: default; }\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6; }\n  .nav-tabs .nav-link {\n    margin-bottom: -1px;\n    border: 1px solid transparent;\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem; }\n    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n      border-color: #e9ecef #e9ecef #dee2e6; }\n    .nav-tabs .nav-link.disabled {\n      color: #6c757d;\n      background-color: transparent;\n      border-color: transparent; }\n  .nav-tabs .nav-link.active,\n  .nav-tabs .nav-item.show .nav-link {\n    color: #495057;\n    background-color: #fff;\n    border-color: #dee2e6 #dee2e6 #fff; }\n  .nav-tabs .dropdown-menu {\n    margin-top: -1px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0; }\n\n.nav-pills .nav-link {\n  border-radius: 0.25rem; }\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #1d35f8; }\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center; }\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center; }\n\n.tab-content > .tab-pane {\n  display: none; }\n\n.tab-content > .active {\n  display: block; }\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.76563rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem; }\n  .popover .arrow {\n    position: absolute;\n    display: block;\n    width: 1rem;\n    height: 0.5rem;\n    margin: 0 0.3rem; }\n    .popover .arrow::before, .popover .arrow::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid; }\n\n.bs-popover-top, .bs-popover-auto[x-placement^=\"top\"] {\n  margin-bottom: 0.5rem; }\n  .bs-popover-top > .arrow, .bs-popover-auto[x-placement^=\"top\"] > .arrow {\n    bottom: calc(-0.5rem - 1px); }\n    .bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=\"top\"] > .arrow::before {\n      bottom: 0;\n      border-width: 0.5rem 0.5rem 0;\n      border-top-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=\"top\"] > .arrow::after {\n      bottom: 1px;\n      border-width: 0.5rem 0.5rem 0;\n      border-top-color: #fff; }\n\n.bs-popover-right, .bs-popover-auto[x-placement^=\"right\"] {\n  margin-left: 0.5rem; }\n  .bs-popover-right > .arrow, .bs-popover-auto[x-placement^=\"right\"] > .arrow {\n    left: calc(-0.5rem - 1px);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0; }\n    .bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=\"right\"] > .arrow::before {\n      left: 0;\n      border-width: 0.5rem 0.5rem 0.5rem 0;\n      border-right-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=\"right\"] > .arrow::after {\n      left: 1px;\n      border-width: 0.5rem 0.5rem 0.5rem 0;\n      border-right-color: #fff; }\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=\"bottom\"] {\n  margin-top: 0.5rem; }\n  .bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow {\n    top: calc(-0.5rem - 1px); }\n    .bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before {\n      top: 0;\n      border-width: 0 0.5rem 0.5rem 0.5rem;\n      border-bottom-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::after {\n      top: 1px;\n      border-width: 0 0.5rem 0.5rem 0.5rem;\n      border-bottom-color: #fff; }\n  .bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: 1rem;\n    margin-left: -0.5rem;\n    content: \"\";\n    border-bottom: 1px solid #f7f7f7; }\n\n.bs-popover-left, .bs-popover-auto[x-placement^=\"left\"] {\n  margin-right: 0.5rem; }\n  .bs-popover-left > .arrow, .bs-popover-auto[x-placement^=\"left\"] > .arrow {\n    right: calc(-0.5rem - 1px);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0; }\n    .bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=\"left\"] > .arrow::before {\n      right: 0;\n      border-width: 0.5rem 0 0.5rem 0.5rem;\n      border-left-color: rgba(0, 0, 0, 0.25); }\n    .bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=\"left\"] > .arrow::after {\n      right: 1px;\n      border-width: 0.5rem 0 0.5rem 0.5rem;\n      border-left-color: #fff; }\n\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px); }\n  .popover-header:empty {\n    display: none; }\n\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #212529; }\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem; }\n  .navbar .container,\n  .navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between; }\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.33594rem;\n  padding-bottom: 0.33594rem;\n  margin-right: 1rem;\n  font-size: 1.09375rem;\n  line-height: inherit;\n  white-space: nowrap; }\n  .navbar-brand:hover, .navbar-brand:focus {\n    text-decoration: none; }\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none; }\n  .navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0; }\n  .navbar-nav .dropdown-menu {\n    position: static;\n    float: none; }\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem; }\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center; }\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.09375rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem; }\n  .navbar-toggler:hover, .navbar-toggler:focus {\n    text-decoration: none; }\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat; }\n\n.navbar-nav-scroll {\n  max-height: 75vh;\n  overflow-y: auto; }\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-sm .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-sm .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-sm .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-sm > .container,\n    .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {\n      flex-wrap: nowrap; }\n    .navbar-expand-sm .navbar-nav-scroll {\n      overflow: visible; }\n    .navbar-expand-sm .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-sm .navbar-toggler {\n      display: none; } }\n\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-md .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-md > .container,\n    .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {\n      flex-wrap: nowrap; }\n    .navbar-expand-md .navbar-nav-scroll {\n      overflow: visible; }\n    .navbar-expand-md .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-md .navbar-toggler {\n      display: none; } }\n\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-lg .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-lg .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-lg > .container,\n    .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {\n      flex-wrap: nowrap; }\n    .navbar-expand-lg .navbar-nav-scroll {\n      overflow: visible; }\n    .navbar-expand-lg .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-lg .navbar-toggler {\n      display: none; } }\n\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {\n    padding-right: 0;\n    padding-left: 0; } }\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start; }\n    .navbar-expand-xl .navbar-nav {\n      flex-direction: row; }\n      .navbar-expand-xl .navbar-nav .dropdown-menu {\n        position: absolute; }\n      .navbar-expand-xl .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem; }\n    .navbar-expand-xl > .container,\n    .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {\n      flex-wrap: nowrap; }\n    .navbar-expand-xl .navbar-nav-scroll {\n      overflow: visible; }\n    .navbar-expand-xl .navbar-collapse {\n      display: flex !important;\n      flex-basis: auto; }\n    .navbar-expand-xl .navbar-toggler {\n      display: none; } }\n\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start; }\n  .navbar-expand > .container,\n  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {\n    padding-right: 0;\n    padding-left: 0; }\n  .navbar-expand .navbar-nav {\n    flex-direction: row; }\n    .navbar-expand .navbar-nav .dropdown-menu {\n      position: absolute; }\n    .navbar-expand .navbar-nav .nav-link {\n      padding-right: 0.5rem;\n      padding-left: 0.5rem; }\n  .navbar-expand > .container,\n  .navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {\n    flex-wrap: nowrap; }\n  .navbar-expand .navbar-nav-scroll {\n    overflow: visible; }\n  .navbar-expand .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto; }\n  .navbar-expand .navbar-toggler {\n    display: none; }\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9); }\n  .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n    color: rgba(0, 0, 0, 0.9); }\n\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5); }\n  .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n    color: rgba(0, 0, 0, 0.7); }\n  .navbar-light .navbar-nav .nav-link.disabled {\n    color: rgba(0, 0, 0, 0.3); }\n\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9); }\n\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1); }\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"); }\n\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5); }\n  .navbar-light .navbar-text a {\n    color: rgba(0, 0, 0, 0.9); }\n    .navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n      color: rgba(0, 0, 0, 0.9); }\n\n.navbar-dark .navbar-brand {\n  color: #fff; }\n  .navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n    color: #fff; }\n\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5); }\n  .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n    color: rgba(255, 255, 255, 0.75); }\n  .navbar-dark .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, 0.25); }\n\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff; }\n\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1); }\n\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"); }\n\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5); }\n  .navbar-dark .navbar-text a {\n    color: #fff; }\n    .navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n      color: #fff; }\n\n/* Slider */\n.slick-loading .slick-list {\n  background: #fff url(\"/imagesajax-loader.gif\") center center no-repeat; }\n\n/* Icons */\n@font-face {\n  font-family: \"slick\";\n  src: url(\"/fontsslick.eot\");\n  src: url(\"/fontsslick.eot?#iefix\") format(\"embedded-opentype\"), url(\"/fontsslick.woff\") format(\"woff\"), url(\"/fontsslick.ttf\") format(\"truetype\"), url(\"/fontsslick.svg#slick\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n/* Arrows */\n.slick-prev,\n.slick-next {\n  position: absolute;\n  display: block;\n  height: 20px;\n  width: 20px;\n  line-height: 0px;\n  font-size: 0px;\n  cursor: pointer;\n  background: transparent;\n  color: transparent;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n  -ms-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding: 0;\n  border: none;\n  outline: none; }\n  .slick-prev:hover, .slick-prev:focus,\n  .slick-next:hover,\n  .slick-next:focus {\n    outline: none;\n    background: transparent;\n    color: transparent; }\n    .slick-prev:hover:before, .slick-prev:focus:before,\n    .slick-next:hover:before,\n    .slick-next:focus:before {\n      opacity: 1; }\n  .slick-prev.slick-disabled:before,\n  .slick-next.slick-disabled:before {\n    opacity: 0.25; }\n  .slick-prev:before,\n  .slick-next:before {\n    font-family: \"slick\";\n    font-size: 20px;\n    line-height: 1;\n    color: white;\n    opacity: 0.75;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; }\n\n.slick-prev {\n  left: -25px; }\n  [dir=\"rtl\"] .slick-prev {\n    left: auto;\n    right: -25px; }\n  .slick-prev:before {\n    content: \"\\2190\"; }\n    [dir=\"rtl\"] .slick-prev:before {\n      content: \"\\2192\"; }\n\n.slick-next {\n  right: -25px; }\n  [dir=\"rtl\"] .slick-next {\n    left: -25px;\n    right: auto; }\n  .slick-next:before {\n    content: \"\\2192\"; }\n    [dir=\"rtl\"] .slick-next:before {\n      content: \"\\2190\"; }\n\n/* Dots */\n.slick-dotted.slick-slider {\n  margin-bottom: 30px; }\n\n.slick-dots {\n  position: absolute;\n  bottom: -25px;\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  width: 100%; }\n  .slick-dots li {\n    position: relative;\n    display: inline-block;\n    height: 20px;\n    width: 20px;\n    margin: 0 5px;\n    padding: 0;\n    cursor: pointer; }\n    .slick-dots li button {\n      border: 0;\n      background: transparent;\n      display: block;\n      height: 20px;\n      width: 20px;\n      outline: none;\n      line-height: 0px;\n      font-size: 0px;\n      color: transparent;\n      padding: 5px;\n      cursor: pointer; }\n      .slick-dots li button:hover, .slick-dots li button:focus {\n        outline: none; }\n        .slick-dots li button:hover:before, .slick-dots li button:focus:before {\n          opacity: 1; }\n      .slick-dots li button:before {\n        position: absolute;\n        top: 0;\n        left: 0;\n        content: \"\\2022\";\n        width: 20px;\n        height: 20px;\n        font-family: \"slick\";\n        font-size: 6px;\n        line-height: 20px;\n        text-align: center;\n        color: black;\n        opacity: 0.25;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale; }\n    .slick-dots li.slick-active button:before {\n      color: black;\n      opacity: 0.75; }\n\n/* Slider */\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent; }\n\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0; }\n  .slick-list:focus {\n    outline: none; }\n  .slick-list.dragging {\n    cursor: pointer;\n    cursor: hand; }\n\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0); }\n\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto; }\n  .slick-track:before, .slick-track:after {\n    content: \"\";\n    display: table; }\n  .slick-track:after {\n    clear: both; }\n  .slick-loading .slick-track {\n    visibility: hidden; }\n\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n  display: none; }\n  [dir=\"rtl\"] .slick-slide {\n    float: right; }\n  .slick-slide img {\n    display: block; }\n  .slick-slide.slick-loading img {\n    display: none; }\n  .slick-slide.dragging img {\n    pointer-events: none; }\n  .slick-initialized .slick-slide {\n    display: block; }\n  .slick-loading .slick-slide {\n    visibility: hidden; }\n  .slick-vertical .slick-slide {\n    display: block;\n    height: auto;\n    border: 1px solid transparent; }\n\n.slick-arrow.slick-hidden {\n  display: none; }\n\n/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: 'FontAwesome';\n  src: url(\"/fonts/fontawesome-webfont.eot?v=4.7.0\");\n  src: url(\"/fonts/fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"), url(\"/fonts/fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"), url(\"/fonts/fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"), url(\"/fonts/fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"), url(\"/fonts/fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n.fa {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n/* makes the font 33% larger relative to the icon container */\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -15%; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-fw {\n  width: 1.28571em;\n  text-align: center; }\n\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.14286em;\n  list-style-type: none; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  position: absolute;\n  left: -2.14286em;\n  width: 2.14286em;\n  top: 0.14286em;\n  text-align: center; }\n  .fa-li.fa-lg {\n    left: -1.85714em; }\n\n.fa-border {\n  padding: .2em .25em .15em;\n  border: solid 0.08em #eee;\n  border-radius: .1em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right {\n  margin-left: .3em; }\n\n/* Deprecated as of 4.4.0 */\n.pull-right {\n  float: right; }\n\n.pull-left {\n  float: left; }\n\n.fa.pull-left {\n  margin-right: .3em; }\n\n.fa.pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n  animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n  animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  transform: scale(1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  filter: none; }\n\n.fa-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle; }\n\n.fa-stack-1x, .fa-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center; }\n\n.fa-stack-1x {\n  line-height: inherit; }\n\n.fa-stack-2x {\n  font-size: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n.fa-glass:before {\n  content: \"\\F000\"; }\n\n.fa-music:before {\n  content: \"\\F001\"; }\n\n.fa-search:before {\n  content: \"\\F002\"; }\n\n.fa-envelope-o:before {\n  content: \"\\F003\"; }\n\n.fa-heart:before {\n  content: \"\\F004\"; }\n\n.fa-star:before {\n  content: \"\\F005\"; }\n\n.fa-star-o:before {\n  content: \"\\F006\"; }\n\n.fa-user:before {\n  content: \"\\F007\"; }\n\n.fa-film:before {\n  content: \"\\F008\"; }\n\n.fa-th-large:before {\n  content: \"\\F009\"; }\n\n.fa-th:before {\n  content: \"\\F00A\"; }\n\n.fa-th-list:before {\n  content: \"\\F00B\"; }\n\n.fa-check:before {\n  content: \"\\F00C\"; }\n\n.fa-remove:before,\n.fa-close:before,\n.fa-times:before {\n  content: \"\\F00D\"; }\n\n.fa-search-plus:before {\n  content: \"\\F00E\"; }\n\n.fa-search-minus:before {\n  content: \"\\F010\"; }\n\n.fa-power-off:before {\n  content: \"\\F011\"; }\n\n.fa-signal:before {\n  content: \"\\F012\"; }\n\n.fa-gear:before,\n.fa-cog:before {\n  content: \"\\F013\"; }\n\n.fa-trash-o:before {\n  content: \"\\F014\"; }\n\n.fa-home:before {\n  content: \"\\F015\"; }\n\n.fa-file-o:before {\n  content: \"\\F016\"; }\n\n.fa-clock-o:before {\n  content: \"\\F017\"; }\n\n.fa-road:before {\n  content: \"\\F018\"; }\n\n.fa-download:before {\n  content: \"\\F019\"; }\n\n.fa-arrow-circle-o-down:before {\n  content: \"\\F01A\"; }\n\n.fa-arrow-circle-o-up:before {\n  content: \"\\F01B\"; }\n\n.fa-inbox:before {\n  content: \"\\F01C\"; }\n\n.fa-play-circle-o:before {\n  content: \"\\F01D\"; }\n\n.fa-rotate-right:before,\n.fa-repeat:before {\n  content: \"\\F01E\"; }\n\n.fa-refresh:before {\n  content: \"\\F021\"; }\n\n.fa-list-alt:before {\n  content: \"\\F022\"; }\n\n.fa-lock:before {\n  content: \"\\F023\"; }\n\n.fa-flag:before {\n  content: \"\\F024\"; }\n\n.fa-headphones:before {\n  content: \"\\F025\"; }\n\n.fa-volume-off:before {\n  content: \"\\F026\"; }\n\n.fa-volume-down:before {\n  content: \"\\F027\"; }\n\n.fa-volume-up:before {\n  content: \"\\F028\"; }\n\n.fa-qrcode:before {\n  content: \"\\F029\"; }\n\n.fa-barcode:before {\n  content: \"\\F02A\"; }\n\n.fa-tag:before {\n  content: \"\\F02B\"; }\n\n.fa-tags:before {\n  content: \"\\F02C\"; }\n\n.fa-book:before {\n  content: \"\\F02D\"; }\n\n.fa-bookmark:before {\n  content: \"\\F02E\"; }\n\n.fa-print:before {\n  content: \"\\F02F\"; }\n\n.fa-camera:before {\n  content: \"\\F030\"; }\n\n.fa-font:before {\n  content: \"\\F031\"; }\n\n.fa-bold:before {\n  content: \"\\F032\"; }\n\n.fa-italic:before {\n  content: \"\\F033\"; }\n\n.fa-text-height:before {\n  content: \"\\F034\"; }\n\n.fa-text-width:before {\n  content: \"\\F035\"; }\n\n.fa-align-left:before {\n  content: \"\\F036\"; }\n\n.fa-align-center:before {\n  content: \"\\F037\"; }\n\n.fa-align-right:before {\n  content: \"\\F038\"; }\n\n.fa-align-justify:before {\n  content: \"\\F039\"; }\n\n.fa-list:before {\n  content: \"\\F03A\"; }\n\n.fa-dedent:before,\n.fa-outdent:before {\n  content: \"\\F03B\"; }\n\n.fa-indent:before {\n  content: \"\\F03C\"; }\n\n.fa-video-camera:before {\n  content: \"\\F03D\"; }\n\n.fa-photo:before,\n.fa-image:before,\n.fa-picture-o:before {\n  content: \"\\F03E\"; }\n\n.fa-pencil:before {\n  content: \"\\F040\"; }\n\n.fa-map-marker:before {\n  content: \"\\F041\"; }\n\n.fa-adjust:before {\n  content: \"\\F042\"; }\n\n.fa-tint:before {\n  content: \"\\F043\"; }\n\n.fa-edit:before,\n.fa-pencil-square-o:before {\n  content: \"\\F044\"; }\n\n.fa-share-square-o:before {\n  content: \"\\F045\"; }\n\n.fa-check-square-o:before {\n  content: \"\\F046\"; }\n\n.fa-arrows:before {\n  content: \"\\F047\"; }\n\n.fa-step-backward:before {\n  content: \"\\F048\"; }\n\n.fa-fast-backward:before {\n  content: \"\\F049\"; }\n\n.fa-backward:before {\n  content: \"\\F04A\"; }\n\n.fa-play:before {\n  content: \"\\F04B\"; }\n\n.fa-pause:before {\n  content: \"\\F04C\"; }\n\n.fa-stop:before {\n  content: \"\\F04D\"; }\n\n.fa-forward:before {\n  content: \"\\F04E\"; }\n\n.fa-fast-forward:before {\n  content: \"\\F050\"; }\n\n.fa-step-forward:before {\n  content: \"\\F051\"; }\n\n.fa-eject:before {\n  content: \"\\F052\"; }\n\n.fa-chevron-left:before {\n  content: \"\\F053\"; }\n\n.fa-chevron-right:before {\n  content: \"\\F054\"; }\n\n.fa-plus-circle:before {\n  content: \"\\F055\"; }\n\n.fa-minus-circle:before {\n  content: \"\\F056\"; }\n\n.fa-times-circle:before {\n  content: \"\\F057\"; }\n\n.fa-check-circle:before {\n  content: \"\\F058\"; }\n\n.fa-question-circle:before {\n  content: \"\\F059\"; }\n\n.fa-info-circle:before {\n  content: \"\\F05A\"; }\n\n.fa-crosshairs:before {\n  content: \"\\F05B\"; }\n\n.fa-times-circle-o:before {\n  content: \"\\F05C\"; }\n\n.fa-check-circle-o:before {\n  content: \"\\F05D\"; }\n\n.fa-ban:before {\n  content: \"\\F05E\"; }\n\n.fa-arrow-left:before {\n  content: \"\\F060\"; }\n\n.fa-arrow-right:before {\n  content: \"\\F061\"; }\n\n.fa-arrow-up:before {\n  content: \"\\F062\"; }\n\n.fa-arrow-down:before {\n  content: \"\\F063\"; }\n\n.fa-mail-forward:before,\n.fa-share:before {\n  content: \"\\F064\"; }\n\n.fa-expand:before {\n  content: \"\\F065\"; }\n\n.fa-compress:before {\n  content: \"\\F066\"; }\n\n.fa-plus:before {\n  content: \"\\F067\"; }\n\n.fa-minus:before {\n  content: \"\\F068\"; }\n\n.fa-asterisk:before {\n  content: \"\\F069\"; }\n\n.fa-exclamation-circle:before {\n  content: \"\\F06A\"; }\n\n.fa-gift:before {\n  content: \"\\F06B\"; }\n\n.fa-leaf:before {\n  content: \"\\F06C\"; }\n\n.fa-fire:before {\n  content: \"\\F06D\"; }\n\n.fa-eye:before {\n  content: \"\\F06E\"; }\n\n.fa-eye-slash:before {\n  content: \"\\F070\"; }\n\n.fa-warning:before,\n.fa-exclamation-triangle:before {\n  content: \"\\F071\"; }\n\n.fa-plane:before {\n  content: \"\\F072\"; }\n\n.fa-calendar:before {\n  content: \"\\F073\"; }\n\n.fa-random:before {\n  content: \"\\F074\"; }\n\n.fa-comment:before {\n  content: \"\\F075\"; }\n\n.fa-magnet:before {\n  content: \"\\F076\"; }\n\n.fa-chevron-up:before {\n  content: \"\\F077\"; }\n\n.fa-chevron-down:before {\n  content: \"\\F078\"; }\n\n.fa-retweet:before {\n  content: \"\\F079\"; }\n\n.fa-shopping-cart:before {\n  content: \"\\F07A\"; }\n\n.fa-folder:before {\n  content: \"\\F07B\"; }\n\n.fa-folder-open:before {\n  content: \"\\F07C\"; }\n\n.fa-arrows-v:before {\n  content: \"\\F07D\"; }\n\n.fa-arrows-h:before {\n  content: \"\\F07E\"; }\n\n.fa-bar-chart-o:before,\n.fa-bar-chart:before {\n  content: \"\\F080\"; }\n\n.fa-twitter-square:before {\n  content: \"\\F081\"; }\n\n.fa-facebook-square:before {\n  content: \"\\F082\"; }\n\n.fa-camera-retro:before {\n  content: \"\\F083\"; }\n\n.fa-key:before {\n  content: \"\\F084\"; }\n\n.fa-gears:before,\n.fa-cogs:before {\n  content: \"\\F085\"; }\n\n.fa-comments:before {\n  content: \"\\F086\"; }\n\n.fa-thumbs-o-up:before {\n  content: \"\\F087\"; }\n\n.fa-thumbs-o-down:before {\n  content: \"\\F088\"; }\n\n.fa-star-half:before {\n  content: \"\\F089\"; }\n\n.fa-heart-o:before {\n  content: \"\\F08A\"; }\n\n.fa-sign-out:before {\n  content: \"\\F08B\"; }\n\n.fa-linkedin-square:before {\n  content: \"\\F08C\"; }\n\n.fa-thumb-tack:before {\n  content: \"\\F08D\"; }\n\n.fa-external-link:before {\n  content: \"\\F08E\"; }\n\n.fa-sign-in:before {\n  content: \"\\F090\"; }\n\n.fa-trophy:before {\n  content: \"\\F091\"; }\n\n.fa-github-square:before {\n  content: \"\\F092\"; }\n\n.fa-upload:before {\n  content: \"\\F093\"; }\n\n.fa-lemon-o:before {\n  content: \"\\F094\"; }\n\n.fa-phone:before {\n  content: \"\\F095\"; }\n\n.fa-square-o:before {\n  content: \"\\F096\"; }\n\n.fa-bookmark-o:before {\n  content: \"\\F097\"; }\n\n.fa-phone-square:before {\n  content: \"\\F098\"; }\n\n.fa-twitter:before {\n  content: \"\\F099\"; }\n\n.fa-facebook-f:before,\n.fa-facebook:before {\n  content: \"\\F09A\"; }\n\n.fa-github:before {\n  content: \"\\F09B\"; }\n\n.fa-unlock:before {\n  content: \"\\F09C\"; }\n\n.fa-credit-card:before {\n  content: \"\\F09D\"; }\n\n.fa-feed:before,\n.fa-rss:before {\n  content: \"\\F09E\"; }\n\n.fa-hdd-o:before {\n  content: \"\\F0A0\"; }\n\n.fa-bullhorn:before {\n  content: \"\\F0A1\"; }\n\n.fa-bell:before {\n  content: \"\\F0F3\"; }\n\n.fa-certificate:before {\n  content: \"\\F0A3\"; }\n\n.fa-hand-o-right:before {\n  content: \"\\F0A4\"; }\n\n.fa-hand-o-left:before {\n  content: \"\\F0A5\"; }\n\n.fa-hand-o-up:before {\n  content: \"\\F0A6\"; }\n\n.fa-hand-o-down:before {\n  content: \"\\F0A7\"; }\n\n.fa-arrow-circle-left:before {\n  content: \"\\F0A8\"; }\n\n.fa-arrow-circle-right:before {\n  content: \"\\F0A9\"; }\n\n.fa-arrow-circle-up:before {\n  content: \"\\F0AA\"; }\n\n.fa-arrow-circle-down:before {\n  content: \"\\F0AB\"; }\n\n.fa-globe:before {\n  content: \"\\F0AC\"; }\n\n.fa-wrench:before {\n  content: \"\\F0AD\"; }\n\n.fa-tasks:before {\n  content: \"\\F0AE\"; }\n\n.fa-filter:before {\n  content: \"\\F0B0\"; }\n\n.fa-briefcase:before {\n  content: \"\\F0B1\"; }\n\n.fa-arrows-alt:before {\n  content: \"\\F0B2\"; }\n\n.fa-group:before,\n.fa-users:before {\n  content: \"\\F0C0\"; }\n\n.fa-chain:before,\n.fa-link:before {\n  content: \"\\F0C1\"; }\n\n.fa-cloud:before {\n  content: \"\\F0C2\"; }\n\n.fa-flask:before {\n  content: \"\\F0C3\"; }\n\n.fa-cut:before,\n.fa-scissors:before {\n  content: \"\\F0C4\"; }\n\n.fa-copy:before,\n.fa-files-o:before {\n  content: \"\\F0C5\"; }\n\n.fa-paperclip:before {\n  content: \"\\F0C6\"; }\n\n.fa-save:before,\n.fa-floppy-o:before {\n  content: \"\\F0C7\"; }\n\n.fa-square:before {\n  content: \"\\F0C8\"; }\n\n.fa-navicon:before,\n.fa-reorder:before,\n.fa-bars:before {\n  content: \"\\F0C9\"; }\n\n.fa-list-ul:before {\n  content: \"\\F0CA\"; }\n\n.fa-list-ol:before {\n  content: \"\\F0CB\"; }\n\n.fa-strikethrough:before {\n  content: \"\\F0CC\"; }\n\n.fa-underline:before {\n  content: \"\\F0CD\"; }\n\n.fa-table:before {\n  content: \"\\F0CE\"; }\n\n.fa-magic:before {\n  content: \"\\F0D0\"; }\n\n.fa-truck:before {\n  content: \"\\F0D1\"; }\n\n.fa-pinterest:before {\n  content: \"\\F0D2\"; }\n\n.fa-pinterest-square:before {\n  content: \"\\F0D3\"; }\n\n.fa-google-plus-square:before {\n  content: \"\\F0D4\"; }\n\n.fa-google-plus:before {\n  content: \"\\F0D5\"; }\n\n.fa-money:before {\n  content: \"\\F0D6\"; }\n\n.fa-caret-down:before {\n  content: \"\\F0D7\"; }\n\n.fa-caret-up:before {\n  content: \"\\F0D8\"; }\n\n.fa-caret-left:before {\n  content: \"\\F0D9\"; }\n\n.fa-caret-right:before {\n  content: \"\\F0DA\"; }\n\n.fa-columns:before {\n  content: \"\\F0DB\"; }\n\n.fa-unsorted:before,\n.fa-sort:before {\n  content: \"\\F0DC\"; }\n\n.fa-sort-down:before,\n.fa-sort-desc:before {\n  content: \"\\F0DD\"; }\n\n.fa-sort-up:before,\n.fa-sort-asc:before {\n  content: \"\\F0DE\"; }\n\n.fa-envelope:before {\n  content: \"\\F0E0\"; }\n\n.fa-linkedin:before {\n  content: \"\\F0E1\"; }\n\n.fa-rotate-left:before,\n.fa-undo:before {\n  content: \"\\F0E2\"; }\n\n.fa-legal:before,\n.fa-gavel:before {\n  content: \"\\F0E3\"; }\n\n.fa-dashboard:before,\n.fa-tachometer:before {\n  content: \"\\F0E4\"; }\n\n.fa-comment-o:before {\n  content: \"\\F0E5\"; }\n\n.fa-comments-o:before {\n  content: \"\\F0E6\"; }\n\n.fa-flash:before,\n.fa-bolt:before {\n  content: \"\\F0E7\"; }\n\n.fa-sitemap:before {\n  content: \"\\F0E8\"; }\n\n.fa-umbrella:before {\n  content: \"\\F0E9\"; }\n\n.fa-paste:before,\n.fa-clipboard:before {\n  content: \"\\F0EA\"; }\n\n.fa-lightbulb-o:before {\n  content: \"\\F0EB\"; }\n\n.fa-exchange:before {\n  content: \"\\F0EC\"; }\n\n.fa-cloud-download:before {\n  content: \"\\F0ED\"; }\n\n.fa-cloud-upload:before {\n  content: \"\\F0EE\"; }\n\n.fa-user-md:before {\n  content: \"\\F0F0\"; }\n\n.fa-stethoscope:before {\n  content: \"\\F0F1\"; }\n\n.fa-suitcase:before {\n  content: \"\\F0F2\"; }\n\n.fa-bell-o:before {\n  content: \"\\F0A2\"; }\n\n.fa-coffee:before {\n  content: \"\\F0F4\"; }\n\n.fa-cutlery:before {\n  content: \"\\F0F5\"; }\n\n.fa-file-text-o:before {\n  content: \"\\F0F6\"; }\n\n.fa-building-o:before {\n  content: \"\\F0F7\"; }\n\n.fa-hospital-o:before {\n  content: \"\\F0F8\"; }\n\n.fa-ambulance:before {\n  content: \"\\F0F9\"; }\n\n.fa-medkit:before {\n  content: \"\\F0FA\"; }\n\n.fa-fighter-jet:before {\n  content: \"\\F0FB\"; }\n\n.fa-beer:before {\n  content: \"\\F0FC\"; }\n\n.fa-h-square:before {\n  content: \"\\F0FD\"; }\n\n.fa-plus-square:before {\n  content: \"\\F0FE\"; }\n\n.fa-angle-double-left:before {\n  content: \"\\F100\"; }\n\n.fa-angle-double-right:before {\n  content: \"\\F101\"; }\n\n.fa-angle-double-up:before {\n  content: \"\\F102\"; }\n\n.fa-angle-double-down:before {\n  content: \"\\F103\"; }\n\n.fa-angle-left:before {\n  content: \"\\F104\"; }\n\n.fa-angle-right:before {\n  content: \"\\F105\"; }\n\n.fa-angle-up:before {\n  content: \"\\F106\"; }\n\n.fa-angle-down:before {\n  content: \"\\F107\"; }\n\n.fa-desktop:before {\n  content: \"\\F108\"; }\n\n.fa-laptop:before {\n  content: \"\\F109\"; }\n\n.fa-tablet:before {\n  content: \"\\F10A\"; }\n\n.fa-mobile-phone:before,\n.fa-mobile:before {\n  content: \"\\F10B\"; }\n\n.fa-circle-o:before {\n  content: \"\\F10C\"; }\n\n.fa-quote-left:before {\n  content: \"\\F10D\"; }\n\n.fa-quote-right:before {\n  content: \"\\F10E\"; }\n\n.fa-spinner:before {\n  content: \"\\F110\"; }\n\n.fa-circle:before {\n  content: \"\\F111\"; }\n\n.fa-mail-reply:before,\n.fa-reply:before {\n  content: \"\\F112\"; }\n\n.fa-github-alt:before {\n  content: \"\\F113\"; }\n\n.fa-folder-o:before {\n  content: \"\\F114\"; }\n\n.fa-folder-open-o:before {\n  content: \"\\F115\"; }\n\n.fa-smile-o:before {\n  content: \"\\F118\"; }\n\n.fa-frown-o:before {\n  content: \"\\F119\"; }\n\n.fa-meh-o:before {\n  content: \"\\F11A\"; }\n\n.fa-gamepad:before {\n  content: \"\\F11B\"; }\n\n.fa-keyboard-o:before {\n  content: \"\\F11C\"; }\n\n.fa-flag-o:before {\n  content: \"\\F11D\"; }\n\n.fa-flag-checkered:before {\n  content: \"\\F11E\"; }\n\n.fa-terminal:before {\n  content: \"\\F120\"; }\n\n.fa-code:before {\n  content: \"\\F121\"; }\n\n.fa-mail-reply-all:before,\n.fa-reply-all:before {\n  content: \"\\F122\"; }\n\n.fa-star-half-empty:before,\n.fa-star-half-full:before,\n.fa-star-half-o:before {\n  content: \"\\F123\"; }\n\n.fa-location-arrow:before {\n  content: \"\\F124\"; }\n\n.fa-crop:before {\n  content: \"\\F125\"; }\n\n.fa-code-fork:before {\n  content: \"\\F126\"; }\n\n.fa-unlink:before,\n.fa-chain-broken:before {\n  content: \"\\F127\"; }\n\n.fa-question:before {\n  content: \"\\F128\"; }\n\n.fa-info:before {\n  content: \"\\F129\"; }\n\n.fa-exclamation:before {\n  content: \"\\F12A\"; }\n\n.fa-superscript:before {\n  content: \"\\F12B\"; }\n\n.fa-subscript:before {\n  content: \"\\F12C\"; }\n\n.fa-eraser:before {\n  content: \"\\F12D\"; }\n\n.fa-puzzle-piece:before {\n  content: \"\\F12E\"; }\n\n.fa-microphone:before {\n  content: \"\\F130\"; }\n\n.fa-microphone-slash:before {\n  content: \"\\F131\"; }\n\n.fa-shield:before {\n  content: \"\\F132\"; }\n\n.fa-calendar-o:before {\n  content: \"\\F133\"; }\n\n.fa-fire-extinguisher:before {\n  content: \"\\F134\"; }\n\n.fa-rocket:before {\n  content: \"\\F135\"; }\n\n.fa-maxcdn:before {\n  content: \"\\F136\"; }\n\n.fa-chevron-circle-left:before {\n  content: \"\\F137\"; }\n\n.fa-chevron-circle-right:before {\n  content: \"\\F138\"; }\n\n.fa-chevron-circle-up:before {\n  content: \"\\F139\"; }\n\n.fa-chevron-circle-down:before {\n  content: \"\\F13A\"; }\n\n.fa-html5:before {\n  content: \"\\F13B\"; }\n\n.fa-css3:before {\n  content: \"\\F13C\"; }\n\n.fa-anchor:before {\n  content: \"\\F13D\"; }\n\n.fa-unlock-alt:before {\n  content: \"\\F13E\"; }\n\n.fa-bullseye:before {\n  content: \"\\F140\"; }\n\n.fa-ellipsis-h:before {\n  content: \"\\F141\"; }\n\n.fa-ellipsis-v:before {\n  content: \"\\F142\"; }\n\n.fa-rss-square:before {\n  content: \"\\F143\"; }\n\n.fa-play-circle:before {\n  content: \"\\F144\"; }\n\n.fa-ticket:before {\n  content: \"\\F145\"; }\n\n.fa-minus-square:before {\n  content: \"\\F146\"; }\n\n.fa-minus-square-o:before {\n  content: \"\\F147\"; }\n\n.fa-level-up:before {\n  content: \"\\F148\"; }\n\n.fa-level-down:before {\n  content: \"\\F149\"; }\n\n.fa-check-square:before {\n  content: \"\\F14A\"; }\n\n.fa-pencil-square:before {\n  content: \"\\F14B\"; }\n\n.fa-external-link-square:before {\n  content: \"\\F14C\"; }\n\n.fa-share-square:before {\n  content: \"\\F14D\"; }\n\n.fa-compass:before {\n  content: \"\\F14E\"; }\n\n.fa-toggle-down:before,\n.fa-caret-square-o-down:before {\n  content: \"\\F150\"; }\n\n.fa-toggle-up:before,\n.fa-caret-square-o-up:before {\n  content: \"\\F151\"; }\n\n.fa-toggle-right:before,\n.fa-caret-square-o-right:before {\n  content: \"\\F152\"; }\n\n.fa-euro:before,\n.fa-eur:before {\n  content: \"\\F153\"; }\n\n.fa-gbp:before {\n  content: \"\\F154\"; }\n\n.fa-dollar:before,\n.fa-usd:before {\n  content: \"\\F155\"; }\n\n.fa-rupee:before,\n.fa-inr:before {\n  content: \"\\F156\"; }\n\n.fa-cny:before,\n.fa-rmb:before,\n.fa-yen:before,\n.fa-jpy:before {\n  content: \"\\F157\"; }\n\n.fa-ruble:before,\n.fa-rouble:before,\n.fa-rub:before {\n  content: \"\\F158\"; }\n\n.fa-won:before,\n.fa-krw:before {\n  content: \"\\F159\"; }\n\n.fa-bitcoin:before,\n.fa-btc:before {\n  content: \"\\F15A\"; }\n\n.fa-file:before {\n  content: \"\\F15B\"; }\n\n.fa-file-text:before {\n  content: \"\\F15C\"; }\n\n.fa-sort-alpha-asc:before {\n  content: \"\\F15D\"; }\n\n.fa-sort-alpha-desc:before {\n  content: \"\\F15E\"; }\n\n.fa-sort-amount-asc:before {\n  content: \"\\F160\"; }\n\n.fa-sort-amount-desc:before {\n  content: \"\\F161\"; }\n\n.fa-sort-numeric-asc:before {\n  content: \"\\F162\"; }\n\n.fa-sort-numeric-desc:before {\n  content: \"\\F163\"; }\n\n.fa-thumbs-up:before {\n  content: \"\\F164\"; }\n\n.fa-thumbs-down:before {\n  content: \"\\F165\"; }\n\n.fa-youtube-square:before {\n  content: \"\\F166\"; }\n\n.fa-youtube:before {\n  content: \"\\F167\"; }\n\n.fa-xing:before {\n  content: \"\\F168\"; }\n\n.fa-xing-square:before {\n  content: \"\\F169\"; }\n\n.fa-youtube-play:before {\n  content: \"\\F16A\"; }\n\n.fa-dropbox:before {\n  content: \"\\F16B\"; }\n\n.fa-stack-overflow:before {\n  content: \"\\F16C\"; }\n\n.fa-instagram:before {\n  content: \"\\F16D\"; }\n\n.fa-flickr:before {\n  content: \"\\F16E\"; }\n\n.fa-adn:before {\n  content: \"\\F170\"; }\n\n.fa-bitbucket:before {\n  content: \"\\F171\"; }\n\n.fa-bitbucket-square:before {\n  content: \"\\F172\"; }\n\n.fa-tumblr:before {\n  content: \"\\F173\"; }\n\n.fa-tumblr-square:before {\n  content: \"\\F174\"; }\n\n.fa-long-arrow-down:before {\n  content: \"\\F175\"; }\n\n.fa-long-arrow-up:before {\n  content: \"\\F176\"; }\n\n.fa-long-arrow-left:before {\n  content: \"\\F177\"; }\n\n.fa-long-arrow-right:before {\n  content: \"\\F178\"; }\n\n.fa-apple:before {\n  content: \"\\F179\"; }\n\n.fa-windows:before {\n  content: \"\\F17A\"; }\n\n.fa-android:before {\n  content: \"\\F17B\"; }\n\n.fa-linux:before {\n  content: \"\\F17C\"; }\n\n.fa-dribbble:before {\n  content: \"\\F17D\"; }\n\n.fa-skype:before {\n  content: \"\\F17E\"; }\n\n.fa-foursquare:before {\n  content: \"\\F180\"; }\n\n.fa-trello:before {\n  content: \"\\F181\"; }\n\n.fa-female:before {\n  content: \"\\F182\"; }\n\n.fa-male:before {\n  content: \"\\F183\"; }\n\n.fa-gittip:before,\n.fa-gratipay:before {\n  content: \"\\F184\"; }\n\n.fa-sun-o:before {\n  content: \"\\F185\"; }\n\n.fa-moon-o:before {\n  content: \"\\F186\"; }\n\n.fa-archive:before {\n  content: \"\\F187\"; }\n\n.fa-bug:before {\n  content: \"\\F188\"; }\n\n.fa-vk:before {\n  content: \"\\F189\"; }\n\n.fa-weibo:before {\n  content: \"\\F18A\"; }\n\n.fa-renren:before {\n  content: \"\\F18B\"; }\n\n.fa-pagelines:before {\n  content: \"\\F18C\"; }\n\n.fa-stack-exchange:before {\n  content: \"\\F18D\"; }\n\n.fa-arrow-circle-o-right:before {\n  content: \"\\F18E\"; }\n\n.fa-arrow-circle-o-left:before {\n  content: \"\\F190\"; }\n\n.fa-toggle-left:before,\n.fa-caret-square-o-left:before {\n  content: \"\\F191\"; }\n\n.fa-dot-circle-o:before {\n  content: \"\\F192\"; }\n\n.fa-wheelchair:before {\n  content: \"\\F193\"; }\n\n.fa-vimeo-square:before {\n  content: \"\\F194\"; }\n\n.fa-turkish-lira:before,\n.fa-try:before {\n  content: \"\\F195\"; }\n\n.fa-plus-square-o:before {\n  content: \"\\F196\"; }\n\n.fa-space-shuttle:before {\n  content: \"\\F197\"; }\n\n.fa-slack:before {\n  content: \"\\F198\"; }\n\n.fa-envelope-square:before {\n  content: \"\\F199\"; }\n\n.fa-wordpress:before {\n  content: \"\\F19A\"; }\n\n.fa-openid:before {\n  content: \"\\F19B\"; }\n\n.fa-institution:before,\n.fa-bank:before,\n.fa-university:before {\n  content: \"\\F19C\"; }\n\n.fa-mortar-board:before,\n.fa-graduation-cap:before {\n  content: \"\\F19D\"; }\n\n.fa-yahoo:before {\n  content: \"\\F19E\"; }\n\n.fa-google:before {\n  content: \"\\F1A0\"; }\n\n.fa-reddit:before {\n  content: \"\\F1A1\"; }\n\n.fa-reddit-square:before {\n  content: \"\\F1A2\"; }\n\n.fa-stumbleupon-circle:before {\n  content: \"\\F1A3\"; }\n\n.fa-stumbleupon:before {\n  content: \"\\F1A4\"; }\n\n.fa-delicious:before {\n  content: \"\\F1A5\"; }\n\n.fa-digg:before {\n  content: \"\\F1A6\"; }\n\n.fa-pied-piper-pp:before {\n  content: \"\\F1A7\"; }\n\n.fa-pied-piper-alt:before {\n  content: \"\\F1A8\"; }\n\n.fa-drupal:before {\n  content: \"\\F1A9\"; }\n\n.fa-joomla:before {\n  content: \"\\F1AA\"; }\n\n.fa-language:before {\n  content: \"\\F1AB\"; }\n\n.fa-fax:before {\n  content: \"\\F1AC\"; }\n\n.fa-building:before {\n  content: \"\\F1AD\"; }\n\n.fa-child:before {\n  content: \"\\F1AE\"; }\n\n.fa-paw:before {\n  content: \"\\F1B0\"; }\n\n.fa-spoon:before {\n  content: \"\\F1B1\"; }\n\n.fa-cube:before {\n  content: \"\\F1B2\"; }\n\n.fa-cubes:before {\n  content: \"\\F1B3\"; }\n\n.fa-behance:before {\n  content: \"\\F1B4\"; }\n\n.fa-behance-square:before {\n  content: \"\\F1B5\"; }\n\n.fa-steam:before {\n  content: \"\\F1B6\"; }\n\n.fa-steam-square:before {\n  content: \"\\F1B7\"; }\n\n.fa-recycle:before {\n  content: \"\\F1B8\"; }\n\n.fa-automobile:before,\n.fa-car:before {\n  content: \"\\F1B9\"; }\n\n.fa-cab:before,\n.fa-taxi:before {\n  content: \"\\F1BA\"; }\n\n.fa-tree:before {\n  content: \"\\F1BB\"; }\n\n.fa-spotify:before {\n  content: \"\\F1BC\"; }\n\n.fa-deviantart:before {\n  content: \"\\F1BD\"; }\n\n.fa-soundcloud:before {\n  content: \"\\F1BE\"; }\n\n.fa-database:before {\n  content: \"\\F1C0\"; }\n\n.fa-file-pdf-o:before {\n  content: \"\\F1C1\"; }\n\n.fa-file-word-o:before {\n  content: \"\\F1C2\"; }\n\n.fa-file-excel-o:before {\n  content: \"\\F1C3\"; }\n\n.fa-file-powerpoint-o:before {\n  content: \"\\F1C4\"; }\n\n.fa-file-photo-o:before,\n.fa-file-picture-o:before,\n.fa-file-image-o:before {\n  content: \"\\F1C5\"; }\n\n.fa-file-zip-o:before,\n.fa-file-archive-o:before {\n  content: \"\\F1C6\"; }\n\n.fa-file-sound-o:before,\n.fa-file-audio-o:before {\n  content: \"\\F1C7\"; }\n\n.fa-file-movie-o:before,\n.fa-file-video-o:before {\n  content: \"\\F1C8\"; }\n\n.fa-file-code-o:before {\n  content: \"\\F1C9\"; }\n\n.fa-vine:before {\n  content: \"\\F1CA\"; }\n\n.fa-codepen:before {\n  content: \"\\F1CB\"; }\n\n.fa-jsfiddle:before {\n  content: \"\\F1CC\"; }\n\n.fa-life-bouy:before,\n.fa-life-buoy:before,\n.fa-life-saver:before,\n.fa-support:before,\n.fa-life-ring:before {\n  content: \"\\F1CD\"; }\n\n.fa-circle-o-notch:before {\n  content: \"\\F1CE\"; }\n\n.fa-ra:before,\n.fa-resistance:before,\n.fa-rebel:before {\n  content: \"\\F1D0\"; }\n\n.fa-ge:before,\n.fa-empire:before {\n  content: \"\\F1D1\"; }\n\n.fa-git-square:before {\n  content: \"\\F1D2\"; }\n\n.fa-git:before {\n  content: \"\\F1D3\"; }\n\n.fa-y-combinator-square:before,\n.fa-yc-square:before,\n.fa-hacker-news:before {\n  content: \"\\F1D4\"; }\n\n.fa-tencent-weibo:before {\n  content: \"\\F1D5\"; }\n\n.fa-qq:before {\n  content: \"\\F1D6\"; }\n\n.fa-wechat:before,\n.fa-weixin:before {\n  content: \"\\F1D7\"; }\n\n.fa-send:before,\n.fa-paper-plane:before {\n  content: \"\\F1D8\"; }\n\n.fa-send-o:before,\n.fa-paper-plane-o:before {\n  content: \"\\F1D9\"; }\n\n.fa-history:before {\n  content: \"\\F1DA\"; }\n\n.fa-circle-thin:before {\n  content: \"\\F1DB\"; }\n\n.fa-header:before {\n  content: \"\\F1DC\"; }\n\n.fa-paragraph:before {\n  content: \"\\F1DD\"; }\n\n.fa-sliders:before {\n  content: \"\\F1DE\"; }\n\n.fa-share-alt:before {\n  content: \"\\F1E0\"; }\n\n.fa-share-alt-square:before {\n  content: \"\\F1E1\"; }\n\n.fa-bomb:before {\n  content: \"\\F1E2\"; }\n\n.fa-soccer-ball-o:before,\n.fa-futbol-o:before {\n  content: \"\\F1E3\"; }\n\n.fa-tty:before {\n  content: \"\\F1E4\"; }\n\n.fa-binoculars:before {\n  content: \"\\F1E5\"; }\n\n.fa-plug:before {\n  content: \"\\F1E6\"; }\n\n.fa-slideshare:before {\n  content: \"\\F1E7\"; }\n\n.fa-twitch:before {\n  content: \"\\F1E8\"; }\n\n.fa-yelp:before {\n  content: \"\\F1E9\"; }\n\n.fa-newspaper-o:before {\n  content: \"\\F1EA\"; }\n\n.fa-wifi:before {\n  content: \"\\F1EB\"; }\n\n.fa-calculator:before {\n  content: \"\\F1EC\"; }\n\n.fa-paypal:before {\n  content: \"\\F1ED\"; }\n\n.fa-google-wallet:before {\n  content: \"\\F1EE\"; }\n\n.fa-cc-visa:before {\n  content: \"\\F1F0\"; }\n\n.fa-cc-mastercard:before {\n  content: \"\\F1F1\"; }\n\n.fa-cc-discover:before {\n  content: \"\\F1F2\"; }\n\n.fa-cc-amex:before {\n  content: \"\\F1F3\"; }\n\n.fa-cc-paypal:before {\n  content: \"\\F1F4\"; }\n\n.fa-cc-stripe:before {\n  content: \"\\F1F5\"; }\n\n.fa-bell-slash:before {\n  content: \"\\F1F6\"; }\n\n.fa-bell-slash-o:before {\n  content: \"\\F1F7\"; }\n\n.fa-trash:before {\n  content: \"\\F1F8\"; }\n\n.fa-copyright:before {\n  content: \"\\F1F9\"; }\n\n.fa-at:before {\n  content: \"\\F1FA\"; }\n\n.fa-eyedropper:before {\n  content: \"\\F1FB\"; }\n\n.fa-paint-brush:before {\n  content: \"\\F1FC\"; }\n\n.fa-birthday-cake:before {\n  content: \"\\F1FD\"; }\n\n.fa-area-chart:before {\n  content: \"\\F1FE\"; }\n\n.fa-pie-chart:before {\n  content: \"\\F200\"; }\n\n.fa-line-chart:before {\n  content: \"\\F201\"; }\n\n.fa-lastfm:before {\n  content: \"\\F202\"; }\n\n.fa-lastfm-square:before {\n  content: \"\\F203\"; }\n\n.fa-toggle-off:before {\n  content: \"\\F204\"; }\n\n.fa-toggle-on:before {\n  content: \"\\F205\"; }\n\n.fa-bicycle:before {\n  content: \"\\F206\"; }\n\n.fa-bus:before {\n  content: \"\\F207\"; }\n\n.fa-ioxhost:before {\n  content: \"\\F208\"; }\n\n.fa-angellist:before {\n  content: \"\\F209\"; }\n\n.fa-cc:before {\n  content: \"\\F20A\"; }\n\n.fa-shekel:before,\n.fa-sheqel:before,\n.fa-ils:before {\n  content: \"\\F20B\"; }\n\n.fa-meanpath:before {\n  content: \"\\F20C\"; }\n\n.fa-buysellads:before {\n  content: \"\\F20D\"; }\n\n.fa-connectdevelop:before {\n  content: \"\\F20E\"; }\n\n.fa-dashcube:before {\n  content: \"\\F210\"; }\n\n.fa-forumbee:before {\n  content: \"\\F211\"; }\n\n.fa-leanpub:before {\n  content: \"\\F212\"; }\n\n.fa-sellsy:before {\n  content: \"\\F213\"; }\n\n.fa-shirtsinbulk:before {\n  content: \"\\F214\"; }\n\n.fa-simplybuilt:before {\n  content: \"\\F215\"; }\n\n.fa-skyatlas:before {\n  content: \"\\F216\"; }\n\n.fa-cart-plus:before {\n  content: \"\\F217\"; }\n\n.fa-cart-arrow-down:before {\n  content: \"\\F218\"; }\n\n.fa-diamond:before {\n  content: \"\\F219\"; }\n\n.fa-ship:before {\n  content: \"\\F21A\"; }\n\n.fa-user-secret:before {\n  content: \"\\F21B\"; }\n\n.fa-motorcycle:before {\n  content: \"\\F21C\"; }\n\n.fa-street-view:before {\n  content: \"\\F21D\"; }\n\n.fa-heartbeat:before {\n  content: \"\\F21E\"; }\n\n.fa-venus:before {\n  content: \"\\F221\"; }\n\n.fa-mars:before {\n  content: \"\\F222\"; }\n\n.fa-mercury:before {\n  content: \"\\F223\"; }\n\n.fa-intersex:before,\n.fa-transgender:before {\n  content: \"\\F224\"; }\n\n.fa-transgender-alt:before {\n  content: \"\\F225\"; }\n\n.fa-venus-double:before {\n  content: \"\\F226\"; }\n\n.fa-mars-double:before {\n  content: \"\\F227\"; }\n\n.fa-venus-mars:before {\n  content: \"\\F228\"; }\n\n.fa-mars-stroke:before {\n  content: \"\\F229\"; }\n\n.fa-mars-stroke-v:before {\n  content: \"\\F22A\"; }\n\n.fa-mars-stroke-h:before {\n  content: \"\\F22B\"; }\n\n.fa-neuter:before {\n  content: \"\\F22C\"; }\n\n.fa-genderless:before {\n  content: \"\\F22D\"; }\n\n.fa-facebook-official:before {\n  content: \"\\F230\"; }\n\n.fa-pinterest-p:before {\n  content: \"\\F231\"; }\n\n.fa-whatsapp:before {\n  content: \"\\F232\"; }\n\n.fa-server:before {\n  content: \"\\F233\"; }\n\n.fa-user-plus:before {\n  content: \"\\F234\"; }\n\n.fa-user-times:before {\n  content: \"\\F235\"; }\n\n.fa-hotel:before,\n.fa-bed:before {\n  content: \"\\F236\"; }\n\n.fa-viacoin:before {\n  content: \"\\F237\"; }\n\n.fa-train:before {\n  content: \"\\F238\"; }\n\n.fa-subway:before {\n  content: \"\\F239\"; }\n\n.fa-medium:before {\n  content: \"\\F23A\"; }\n\n.fa-yc:before,\n.fa-y-combinator:before {\n  content: \"\\F23B\"; }\n\n.fa-optin-monster:before {\n  content: \"\\F23C\"; }\n\n.fa-opencart:before {\n  content: \"\\F23D\"; }\n\n.fa-expeditedssl:before {\n  content: \"\\F23E\"; }\n\n.fa-battery-4:before,\n.fa-battery:before,\n.fa-battery-full:before {\n  content: \"\\F240\"; }\n\n.fa-battery-3:before,\n.fa-battery-three-quarters:before {\n  content: \"\\F241\"; }\n\n.fa-battery-2:before,\n.fa-battery-half:before {\n  content: \"\\F242\"; }\n\n.fa-battery-1:before,\n.fa-battery-quarter:before {\n  content: \"\\F243\"; }\n\n.fa-battery-0:before,\n.fa-battery-empty:before {\n  content: \"\\F244\"; }\n\n.fa-mouse-pointer:before {\n  content: \"\\F245\"; }\n\n.fa-i-cursor:before {\n  content: \"\\F246\"; }\n\n.fa-object-group:before {\n  content: \"\\F247\"; }\n\n.fa-object-ungroup:before {\n  content: \"\\F248\"; }\n\n.fa-sticky-note:before {\n  content: \"\\F249\"; }\n\n.fa-sticky-note-o:before {\n  content: \"\\F24A\"; }\n\n.fa-cc-jcb:before {\n  content: \"\\F24B\"; }\n\n.fa-cc-diners-club:before {\n  content: \"\\F24C\"; }\n\n.fa-clone:before {\n  content: \"\\F24D\"; }\n\n.fa-balance-scale:before {\n  content: \"\\F24E\"; }\n\n.fa-hourglass-o:before {\n  content: \"\\F250\"; }\n\n.fa-hourglass-1:before,\n.fa-hourglass-start:before {\n  content: \"\\F251\"; }\n\n.fa-hourglass-2:before,\n.fa-hourglass-half:before {\n  content: \"\\F252\"; }\n\n.fa-hourglass-3:before,\n.fa-hourglass-end:before {\n  content: \"\\F253\"; }\n\n.fa-hourglass:before {\n  content: \"\\F254\"; }\n\n.fa-hand-grab-o:before,\n.fa-hand-rock-o:before {\n  content: \"\\F255\"; }\n\n.fa-hand-stop-o:before,\n.fa-hand-paper-o:before {\n  content: \"\\F256\"; }\n\n.fa-hand-scissors-o:before {\n  content: \"\\F257\"; }\n\n.fa-hand-lizard-o:before {\n  content: \"\\F258\"; }\n\n.fa-hand-spock-o:before {\n  content: \"\\F259\"; }\n\n.fa-hand-pointer-o:before {\n  content: \"\\F25A\"; }\n\n.fa-hand-peace-o:before {\n  content: \"\\F25B\"; }\n\n.fa-trademark:before {\n  content: \"\\F25C\"; }\n\n.fa-registered:before {\n  content: \"\\F25D\"; }\n\n.fa-creative-commons:before {\n  content: \"\\F25E\"; }\n\n.fa-gg:before {\n  content: \"\\F260\"; }\n\n.fa-gg-circle:before {\n  content: \"\\F261\"; }\n\n.fa-tripadvisor:before {\n  content: \"\\F262\"; }\n\n.fa-odnoklassniki:before {\n  content: \"\\F263\"; }\n\n.fa-odnoklassniki-square:before {\n  content: \"\\F264\"; }\n\n.fa-get-pocket:before {\n  content: \"\\F265\"; }\n\n.fa-wikipedia-w:before {\n  content: \"\\F266\"; }\n\n.fa-safari:before {\n  content: \"\\F267\"; }\n\n.fa-chrome:before {\n  content: \"\\F268\"; }\n\n.fa-firefox:before {\n  content: \"\\F269\"; }\n\n.fa-opera:before {\n  content: \"\\F26A\"; }\n\n.fa-internet-explorer:before {\n  content: \"\\F26B\"; }\n\n.fa-tv:before,\n.fa-television:before {\n  content: \"\\F26C\"; }\n\n.fa-contao:before {\n  content: \"\\F26D\"; }\n\n.fa-500px:before {\n  content: \"\\F26E\"; }\n\n.fa-amazon:before {\n  content: \"\\F270\"; }\n\n.fa-calendar-plus-o:before {\n  content: \"\\F271\"; }\n\n.fa-calendar-minus-o:before {\n  content: \"\\F272\"; }\n\n.fa-calendar-times-o:before {\n  content: \"\\F273\"; }\n\n.fa-calendar-check-o:before {\n  content: \"\\F274\"; }\n\n.fa-industry:before {\n  content: \"\\F275\"; }\n\n.fa-map-pin:before {\n  content: \"\\F276\"; }\n\n.fa-map-signs:before {\n  content: \"\\F277\"; }\n\n.fa-map-o:before {\n  content: \"\\F278\"; }\n\n.fa-map:before {\n  content: \"\\F279\"; }\n\n.fa-commenting:before {\n  content: \"\\F27A\"; }\n\n.fa-commenting-o:before {\n  content: \"\\F27B\"; }\n\n.fa-houzz:before {\n  content: \"\\F27C\"; }\n\n.fa-vimeo:before {\n  content: \"\\F27D\"; }\n\n.fa-black-tie:before {\n  content: \"\\F27E\"; }\n\n.fa-fonticons:before {\n  content: \"\\F280\"; }\n\n.fa-reddit-alien:before {\n  content: \"\\F281\"; }\n\n.fa-edge:before {\n  content: \"\\F282\"; }\n\n.fa-credit-card-alt:before {\n  content: \"\\F283\"; }\n\n.fa-codiepie:before {\n  content: \"\\F284\"; }\n\n.fa-modx:before {\n  content: \"\\F285\"; }\n\n.fa-fort-awesome:before {\n  content: \"\\F286\"; }\n\n.fa-usb:before {\n  content: \"\\F287\"; }\n\n.fa-product-hunt:before {\n  content: \"\\F288\"; }\n\n.fa-mixcloud:before {\n  content: \"\\F289\"; }\n\n.fa-scribd:before {\n  content: \"\\F28A\"; }\n\n.fa-pause-circle:before {\n  content: \"\\F28B\"; }\n\n.fa-pause-circle-o:before {\n  content: \"\\F28C\"; }\n\n.fa-stop-circle:before {\n  content: \"\\F28D\"; }\n\n.fa-stop-circle-o:before {\n  content: \"\\F28E\"; }\n\n.fa-shopping-bag:before {\n  content: \"\\F290\"; }\n\n.fa-shopping-basket:before {\n  content: \"\\F291\"; }\n\n.fa-hashtag:before {\n  content: \"\\F292\"; }\n\n.fa-bluetooth:before {\n  content: \"\\F293\"; }\n\n.fa-bluetooth-b:before {\n  content: \"\\F294\"; }\n\n.fa-percent:before {\n  content: \"\\F295\"; }\n\n.fa-gitlab:before {\n  content: \"\\F296\"; }\n\n.fa-wpbeginner:before {\n  content: \"\\F297\"; }\n\n.fa-wpforms:before {\n  content: \"\\F298\"; }\n\n.fa-envira:before {\n  content: \"\\F299\"; }\n\n.fa-universal-access:before {\n  content: \"\\F29A\"; }\n\n.fa-wheelchair-alt:before {\n  content: \"\\F29B\"; }\n\n.fa-question-circle-o:before {\n  content: \"\\F29C\"; }\n\n.fa-blind:before {\n  content: \"\\F29D\"; }\n\n.fa-audio-description:before {\n  content: \"\\F29E\"; }\n\n.fa-volume-control-phone:before {\n  content: \"\\F2A0\"; }\n\n.fa-braille:before {\n  content: \"\\F2A1\"; }\n\n.fa-assistive-listening-systems:before {\n  content: \"\\F2A2\"; }\n\n.fa-asl-interpreting:before,\n.fa-american-sign-language-interpreting:before {\n  content: \"\\F2A3\"; }\n\n.fa-deafness:before,\n.fa-hard-of-hearing:before,\n.fa-deaf:before {\n  content: \"\\F2A4\"; }\n\n.fa-glide:before {\n  content: \"\\F2A5\"; }\n\n.fa-glide-g:before {\n  content: \"\\F2A6\"; }\n\n.fa-signing:before,\n.fa-sign-language:before {\n  content: \"\\F2A7\"; }\n\n.fa-low-vision:before {\n  content: \"\\F2A8\"; }\n\n.fa-viadeo:before {\n  content: \"\\F2A9\"; }\n\n.fa-viadeo-square:before {\n  content: \"\\F2AA\"; }\n\n.fa-snapchat:before {\n  content: \"\\F2AB\"; }\n\n.fa-snapchat-ghost:before {\n  content: \"\\F2AC\"; }\n\n.fa-snapchat-square:before {\n  content: \"\\F2AD\"; }\n\n.fa-pied-piper:before {\n  content: \"\\F2AE\"; }\n\n.fa-first-order:before {\n  content: \"\\F2B0\"; }\n\n.fa-yoast:before {\n  content: \"\\F2B1\"; }\n\n.fa-themeisle:before {\n  content: \"\\F2B2\"; }\n\n.fa-google-plus-circle:before,\n.fa-google-plus-official:before {\n  content: \"\\F2B3\"; }\n\n.fa-fa:before,\n.fa-font-awesome:before {\n  content: \"\\F2B4\"; }\n\n.fa-handshake-o:before {\n  content: \"\\F2B5\"; }\n\n.fa-envelope-open:before {\n  content: \"\\F2B6\"; }\n\n.fa-envelope-open-o:before {\n  content: \"\\F2B7\"; }\n\n.fa-linode:before {\n  content: \"\\F2B8\"; }\n\n.fa-address-book:before {\n  content: \"\\F2B9\"; }\n\n.fa-address-book-o:before {\n  content: \"\\F2BA\"; }\n\n.fa-vcard:before,\n.fa-address-card:before {\n  content: \"\\F2BB\"; }\n\n.fa-vcard-o:before,\n.fa-address-card-o:before {\n  content: \"\\F2BC\"; }\n\n.fa-user-circle:before {\n  content: \"\\F2BD\"; }\n\n.fa-user-circle-o:before {\n  content: \"\\F2BE\"; }\n\n.fa-user-o:before {\n  content: \"\\F2C0\"; }\n\n.fa-id-badge:before {\n  content: \"\\F2C1\"; }\n\n.fa-drivers-license:before,\n.fa-id-card:before {\n  content: \"\\F2C2\"; }\n\n.fa-drivers-license-o:before,\n.fa-id-card-o:before {\n  content: \"\\F2C3\"; }\n\n.fa-quora:before {\n  content: \"\\F2C4\"; }\n\n.fa-free-code-camp:before {\n  content: \"\\F2C5\"; }\n\n.fa-telegram:before {\n  content: \"\\F2C6\"; }\n\n.fa-thermometer-4:before,\n.fa-thermometer:before,\n.fa-thermometer-full:before {\n  content: \"\\F2C7\"; }\n\n.fa-thermometer-3:before,\n.fa-thermometer-three-quarters:before {\n  content: \"\\F2C8\"; }\n\n.fa-thermometer-2:before,\n.fa-thermometer-half:before {\n  content: \"\\F2C9\"; }\n\n.fa-thermometer-1:before,\n.fa-thermometer-quarter:before {\n  content: \"\\F2CA\"; }\n\n.fa-thermometer-0:before,\n.fa-thermometer-empty:before {\n  content: \"\\F2CB\"; }\n\n.fa-shower:before {\n  content: \"\\F2CC\"; }\n\n.fa-bathtub:before,\n.fa-s15:before,\n.fa-bath:before {\n  content: \"\\F2CD\"; }\n\n.fa-podcast:before {\n  content: \"\\F2CE\"; }\n\n.fa-window-maximize:before {\n  content: \"\\F2D0\"; }\n\n.fa-window-minimize:before {\n  content: \"\\F2D1\"; }\n\n.fa-window-restore:before {\n  content: \"\\F2D2\"; }\n\n.fa-times-rectangle:before,\n.fa-window-close:before {\n  content: \"\\F2D3\"; }\n\n.fa-times-rectangle-o:before,\n.fa-window-close-o:before {\n  content: \"\\F2D4\"; }\n\n.fa-bandcamp:before {\n  content: \"\\F2D5\"; }\n\n.fa-grav:before {\n  content: \"\\F2D6\"; }\n\n.fa-etsy:before {\n  content: \"\\F2D7\"; }\n\n.fa-imdb:before {\n  content: \"\\F2D8\"; }\n\n.fa-ravelry:before {\n  content: \"\\F2D9\"; }\n\n.fa-eercast:before {\n  content: \"\\F2DA\"; }\n\n.fa-microchip:before {\n  content: \"\\F2DB\"; }\n\n.fa-snowflake-o:before {\n  content: \"\\F2DC\"; }\n\n.fa-superpowers:before {\n  content: \"\\F2DD\"; }\n\n.fa-wpexplorer:before {\n  content: \"\\F2DE\"; }\n\n.fa-meetup:before {\n  content: \"\\F2E0\"; }\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto; }\n\n@font-face {\n  font-family: 'icomoon';\n  src: url(" + escape(__webpack_require__(428)) + ");\n  src: url(" + escape(__webpack_require__(428)) + ") format(\"embedded-opentype\"), url(" + escape(__webpack_require__(1447)) + ") format(\"truetype\"), url(" + escape(__webpack_require__(1448)) + ") format(\"woff\"), url(" + escape(__webpack_require__(1449)) + ") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n[class^='icon-gc'],\n[class*=' icon-gc'] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.btn-light {\n  color: #212529;\n  background-color: #d8d8d8;\n  border-color: #d2d2d2; }\n\n.btn-light:hover {\n  color: #212529;\n  background-color: #c4c2c2;\n  border-color: #d2d2d2; }\n\n.icon-gc-subs:before {\n  content: '\\E900'; }\n\nh1.title {\n  font: normal 24px/1.5 \"Helvetica Neue\", sans-serif;\n  color: #e02619; }\n\n.alert-red {\n  color: #e02619; }\n\n.error {\n  color: #e02619;\n  font-size: 0.8rem; }\n\n.account-view {\n  min-height: 60.2vh; }\n\n.error-boundary-main {\n  width: 100%;\n  height: 100%;\n  justify-content: center; }\n\n.link-text {\n  color: #337ab7; }\n\n.italic {\n  font-style: italic; }\n\n.pointer {\n  cursor: pointer; }\n\n.bold {\n  font-weight: 700; }\n\n.muted {\n  color: #838383; }\n\n.text-small {\n  font-size: 0.8rem;\n  line-height: 1rem; }\n\n.list-group.no-borders {\n  border: none; }\n  .list-group.no-borders .list-group-item {\n    border: none; }\n\n.icon-blue {\n  color: #1d35f8; }\n\n.has-border {\n  border: 1px solid #bbbbbb;\n  border-radius: 0.6rem; }\n\n.text-left {\n  text-align: left; }\n\n.text-center {\n  text-align: center; }\n\n.text-right {\n  text-align: right; }\n\n.hidden {\n  display: none; }\n\n.cds-container {\n  padding: 1rem 0; }\n\n.relative {\n  position: relative; }\n\n.border-right {\n  border-right: 1px solid #302e2e; }\n\n.container-fluid.no-margins, .no-margins.container-sm, .no-margins.container-md, .no-margins.container-lg, .no-margins.container-xl {\n  margin-left: 0px;\n  margin-right: 0px;\n  padding-left: 0px;\n  padding-right: 0px; }\n\n.width-100 {\n  width: 100%; }\n\n.no-border {\n  border: none; }\n\n.print {\n  display: none; }\n\n.Select-control {\n  border: 1px solid #ced4da !important; }\n\n.jsonOdd {\n  background-color: rgba(202, 202, 202, 0.3) !important !important; }\n\n.name-drop-down {\n  display: block; }\n\n.detail-container div.has-border {\n  border: none; }\n\n.view-order {\n  background-color: #f9f9f9;\n  color: #333333; }\n\n@media print {\n  .no-print {\n    display: none; }\n  .print {\n    display: inline; }\n  .jsonCell {\n    min-height: 40px; }\n  .entry {\n    margin-bottom: 1.5rem; }\n  span.print.sub-heading {\n    font-size: 1.3rem;\n    font-weight: bold; }\n  .border-right {\n    border-right: 0px solid transparent; }\n  .has-border {\n    border: none; }\n  .row.print-col {\n    flex-direction: row; }\n  .row.print-col div.col-md-4,\n  .row.print-col div.col-md-3 {\n    flex-grow: 0;\n    flex-shrink: 0;\n    flex-basis: 33.3333%; }\n  .col-md-4 {\n    flex: 0 0 100%;\n    max-width: 100%; } }\n\n.btn-light:focus {\n  border: 4px solid rgba(117, 171, 218, 0.4);\n  border-radius: 5px; }\n\n.social-login button {\n  font-size: 1px;\n  color: transparent; }\n\n.status-card.warning,\ndiv.text-center.heading,\ninput.card-button.warning,\ninput.card-button.info {\n  background-color: #fff; }\n\n.notification-error .notification-message {\n  color: #ec3d3d; }\n\n.DateInput > .DateInput_input {\n  font-size: 16px; }\n\n.top-skip-to-main {\n  padding: 6px;\n  position: absolute;\n  top: -40px;\n  left: 0px;\n  color: white;\n  border-right: 1px solid white;\n  border-bottom: 1px solid white;\n  border-bottom-right-radius: 8px;\n  background: #07368d;\n  -webkit-transition: top 1s ease-out;\n  transition: top 1s ease-out;\n  z-index: 100; }\n\n.top-skip-to-main:focus {\n  top: 0px;\n  color: #fff; }\n\n.flex-column-wrapper {\n  display: flex;\n  flex-direction: column; }\n\n/* remove input zoom mobile safari */\n@media (max-width: 48em) {\n  input[type=\"color\"],\n  input[type=\"date\"],\n  input[type=\"datetime\"],\n  input[type=\"datetime-local\"],\n  input[type=\"email\"],\n  input[type=\"month\"],\n  input[type=\"number\"],\n  input[type=\"password\"],\n  input[type=\"search\"],\n  input[type=\"tel\"],\n  input[type=\"text\"],\n  input[type=\"time\"],\n  input[type=\"url\"],\n  input[type=\"week\"],\n  select:focus,\n  textarea {\n    font-size: 16px; } }\n\n/* new float labels */\n.TextField__FieldWrapper {\n  margin-bottom: 1rem; }\n\n.TextField__LabelWrapper {\n  position: relative;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  overflow: hidden; }\n\n.TextField__LabelWrapper:hover {\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 0.375rem 0.375rem -0.375rem; }\n\n.TextInput {\n  -webkit-appearance: none;\n  line-height: 1.2;\n  width: 100%;\n  box-sizing: border-box;\n  resize: none;\n  font-size: 1rem;\n  height: 2.8125rem;\n  letter-spacing: 0.03em;\n  background: white;\n  border-width: 0px;\n  border-style: initial;\n  border-color: initial;\n  border-image: initial;\n  outline: none;\n  padding: 1.125rem 0.625rem 0.1875rem;\n  border-radius: 0.3125rem;\n  border-width: 0.0625rem;\n  border-style: solid;\n  border-color: #dadce0;\n  border-image: initial;\n  transition: box-shadow 0.2s ease-in-out 0s, color 0.2s ease-in-out 0s, border 0.2s ease-in-out 0s;\n  text-align: left !important; }\n\n.TextInput:focus {\n  border-color: #1d35f8; }\n\n.TextInput.is-invalid {\n  border-color: #d50000; }\n\n.Label__FloatedLabel {\n  color: #9b9b9b;\n  font-size: 1rem;\n  line-height: 1;\n  font-weight: normal;\n  letter-spacing: 0px;\n  pointer-events: none;\n  position: absolute;\n  top: 0.9375rem;\n  left: 0.5625rem;\n  transition: all 200ms cubic-bezier(0, 0.22, 0.12, 1) 0s; }\n\n.Select.has-value + .Label__FloatedLabel,\n.selected input + .Label__FloatedLabel,\ninput.TextInput:focus + .Label__FloatedLabel,\n.Label__FloatedLabel.on,\n.Label__FloatedLabel.show {\n  line-height: 1;\n  font-weight: normal;\n  pointer-events: none;\n  position: absolute;\n  left: 0.5625rem;\n  color: #1d35f8;\n  font-size: 0.625rem;\n  letter-spacing: 0.05rem;\n  opacity: 1;\n  top: 0.5625rem;\n  transition: all 200ms cubic-bezier(0, 0.22, 0.12, 1) 0s; }\n\n.FieldError__ErrorContainer {\n  font-size: 0.625rem;\n  color: #d50000;\n  display: flex;\n  margin-top: 0.25rem;\n  -webkit-box-align: center;\n  align-items: center;\n  letter-spacing: 0.02em; }\n  .FieldError__ErrorContainer > svg {\n    margin: 0px 0.25rem; }\n\n.TextField__LabelWrapper:focus {\n  border-color: #1d35f8; }\n\n.is-invalid .Label__FloatedLabel,\ninput.TextInput.is-invalid + .Label__FloatedLabel {\n  color: #d50000; }\n\n.Select-control {\n  font-size: 1rem;\n  height: 2.8125rem;\n  letter-spacing: 0.03em; }\n\n.TextField__FieldWrapper {\n  text-align: left !important; }\n\n.select-ct {\n  text-align: left; }\n\n.Select.has-value.is-clearable.Select--single > .Select-control .Select-value {\n  -webkit-appearance: none;\n  line-height: 1.2;\n  width: 100%;\n  box-sizing: border-box;\n  resize: none;\n  font-size: 1rem;\n  height: 2.8125rem;\n  letter-spacing: 0.03em;\n  background: white;\n  border-width: 0px;\n  border-style: initial;\n  border-color: initial;\n  border-image: initial;\n  outline: none;\n  padding: 1.125rem 0.625rem 0.1875rem;\n  border-radius: 0.3125rem;\n  border-image: initial;\n  transition: box-shadow 0.2s ease-in-out 0s, color 0.2s ease-in-out 0s, border 0.2s ease-in-out 0s;\n  text-align: left !important; }\n\n.Select.is-searchable.is-focused:not(is-open) > .Select-control {\n  box-shadow: none !important; }\n\n.Select.has-value.is-focused .Select-control,\n.Select.is-focused .Select-control {\n  border-color: #1d35f8 !important; }\n\n.select-ct.has-error {\n  height: auto; }\n\n.Select .Select-menu-outer {\n  border-radius: 4px; }\n\n.Select .Select-option.is-focused {\n  background: #f5f5f5 !important; }\n\n.Select .Select-option.is-selected {\n  background: #e0e0e0 !important;\n  color: #1d35f8 !important; }\n\n.Select.has-value.is-clearable.Select--single > .Select-control {\n  border: 0 !important; }\n\n.Select.has-value.is-clearable.Select--single > .Select-control .Select-value {\n  border: 1px solid #ced4da !important; }\n\n.Select.is-focused.has-value.is-clearable.Select--single > .Select-control .Select-value {\n  border: 1px solid #1d35f8 !important; }\n\n.has-error .Select-control,\n.has-error .Select.is-focused .Select-control {\n  border-color: #d50000 !important; }\n\n.has-error .Label__FloatedLabel {\n  color: #d50000; }\n\n.btn-primary {\n  cursor: pointer;\n  height: 2.8125rem;\n  font-size: 0.875rem;\n  display: inline-flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  align-items: center;\n  position: relative;\n  color: white;\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625rem 0.125rem 0px, rgba(0, 0, 0, 0.15) 0px 0.0625rem 0.1875rem 0px;\n  background: none #1d35f8;\n  background: #1d35f8;\n  outline: 0px;\n  border-width: 0px;\n  border-style: initial;\n  border-color: initial;\n  border-image: initial;\n  padding: 0px 1.5625rem;\n  border-radius: 0.25rem;\n  text-decoration: none;\n  transition: background-color 0.28s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.28s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1) 0s; }\n  .btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled):visited, .btn-primary:not(:disabled):not(.disabled):focus {\n    outline: 0px;\n    background: none #1d35f8;\n    box-shadow: rgba(34, 64, 245, 0.22) 0px 0.05rem 0.5rem 0px, rgba(34, 64, 245, 0.3) 0px 0.25rem 0.5rem 0px; }\n\n.btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed; }\n\n/*.status-card .btn-primary,.status-card .btn-primary:hover,*/\n.btn-light, .cell-button, .cell-button:hover,\n.btn-light:hover,\n.btn-light:not(:disabled):not(.disabled):active,\n.btn-light:focus {\n  cursor: pointer;\n  height: 2.8125rem;\n  font-size: 0.875rem;\n  display: inline-flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  align-items: center;\n  position: relative;\n  color: #222;\n  background: none #fff;\n  outline: 0px;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #ccc;\n  border-image: initial;\n  padding: 0px 1.5625rem;\n  border-radius: 0.25rem;\n  text-decoration: none;\n  box-shadow: none; }\n\n.cell-button, .cell-button:hover {\n  height: 2rem; }\n\n/*.status-card .btn-primary:hover, .status-card .btn-primary:not(:disabled):not(.disabled):active:focus, .status-card .btn-primary:not(:disabled):not(.disabled):visited, .status-card .btn-primary:not(:disabled):not(.disabled):focus,\n.status-card .btn-primary:not(:disabled):not(.disabled):active, .status-card .btn-primary:not(:disabled):not(.disabled).active,*/\n.btn-light:hover, .cell-button:hover, .cell-button:not(:disabled):not(.disabled):active:focus, .cell-button:not(:disabled):not(.disabled):visited, .cell-button:not(:disabled):not(.disabled):focus,\n.cell-button:not(:disabled):not(.disabled):active, .cell-button:not(:disabled):not(.disabled).active, .show > .cell-button.dropdown-toggle {\n  background: none #fff;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 0.375rem 0.375rem -0.375rem;\n  color: #000; }\n\n.status-card .btn-primary,\n.status-card .btn-primary:hover, .status-card .btn-primary:not(:disabled):not(.disabled):active:focus, .status-card .btn-primary:not(:disabled):not(.disabled):visited, .status-card .btn-primary:not(:disabled):not(.disabled):focus,\n.status-card .btn-primary:not(:disabled):not(.disabled):active, .status-card .btn-primary:not(:disabled):not(.disabled).active {\n  cursor: pointer;\n  height: 2.25rem;\n  font-size: 0.875rem;\n  display: inline-flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  align-items: center;\n  position: relative;\n  color: #1d35f8;\n  background: none #fff;\n  outline: 0px;\n  border: 1px solid #1d35f8;\n  padding: 0px 1.5625rem;\n  border-radius: 0.25rem;\n  text-decoration: none;\n  box-shadow: none;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }\n\n.status-card .btn-primary:hover, .status-card .btn-primary:not(:disabled):not(.disabled):active:focus, .status-card .btn-primary:not(:disabled):not(.disabled):visited, .status-card .btn-primary:not(:disabled):not(.disabled):focus,\n.status-card .btn-primary:not(:disabled):not(.disabled):active, .status-card .btn-primary:not(:disabled):not(.disabled).active {\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 0.375rem 0.375rem -0.375rem; }\n\n.login-view .btn-primary,\n.login-view .btn-light {\n  min-width: 260px !important;\n  display: inline-flex; }\n\n.notification.notification-success {\n  background-image: url(" + escape(__webpack_require__(1450)) + ");\n  background-repeat: no-repeat;\n  background-position: 10px 50%;\n  background-color: #E7FADF !important;\n  border-radius: 2px;\n  border-top: 0 !important;\n  border: 1px solid #6FB250 !important;\n  padding: 10px 10px 10px 45px !important;\n  height: auto !important;\n  color: #000 !important; }\n  .notification.notification-success .notification-title {\n    color: #000 !important;\n    font-weight: 500 !important; }\n\n.notifications-wrapper .notifications-tc,\n.notifications-wrapper .notifications-bl {\n  left: 50px !important;\n  top: auto !important;\n  bottom: 50px !important;\n  padding: 0 !important;\n  margin: 0 !important; }\n\n.notification-dismiss {\n  background-color: #6FB250 !important;\n  color: #fff !important;\n  font-weight: normal !important; }\n\n.notification.notification-error {\n  background-image: url(" + escape(__webpack_require__(1451)) + ");\n  background-repeat: no-repeat;\n  background-position: 10px 50%;\n  background-color: #FADFDF !important;\n  border-radius: 2px;\n  border-top: 0 !important;\n  border: 1px solid #CF2626 !important;\n  padding: 10px 10px 10px 45px !important;\n  height: auto !important;\n  color: #000 !important; }\n  .notification.notification-error .notification-title {\n    color: #000 !important;\n    font-weight: 500 !important; }\n  .notification.notification-error .notification-message {\n    color: #000 !important; }\n  .notification.notification-error .notification-dismiss {\n    background-color: #CF2626 !important;\n    color: #fff !important;\n    font-weight: normal !important; }\n\ninput.btn.cell-button.btn-primary:not(.view-order) {\n  border-color: #1d35f8 !important;\n  background-color: #1d35f8 !important;\n  color: #fff !important; }\n\n@media screen and (max-width: 30em) {\n  .notifications-wrapper .notifications-tc,\n  .notifications-wrapper .notifications-bl {\n    left: 50% !important;\n    transform: translate(-50%, 0); }\n  .button-ct {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between; }\n    .button-ct .btn-primary {\n      width: 100%;\n      margin: 0 0 1rem !important; }\n    .button-ct .btn:not(.btn-primary) {\n      margin: 0 !important; }\n    .button-ct .btn:nth-child(n+3) {\n      margin: 0 0 0 1rem !important; } }\n\n.DateInput_input__focused {\n  border-color: #1d35f8; }\n\nbutton.print-page {\n  background: transparent;\n  border: none; }\n\n.slick-initialized .slick-slide:only-child {\n  max-width: 300px; }\n\n@media (min-width: 48em) {\n  .agecheck-inputs > div:nth-child(2) {\n    margin: 0 0.5rem; } }\n\n.SlideIn-appear {\n  transform: translateX(10px);\n  opacity: 0; }\n\n.SlideIn-appear.SlideIn-appear-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: all 0.5s linear; }\n\n.SlideIn-enter {\n  opacity: 0;\n  transform: translateX(10px); }\n\n.SlideIn-enter.SlideIn-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: all 0.2s linear 0.4s; }\n\n.SlideIn-leave {\n  opacity: 1.0;\n  transform: translateX(0); }\n\n.SlideIn-leave.SlideIn-leave-active {\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  transform: translateX(-10px);\n  transition: all 0.2s linear; }\n\n.SlideOut-appear {\n  transform: translateX(-10px);\n  opacity: 0; }\n\n.SlideOut-appear.SlideOut-appear-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: all 0.5s linear; }\n\n.SlideOut-enter {\n  opacity: 0;\n  transform: translateX(-10px); }\n\n.SlideOut-enter.SlideOut-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: all 0.2s linear 0.3s; }\n\n.SlideOut-leave {\n  opacity: 1.0;\n  transform: translateX(0); }\n\n.SlideOut-leave.SlideOut-leave-active {\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  transform: translateX(10px);\n  transition: all 0.2s linear; }\n\n/**\nDont put any css or scss in this file. imports only\n**/\n", ""]);

// exports


/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icomoon.1f638443.ttf";

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icomoon.7a375c43.woff";

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icomoon.07d73f20.svg";

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/radio-selected.de738775.svg";

/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/alert-triangle.b765a62b.svg";

/***/ }),

/***/ 1452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Header */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_header_HeaderNav__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_header_UserDropDown__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__header_scss__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_login_cognito_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_global_utility_adminConfigUtils__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_user_actions__ = __webpack_require__(113);











var setupLogoContainer = function (logoUrl, logo, fullWidthLogo) {
    if (!logoUrl && !logo) {
        return 'hidden';
    }
    else {
        if (fullWidthLogo) {
            return '';
        }
        else {
            return 'client-logo container';
        }
    }
};
var setupBackgroundImage = function (path) {
    return {
        backgroundImage: 'url(' + path + ')',
    };
};
var setupLogoImageClass = function (fullWidthLogo) {
    if (fullWidthLogo) {
        return 'logo-image-wide no-print';
    }
    else {
        return 'logo-image no-print';
    }
};
var setupUserInfoClass = function (fullWidthLogo) {
    if (fullWidthLogo) {
        return 'user-info';
    }
    else {
        return 'user-info';
    }
};
var Header = function (props) {
    var onLogout = function () {
        var history = props.history, myloLogin = props.myloLogin, myloConfig = props.myloConfig;
        history.push('/login');
        Object(__WEBPACK_IMPORTED_MODULE_7__src_app_login_cognito_actions__["d" /* cognitoLogout */])(myloLogin, myloConfig);
    };
    var onClickLeftNavOpen = function () {
        props.leftNavOpenAction({ payload: !props.leftNavOpen });
    };
    var myloUrl = "" + props.myloConfig.myloUiBaseUrl + props.myloPath + "?client_id=" + props.myloConfig.clientId;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("header", { className: "main-header" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "header-inner" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: setupLogoContainer(props.logoUrl, props.logo, props.fullWidthLogo) },
                props.isAuth ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-nav-toggle", onClick: function () { return onClickLeftNavOpen(); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "pull-left fa fa-bars" }))) : null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: setupBackgroundImage(props.logoUrl ? props.logoUrl : props.assetUrl + '/' + props.logo), className: setupLogoImageClass(props.fullWidthLogo), title: props.logoAltText }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: setupUserInfoClass(props.fullWidthLogo) }, props.isAuth ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__src_app_header_UserDropDown__["a" /* UserDropDown */], { userName: props.userName.address.name, onClick: function () { return onLogout(); }, myloLogin: props.myloLogin, myloUrl: myloUrl })) : null)),
            !props.logoUrl && !props.logo ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "client-no-logo container" },
                props.isAuth ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "main-nav-toggle", onClick: function () { return onClickLeftNavOpen(); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "pull-left fa fa-bars" }))) : null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: setupUserInfoClass(props.fullWidthLogo) }, props.isAuth ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__src_app_header_UserDropDown__["a" /* UserDropDown */], { userName: props.userName.address.name, onClick: function () { return onLogout(); }, myloLogin: props.myloLogin, myloUrl: myloUrl }))) : null))) : null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "no-print" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__src_app_header_HeaderNav__["a" /* HeaderNav */], { mode: "horizontal", openAnimation: "slide-up", clientConfig: props.clientConfig, adminConfig: props.adminConfig })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, props.headerBanner && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { style: setupBackgroundImage(props.assetUrl + '/' + props.headerBanner), className: "banner-image no-print", title: props.bannerAltText }))))));
};
var mapState = function (state) {
    var pageHeader = Object(__WEBPACK_IMPORTED_MODULE_8__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(state.adminConfig, state.clientConfig, 'PageHeader');
    var availActions = Object(__WEBPACK_IMPORTED_MODULE_8__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(state.adminConfig, state.clientConfig, 'AvailableActions');
    return {
        userName: Object(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state) || 'Not Found',
        isAuth: state.auth.omsAuth.isLoginSuccessful,
        logo: pageHeader.LogoPath || null,
        logoAltText: pageHeader.LogoAltText || null,
        logoUrl: pageHeader.LogoUrl || null,
        headerBanner: pageHeader.BannerPath || null,
        bannerAltText: pageHeader.BannerAltText || null,
        fullWidthLogo: pageHeader.FullWidthLogo || false,
        myloLogin: state.auth.weakLogin.identityId !== 'initialid',
        myloConfig: state.clientConfig.clientConfig.myloConfig,
        assetUrl: state.clientConfig.clientConfig.userFilesBucket,
        clientConfig: state.clientConfig,
        adminConfig: state.adminConfig,
        leftNavOpen: state.userState.leftNavOpen,
        myloPath: availActions.Preferences.myloAccountCustomPath || '/account',
    };
};
var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({
        leftNavOpenAction: __WEBPACK_IMPORTED_MODULE_10__src_app_user_actions__["j" /* actionCreators */].leftNavOpen,
    }, dispatch);
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapState, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["withRouter"])(Header)));


/***/ }),

/***/ 1453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderNav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_scss__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_menu__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_menu_assets_index_css__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_menu_assets_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rc_menu_assets_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_css_animation__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_utility_adminConfigUtils__ = __webpack_require__(42);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






function handleClick(info) {
    console.log("clicked " + info.key);
    console.log(info);
}
var animation = {
    enter: function (node, done) {
        var height;
        return Object(__WEBPACK_IMPORTED_MODULE_4_css_animation__["a" /* default */])(node, 'rc-menu-collapse', {
            start: function () {
                height = node.offsetHeight;
                node.style.height = 0;
            },
            active: function () {
                node.style.height = height + "px";
            },
            end: function () {
                node.style.height = '';
                done();
            },
        });
    },
    appear: function () {
        return this.enter.apply(this, arguments);
    },
    leave: function (node, done) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_css_animation__["a" /* default */])(node, 'rc-menu-collapse', {
            start: function () {
                node.style.height = node.offsetHeight + "px";
            },
            active: function () {
                node.style.height = 0;
            },
            end: function () {
                node.style.height = '';
                done();
            },
        });
    },
};
var HeaderNav = /** @class */ (function (_super) {
    __extends(HeaderNav, _super);
    function HeaderNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            overflowedIndicator: undefined,
        };
        return _this;
    }
    HeaderNav.prototype.render = function () {
        var overflowedIndicator = this.state.overflowedIndicator;
        var pageHeaderAdminData = Object(__WEBPACK_IMPORTED_MODULE_5__global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(this.props.adminConfig, this.props.clientConfig, 'PageHeader', this.props.clientConfig.clientConfig.magCode);
        var navMenu = [];
        var subMenuKey = 1;
        var menuItemKey = 0;
        if (pageHeaderAdminData.Navigation !== undefined) {
            pageHeaderAdminData.Navigation.forEach(function (navItem) {
                navMenu.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_menu__["b" /* SubMenu */], { key: subMenuKey, title: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "submenu-title-wrapper" }, navItem.customUrl ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: navItem.protocol + navItem.customUrl, target: navItem.newTab ? '_blank' : '' }, navItem.title) : navItem.title) }, navItem.children !== undefined && (navItem.children.map(function (childItem) {
                    menuItemKey++;
                    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_menu__["a" /* Item */], { key: subMenuKey + '-' + menuItemKey, title: childItem.title }, childItem.customUrl ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: childItem.protocol + childItem.customUrl, target: childItem.newTab ? '_blank' : '' },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "submenu-title-wrapper" }, childItem.title)) : childItem.title);
                }))));
                subMenuKey++;
                menuItemKey = 0;
            });
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_menu__["c" /* default */]
            // onClick={handleClick}
            , { 
                // onClick={handleClick}
                triggerSubMenuAction: 'hover', 
                // onOpenChange={onOpenChange}
                // selectedKeys={['1']}
                mode: this.props.mode, openAnimation: animation, overflowedIndicator: overflowedIndicator, className: 'rc-menu' }, navMenu)));
    };
    return HeaderNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(70)(false);
// imports


// module
exports.push([module.i, ".notification {\n  background-color: #fff !important;\n  color: #498000 !important; }\n\n.main-header .row.add-padding {\n  padding-left: 20px;\n  padding-right: 15px; }\n\n.main-header .user-icon {\n  display: none; }\n\n.main-header .user-info {\n  display: flex;\n  flex-direction: column;\n  align-content: flex-end;\n  flex-wrap: wrap;\n  margin-right: 2rem; }\n\n.main-header .client-logo {\n  display: flex;\n  justify-content: space-between;\n  height: 100px;\n  align-items: center; }\n\n.main-header .client-no-logo {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; }\n\n.main-header .logo-image-wide {\n  width: 100%;\n  height: 100%;\n  background-size: cover; }\n\n.main-header .banner-image {\n  width: 100%;\n  background-size: cover; }\n\n@media (max-width: 48em) {\n  .main-header .logo-image {\n    width: 100%;\n    height: 100%;\n    background-size: contain; }\n  .main-header .logo-image-wide {\n    height: 50px; }\n  .main-header .banner-image {\n    height: 50px; }\n  .main-header .user-info {\n    display: flex;\n    align-items: center;\n    right: 0px;\n    bottom: 0px; }\n  .main-header .client-logo {\n    height: 70px; } }\n\n@media (min-width: 48em) {\n  .main-header .main-nav-toggle {\n    display: none; }\n  .main-header .main-nav-toggle-no-logo {\n    display: none; }\n  .main-header .logo-image {\n    width: 300px;\n    height: 80px;\n    background-size: contain; }\n  .main-header .logo-image-wide {\n    height: 130px; }\n  .main-header .banner-image {\n    height: 130px; }\n  .main-header .client-logo {\n    height: 100px; }\n  .main-header .user-info {\n    margin-left: auto;\n    padding-right: 1rem; } }\n\n.main-header .banner-image,\n.main-header .logo-image {\n  background-position: center;\n  background-repeat: no-repeat; }\n\n.main-header .header-image {\n  width: 100%;\n  height: 150px; }\n\n.main-header .dropdown button.user-drop-btn,\n.main-header .dropdown-item a,\n.main-header .dropdown a,\n.main-header .dropdown-item:hover {\n  color: #1d35f8;\n  background-color: #fff;\n  border: none;\n  border-radius: 0; }\n\n.main-header .dropdown button.user-drop-btn.btn-secondary:not([disabled]):not(.disabled):active,\n.main-header .btn-secondary:not([disabled]):not(.disabled).active,\n.main-header .show > .btn-secondary.dropdown-toggle {\n  border: none;\n  background-color: #fff;\n  border-color: transparent;\n  color: #1d35f8;\n  outline: none;\n  cursor: pointer;\n  box-shadow: none; }\n\n.main-header .btn-secondary:focus, .main-header .btn-secondary.focus {\n  box-shadow: none; }\n\n.main-header button.logout-btn {\n  cursor: pointer; }\n\n.main-header .rc-menu-submenu {\n  border: 0 !important; }\n\n.main-header .rc-menu-submenu-open {\n  border: 0 !important; }\n\n.main-header .rc-menu-submenu-active {\n  border: 0; }\n\n@media screen and (max-width: 48em) {\n  .main-header .main-nav-toggle {\n    color: #000;\n    font-size: 1.25rem;\n    display: block; }\n  .main-header .main-nav-toggle-no-logo {\n    color: #000;\n    font-size: 1.25rem;\n    display: block; }\n  .main-header .border-right {\n    border-right: none; }\n  .main-header .user-name {\n    display: none; }\n  .main-header .user-icon {\n    display: inline-block;\n    color: #000;\n    font-size: 1.25rem; }\n  .main-header .dropdown button.user-drop-btn,\n  .main-header .dropdown-toggle::after {\n    color: #000; }\n  .main-header button.user-drop-btn.logout-btn.dropdown-item {\n    color: #1d35f8 !important; } }\n\n.rc-menu-submenu-popup {\n  z-index: 5; }\n", ""]);

// exports


/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACCOUNT_SAVE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCOUNT_SAVE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_SAVE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACCOUNT_SAVE_SUCCESS; });
/* unused harmony export ADDRESS_SAVE_START */
/* unused harmony export ADDRESS_SAVE_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADDRESS_SAVE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADDRESS_SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EMAIL_SAVE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EMAIL_SAVE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EMAIL_SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RESET_EMAIL_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTO_COFE_SAVE_START; });
/* unused harmony export AUTO_COFE_SAVE_ERROR */
/* unused harmony export AUTO_COFE_SAVE_SUCCESS */
/* unused harmony export FETCH_ACCTS_START */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_ACCTS_SUCCESS; });
/* unused harmony export FETCH_ACCTS_ERROR */
/* unused harmony export FETCH_OFFERS_START */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_OFFERS_SUCCESS; });
/* unused harmony export FETCH_OFFERS_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RESET_PASSWORD_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RESET_PASSWORD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CANCEL_RESET_PASSWORD_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return actionCreators; });
var ACCOUNT_SAVE_START = 'ACCOUNT_SAVE_START';
var ACCOUNT_SAVE_LOADING = 'ACCOUNT_SAVE_LOADING';
var ACCOUNT_SAVE_ERROR = 'ACCOUNT_SAVE_ERROR';
var ACCOUNT_SAVE_SUCCESS = 'ACCOUNT_SAVE_SUCCESS';
var ADDRESS_SAVE_START = 'ADDRESS_SAVE_START';
var ADDRESS_SAVE_LOADING = 'ADDRESS_SAVE_LOADING';
var ADDRESS_SAVE_ERROR = 'ADDRESS_SAVE_ERROR';
var ADDRESS_SAVE_SUCCESS = 'ADDRESS_SAVE_SUCCESS';
var EMAIL_SAVE_START = 'EMAIL_SAVE_START';
var EMAIL_SAVE_ERROR = 'EMAIL_SAVE_ERROR';
var EMAIL_SAVE_SUCCESS = 'EMAIL_SAVE_SUCCESS';
var RESET_EMAIL_FORM = 'RESET_EMAIL_FORM';
var AUTO_COFE_SAVE_START = 'AUTO_COFE_SAVE_START';
var AUTO_COFE_SAVE_ERROR = 'AUTO_COFE_SAVE_ERROR';
var AUTO_COFE_SAVE_SUCCESS = 'AUTO_COFE_SAVE_SUCCESS';
var FETCH_ACCTS_START = 'FETCH_ACCTS_START';
var FETCH_ACCTS_SUCCESS = 'FETCH_ACCTS_SUCCESS';
var FETCH_ACCTS_ERROR = 'FETCH_ACCTS_ERROR';
var FETCH_OFFERS_START = 'FETCH_OFFERS_START';
var FETCH_OFFERS_SUCCESS = 'FETCH_OFFERS_SUCCESS';
var FETCH_OFFERS_ERROR = 'FETCH_OFFERS_ERROR';
var RESET_PASSWORD_START = 'RESET_PASSWORD_START';
var RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
var RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
var CANCEL_RESET_PASSWORD_FORM = 'CANCEL_RESET_PASSWORD_FORM';
// Action Creators
var actionCreators = {
    accountSaveStart: function (payload) { return ({
        type: ACCOUNT_SAVE_START,
        payload: payload,
    }); },
    accountSaveError: function (payload) { return ({
        type: ACCOUNT_SAVE_ERROR,
        payload: payload,
    }); },
    accountSaveSuccess: function (payload) { return ({
        type: ACCOUNT_SAVE_SUCCESS,
        payload: payload,
    }); },
    accountSaveLoading: function (payload) { return ({
        type: ACCOUNT_SAVE_LOADING,
        payload: payload,
    }); },
    fetchAccountsSuccess: function (payload) { return ({
        type: FETCH_ACCTS_SUCCESS,
        payload: payload,
    }); },
    fetchAccountsStart: function (payload) { return ({
        type: FETCH_ACCTS_START,
        payload: payload,
    }); },
    addressSaveStart: function (payload) { return ({
        type: ADDRESS_SAVE_START,
        payload: payload,
    }); },
    addressSaveError: function (payload) { return ({
        type: ADDRESS_SAVE_ERROR,
        payload: payload,
    }); },
    addressSaveSuccess: function (payload) { return ({
        type: ADDRESS_SAVE_SUCCESS,
        payload: payload,
    }); },
    addressSaveLoading: function (payload) { return ({
        type: ADDRESS_SAVE_LOADING,
        payload: payload,
    }); },
    emailSaveStart: function (payload) { return ({
        type: EMAIL_SAVE_START,
        payload: payload,
    }); },
    emailSaveError: function (payload) { return ({
        type: EMAIL_SAVE_ERROR,
        payload: payload,
    }); },
    emailSaveSuccess: function (payload) { return ({
        type: EMAIL_SAVE_SUCCESS,
        payload: payload,
    }); },
    autoCofeSaveStart: function (payload) { return ({
        type: AUTO_COFE_SAVE_START,
        payload: payload,
    }); },
    autoCofeSaveError: function (payload) { return ({
        type: AUTO_COFE_SAVE_ERROR,
        payload: payload,
    }); },
    autoCofeSaveSuccess: function (payload) { return ({
        type: AUTO_COFE_SAVE_SUCCESS,
        payload: payload,
    }); },
    resetEmail: function (payload) { return ({
        type: RESET_EMAIL_FORM,
        payload: payload,
    }); },
    fetchOffersSuccess: function (payload) { return ({
        type: FETCH_OFFERS_SUCCESS,
        payload: payload,
    }); },
    fetchOffersFailure: function (payload) { return ({
        type: FETCH_OFFERS_ERROR,
        payload: payload,
    }); },
    fetchOffersStart: function (payload) { return ({
        type: FETCH_OFFERS_START,
        payload: payload,
    }); },
    resetPasswordStart: function (payload) { return ({
        type: RESET_PASSWORD_START,
        payload: payload,
    }); },
    resetPasswordError: function (payload) { return ({
        type: RESET_PASSWORD_ERROR,
        payload: payload,
    }); },
    resetPasswordSuccess: function (payload) {
        payload.history.push('/accounts/summary');
        return ({ type: RESET_PASSWORD_SUCCESS, payload: payload });
    },
    cancelResetPassword: function (payload) { return ({
        type: CANCEL_RESET_PASSWORD_FORM,
        payload: payload,
    }); },
};


/***/ }),

/***/ 1536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserDropDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(38);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var UserDropDown = /** @class */ (function (_super) {
    __extends(UserDropDown, _super);
    function UserDropDown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserDropDown.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["p" /* UncontrolledDropdown */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["h" /* DropdownToggle */], { caret: true, className: "user-drop-btn" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "user-name" },
                    " ",
                    this.props.userName),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "fa fa-user-o fa-2x spacer-left user-icon", "aria-label": "User drop-down list" })),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["g" /* DropdownMenu */], { right: true },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["f" /* DropdownItem */], null,
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Link"], { to: "/accounts/summary" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], { id: 'acnt.myaccount', description: 'my account', defaultMessage: 'Account Summary' })),
                    ' '),
                this.props.myloLogin && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["f" /* DropdownItem */], { divider: true })),
                this.props.myloLogin && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["f" /* DropdownItem */], { tag: "a", target: "_blank", href: this.props.myloUrl },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], { id: 'acnt.myloaccount', description: 'mylo account', defaultMessage: 'Manage My Sign In Info' }))),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["f" /* DropdownItem */], { divider: true }),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["f" /* DropdownItem */], { className: "user-drop-btn logout-btn", onClick: function () {
                        _this.props.onClick();
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], { id: 'nav.logout', description: 'logout', defaultMessage: 'Sign Out' })))));
    };
    return UserDropDown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),

/***/ 1537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Footer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_scss__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__footer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_global_utility_adminConfigUtils__ = __webpack_require__(42);





var formatDisclaimerCopy = function (disclaimerCopy) {
    if (disclaimerCopy) {
        var currentYear = new Date().getFullYear();
        var regex = /<\$CURRENT_YEAR>/ig;
        return disclaimerCopy.replace(regex, currentYear.toString(10));
    }
    return;
};
var Footer = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("footer", { className: "main-footer footer-body no-print" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["e" /* Container */], { className: "no-print" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["o" /* Row */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["d" /* Col */], { className: "disclaimer-col" }, formatDisclaimerCopy(props.disclaimerCopy))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["o" /* Row */], { className: "disclaimer-links" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_reactstrap__["d" /* Col */], { className: "disclaimer-col" }, props.disclaimerLinks &&
                    props.disclaimerLinks.map(function (disclaimer, index) {
                        var link = disclaimer.customUrl ? "" + disclaimer.protocol + disclaimer.customUrl : "/accounts/" + disclaimer.selectedRoute;
                        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { key: index + 1, className: "disclaimer-link" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { key: index, href: link, target: disclaimer.newTab ? '_blank' : '' }, disclaimer.label)));
                    }))))));
};
var mapState = function (state) {
    var footerData = Object(__WEBPACK_IMPORTED_MODULE_4__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(state.adminConfig, state.clientConfig, 'PageFooter');
    return {
        disclaimerCopy: footerData.DisclaimerCopy,
        disclaimerLinks: footerData.DisclaimerLinks,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapState)(Footer));


/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1539);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(71)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./footer.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./footer.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(70)(false);
// imports


// module
exports.push([module.i, ".footer-body {\n  background-color: #333333;\n  color: #ffffff;\n  padding-top: 0.25rem;\n  padding-left: 0.25rem;\n  padding-bottom: 0.5rem;\n  display: flex;\n  /* establish flex container */\n  flex-direction: column;\n  /* stack flex items vertically */\n  justify-content: center;\n  /* center items vertically, in this case */\n  align-items: center; }\n\n.disclaimer-links {\n  background-color: #333333;\n  color: #ffffff; }\n\n.disclaimer-col {\n  padding-top: 0.5rem;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  text-align: center; }\n\n.disclaimer-links a {\n  margin-right: 1rem;\n  background-color: #333333;\n  color: #ffffff;\n  padding-right: 1.5rem;\n  padding-left: 0;\n  border-right: 2px solid #ffffff;\n  margin-bottom: 1rem;\n  line-height: 1rem; }\n\n@media screen and (max-width: 48em) {\n  .disclaimer-links a {\n    margin-right: 0.5rem;\n    padding-right: 0.8rem;\n    margin-bottom: 0.5rem; } }\n\ndiv:last-of-type > a {\n  border-right: none;\n  margin-right: 0rem;\n  padding-right: 0rem; }\n", ""]);

// exports


/***/ }),

/***/ 1541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_global_field_validations__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_accounts_customer_service_actions__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_adminConfigUtils__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_global_components_Loading__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_accounts_customer_service_components_ResponseView__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_app_global_constants__ = __webpack_require__(158);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














var validate = function (values) {
    var errors = {};
    var email1 = values.email1, email2 = values.email2, emailSubjectSelected = values.emailSubjectSelected;
    if (!emailSubjectSelected) {
        errors.emailSubjectSelected = 'Required';
    }
    var isError = email1 !== email2;
    if (isError) {
        errors.email2 = 'Emails do not match';
    }
    if (!values.productSelected || values.productSelected === '') {
        errors.productSelected = 'Required';
    }
    if (!values.emailAdditionalInfo || values.emailAdditionalInfo === '') {
        errors.emailAdditionalInfo = 'Required';
    }
    return errors;
};
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.history = _this.props.history;
        _this.state = {
            selectedProdIdAlias: 'GFT',
            custServEmailAddress: '',
            customerEmailAddress: '',
            currentPrompt: '',
            emailSubjects: []
        };
        _this.onProductChange = _this.onProductChange.bind(_this);
        _this.onReasonChange = _this.onReasonChange.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.onSaveClick = _this.onSaveClick.bind(_this);
        return _this;
    }
    Form.prototype.componentDidMount = function () {
        this.props.sendCustservEmailCancel();
        var customerServiceAdminData = Object(__WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(this.props.adminConfig, this.props.clientConfig, 'CustomerService', this.props.clientConfig.clientConfig.magCode);
        this.setState({
            selectedProdIdAlias: this.props.clientConfig.clientConfig.magCode,
            emailSubjects: customerServiceAdminData.ListConfiguration,
        });
    };
    Form.prototype.handleCancel = function () {
        this.props.sendCustservEmailCancel();
        this.props.destroy();
        this.props.history.push('/accounts/summary');
    };
    Form.prototype.onSaveClick = function (values) {
        // tslint:disable-next-line:no-string-literal
        var selectedProdIdAlias = values['productSelected'];
        // tslint:disable-next-line:no-string-literal
        var subject = values['emailSubjectSelected'].title;
        var customerServiceAdminData = Object(__WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(this.props.adminConfig, this.props.clientConfig, 'CustomerService', this.state.selectedProdIdAlias);
        var csEmailAddr = customerServiceAdminData.CustomerServiceEmailAddress;
        var customerEmailAddr = values.email1;
        var address = {
            name: values.address.name,
            address1: values.address.address1,
            address2: values.address.address2 ? values.address.address2 : '',
            address3: '',
            city: values.address.city,
            state: values.address.state,
            postalCode: values.address.postalCode,
            countryCode: values.address.countryCode,
        };
        var customer = {
            address: address,
            prodIdAlias: values.productSelected.value,
            accountNumber: values.accountNumber,
        };
        this.props.sendCustservEmailStart({
            'emailContent': values,
            'custServEmailAddress': csEmailAddr,
            'customerEmailAddress': customerEmailAddr,
            'emailSubject': subject,
            'customer': customer,
            'prodIdAlias': this.state.selectedProdIdAlias,
            'emailType': 'Send Custserv Email',
            'fromLogin': true,
        });
    };
    Form.prototype.onProductChange = function (selectedProduct) {
        var customerServiceAdminData = Object(__WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(this.props.adminConfig, this.props.clientConfig, 'CustomerService', selectedProduct.value);
        this.setState({
            selectedProdIdAlias: selectedProduct.value,
            emailSubjects: customerServiceAdminData.ListConfiguration,
        });
        this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */])('contact-customer-service', 'emailSubjectSelected', ''));
    };
    Form.prototype.onReasonChange = function (selectedReason) {
        if (selectedReason.title) {
            var customerServiceAdminData = Object(__WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(this.props.adminConfig, this.props.clientConfig, 'CustomerService', this.state.selectedProdIdAlias);
            var listItem = customerServiceAdminData.ListConfiguration.find(function (item) {
                return item.title === selectedReason.title;
            });
            this.setState({
                currentPrompt: listItem.prompt
            });
        }
    };
    Form.prototype.render = function () {
        var _this = this;
        var _a = this.props, intl = _a.intl, handleSubmit = _a.handleSubmit, productNames = _a.productNames, submitting = _a.submitting, sendEmailData = _a.sendEmailData, formCountry = _a.formCountry;
        var formatMessage = function (messId, messDisc, messDefault) {
            var title = intl.formatMessage({
                id: messId,
                description: messDisc,
                defaultMessage: messDefault,
            });
            return title;
        };
        var stateOptions = [{}];
        if (formCountry === 'US') {
            stateOptions = __WEBPACK_IMPORTED_MODULE_13__src_app_global_constants__["d" /* usStates */];
        }
        else if (formCountry === 'CA') {
            stateOptions = __WEBPACK_IMPORTED_MODULE_13__src_app_global_constants__["a" /* canadianProvinces */];
        }
        var countryOnChange = function (event) {
            _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["c" /* change */])('edit-address', 'address.state', ''));
            return true;
        };
        var summaryText = formatMessage('custserv.email.desc', 'email your info', 'Your email will be forwarded to a customer service representative for review and resolution.');
        var additionalinfoLabel = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], { id: "custserv.addtionalinfo", description: "customer service email additional info", defaultMessage: "Additional information:" }));
        var emailAddressLabel = formatMessage('email.newemail', 'heading new email', 'Please enter your email');
        var confirmEmailAddressLabel = formatMessage('email.confirmemail', 'heading confirm email', 'Please enter your email again to confirm');
        var productionSelectLabel = formatMessage('email.product', 'product selection', 'Please select which product you wish to contact:');
        var emailSubjectLabel = formatMessage('email.subject', 'email subject selection', 'Reason for contacting customer service:');
        var nameLabel = formatMessage('app.name', 'acct detail name', 'Name');
        var address1Label = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], { id: "app.address1", description: "acct detail address1", defaultMessage: "Address" }));
        var address2Label = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], { id: "app.address2", description: "acct detail address2", defaultMessage: "Additional Address (optional)" }));
        var accountNumberLabel = (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], { id: "app.acntnum", description: "acct account number", defaultMessage: "Account Number(s)" }));
        var cityLabel = formatMessage('app.city', 'acct detail city', 'City');
        var stateLabel = formatMessage('app.state', 'acct detail state', 'State/Province');
        var postalLabel = formatMessage('app.postal', 'acct detail postal', 'ZIP/Postal Code');
        var countryLabel = formatMessage('app.country', 'acct detail country', 'Country');
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["e" /* Container */], { className: "mb-3 mt-3", tabIndex: 0, fluid: true }, sendEmailData.loading ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__src_app_global_components_Loading__["a" /* LoadingView */], { loadingText: "Loading..." })) : (sendEmailData.sendEmailResult !== null ? (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__src_app_accounts_customer_service_components_ResponseView__["a" /* ResponseView */], { onExit: this.handleCancel })) : (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("form", { onSubmit: handleSubmit(function (fields) { return _this.onSaveClick(fields); }) },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "flex-column-wrapper" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "edit-address-ct" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["o" /* Row */], null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "h3 view-heading", id: "view-heading" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], { id: "acnt.preferences", description: "select preferences", defaultMessage: "Contact Customer Service" })),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text mb-2" }),
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { id: emailAddressLabel, name: "email1", label: emailAddressLabel, validate: [__WEBPACK_IMPORTED_MODULE_6__src_app_global_field_validations__["f" /* required */], __WEBPACK_IMPORTED_MODULE_6__src_app_global_field_validations__["b" /* email */]], component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { id: confirmEmailAddressLabel, name: "email2", label: confirmEmailAddressLabel, validate: [__WEBPACK_IMPORTED_MODULE_6__src_app_global_field_validations__["f" /* required */], __WEBPACK_IMPORTED_MODULE_6__src_app_global_field_validations__["b" /* email */]], component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "address.name", id: 'addressName', label: nameLabel, validate: [__WEBPACK_IMPORTED_MODULE_6__src_app_global_field_validations__["f" /* required */]], component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "address.address1", id: 'address1', label: address1Label, validate: [__WEBPACK_IMPORTED_MODULE_6__src_app_global_field_validations__["f" /* required */]], component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "address.address2", id: 'address2', label: address2Label, component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "address.countryCode", id: 'addressCountry', label: countryLabel, validate: [__WEBPACK_IMPORTED_MODULE_6__src_app_global_field_validations__["f" /* required */]], component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["c" /* SimpleSelect */], options: __WEBPACK_IMPORTED_MODULE_13__src_app_global_constants__["b" /* countries */], onChange: countryOnChange }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "address.city", id: 'addressCity', label: cityLabel, validate: [__WEBPACK_IMPORTED_MODULE_6__src_app_global_field_validations__["f" /* required */]], component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "address.state", id: 'addressState', label: stateLabel, component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["c" /* SimpleSelect */], options: stateOptions }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "address.postalCode", id: 'addressPostal', label: postalLabel, component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" }),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "accountNumber", id: 'accountNumber', label: accountNumberLabel, component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["f" /* TextInput */], type: "text" })))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text mb-2" }, summaryText),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "card" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["o" /* Row */], { className: "card-body m-0 pb-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["k" /* Label */], { for: "productSelected", className: "mb-0" },
                                    productionSelectLabel,
                                    " "),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "productSelected", id: "productSelected", component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["c" /* SimpleSelect */], options: productNames, simpleValue: false, onChange: this.onProductChange }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["o" /* Row */], { className: "card-body m-0 pb-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 6 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["k" /* Label */], { for: "emailSubjectSelected", className: "mb-0" }, emailSubjectLabel),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "emailSubjectSelected", id: "emailSubjectSelected", component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["c" /* SimpleSelect */], options: this.state.emailSubjects, simpleValue: false, valueKey: 'title', labelKey: 'title', onChange: this.onReasonChange }))),
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["o" /* Row */], { className: "card-body m-0 pb-0" },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12 },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["k" /* Label */], { for: "emailAdditionalInfo", className: "mb-0" },
                                    additionalinfoLabel,
                                    " "),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null, this.state.currentPrompt),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], { name: "emailAdditionalInfo", id: 'emailAdditionalInfo', component: __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements__["e" /* TextArea */], type: "text", rows: 4, placeholder: "Please provide details about your question" })))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["o" /* Row */], { className: "pulldown" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12 },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex flex-row mt-2 " },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-primary", type: "submit", disabled: submitting },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], { id: "app.next", description: "acct detail next button", defaultMessage: "Send" })),
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-light ml-2", type: "button", onClick: this.handleCancel },
                                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], { id: "app.cancel", description: "acct detail cancel button", defaultMessage: "Cancel" }))))))))))));
    };
    return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var CustServReduxForm = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["f" /* reduxForm */])({
    form: 'contact-customer-service',
    validate: validate,
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
})(Form);
var selector = Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["d" /* formValueSelector */])('contact-customer-service');
var mapStateToProps = function (state) { return ({
    selectedProdIdAlias: selector(state, 'productSelected'),
    productNames: Object(__WEBPACK_IMPORTED_MODULE_4__src_app_accounts_selectors__["n" /* getProdIdsFromAdminConfig */])(state),
    adminConfig: state.adminConfig,
    clientConfig: state.clientConfig,
    sendEmailData: state.account.customerServiceEmailData,
    formCountry: selector(state, 'address.countryCode'),
}); };
var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({
        sendCustservEmailStart: __WEBPACK_IMPORTED_MODULE_8__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendCustservEmailStart,
        sendCustservEmailCancel: __WEBPACK_IMPORTED_MODULE_8__src_app_accounts_customer_service_actions__["k" /* actionCreators */].sendCustservEmailCancel
    }, dispatch);
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["e" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state, _a) {
    var params = _a.match.params;
    return mapStateToProps;
}, mapDispatchToProps)(CustServReduxForm)));


/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyloForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyloSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(38);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var MyloForm = /** @class */ (function (_super) {
    __extends(MyloForm, _super);
    function MyloForm(props) {
        return _super.call(this, props) || this;
    }
    MyloForm.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.mylo.getTokens(true)];
                    case 1:
                        tokens = _a.sent();
                        if (window.opener) {
                            window.opener.location.href =
                                "/auth/success/#access_token=" + tokens.access_token + "&id_token=" + tokens.id_token;
                        }
                        else {
                            window.location.href =
                                "/auth/success/#access_token=" + tokens.access_token + "&id_token=" + tokens.id_token;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MyloForm.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mylo-view" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                "Click",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", onClick: function () { return window.close(); }, className: "" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], { id: "app.cancel", description: "Cancel", defaultMessage: " here" })),
                " to close window.")));
    };
    return MyloForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var mapStateToProps = function (state) {
    return {
        mylo: Object(__WEBPACK_IMPORTED_MODULE_1__src_app_login_selectors__["a" /* getMylo */])(state),
    };
};
var MyloSuccess = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(MyloForm);


/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MyloContinueForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyloContinue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_user_actions__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var MyloContinueForm = /** @class */ (function (_super) {
    __extends(MyloContinueForm, _super);
    function MyloContinueForm(props) {
        return _super.call(this, props) || this;
    }
    MyloContinueForm.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokens;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // this is needed to set up PKCE in the SDK
                    return [4 /*yield*/, this.props.mylo.getPopupUrl()];
                    case 1:
                        // this is needed to set up PKCE in the SDK
                        _a.sent();
                        return [4 /*yield*/, this.props.mylo.getTokens(false)];
                    case 2:
                        tokens = _a.sent();
                        if (tokens) {
                            // set the account info into userState
                            this.props.loginAccountNumberAction({ payload: this.props.accountNumber });
                            this.props.loginPostalCodeAction({ payload: this.props.postalCode });
                            if (window.opener) {
                                window.opener.location.href =
                                    "/auth/success/#access_token=" + tokens.access_token + "&id_token=" + tokens.id_token;
                            }
                            else {
                                window.location.href =
                                    "/auth/success/#access_token=" + tokens.access_token + "&id_token=" + tokens.id_token;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MyloContinueForm.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mylo-view" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                "Click",
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", onClick: function () { return window.location.href = '/login'; }, className: "" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], { id: "app.cancel", description: "Cancel", defaultMessage: " here" })),
                " if not redirected.")));
    };
    return MyloContinueForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var mapStateToProps = function (state, props) {
    // get the account number and postal code props from the query string
    // base64 encoded value: accountNumber|postalCode
    var accountInfo = Object(__WEBPACK_IMPORTED_MODULE_6_query_string__["parse"])(props.location.search).ac;
    var decodedAccountInfo = atob(accountInfo).split('|');
    var accountNumberParm = decodedAccountInfo[0] || '';
    var postalCodeParm = decodedAccountInfo[1] || '';
    return {
        accountNumber: accountNumberParm,
        postalCode: postalCodeParm,
        mylo: Object(__WEBPACK_IMPORTED_MODULE_1__src_app_login_selectors__["a" /* getMylo */])(state, "/mylo/continue?ac=" + accountInfo),
    };
};
var mapDispatchToProps = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({
        loginAccountNumberAction: __WEBPACK_IMPORTED_MODULE_2__src_app_user_actions__["j" /* actionCreators */].loginAccountNumber,
        loginPostalCodeAction: __WEBPACK_IMPORTED_MODULE_2__src_app_user_actions__["j" /* actionCreators */].loginPostalCode,
    }, dispatch);
};
var MyloContinue = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(MyloContinueForm);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-US.json": 1549,
	"./fr-CA.json": 1550
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1548;

/***/ }),

/***/ 1549:
/***/ (function(module, exports) {

module.exports = {"locale":"en-US","messages":{"login.notfoundmessage":"<p> You have successfully logged in using your {socialLoginDesc} account with the email address of {props.email}. </p> <p> There's just one more step to access your account.  Don't worry, you'll only have to do this once, and we'll remember who you are for your next visit.</p>","app.address":"Address {num} {optional}"}}

/***/ }),

/***/ 1550:
/***/ (function(module, exports) {

module.exports = {"locale":"fr-CA","messages":{"login.notfound":"","login.notfoundmessage":" ","login.accountaccess":"Accès au compte","login.mainheading":"Connectez-vous en utilisant l’un de vos comptes des médias sociaux préférés","login.registeredheading":"Si vous êtes déjà inscrit pour le compte d'accès","login.subheadingone":"Choisissez l’une de ces options pour vous connecter","login.subheadingtwo":"Ou choisissez l’une de ces options pour vous connecter","nav.acntsum":"Sommaire du compte","nav.subscripts":"Mes abonnements","nav.subscript":"Mes abonnement","nav.orders":"Mes commandes","nav.gifts":"Mes abonnements cadeaux","nav.renewals":"Mes renouvellements","nav.pay":"Faire un paiment","nav.wallet":"Mon portefeuille","nav.custservice":"Service Clients","nav.custservecontact":"Contactez le service clientèle","nav.comms":"Préférences de communication","nav.chat":"Communiquer avec le service à la clientèle","nav.faq":"FAQs","nav.logout":"Déconnexion","nav.wanttoshop":"Je veux magasiner","app.access":"Accès au compte","app.acntnum":"Numéro de compte","app.email":"Courriel","app.emailadd":"Adresse courriel","app.password":"Mot de passe","app.nameaddrs":"Nom et adresse","app.postal":"Code Postal","app.pobox":"Casier Postal","app.btnfindacnt":"Trouvez votre compte","app.name":"Nom","app.firstname":"Prénom","app.lastname":"Nom de famille","app.phonenum":"Numéro de téléphone (optionnel)","app.country":"Pays","app.state":"État","app.prov":"Province","app.stprov":"État/Province","app.zippc":"Code Postal","app.address1":"Adresse","app.address2":"Adresse supplémentaire","app.city":"Ville","app.search":"Recherche","app.cancel":"Annuler","app.previous":"Précédent","app.next":"Prochain","app.securelogin":"Accès Sécurisé","acnt.myaccount":"Mon compte","acnt.info":"Information du compte","acnt.paymentdue":"En paiements sont dus","acnt.nextpaymentdue":"Date du prochain paiement","acnt.paybalance":"Payer le montant","orders.myorders":"Mes commandes","orders.orddate":"Date de commande","orders.description":"Description de la commande","orders.detaildescription":"Description","orders.detailquantity":"Quantité","orders.detailprice":"Prix","orders.detailshipto":"Envoyez à","orders.detailsameasbilling":"Identique à l'adresse de facturation","orders.number":"Numéro de commande","orders.type":"Type de commande","orders.total":"Total de la commande","orders.view":"Voir la commande","orders.renew":"Renouveler","orders.status":"Statut","orders.orderstatus":"Statut de le commande","orders.preview":"Aperçu","orders.expires":"Expire le","orders.nextpay":"Date du prochain paiement","orders.paymentinfo":"Informations de paiement","orders.suspendall":"Suspendre tout ce qui est actif","orders.lasttwelve":"Commande au cours des 12 derniers mois","orders.lasttwelvepl":"Commandes au cours des 12 derniers mois","orders.billto":"Facturer","orders.invoice":"Numéro de facture","orders.actions":"Actes","orders.actionsheader":"french Select an action...","orders.suspend":"french Suspend...","orders.transfer":"french Transfer...","orders.refund":"french Request a Refund...","orders.updatepaymentoption":"french Update Payment Option...","orders.upgradedowngrade":"french Upgrade/Downgrade...","gift.renewal":"Cadeau en attente de renouvellement","gift.mygifts":"Mes abonnements cadeaux","gift.showbystatus":"Montrer par statut","gift.abouttoexpire":"Sur le point d`expirer","gift.exired":"Expiré","gift.expireson":"Expire le","gift.preview":"Aperçu","gift.title":"Titre","gift.sentto":"Envoyé à","gift.resendannoucement":"Retourner une annonce cadeau","gift.renew":"Rnouveler le cadeau","gift.renewalpl":"cadeaux à renouveler","gift.active":"Cadeau actif","gift.viewactive":"Voir mes cadeaux","gift.activepl":"cadeaux actifs","gift.to":"Pour","gift.from":"De","subscripts.mysubs":"Mes abonnements","subscripts.mysub":"Mes abonnement","subscripts.hasexpired":"Abonnement a expiré","subscripts.hasexpiredpl":"Abonnements ont expiré","subscripts.expiresoon":"Abonnement expirera bientôt","subscripts.expiresoonpl":"Abonnements expireront bientôt","subscripts.expireon":"Expire le","subscripts.active":"Abonnement actif","subscripts.activepl":"Abonnements actifs","subscripts.renewtoday":"Renouveler les abonnements","subscripts.renew":"Renouveler","subscripts.view":"Voir mes abonnements","subscripts.manage":"Gérer cet abonnement","card.expire":"Carte de crédit expirant bientôt","card.expirepl":"Cartes de crédit expirant bientôt","card.update":"Mettre mes cartes de crédit","email.editemailaddress":"Modifier l’adresse courriel","email.currentemail":"Courriel actuel: ","email.newemail":"Nouveau courriel","email.confirmemail":"Veuillez entrer la nouvelle adresse courriel de nouveau pour confirmer","email.changeemail":"Changer l’adresse courriel","email.emailsdonotmatch":"french Emails no not match...","email.emailupdatesuccess":"French you have successfully updated your email. . .","address.editaccountdetails":"Modifier les détails du compte","address.enteryouraddressinfo":"Veuillez entrer votre adresse","address.noteffectiveyet":"Pas encore déménagé?","address.assignstartdate":"Vous pouvez simplement indiquer la date de début pour la nouvelle adresse.","address.startdate":"Date de début (optionnelle)","address.temporarychange":"Changement temporaire?","address.assignenddate":"Si vous souhaitez attribuer une date de début et de fin à cette adresse, veuillez completer le champ ci-dessous.","address.enddate":"Date de fin","address.oldaddress":"Ancienne adresse:","address.newaddress":"Nouvelle adresse:","address.saveaddresschanges":"Sauvegarder les changements","address.error":"french An error has occurred!...","address.congratulations":"Félécitation!","address.updatesuccess":"french You have successfully updated your address for...","address.updatesuccess2":"french these magazines and products:...","address.greatoffers":"french Great Offers You Might Enjoy...","progressbar.accountinformation":"french Account Information...","progressbar.effectivedates":"french Effective Dates...","progressbar.accountupdates":"french Account Updates...","progressbar.confirmation":"french Confirmation...","status.Canceled":"Annulé","status.Active":"Actif","status.Non-Subscribing donor":"Donateur non-abonné","status.Pending":"En attente","status.On Hold":"Mise en attente","status.Future":"Futur","status.Suspended":"Suspendu","status.Deceased":"Décédé","status.Base":"Base","status.Partially Cancelled":"Partiellement annulé","status.Returned":"Retourné","status.Partially Returned":"Partiellement retourné","status.Finished":"Terminé","status.Discontinued":"Discontinué","status.Awaiting Payment":"French Awaiting Payment","status.Unpaid":"French Unpaid","status.Gift":"Cadeau","issue.title":"Replacement Issue","issue.reason":"Reason","issue.confirmation":"Confirmation","issue.replacement":"Replacement","issue.selectreason":"Please select your reason for a replacement:","issue.selectissue":"Please select which item needs replacement:","issue.damaged":"Damaged Issue","issue.missing":"Missing Issue","issue.success.header":"Congratulations!","issue.success.desc":"You have successfully extended your subscription by one (1) issue!","issue.failure.header":"Oops!","issue.submit":"Submit Request","issue.failure.desc":"Something went wrong!","issue.option1":"Extend my subscription by one (1)issue instead of sending a replacement. My subscription will now be through ","issue.option2":"I would like to receive the missing issue from ","issue.available":"Thank you! Great news, we still have this issue available. The choice is yours!","issue.outofstock":"Unfortunately that issue is not available for replacement. As a result, your subscription will be extended by one (1) issue.","issue.buttonDone":"I'm Done","issue.buttonStart":"Submit another issue"}}

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_PAYMENT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_PAYMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_PAYMENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_PAYMENT_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_PAYMENT_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
var UPDATE_PAYMENT_START = 'UPDATE_PAYMENT_START';
var UPDATE_PAYMENT_SUCCESS = 'UPDATE_PAYMENT_SUCCESS';
var UPDATE_PAYMENT_ERROR = 'UPDATE_PAYMENT_ERROR';
var UPDATE_PAYMENT_LOADING = 'UPDATE_PAYMENT_LOADING';
var UPDATE_PAYMENT_CANCEL = 'UPDATE_PAYMENT_CANCEL';
// Action Creators
var actionCreators = {
    updatePaymentStart: function (payload) { return ({
        type: UPDATE_PAYMENT_START,
        payload: payload,
    }); },
    updatePaymentError: function (payload) { return ({
        type: UPDATE_PAYMENT_ERROR,
        payload: payload,
    }); },
    updatePaymentSuccess: function (payload) {
        return ({ type: UPDATE_PAYMENT_SUCCESS, payload: payload });
    },
    updatePaymentLoading: function (payload) { return ({
        type: UPDATE_PAYMENT_LOADING,
        payload: payload,
    }); },
    updatePaymentCancel: function (payload) { return ({
        type: UPDATE_PAYMENT_CANCEL,
        payload: payload,
    }); },
};


/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return usStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canadianProvinces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return countries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return countriesWithNoPostalCodes; });
var usStates = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Federated States of Micronesia', value: 'FM' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Guam', value: 'GU' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Northern Mariana Islands', value: 'MP' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Palau', value: 'PW' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virgin Islands', value: 'VI' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' }
];
var canadianProvinces = [
    { label: 'Alberta', value: 'AB' },
    { label: 'British Columbia', value: 'BC' },
    { label: 'Manitoba', value: 'MB' },
    { label: 'New Brunswick', value: 'NB' },
    { label: 'Newfoundland and Labrador', value: 'NL' },
    { label: 'Northwest Territories', value: 'NT' },
    { label: 'Nova Scotia', value: 'NS' },
    { label: 'Nunavut', value: 'NU' },
    { label: 'Ontario', value: 'ON' },
    { label: 'Prince Edward Island', value: 'PE' },
    { label: 'Quebec', value: 'QC' },
    { label: 'Saskatchewan', value: 'SK' },
    { label: 'Yukon', value: 'YT' }
];
var countries = [
    { label: 'United States', value: 'US' },
    { label: 'Canada', value: 'CA' },
    { label: 'Afghanistan', value: 'AF' },
    { label: 'Åland Islands', value: 'AX' },
    { label: 'Albania', value: 'AL' },
    { label: 'Algeria', value: 'DZ' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Andorra', value: 'AD' },
    { label: 'Angola', value: 'AO' },
    { label: 'Anguilla', value: 'AI' },
    { label: 'Antarctica', value: 'AQ' },
    { label: 'Antigua and Barbuda', value: 'AG' },
    { label: 'Argentina', value: 'AR' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Aruba', value: 'AW' },
    { label: 'Australia', value: 'AU' },
    { label: 'Austria', value: 'AT' },
    { label: 'Azerbaijan', value: 'AZ' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bahrain', value: 'BH' },
    { label: 'Bangladesh', value: 'BD' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Belarus', value: 'BY' },
    { label: 'Belgium', value: 'BE' },
    { label: 'Belize', value: 'BZ' },
    { label: 'Benin', value: 'BJ' },
    { label: 'Bermuda', value: 'BM' },
    { label: 'Bhutan', value: 'BT' },
    { label: 'Bolivia', value: 'BO' },
    { label: 'Bosnia and Herzegovina', value: 'BA' },
    { label: 'Botswana', value: 'BW' },
    { label: 'Bouvet Island', value: 'BV' },
    { label: 'Brazil', value: 'BR' },
    { label: 'British Indian Ocean Territory', value: 'IO' },
    { label: 'Brunei Darussalam', value: 'BN' },
    { label: 'Bulgaria', value: 'BG' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Cabo Verde', value: 'CV' },
    { label: 'Cambodia', value: 'KH' },
    { label: 'Cameroon', value: 'CM' },
    { label: 'Cayman Islands', value: 'KY' },
    { label: 'Central African Republic', value: 'CF' },
    { label: 'Chad', value: 'TD' },
    { label: 'Chile', value: 'CL' },
    { label: 'China', value: 'CN' },
    { label: 'Christmas Island', value: 'CX' },
    { label: 'Cocos (Keeling) Islands', value: 'CC' },
    { label: 'Colombia', value: 'CO' },
    { label: 'Comoros', value: 'KM' },
    { label: 'Congo', value: 'CG' },
    { label: 'Congo, Democratic Republic of the', value: 'CD' },
    { label: 'Cook Islands', value: 'CK' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Côte d\'Ivoire', value: 'CI' },
    { label: 'Croatia', value: 'HR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Curaçao', value: 'CW' },
    { label: 'Cyprus', value: 'CY' },
    { label: 'Czechia', value: 'CZ' },
    { label: 'Denmark', value: 'DK' },
    { label: 'Djibouti', value: 'DJ' },
    { label: 'Dominica', value: 'DM' },
    { label: 'Dominican Republic', value: 'DO' },
    { label: 'Ecuador', value: 'EC' },
    { label: 'Egypt', value: 'EG' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'Equatorial Guinea', value: 'GQ' },
    { label: 'Eritrea', value: 'ER' },
    { label: 'Estonia', value: 'EE' },
    { label: 'Eswatini', value: 'SZ' },
    { label: 'Ethiopia', value: 'ET' },
    { label: 'Falkland Islands (Malvinas)', value: 'FK' },
    { label: 'Faroe Islands', value: 'FO' },
    { label: 'Fiji', value: 'FJ' },
    { label: 'Finland', value: 'FI' },
    { label: 'France', value: 'FR' },
    { label: 'French Guiana', value: 'GF' },
    { label: 'French Polynesia', value: 'PF' },
    { label: 'French Southern Territories', value: 'TF' },
    { label: 'Gabon', value: 'GA' },
    { label: 'Gambia', value: 'GM' },
    { label: 'Georgia', value: 'GE' },
    { label: 'Germany', value: 'DE' },
    { label: 'Ghana', value: 'GH' },
    { label: 'Gibraltar', value: 'GI' },
    { label: 'Greece', value: 'GR' },
    { label: 'Greenland', value: 'GL' },
    { label: 'Grenada', value: 'GD' },
    { label: 'Guadeloupe', value: 'GP' },
    { label: 'Guam', value: 'GU' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guernsey', value: 'GG' },
    { label: 'Guinea', value: 'GN' },
    { label: 'Guinea-Bissau', value: 'GW' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Haiti', value: 'HT' },
    { label: 'Heard Island and McDonald Islands', value: 'HM' },
    { label: 'Holy See (Vatican City State)', value: 'VA' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Hong Kong', value: 'HK' },
    { label: 'Hungary', value: 'HU' },
    { label: 'Iceland', value: 'IS' },
    { label: 'India', value: 'IN' },
    { label: 'Indonesia', value: 'ID' },
    { label: 'Iran, Islamic Republic Of', value: 'IR' },
    { label: 'Iraq', value: 'IQ' },
    { label: 'Ireland', value: 'IE' },
    { label: 'Isle of Man', value: 'IM' },
    { label: 'Israel', value: 'IL' },
    { label: 'Italy', value: 'IT' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Japan', value: 'JP' },
    { label: 'Jersey', value: 'JE' },
    { label: 'Jordan', value: 'JO' },
    { label: 'Kazakhstan', value: 'KZ' },
    { label: 'Kenya', value: 'KE' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Korea, Democratic People\'s Republic of', value: 'KP' },
    { label: 'Korea, Republic of', value: 'KR' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Kyrgyzstan', value: 'KG' },
    { label: 'Lao People\'s Democratic Republic', value: 'LA' },
    { label: 'Latvia', value: 'LV' },
    { label: 'Lebanon', value: 'LB' },
    { label: 'Lesotho', value: 'LS' },
    { label: 'Liberia', value: 'LR' },
    { label: 'Libya', value: 'LY' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Lithuania', value: 'LT' },
    { label: 'Luxembourg', value: 'LU' },
    { label: 'Macao', value: 'MO' },
    { label: 'Madagascar', value: 'MG' },
    { label: 'Malawi', value: 'MW' },
    { label: 'Malaysia', value: 'MY' },
    { label: 'Maldives', value: 'MV' },
    { label: 'Mali', value: 'ML' },
    { label: 'Malta', value: 'MT' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Martinique', value: 'MQ' },
    { label: 'Mauritania', value: 'MR' },
    { label: 'Mauritius', value: 'MU' },
    { label: 'Mayotte', value: 'YT' },
    { label: 'Mexico', value: 'MX' },
    { label: 'Micronesia, Federated States of', value: 'FM' },
    { label: 'Moldova, Republic of', value: 'MD' },
    { label: 'Monaco', value: 'MC' },
    { label: 'Mongolia', value: 'MN' },
    { label: 'Montenegro', value: 'ME' },
    { label: 'Montserrat', value: 'MS' },
    { label: 'Morocco', value: 'MA' },
    { label: 'Mozambique', value: 'MZ' },
    { label: 'Myanmar', value: 'MM' },
    { label: 'Namibia', value: 'NA' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Netherlands', value: 'NL' },
    { label: 'Netherlands Antilles', value: 'AN' },
    { label: 'New Caledonia', value: 'NC' },
    { label: 'New Zealand', value: 'NZ' },
    { label: 'Nicaragua', value: 'NI' },
    { label: 'Niger', value: 'NE' },
    { label: 'Nigeria', value: 'NG' },
    { label: 'Niue', value: 'NU' },
    { label: 'Norfolk Island', value: 'NF' },
    { label: 'North Macedonia', value: 'MK' },
    { label: 'Northern Mariana Islands', value: 'MP' },
    { label: 'Norway', value: 'NO' },
    { label: 'Oman', value: 'OM' },
    { label: 'Pakistan', value: 'PK' },
    { label: 'Palau', value: 'PW' },
    { label: 'Palestinian Territory, Occupied', value: 'PS' },
    { label: 'Panama', value: 'PA' },
    { label: 'Papua New Guinea', value: 'PG' },
    { label: 'Paraguay', value: 'PY' },
    { label: 'Peru', value: 'PE' },
    { label: 'Philippines', value: 'PH' },
    { label: 'Pitcairn', value: 'PN' },
    { label: 'Poland', value: 'PL' },
    { label: 'Portugal', value: 'PT' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Qatar', value: 'QA' },
    { label: 'Reunion', value: 'RE' },
    { label: 'Romania', value: 'RO' },
    { label: 'Russian Federation', value: 'RU' },
    { label: 'Rwanda', value: 'RW' },
    { label: 'Saint Helena', value: 'SH' },
    { label: 'Saint Kitts and Nevis', value: 'KN' },
    { label: 'Saint Lucia', value: 'LC' },
    { label: 'Saint Martin', value: 'MF' },
    { label: 'Saint Pierre and Miquelon', value: 'PM' },
    { label: 'Saint Vincent and the Grenadines', value: 'VC' },
    { label: 'Samoa', value: 'WS' },
    { label: 'San Marino', value: 'SM' },
    { label: 'Sao Tome and Principe', value: 'ST' },
    { label: 'Saudi Arabia', value: 'SA' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Serbia', value: 'RS' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Sierra Leone', value: 'SL' },
    { label: 'Singapore', value: 'SG' },
    { label: 'Slovakia', value: 'SK' },
    { label: 'Slovenia', value: 'SI' },
    { label: 'Solomon Islands', value: 'SB' },
    { label: 'Somalia', value: 'SO' },
    { label: 'South Africa', value: 'ZA' },
    { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
    { label: 'Spain', value: 'ES' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Sudan', value: 'SD' },
    { label: 'Suriname', value: 'SR' },
    { label: 'Svalbard and Jan Mayen', value: 'SJ' },
    { label: 'Sweden', value: 'SE' },
    { label: 'Switzerland', value: 'CH' },
    { label: 'Syrian Arab Republic', value: 'SY' },
    { label: 'Taiwan, Province of China', value: 'TW' },
    { label: 'Tajikistan', value: 'TJ' },
    { label: 'Tanzania, United Republic of', value: 'TZ' },
    { label: 'Thailand', value: 'TH' },
    { label: 'Timor-Leste', value: 'TL' },
    { label: 'Togo', value: 'TG' },
    { label: 'Tokelau', value: 'TK' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Trinidad and Tobago', value: 'TT' },
    { label: 'Tunisia', value: 'TN' },
    { label: 'Turkey', value: 'TR' },
    { label: 'Turkmenistan', value: 'TM' },
    { label: 'Turks and Caicos Islands', value: 'TC' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Ukraine', value: 'UA' },
    { label: 'United Arab Emirates', value: 'AE' },
    { label: 'United Kingdom', value: 'GB' },
    { label: 'United States Minor Outlying Islands', value: 'UM' },
    { label: 'Uruguay', value: 'UY' },
    { label: 'Uzbekistan', value: 'UZ' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'Viet Nam', value: 'VN' },
    { label: 'Virgin Islands, British', value: 'VG' },
    { label: 'Virgin Islands, U.S.', value: 'VI' },
    { label: 'Wallis and Futuna', value: 'WF' },
    { label: 'Western Sahara', value: 'EH' },
    { label: 'Yemen', value: 'YE' },
    { label: 'Zambia', value: 'ZM' },
    { label: 'Zimbabwe', value: 'ZW' }
];
var countriesWithNoPostalCodes = [
    { label: 'Angola', value: 'AO', postalCode: '%' },
    { label: 'Antigua and Barbuda', value: 'AG', postalCode: '%' },
    { label: 'Aruba', value: 'AW', postalCode: '%' },
    { label: 'Bahamas', value: 'BS', postalCode: '%' },
    { label: 'Belize', value: 'BZ', postalCode: '%' },
    { label: 'Benin', value: 'BJ', postalCode: '%' },
    { label: 'Bolivia', value: 'BO', postalCode: '%' },
    { label: 'Botswana', value: 'BW', postalCode: '%' },
    { label: 'Burkina Faso', value: 'BF', postalCode: '%' },
    { label: 'Burundi', value: 'BI', postalCode: '%' },
    { label: 'Cameroon', value: 'CM', postalCode: '%' },
    { label: 'Central African Republic', value: 'CF', postalCode: '%' },
    { label: 'Chad', value: 'TD', postalCode: '%' },
    { label: 'Congo, Democratic Republic of the', value: 'CD', postalCode: '%' },
    { label: 'Cook Islands', value: 'CK', postalCode: '%' },
    { label: 'Côte d\'Ivoire', value: 'CI', postalCode: '%' },
    { label: 'Curaçao', value: 'CW', postalCode: '%' },
    { label: 'Dominica', value: 'DM', postalCode: '%' },
    { label: 'Equatorial Guinea', value: 'GQ', postalCode: '%' },
    { label: 'Eritrea', value: 'ER', postalCode: '%' },
    { label: 'Fiji', value: 'FJ', postalCode: '%' },
    { label: 'Gambia', value: 'GM', postalCode: '%' },
    { label: 'Ghana', value: 'GH', postalCode: '%' },
    { label: 'Grenada', value: 'GD', postalCode: '%' },
    { label: 'Guyana', value: 'GY', postalCode: '%' },
    { label: 'Heard Island and McDonald Islands', value: 'HM', postalCode: '%' },
    { label: 'Korea, Democratic People\'s Republic of', value: 'KP', postalCode: '%' },
    { label: 'Libya', value: 'LY', postalCode: '%' },
    { label: 'Macao', value: 'MO', postalCode: '%' },
    { label: 'Mali', value: 'ML', postalCode: '%' },
    { label: 'Mauritania', value: 'MR', postalCode: '%' },
    { label: 'Panama', value: 'PA', postalCode: '%' },
    { label: 'Qatar', value: 'QA', postalCode: '%' },
    { label: 'Rwanda', value: 'RW', postalCode: '%' },
    { label: 'Saint Kitts and Nevis', value: 'KN', postalCode: '%' },
    { label: 'Saint Lucia', value: 'LC', postalCode: '%' },
    { label: 'Sao Tome and Principe', value: 'ST', postalCode: '%' },
    { label: 'Seychelles', value: 'SC', postalCode: '%' },
    { label: 'Suriname', value: 'SR', postalCode: '%' },
    { label: 'Syrian Arab Republic', value: 'SY', postalCode: '%' },
    { label: 'Tanzania, United Republic of', value: 'TZ', postalCode: '%' },
    { label: 'Tokelau', value: 'TK', postalCode: '%' },
    { label: 'Tonga', value: 'TO', postalCode: '%' },
    { label: 'Tuvalu', value: 'TV', postalCode: '%' },
    { label: 'Uganda', value: 'UG', postalCode: '%' },
    { label: 'United Arab Emirates', value: 'AE', postalCode: '%' },
    { label: 'United States Minor Outlying Islands', value: 'UM', postalCode: '%' },
    { label: 'Vanuatu', value: 'VU', postalCode: '%' },
    { label: 'Yemen', value: 'YE', postalCode: '%' },
    { label: 'Zambia', value: 'ZM', postalCode: '%' },
];



/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UNAUTH_GET_IAM_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNAUTH_IAM_KEYS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_IAM_KEYS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REFETCH_CUSTOMER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIND_SECURED_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
var UNAUTH_GET_IAM_KEYS = 'UNAUTH_GET_IAM_KEYS';
var UNAUTH_IAM_KEYS_SUCCESS = 'UNAUTH_IAM_KEYS_SUCCESS';
var AUTH_IAM_KEYS_SUCCESS = 'AUTH_IAM_KEYS_SUCCESS';
var REFETCH_CUSTOMER_DATA = 'REFETCH_CUSTOMER_DATA';
var FIND_SECURED_USER = 'FIND_SECURED_USER';
// Action Creators
var actionCreators = {
    unauthGetIamKeys: function (request) { return ({
        type: UNAUTH_GET_IAM_KEYS,
        payload: request,
    }); },
    unauthIamKeysSuccess: function (identityId, lookupPayload) { return ({
        type: UNAUTH_IAM_KEYS_SUCCESS,
        payload: { identityId: identityId, wsgPayload: lookupPayload },
    }); },
    authIamKeysSuccess: function (credentials, lookupPayload) { return ({
        type: AUTH_IAM_KEYS_SUCCESS,
        payload: { credentials: credentials, wsgPayload: lookupPayload },
    }); },
    refetchCustomer: function (payload) { return ({
        type: REFETCH_CUSTOMER_DATA,
        payload: payload,
    }); },
    findMyloUser: function (payload) { return ({
        type: FIND_SECURED_USER,
        payload: payload,
    }); },
};


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1421);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(71)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./login.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./login.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_CLIENT_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLIENT_CONFIG_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLIENT_CONFIG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLIENT_CONFIG_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return actionCreators; });
var GET_CLIENT_CONFIG = 'GET_CLIENT_CONFIG';
var CLIENT_CONFIG_LOADING = 'CLIENT_CONFIG_LOADING';
var CLIENT_CONFIG_SUCCESS = 'CLIENT_CONFIG_SUCCESS';
var CLIENT_CONFIG_FAILURE = 'CLIENT_CONFIG_FAILURE';
var actionCreators = {
    getClientConfig: function (magCode) { return ({
        type: GET_CLIENT_CONFIG,
        payload: magCode,
    }); },
    clientConfigLoading: function (payload) { return ({
        type: CLIENT_CONFIG_LOADING,
        payload: payload,
    }); },
    clientConfigSuccess: function (clientConfig) { return ({
        type: CLIENT_CONFIG_SUCCESS,
        payload: clientConfig,
    }); },
    clientConfigFailure: function (err) { return ({
        type: CLIENT_CONFIG_FAILURE,
        payload: err,
    }); },
};


/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCT_POSTAL_CODE_LOGIN_INITIATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionCreators; });
var ACCT_POSTAL_CODE_LOGIN_INITIATE = 'ACCT_POSTAL_CODE_LOGIN_INITIATE';
// Action Creators
var actionCreators = {
    accountPostalCodeLogin: function (payload) { return ({
        type: ACCT_POSTAL_CODE_LOGIN_INITIATE,
        payload: payload,
    }); },
};


/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMAIL_POSTAL_CODE_LOGIN_INITIATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionCreators; });
var EMAIL_POSTAL_CODE_LOGIN_INITIATE = 'EMAIL_POSTAL_CODE_LOGIN_INITIATE';
var actionCreators = {
    emailPostalCodeLogin: function (payload) { return ({
        type: EMAIL_POSTAL_CODE_LOGIN_INITIATE,
        payload: payload,
    }); },
};


/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME_ADDRESS_LOGIN_INITIATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionCreators; });
var NAME_ADDRESS_LOGIN_INITIATE = 'NAME_ADDRESS_LOGIN_INITIATE';
// Action Creators
var actionCreators = {
    nameAddressLogin: function (payload) { return ({
        type: NAME_ADDRESS_LOGIN_INITIATE,
        payload: payload,
    }); },
};


/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiClient; });
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var apigClientFactory = __webpack_require__(850).default;
var ApiClient = /** @class */ (function () {
    function ApiClient() {
        var _this = this;
        this.getSessionStorageValue = function (value) {
            var valueString = sessionStorage.getItem(value);
            if (valueString) {
                return JSON.parse(valueString);
            }
        };
        this.callApiGateway = function (config) {
            return new Promise(function (resolve, reject) {
                var theData;
                if (config.creds) {
                    config.creds.get(function (err) { return __awaiter(_this, void 0, void 0, function () {
                        var apigClient, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!err) return [3 /*break*/, 1];
                                    console.log(err);
                                    reject(err);
                                    return [3 /*break*/, 3];
                                case 1:
                                    apigClient = apigClientFactory.newClient({
                                        accessKey: config.creds.accessKeyId,
                                        secretKey: config.creds.secretAccessKey,
                                        sessionToken: config.creds.sessionToken,
                                        region: config.region,
                                        invokeUrl: config.url,
                                    });
                                    return [4 /*yield*/, apigClient
                                            .invokeApi(config.parms, config.path, config.requestmethod, config.additionalParms, config.requestbody)
                                            // tslint:disable-next-line:no-any
                                            .then(function (iamResult) {
                                            if (iamResult.data) {
                                                if (iamResult.data.prodId) {
                                                    var response = iamResult.data;
                                                    // theData = response;
                                                    // console.log('theData', theData);
                                                    return response;
                                                }
                                                else {
                                                    // console.log('no prodId');
                                                    return iamResult.data;
                                                }
                                            }
                                            else {
                                                console.log('no result.data');
                                                return undefined;
                                            }
                                        })
                                            .catch(function (data) {
                                            var responseData = data.message;
                                            console.error('IAM error result: ', responseData);
                                            console.error(data.stack);
                                            return responseData;
                                        })];
                                case 2:
                                    result = _a.sent();
                                    resolve(result);
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); });
                }
                else {
                    reject('no config creds');
                }
            });
        };
    }
    return ApiClient;
}());



/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__ = __webpack_require__(152);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_summary_actions__["r"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary_reducer__ = __webpack_require__(360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_summary_epics__ = __webpack_require__(361);
/* unused harmony namespace reexport */
// public API





/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CREATE_GA_EVENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_eventLogging_actions__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga4__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_ga4__);


var CREATE_GA_EVENT = 'CREATE_GA_EVENT';


var actionCreators = {
    createGAEvent: function (payload) {
        var intValue = payload.value;
        var floatValue = payload.value;
        if (payload.value) {
            if (Number.isInteger(payload.value)) {
                floatValue = parseFloat((payload.value / 100).toFixed(2));
                intValue = payload.value;
            }
            else {
                floatValue = payload.value;
                intValue = payload.value * 100;
                // put inValue in payload since eventBus always assumes an integer value since it is "corrected" in the backend
                payload.value = intValue;
            }
        }
        __WEBPACK_IMPORTED_MODULE_0__src_store__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__src_app_eventLogging_actions__["a" /* EVENTBUS_PUBLISH */], payload: payload });
        __WEBPACK_IMPORTED_MODULE_3_react_ga4___default.a.event('GC: ' + payload.category, {
            result: payload.action,
            prodId: payload.label,
            value: floatValue,
        });
        __WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* event */]({
            category: payload.category,
            action: payload.action,
            label: payload.label,
            value: intValue,
        }, ['CDS_SSP_Secondary']);
    }
};


/***/ }),

/***/ 221:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1411);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(71)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../../../node_modules/sass-loader/lib/loader.js??postcss!./form-elements.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../../../node_modules/sass-loader/lib/loader.js??postcss!./form-elements.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAccount */
/* unused harmony export getClientConfig */
/* unused harmony export getAdminConfig */
/* unused harmony export associatedAccounts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAssociatedAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDedupedAssociatedAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAssociatedGiftAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllPaymentMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getPaymentMethodsNeedsAttention; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getPaymentMethodsRegular; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getLoggedInCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLoggedInAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return suspendOrderById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getSuspendOrdersById; });
/* unused harmony export resumeOrderById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getResumeOrdersById; });
/* unused harmony export resumedOrders */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getResumedOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCustomers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getClientNamesForCustomers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getProdIdsForCustomers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getProdIdsFromAdminConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getProdIdsForGlobalCodeFromAdminConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getResinProdIdsForGlobalCodeFromAdminConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getResinClientIdsForGlobalCodeFromAdminConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_adminConfigUtils__ = __webpack_require__(42);


var getAccount = function (_a) {
    var account = _a.account;
    return account;
};
var getClientConfig = function (_a) {
    var clientConfig = _a.clientConfig;
    return clientConfig;
};
var getAdminConfig = function (_a) {
    var adminConfig = _a.adminConfig;
    return adminConfig;
};
var associatedAccounts = function (_a) {
    var account = _a.account, adminConfig = _a.adminConfig;
    if (account.customerData.customers) {
        return account.customerData.customers.map(function (_a) {
            var productName = _a.productName, accountNumber = _a.accountNumber, prodIdAlias = _a.prodIdAlias, email = _a.email, activeSubscriptions = _a.activeSubscriptions, address = _a.address, systemCode = _a.systemCode;
            var clientCode = '';
            var tableName = 'ClientProperties';
            if (adminConfig.adminConfig[prodIdAlias]) {
                clientCode = adminConfig.adminConfig[prodIdAlias][tableName].ClientCode;
            }
            return { name: productName, accountNumber: accountNumber, prodIdAlias: prodIdAlias, email: email, address: address, activeSubscriptions: activeSubscriptions, systemCode: systemCode, clientCode: clientCode };
        });
    }
    return null;
};
var getAssociatedAccounts = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(associatedAccounts, function (accounts) {
    if (accounts === void 0) { accounts = []; }
    return accounts;
});
var getDedupedAssociatedAccounts = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(associatedAccounts, function (accounts) {
    return accounts.filter(function (payload, index, self) {
        return self.findIndex(function (t) { return t.name === payload.name; }) === index;
    });
});
var getAssociatedGiftAccounts = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAccount, function (account) {
    var associatedGiftAccounts;
    if (account.associatedGiftAccountsMap) {
        associatedGiftAccounts =
            account.associatedGiftAccountsMap.associatedGiftAccounts;
    }
    return associatedGiftAccounts;
});
var getAllPaymentMethods = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAccount, function (account) {
    var paymentMethods;
    if (account.paymentMethodsData) {
        paymentMethods =
            account.paymentMethodsData.paymentMethods;
    }
    return paymentMethods;
});
var getPaymentMethodsNeedsAttention = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAccount, function (account) {
    var paymentMethods;
    if (account.paymentMethodsData) {
        paymentMethods =
            account.paymentMethodsData.paymentMethods;
    }
    return paymentMethods.filter(function (pm) { return pm.needsAttention && pm.associatedAccounts.length > 0; });
});
var getPaymentMethodsRegular = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAccount, function (account) {
    var paymentMethods;
    if (account.paymentMethodsData) {
        paymentMethods =
            account.paymentMethodsData.paymentMethods;
    }
    return paymentMethods.filter(function (pm) {
        return !pm.needsAttention && pm.associatedAccounts.length > 0;
    });
});
var getLoggedInCustomer = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAccount, function (account) {
    var cust;
    if (account && account.customerData && account.customerData.customers) {
        cust = account.customerData.customers[0];
    }
    return cust;
});
var getLoggedInAddress = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getLoggedInCustomer, function (customer) {
    var address;
    return (address = customer.address || {});
});
var getOrders = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAccount, function (account) {
    return account.orderData.orders;
});
var suspendOrderById = function (state, orderNumberProp) {
    var orders = getOrders(state);
    if (orderNumberProp === 'ALL') {
        return orders.filter(function (order, index, self) {
            var availableActions = Object(__WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(state.adminConfig, state.clientConfig, 'AvailableActions', order.prodIdAlias);
            if (order.isPf) {
                return order.isDisplayedOnMySubs
                    && availableActions && availableActions.Preferences && availableActions.Preferences.enableSuspend
                    && order.isSuspendable
                    && self.findIndex(function (t) { return t.isSuspendable && t.prodIdAlias === order.prodIdAlias
                        && t.planCode === order.planCode
                        && t.accountNumber === order.accountNumber; }) === index; // dedupe pf
            }
            else {
                return order.isDisplayedOnMySubs
                    && availableActions && availableActions.Preferences && availableActions.Preferences.enableSuspend
                    && order.isSuspendable
                    && self.findIndex(function (t) { return t.isSuspendable && t.prodIdAlias === order.prodIdAlias; }) === index; // dedupe mags
            }
        });
    }
    else {
        return orders.filter(function (order) { return order.orderNumber === orderNumberProp; });
    }
};
var getSuspendOrdersById = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([suspendOrderById], function (order) { return order; });
var resumeOrderById = function (state) {
    var orders = getOrders(state);
    return orders.filter(function (order, index, self) {
        return order.isResumable
            && self.findIndex(function (t) { return t.isResumable && t.prodIdAlias === order.prodIdAlias
                && t.planCode === order.planCode
                && t.accountNumber === order.accountNumber; }) === index; // dedupe);
    });
};
var getResumeOrdersById = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([resumeOrderById], function (order) { return order; });
var resumedOrders = function (state) {
    // This will return a collection of the orders that were resumed.  
    // The order info will be the updated info after the 'refresh' GCF call, which happens after the Resume txn is processed.
    var orders = getOrders(state);
    if (state.account.resumeData.resumeSavedResult && !state.account.resumeData.resumeSavedResult.success) {
        return [];
    }
    var myResumedOrders = state.account.resumeData.resumeSavedResult ? state.account.resumeData.resumeSavedResult.payload : [];
    var submittedOrders = orders.filter(function (order) {
        // return orders.filter(order => {
        var foundOrder = myResumedOrders.find(function (resumePayload) {
            return resumePayload.accountNumber === order.billToAccountNumber
                && resumePayload.prodIdAlias === order.prodIdAlias
                && resumePayload.planCode === order.planCode
                && order.isDisplayedOnMySubs;
        });
        return foundOrder ? true : false;
    });
    // return submittedOrders;
    return submittedOrders.filter(function (order, index, self) {
        return self.findIndex(function (t) { return t.prodIdAlias === order.prodIdAlias
            && t.planCode === order.planCode
            && t.accountNumber === order.accountNumber; }) === index; // dedupe);;
    });
};
var getResumedOrders = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([resumedOrders], function (order) { return order; });
var getCustomers = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAccount, function (account) {
    return account.customerData.customers;
});
var getClientNamesForCustomers = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAccount, getClientConfig, getAdminConfig, function (account, clientConfig, adminConfig) {
    if (account.customerData.customers) {
        var clientNames_1 = [];
        account.customerData.customers.forEach(function (customer) {
            if (clientNames_1.filter(function (item) { return item.prodIdAlias === customer.prodIdAlias; }).length === 0) {
                var clientProperties = Object(__WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(adminConfig, clientConfig, 'ClientProperties', customer.prodIdAlias);
                var name_1 = customer.systemCode === 'SERVPF' ? clientProperties.ClientName : clientProperties.ProductName;
                var found = clientNames_1.some(function (el) { return el.clientName === name_1; });
                if (!found) {
                    clientNames_1.push({
                        prodIdAlias: customer.prodIdAlias,
                        clientName: customer.systemCode === 'SERVPF' ? clientProperties.ClientName : clientProperties.ProductName,
                    });
                }
            }
        });
        return clientNames_1;
    }
    return null;
});
var getProdIdsForCustomers = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAccount, function (account) {
    if (account.orderData.orders) {
        var prodNames_1 = [];
        account.orderData.orders.forEach(function (order) {
            var productDesc = '';
            if (!order.isContinuity && order.isPf && account.customerData.customers) {
                var cust = account.customerData.customers.find(function (customer) {
                    return customer.prodIdAlias.substring(0, 3) === order.prodIdAlias.substring(0, 3);
                });
                productDesc = cust ? cust.productName : order.productName;
            }
            else {
                productDesc = order.isContinuity ? order.subscriptionName : order.productName;
            }
            if (prodNames_1.filter(function (item) { return item.label === productDesc; }).length === 0) {
                prodNames_1.push({
                    label: productDesc,
                    value: order.prodIdAlias,
                });
            }
        });
        return prodNames_1;
    }
    return null;
});
var getProdIdsFromAdminConfig = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAdminConfig, function (adminConfig) {
    if (adminConfig.adminConfig) {
        var prodNames_2 = [];
        Object.keys(adminConfig.adminConfig).forEach(function (key, index) {
            if (adminConfig.adminConfig[key].ClientProperties.ProductName) {
                prodNames_2.push({
                    label: adminConfig.adminConfig[key].ClientProperties.ProductName,
                    value: adminConfig.adminConfig[key].ClientProperties.ProdId,
                });
            }
        }, adminConfig.adminConfig);
        return prodNames_2;
    }
    return null;
});
var getProdIdsForGlobalCodeFromAdminConfig = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAdminConfig, getClientConfig, function (adminConfig, clientConfig) {
    var instanceMag = clientConfig.clientConfig.magCode;
    var clientPropsTableName = 'ClientProperties';
    var availActionsTableName = 'AvailableActions';
    var productExcludes = [];
    var products = [];
    if (adminConfig.adminConfig[instanceMag]) {
        var globalCode_1 = adminConfig.adminConfig[instanceMag][clientPropsTableName].GlobalCode;
        Object.keys(adminConfig.adminConfig).forEach(function (key) {
            if (key !== '*' && adminConfig.adminConfig[key].ClientProperties.GlobalCode === globalCode_1) {
                products.push(key);
            }
        }, adminConfig.adminConfig);
        products.forEach(function (product) {
            if (adminConfig.adminConfig[product][availActionsTableName]
                && adminConfig.adminConfig[product][availActionsTableName].Preferences
                && adminConfig.adminConfig[product][availActionsTableName].Preferences.excludeProductOnGCF) {
                productExcludes.push(product);
            }
        });
        return productExcludes;
    }
    return null;
});
var getResinProdIdsForGlobalCodeFromAdminConfig = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAdminConfig, function (adminConfig) {
    var clientPropsTableName = 'ClientProperties';
    var availActionsTableName = 'AvailableActions';
    var resinProducts = [];
    Object.keys(adminConfig.adminConfig).forEach(function (key) {
        if (adminConfig.adminConfig[key][availActionsTableName]
            && adminConfig.adminConfig[key][availActionsTableName].Preferences
            && !adminConfig.adminConfig[key][availActionsTableName].Preferences.excludeProductOnGCF
            && adminConfig.adminConfig[key][clientPropsTableName]
            && adminConfig.adminConfig[key][clientPropsTableName].ProductType === 'Resin') {
            resinProducts.push({ prodId: key, clientId: adminConfig.adminConfig[key][clientPropsTableName].ClientCode });
        }
    });
    return resinProducts;
});
var getResinClientIdsForGlobalCodeFromAdminConfig = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAdminConfig, function (adminConfig) {
    var clientPropsTableName = 'ClientProperties';
    var availActionsTableName = 'AvailableActions';
    var resinProducts = [];
    Object.keys(adminConfig.adminConfig).forEach(function (key) {
        if (adminConfig.adminConfig[key][availActionsTableName]
            && adminConfig.adminConfig[key][availActionsTableName].Preferences
            && !adminConfig.adminConfig[key][availActionsTableName].Preferences.excludeProductOnGCF
            && adminConfig.adminConfig[key][clientPropsTableName]
            && adminConfig.adminConfig[key][clientPropsTableName].ProductType === 'Resin') {
            var clientCode = resinProducts.find(function (product) { return product === adminConfig.adminConfig[key][clientPropsTableName].ClientCode; });
            if (!clientCode) {
                resinProducts.push(adminConfig.adminConfig[key][clientPropsTableName].ClientCode);
            }
        }
    });
    return resinProducts;
});


/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var LoadingView = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "loading-spinner" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-2" }, props.loadingText || 'Just a moment'),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-spinner fa-spin fa-3x fa-fw" }))));
};


/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ORDER_UPDATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ORDER_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ORDER_UPDATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ORDER_UPDATE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ORDER_UPDATE_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESIN_ORDER_UPDATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESIN_ORDER_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESIN_ORDER_UPDATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESIN_ORDER_UPDATE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESIN_ORDER_UPDATE_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return actionCreators; });
var ORDER_UPDATE_START = 'ORDER_UPDATE_START';
var ORDER_UPDATE_SUCCESS = 'ORDER_UPDATE_SUCCESS';
var ORDER_UPDATE_ERROR = 'ORDER_UPDATE_ERROR';
var ORDER_UPDATE_LOADING = 'ORDER_UPDATE_LOADING';
var ORDER_UPDATE_CANCEL = 'ORDER_UPDATE_CANCEL';
var RESIN_ORDER_UPDATE_START = 'RESIN_ORDER_UPDATE_START';
var RESIN_ORDER_UPDATE_SUCCESS = 'RESIN_ORDER_UPDATE_SUCCESS';
var RESIN_ORDER_UPDATE_ERROR = 'RESIN_ORDER_UPDATE_ERROR';
var RESIN_ORDER_UPDATE_LOADING = 'RESIN_ORDER_UPDATE_LOADING';
var RESIN_ORDER_UPDATE_CANCEL = 'RESIN_ORDER_UPDATE_CANCEL';
// Action Creators
var actionCreators = {
    orderUpdateStart: function (payload) { return ({
        type: ORDER_UPDATE_START, payload: payload,
    }); },
    orderUpdateError: function (payload) { return ({
        type: ORDER_UPDATE_ERROR, payload: payload,
    }); },
    orderUpdateSuccess: function (payload) { return ({
        type: ORDER_UPDATE_SUCCESS, payload: payload,
    }); },
    orderUpdateLoading: function (payload) { return ({
        type: ORDER_UPDATE_LOADING, payload: payload,
    }); },
    orderUpdateCancel: function (payload) { return ({
        type: ORDER_UPDATE_CANCEL, payload: payload,
    }); },
    resinOrderUpdateStart: function (payload) { return ({
        type: RESIN_ORDER_UPDATE_START, payload: payload,
    }); },
    resinOrderUpdateError: function (payload) { return ({
        type: RESIN_ORDER_UPDATE_ERROR, payload: payload,
    }); },
    resinOrderUpdateSuccess: function (payload) { return ({
        type: RESIN_ORDER_UPDATE_SUCCESS, payload: payload,
    }); },
    resinOrderUpdateLoading: function (payload) { return ({
        type: RESIN_ORDER_UPDATE_LOADING, payload: payload,
    }); },
    resinOrderUpdateCancel: function (payload) { return ({
        type: RESIN_ORDER_UPDATE_CANCEL, payload: payload,
    }); },
};


/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SUBSCRIPTION_EXTENSION_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SUBSCRIPTION_EXTENSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SUBSCRIPTION_EXTENSION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SUBSCRIPTION_EXTENSION_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SUBSCRIPTION_EXTENSION_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REPLACEMENT_ISSUE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REPLACEMENT_ISSUE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REPLACEMENT_ISSUE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REPLACEMENT_ISSUE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MISSED_DAMAGED_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_ENTITLED_ISSUES_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_ENTITLED_ISSUES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ENTITLED_ISSUES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_ENTITLED_ISSUES_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return actionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__ = __webpack_require__(16);


var SUBSCRIPTION_EXTENSION_START = 'SUBSCRIPTION_EXTENSION_START';
var SUBSCRIPTION_EXTENSION_SUCCESS = 'SUBSCRIPTION_EXTENSION_SUCCESS';
var SUBSCRIPTION_EXTENSION_ERROR = 'SUBSCRIPTION_EXTENSION_ERROR';
var SUBSCRIPTION_EXTENSION_CANCEL = 'SUBSCRIPTION_EXTENSION_CANCEL';
var SUBSCRIPTION_EXTENSION_LOADING = 'SUBSCRIPTION_EXTENSION_LOADING';
var REPLACEMENT_ISSUE_START = 'REPLACEMENT_ISSUE_START';
var REPLACEMENT_ISSUE_SUCCESS = 'REPLACEMENT_ISSUE_SUCCESS';
var REPLACEMENT_ISSUE_ERROR = 'REPLACEMENT_ISSUE_ERROR';
var REPLACEMENT_ISSUE_LOADING = 'REPLACEMENT_ISSUE_LOADING';
var MISSED_DAMAGED_CANCEL = 'MISSED_DAMAGED_CANCEL';
var GET_ENTITLED_ISSUES_START = 'GET_ENTITLED_ISSUES_START';
var GET_ENTITLED_ISSUES_SUCCESS = 'GET_ENTITLED_ISSUES_SUCCESS';
var GET_ENTITLED_ISSUES_ERROR = 'GET_ENTITLED_ISSUES_ERROR';
var GET_ENTITLED_ISSUES_LOADING = 'GET_ENTITLED_ISSUES_LOADING';
// Action Creators
var actionCreators = {
    subscriptionExtensionStart: function (payload) { return ({
        type: SUBSCRIPTION_EXTENSION_START,
        payload: payload,
    }); },
    subscriptionExtensionError: function (payload) { return ({
        type: SUBSCRIPTION_EXTENSION_ERROR,
        payload: payload,
    }); },
    subscriptionExtensionSuccess: function (payload) {
        __WEBPACK_IMPORTED_MODULE_0__src_store__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["c" /* REFETCH_CUSTOMER_DATA */], payload: payload.refetchCustomerPayload });
        return ({ type: SUBSCRIPTION_EXTENSION_SUCCESS, payload: payload });
    },
    subscriptionExtensionLoading: function (payload) { return ({
        type: SUBSCRIPTION_EXTENSION_LOADING,
        payload: payload,
    }); },
    subscriptionExtensionCancel: function (payload) { return ({
        type: SUBSCRIPTION_EXTENSION_CANCEL, payload: payload,
    }); },
    replacementIssueStart: function (payload) { return ({
        type: REPLACEMENT_ISSUE_START,
        payload: payload,
    }); },
    replacementIssueError: function (payload) { return ({
        type: REPLACEMENT_ISSUE_ERROR,
        payload: payload,
    }); },
    replacementIssueSuccess: function (payload) {
        __WEBPACK_IMPORTED_MODULE_0__src_store__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["c" /* REFETCH_CUSTOMER_DATA */], payload: payload.refetchCustomerPayload });
        return ({ type: REPLACEMENT_ISSUE_SUCCESS, payload: payload });
    },
    replacementIssueLoading: function (payload) { return ({
        type: REPLACEMENT_ISSUE_LOADING,
        payload: payload,
    }); },
    getEntitledIssuesStart: function (payload) { return ({
        type: GET_ENTITLED_ISSUES_START,
        payload: payload,
    }); },
    getEntitledIssuesError: function (payload) { return ({
        type: GET_ENTITLED_ISSUES_ERROR,
        payload: payload,
    }); },
    getEntitledIssuesSuccess: function (payload) { return ({
        type: GET_ENTITLED_ISSUES_SUCCESS,
        payload: payload,
    }); },
    getEntitledIssuesLoading: function (payload) { return ({
        type: GET_ENTITLED_ISSUES_LOADING,
        payload: payload,
    }); },
    missedDamagedCancel: function (payload) { return ({
        type: MISSED_DAMAGED_CANCEL,
        payload: payload,
    }); },
};


/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SERIES_UPDATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SERIES_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SERIES_UPDATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SERIES_UPDATE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SERIES_UPDATE_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
var SERIES_UPDATE_START = 'SERIES_UPDATE_START';
var SERIES_UPDATE_SUCCESS = 'SERIES_UPDATE_SUCCESS';
var SERIES_UPDATE_ERROR = 'SERIES_UPDATE_ERROR';
var SERIES_UPDATE_LOADING = 'SERIES_UPDATE_LOADING';
var SERIES_UPDATE_CANCEL = 'SERIES_UPDATE_CANCEL';
// Action Creators
var actionCreators = {
    seriesUpdateStart: function (payload) { return ({
        type: SERIES_UPDATE_START,
        payload: payload,
    }); },
    seriesUpdateError: function (payload) { return ({
        type: SERIES_UPDATE_ERROR,
        payload: payload,
    }); },
    seriesUpdateSuccess: function (payload) {
        return ({ type: SERIES_UPDATE_SUCCESS, payload: payload });
    },
    seriesUpdateLoading: function (payload) { return ({
        type: SERIES_UPDATE_LOADING,
        payload: payload,
    }); },
    seriesUpdateCancel: function (payload) { return ({
        type: SERIES_UPDATE_CANCEL,
        payload: payload,
    }); },
};


/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SUSPEND_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SUSPEND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SUSPEND_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SUSPEND_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SUSPEND_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_ISSUES_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_ISSUES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_ISSUES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_ISSUES_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return actionCreators; });
var SUSPEND_START = 'SUSPEND_START';
var SUSPEND_SUCCESS = 'SUSPEND_SUCCESS';
var SUSPEND_ERROR = 'SUSPEND_ERROR';
var SUSPEND_LOADING = 'SUSPEND_LOADING';
var SUSPEND_CANCEL = 'SUSPEND_CANCEL';
var GET_ISSUES_START = 'GET_ISSUES_START';
var GET_ISSUES_SUCCESS = 'GET_ISSUES_SUCCESS';
var GET_ISSUES_ERROR = 'GET_ISSUES_ERROR';
var GET_ISSUES_LOADING = 'GET_ISSUES_LOADING';
// Action Creators
var actionCreators = {
    suspendStart: function (payload) { return ({
        type: SUSPEND_START,
        payload: payload,
    }); },
    suspendError: function (payload) { return ({
        type: SUSPEND_ERROR,
        payload: payload,
    }); },
    suspendSuccess: function (payload) {
        // store.dispatch({type: REFETCH_CUSTOMER_DATA, payload: payload.refetchCustomerPayload});
        return ({ type: SUSPEND_SUCCESS, payload: payload });
    },
    suspendLoading: function (payload) { return ({
        type: SUSPEND_LOADING,
        payload: payload,
    }); },
    suspendCancel: function (payload) { return ({
        type: SUSPEND_CANCEL,
        payload: payload,
    }); },
    getIssuesStart: function (payload) { return ({
        type: GET_ISSUES_START,
        payload: payload,
    }); },
    getIssuesError: function (payload) { return ({
        type: GET_ISSUES_ERROR,
        payload: payload,
    }); },
    getIssuesSuccess: function (payload) { return ({
        type: GET_ISSUES_SUCCESS,
        payload: payload,
    }); },
    getIssuesLoading: function (payload) { return ({
        type: GET_ISSUES_LOADING,
        payload: payload,
    }); },
};


/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESUME_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESUME_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESUME_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESUME_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESUME_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_store__ = __webpack_require__(51);

var RESUME_START = 'RESUME_START';
var RESUME_SUCCESS = 'RESUME_SUCCESS';
var RESUME_ERROR = 'RESUME_ERROR';
var RESUME_LOADING = 'RESUME_LOADING';
var RESUME_CANCEL = 'RESUME_CANCEL';
// Action Creators
var actionCreators = {
    resumeStart: function (payload) { return ({
        type: RESUME_START,
        payload: payload,
    }); },
    resumeError: function (payload) { return ({
        type: RESUME_ERROR,
        payload: payload,
    }); },
    resumeSuccess: function (payload) {
        // store.dispatch({type: REFETCH_CUSTOMER_DATA, payload: payload.refetchCustomerPayload});
        __WEBPACK_IMPORTED_MODULE_0__src_store__["a" /* default */].dispatch({ type: RESUME_LOADING, payload: true });
        if (payload && payload.payload[0] && payload.payload[0].directResume) {
            // We resumed 1 sub directly without going to the Resume All view.  Need to route differently to the cfm page.
            payload.payload[0].history.push('/accounts/resume');
        }
        return ({ type: RESUME_SUCCESS, payload: payload });
    },
    resumeLoading: function (payload) { return ({
        type: RESUME_LOADING,
        payload: payload,
    }); },
    resumeCancel: function (payload) { return ({
        type: RESUME_CANCEL,
        payload: payload,
    }); },
};


/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAYMENTS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAYMENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAYMENTS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAYMENTS_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAYMENTS_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__ = __webpack_require__(157);


var PAYMENTS_START = 'PAYMENTS_START';
var PAYMENTS_SUCCESS = 'PAYMENTS_SUCCESS';
var PAYMENTS_ERROR = 'PAYMENTS_ERROR';
var PAYMENTS_LOADING = 'PAYMENTS_LOADING';
var PAYMENTS_CANCEL = 'PAYMENTS_CANCEL';
// Action Creators
var actionCreators = {
    paymentsStart: function (payload) { return ({
        type: PAYMENTS_START, payload: payload,
    }); },
    paymentsError: function (payload) { return ({
        type: PAYMENTS_ERROR, payload: payload,
    }); },
    paymentsSuccess: function (payload) {
        payload.accountResponse.paymentsPayloads.forEach(function (paymentPayload) {
            if (paymentPayload.autoRenewOptIn) {
                if (paymentPayload.systemCode === 'SERVPF' && paymentPayload.planCode !== '') {
                    // tslint:disable-next-line: no-string-literal
                    paymentPayload['googleAnalyticsCategory'] = 'Update Payment Method';
                    __WEBPACK_IMPORTED_MODULE_0__src_store__["a" /* default */].dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__["d" /* UPDATE_PAYMENT_START */], payload: [paymentPayload] });
                }
            }
        });
        return ({ type: PAYMENTS_SUCCESS, payload: payload, });
    },
    paymentsLoading: function (payload) { return ({
        type: PAYMENTS_LOADING, payload: payload,
    }); },
    paymentsCancel: function (payload) { return ({
        type: PAYMENTS_CANCEL, payload: payload,
    }); },
};


/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_PREFERENCES_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_PREFERENCES_SUCCESS; });
/* unused harmony export SAVE_PREFERENCES_ERROR */
/* unused harmony export SAVE_PREFERENCES_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return actionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_store__ = __webpack_require__(51);


var SAVE_PREFERENCES_START = 'SAVE_PREFERENCES_START';
var SAVE_PREFERENCES_SUCCESS = 'SAVE_PREFERENCES_SUCCESS';
var SAVE_PREFERENCES_ERROR = 'SAVE_PREFERENCES_ERROR';
var SAVE_PREFERENCES_LOADING = 'SAVE_PREFERENCES_LOADING';
var savePreferencesSuccess = {
    title: 'Preferences Update Successful',
    message: 'You have successfully updated your account preferences.',
    position: 'tc',
    autoDismiss: 0,
};
var savePreferencesError = {
    title: 'Preferences Update Error',
    message: 'There was an error updating your account preferences.',
    position: 'tc',
    autoDismiss: 0,
};
// Action Creators
var actionCreators = {
    savePreferencesStart: function (payload) { return ({
        type: SAVE_PREFERENCES_START,
        payload: payload,
    }); },
    savePreferencesError: function (payload) {
        __WEBPACK_IMPORTED_MODULE_1__src_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__["error"])(savePreferencesError));
        return ({ type: SAVE_PREFERENCES_ERROR, payload: payload });
    },
    savePreferencesSuccess: function (payload) { return ({
        type: SAVE_PREFERENCES_SUCCESS,
        payload: payload,
    }); },
    savePreferencesLoading: function (payload) { return ({
        type: SAVE_PREFERENCES_LOADING,
        payload: payload,
    }); },
    savePreferencesSuccessNotification: function () {
        __WEBPACK_IMPORTED_MODULE_1__src_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__["success"])(savePreferencesSuccess));
    },
    savePreferencesErrorNotification: function () {
        __WEBPACK_IMPORTED_MODULE_1__src_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__["error"])(savePreferencesError));
    },
};


/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STOPCHARGE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STOPCHARGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STOPCHARGE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STOPCHARGE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STOPCHARGE_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
var STOPCHARGE_START = 'STOPCHARGE_START';
var STOPCHARGE_SUCCESS = 'STOPCHARGE_SUCCESS';
var STOPCHARGE_ERROR = 'STOPCHARGE_ERROR';
var STOPCHARGE_LOADING = 'STOPCHARGE_LOADING';
var STOPCHARGE_CANCEL = 'STOPCHARGE_CANCEL';
// Action Creators
var actionCreators = {
    stopChargeStart: function (payload) { return ({
        type: STOPCHARGE_START,
        payload: payload,
    }); },
    stopChargeError: function (payload) { return ({
        type: STOPCHARGE_ERROR,
        payload: payload,
    }); },
    stopChargeSuccess: function (payload) {
        return ({ type: STOPCHARGE_SUCCESS, payload: payload });
    },
    stopChargeLoading: function (payload) { return ({
        type: STOPCHARGE_LOADING,
        payload: payload,
    }); },
    stopChargeCancel: function (payload) { return ({
        type: STOPCHARGE_CANCEL,
        payload: payload,
    }); },
};


/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STOP_AUTO_RENEW_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STOP_AUTO_RENEW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STOP_AUTO_RENEW_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STOP_AUTO_RENEW_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STOP_AUTO_RENEW_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
var STOP_AUTO_RENEW_START = 'STOP_AUTO_RENEW_START';
var STOP_AUTO_RENEW_SUCCESS = 'STOP_AUTO_RENEW_SUCCESS';
var STOP_AUTO_RENEW_ERROR = 'STOP_AUTO_RENEW_ERROR';
var STOP_AUTO_RENEW_LOADING = 'STOP_AUTO_RENEW_LOADING';
var STOP_AUTO_RENEW_CANCEL = 'STOP_AUTO_RENEW_CANCEL';
// Action Creators
var actionCreators = {
    stopAutoRenewStart: function (payload) { return ({
        type: STOP_AUTO_RENEW_START,
        payload: payload,
    }); },
    stopAutoRenewError: function (payload) { return ({
        type: STOP_AUTO_RENEW_ERROR,
        payload: payload,
    }); },
    stopAutoRenewSuccess: function (payload) {
        return ({ type: STOP_AUTO_RENEW_SUCCESS, payload: payload });
    },
    stopAutoRenewLoading: function (payload) { return ({
        type: STOP_AUTO_RENEW_LOADING,
        payload: payload,
    }); },
    stopAutoRenewCancel: function (payload) { return ({
        type: STOP_AUTO_RENEW_CANCEL,
        payload: payload,
    }); },
};


/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return START_AUTO_RENEW_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return START_AUTO_RENEW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_AUTO_RENEW_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return START_AUTO_RENEW_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return START_AUTO_RENEW_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
var START_AUTO_RENEW_START = 'START_AUTO_RENEW_START';
var START_AUTO_RENEW_SUCCESS = 'START_AUTO_RENEW_SUCCESS';
var START_AUTO_RENEW_ERROR = 'START_AUTO_RENEW_ERROR';
var START_AUTO_RENEW_LOADING = 'START_AUTO_RENEW_LOADING';
var START_AUTO_RENEW_CANCEL = 'START_AUTO_RENEW_CANCEL';
// Action Creators
var actionCreators = {
    startAutoRenewStart: function (payload) { return ({
        type: START_AUTO_RENEW_START,
        payload: payload,
    }); },
    startAutoRenewError: function (payload) { return ({
        type: START_AUTO_RENEW_ERROR,
        payload: payload,
    }); },
    startAutoRenewSuccess: function (payload) {
        return ({ type: START_AUTO_RENEW_SUCCESS, payload: payload });
    },
    startAutoRenewLoading: function (payload) { return ({
        type: START_AUTO_RENEW_LOADING,
        payload: payload,
    }); },
    startAutoRenewCancel: function (payload) { return ({
        type: START_AUTO_RENEW_CANCEL,
        payload: payload,
    }); },
};


/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REFUND_STORE_CREDIT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REFUND_STORE_CREDIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REFUND_STORE_CREDIT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REFUND_STORE_CREDIT_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REFUND_STORE_CREDIT_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return actionCreators; });
var REFUND_STORE_CREDIT_START = 'REFUND_STORE_CREDIT_START';
var REFUND_STORE_CREDIT_SUCCESS = 'REFUND_STORE_CREDIT_SUCCESS';
var REFUND_STORE_CREDIT_ERROR = 'REFUND_STORE_CREDIT_ERROR';
var REFUND_STORE_CREDIT_LOADING = 'REFUND_STORE_CREDIT_LOADING';
var REFUND_STORE_CREDIT_CANCEL = 'REFUND_STORE_CREDIT_CANCEL';
// Action Creators
var actionCreators = {
    refundStoreCreditStart: function (payload) { return ({
        type: REFUND_STORE_CREDIT_START,
        payload: payload,
    }); },
    refundStoreCreditError: function (payload) { return ({
        type: REFUND_STORE_CREDIT_ERROR,
        payload: payload,
    }); },
    refundStoreCreditSuccess: function (payload) {
        return ({ type: REFUND_STORE_CREDIT_SUCCESS, payload: payload });
    },
    refundStoreCreditLoading: function (payload) { return ({
        type: REFUND_STORE_CREDIT_LOADING,
        payload: payload,
    }); },
    refundStoreCreditCancel: function (payload) { return ({
        type: REFUND_STORE_CREDIT_CANCEL,
        payload: payload,
    }); },
};


/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESIN_ORDER_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESIN_ORDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESIN_ORDER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESIN_ORDER_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESIN_ORDER_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESIN_SPECULATIVE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESIN_SPECULATIVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESIN_SPECULATIVE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESIN_SPECULATIVE_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return actionCreators; });
var RESIN_ORDER_START = 'RESIN_ORDER_START';
var RESIN_ORDER_SUCCESS = 'RESIN_ORDER_SUCCESS';
var RESIN_ORDER_ERROR = 'RESIN_ORDER_ERROR';
var RESIN_ORDER_CANCEL = 'RESIN_ORDER_CANCEL';
var RESIN_ORDER_LOADING = 'RESIN_ORDER_LOADING';
var RESIN_SPECULATIVE_START = 'RESIN_SPECULATIVE_START';
var RESIN_SPECULATIVE_SUCCESS = 'RESIN_SPECULATIVE_SUCCESS';
var RESIN_SPECULATIVE_ERROR = 'RESIN_SPECULATIVE_ERROR';
var RESIN_SPECULATIVE_CANCEL = 'RESIN_SPECULATIVE_CANCEL';
// Action Creators
var actionCreators = {
    resinOrderStart: function (payload) { return ({
        type: RESIN_ORDER_START,
        payload: payload,
    }); },
    resinOrderError: function (payload) { return ({
        type: RESIN_ORDER_ERROR,
        payload: payload,
    }); },
    resinOrderSuccess: function (payload) { return ({
        type: RESIN_ORDER_SUCCESS,
        payload: payload
    }); },
    resinOrderLoading: function (payload) { return ({
        type: RESIN_ORDER_LOADING,
        payload: payload,
    }); },
    resinOrderCancel: function (payload) { return ({
        type: RESIN_ORDER_CANCEL, payload: payload,
    }); },
    resinSpeculativeStart: function (payload) { return ({
        type: RESIN_SPECULATIVE_START,
        payload: payload,
    }); },
    resinSpeculativeError: function (payload) { return ({
        type: RESIN_SPECULATIVE_ERROR,
        payload: payload,
    }); },
    resinSpeculativeSuccess: function (payload) { return ({
        type: RESIN_SPECULATIVE_SUCCESS,
        payload: payload
    }); },
    resinSpeculativeCancel: function (payload) { return ({
        type: RESIN_SPECULATIVE_CANCEL, payload: payload,
    }); },
};


/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadLocalState */
/* unused harmony export clearLocalState */
/* unused harmony export saveLocalState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadSessionState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveSessionState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearSessionState; });
var loadLocalState = function () {
    try {
        var serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }
    catch (err) {
        /*add better logging for errors*/
        return undefined;
    }
};
var clearLocalState = function () {
    try {
        if (localStorage.getItem('state') !== null) {
            localStorage.clear();
        }
    }
    catch (err) {
        console.log(err);
    }
};
var saveLocalState = function (state) {
    try {
        var serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    }
    catch (err) {
        console.log(err);
    }
};
var loadSessionState = function () {
    try {
        var serializedState = sessionStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }
    catch (err) {
        /*add better logging for errors*/
        return undefined;
    }
};
var saveSessionState = function (state) {
    try {
        var serializedState = JSON.stringify(state);
        sessionStorage.setItem('state', serializedState);
    }
    catch (err) {
        console.log(err);
    }
};
var clearSessionState = function () {
    try {
        if (sessionStorage.getItem('state') !== null) {
            sessionStorage.clear();
        }
        localStorage.clear();
    }
    catch (err) {
        console.log(err);
    }
};


/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["l" /* FETCH_ACCTS_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["i" /* EMAIL_SAVE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["k" /* EMAIL_SAVE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["f" /* ADDRESS_SAVE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["d" /* ACCOUNT_SAVE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["e" /* ADDRESS_SAVE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["c" /* OMS_LOOKUP_FAILURE */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["a" /* ACCOUNT_SAVE_ERROR */]:
            case '@@INIT':
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["q" /* RESET_PASSWORD_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["o" /* RESET_PASSWORD_ERROR */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["a" /* INITIATE_OMS_LOOKUP */]:
                return true;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["b" /* ACCOUNT_SAVE_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    associatedAccounts: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["l" /* FETCH_ACCTS_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    offers: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["m" /* FETCH_OFFERS_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    emailSavedResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["i" /* EMAIL_SAVE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["k" /* EMAIL_SAVE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["o" /* RESET_PASSWORD_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["q" /* RESET_PASSWORD_SUCCESS */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["j" /* EMAIL_SAVE_START */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["n" /* RESET_EMAIL_FORM */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["p" /* RESET_PASSWORD_START */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["h" /* CANCEL_RESET_PASSWORD_FORM */]:
                return null;
            default:
                return state;
        }
    },
    accountSavedResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["a" /* ACCOUNT_SAVE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["d" /* ACCOUNT_SAVE_SUCCESS */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["c" /* ACCOUNT_SAVE_START */]:
                return null;
            default:
                return state;
        }
    },
    updatedAccountNumbers: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["k" /* EMAIL_SAVE_SUCCESS */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["i" /* EMAIL_SAVE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["n" /* RESET_EMAIL_FORM */]:
                return null;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary__["j" /* EMAIL_SAVE_START */]:
                return state;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_observable_forkJoin__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_observable_forkJoin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__ = __webpack_require__(25);













var saveAccountEpic = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["c" /* ACCOUNT_SAVE_START */]), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var loading = Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].accountSaveLoading(true));
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        if (!__WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region) {
            __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region = clientConfig.Region;
            // AWSConfig.update({region: clientConfig.Region});
        }
        var accountNumbers = payload.payload.map(function (item) { return item.accountNumber; });
        var newPostalCode = payload.payload[0].postalCode;
        var promises = payload.payload.map(function (item) {
            var postBody = item;
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: '/cofa',
                requestmethod: 'POST',
                region: clientConfig.Region,
                requestbody: postBody,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_8_rxjs_observable_forkJoin__["forkJoin"])(promises, getAllSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["e" /* map */])(function (allSucceeded) {
            if (allSucceeded) {
                payload.payload.forEach(function (cofaPayload) {
                    __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: cofaPayload.googleAnalyticsCategory,
                        action: 'Successful',
                        label: cofaPayload.prodIdAlias,
                    });
                });
                var accountResponse = void 0;
                if (payload.firstResponse) {
                    accountResponse = payload.firstResponse;
                }
                else {
                    accountResponse = {
                        success: allSucceeded,
                        accountNumbers: accountNumbers,
                    };
                }
                if (payload.secondPayload && payload.secondPayload.length > 0) {
                    return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].accountSaveStart({
                        payload: payload.secondPayload,
                        firstResponse: accountResponse,
                    });
                }
                else {
                    return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].accountSaveSuccess({ accountResponse: payload.payload, success: allSucceeded });
                }
            }
            else {
                payload.payload.forEach(function (cofaPayload) {
                    __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: cofaPayload.googleAnalyticsCategory,
                        action: 'Unsuccessful',
                        label: cofaPayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].accountSaveError({
                    success: false,
                    message: 'Error on Change of Address',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.payload[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload.payload[0].prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].accountSaveError({ success: false, message: err }));
        }));
        if (payload.secondPayload && payload.secondPayload.length > 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_concat__["concat"])(loading, source$);
        }
        else {
            var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
            var refetchCustomerPayload = {
                accountNumber: loggedIncustomer.accountNumber,
                postalCode: newPostalCode,
            };
            var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_3__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
            // let reloadCust = of(setTimeout(weakActionCreators.refetchCustomer(refetchCustomerPayload), 2000));
            return Object(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_concat__["concat"])(loading, source$, reloadCust.pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["b" /* delay */])(2000)));
        }
    }));
};
var getAllSucceeded = function () {
    var responses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        responses[_i] = arguments[_i];
    }
    var successCount = responses.filter(function (item) { return item.success; });
    return successCount.length === responses.length;
};
var saveEmailEpic = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["j" /* EMAIL_SAVE_START */]), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var loading = Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].accountSaveLoading(true));
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        if (!__WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region) {
            __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region = clientConfig.Region;
        }
        var accountNumbers = payload.map(function (item) { return item.accountNumber; });
        var email = payload[0].email;
        var promises = payload.map(function (item) {
            var postBody = item;
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: '/cofe',
                requestmethod: 'POST',
                region: __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region,
                requestbody: postBody,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_8_rxjs_observable_forkJoin__["forkJoin"])(promises, getAllSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["e" /* map */])(function (allSucceeded) {
            if (allSucceeded) {
                payload.forEach(function (cofePayload) {
                    __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: cofePayload.googleAnalyticsCategory,
                        action: 'Successful',
                        label: cofePayload.prodIdAlias,
                    });
                });
                var emailResponse = {
                    success: allSucceeded,
                    email: email,
                    accountNumbers: accountNumbers,
                };
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].emailSaveSuccess(emailResponse);
            }
            else {
                payload.forEach(function (cofePayload) {
                    __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: cofePayload.googleAnalyticsCategory,
                        action: 'Unsuccessful',
                        label: cofePayload.prodIdAlias,
                    });
                });
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].emailSaveError({
                    success: false,
                    message: 'Error on Change of Email',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload[0].googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload[0].prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].emailSaveError({ success: false, message: err }));
        }));
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_3__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        return Object(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_concat__["concat"])(loading, source$, reloadCust.pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["b" /* delay */])(2000)));
    }));
};
var saveAutoCofeEpic = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["g" /* AUTO_COFE_SAVE_START */]), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        if (__WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].credentials) {
            var creds = __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].credentials;
            creds.clearCachedId();
        }
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        if (!__WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region) {
            __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region = clientConfig.Region;
        }
        var customers = state$.value.account.customerData.customers;
        if (!customers) {
            console.log('AutoCofe epic no customers');
            return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].autoCofeSaveError({
                success: false,
                message: 'No Auto COFE From Bad Account Lookup',
            }));
        }
        var email = payload.email;
        var accountNumbers = Array();
        var promises = customers.map(function (item) {
            var postBody = {
                email: '',
                prodIdAlias: '',
                accountNumber: ''
            };
            if (item.systemCode === 'SERV' || item.systemCode === 'EHUB') {
                postBody = {
                    email: email,
                    prodIdAlias: item.prodIdAlias,
                    accountNumber: item.accountNumber,
                    emailAuthorization: payload.emailOptIn,
                };
            }
            else if (item.systemCode === 'SERVPF') {
                postBody = {
                    email: email,
                    prodIdAlias: item.prodIdAlias,
                    accountNumber: item.accountNumber,
                    emailPermission1: payload.emailOptIn,
                };
            }
            accountNumbers.push(item.accountNumber);
            var apiConfig = {
                creds: __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].credentials,
                url: clientConfig.url,
                path: '/cofe',
                requestmethod: 'POST',
                region: __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region,
                requestbody: postBody,
                parms: {},
                additionalParms: {
                    headers: {
                        'x-session-id': clientConfig.uuid
                    },
                },
            };
            return Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig));
        });
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_8_rxjs_observable_forkJoin__["forkJoin"])(promises, getAllSucceeded).pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["e" /* map */])(function (allSucceeded) {
            if (allSucceeded) {
                var emailResponse = {
                    success: allSucceeded,
                    email: email,
                    accountNumbers: accountNumbers,
                };
                __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload.prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].autoCofeSaveSuccess(emailResponse);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload.prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].autoCofeSaveError({
                    success: false,
                    message: 'Error on Change of Email',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload.prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].emailSaveError({ success: false, message: err }));
        }));
        var loggedIncustomer = Object(__WEBPACK_IMPORTED_MODULE_11__src_app_accounts_selectors__["h" /* getLoggedInCustomer */])(state$.value);
        var refetchCustomerPayload = {
            accountNumber: loggedIncustomer.accountNumber,
            postalCode: loggedIncustomer.address.postalCode,
        };
        var reloadCust = Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_3__src_app_login_weak_actions__["f" /* actionCreators */].refetchCustomer(refetchCustomerPayload));
        return Object(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_concat__["concat"])(source$, reloadCust.pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["b" /* delay */])(3000)));
    }));
};
var resetPasswordEpic = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["p" /* RESET_PASSWORD_START */]), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["CognitoIdentityCredentials"](state$.value.auth.omsAuth.credentials);
        var loading = Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].accountSaveLoading(true));
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        if (!__WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region) {
            __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region = clientConfig.Region;
        }
        var postBody = {
            email: payload.email,
            clientId: payload.clientId,
        };
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: '/passwordreset',
            requestmethod: 'POST',
            region: __WEBPACK_IMPORTED_MODULE_4_aws_sdk_global__["config"].region,
            requestbody: postBody,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["e" /* map */])(function (answer) {
            if (answer.success) {
                __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.googleAnalyticsCategory,
                    action: 'Successful',
                    label: payload.prodIdAlias,
                });
                // add the history to the response to redirect in action
                answer.history = payload.history;
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].resetPasswordSuccess(answer);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: payload.googleAnalyticsCategory,
                    action: 'Unsuccessful',
                    label: payload.prodIdAlias,
                });
                return __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].resetPasswordError({
                    success: false,
                    message: 'Error Sending Password Reset',
                });
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: payload.googleAnalyticsCategory,
                action: 'Unknown Error',
                label: payload.prodIdAlias,
            });
            return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_5__src_app_accounts_summary__["r" /* actionCreators */].resetPasswordError({ success: false, message: err }));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_10_rxjs_observable_concat__["concat"])(loading, source$);
    }));
};
var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(saveAccountEpic, saveEmailEpic, saveAutoCofeEpic, resetPasswordEpic);


/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTBUS_PUBLISH; });
/* unused harmony export actionCreators */
var EVENTBUS_PUBLISH = 'EVENTBUS_PUBLISH';
var actionCreators = {
    eventBusPublish: function (payload) { return ({
        type: EVENTBUS_PUBLISH,
        payload: payload,
    }); },
};


/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__ = __webpack_require__(960);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["e" /* ORDER_UPDATE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["b" /* ORDER_UPDATE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["a" /* ORDER_UPDATE_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["j" /* RESIN_ORDER_UPDATE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["g" /* RESIN_ORDER_UPDATE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["f" /* RESIN_ORDER_UPDATE_CANCEL */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["c" /* ORDER_UPDATE_LOADING */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["h" /* RESIN_ORDER_UPDATE_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    orders: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return action.payload.orders;
            default:
                return state;
        }
    },
    orderUpdateResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["e" /* ORDER_UPDATE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["b" /* ORDER_UPDATE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["j" /* RESIN_ORDER_UPDATE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["g" /* RESIN_ORDER_UPDATE_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["a" /* ORDER_UPDATE_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["d" /* ORDER_UPDATE_START */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["f" /* RESIN_ORDER_UPDATE_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders__["i" /* RESIN_ORDER_UPDATE_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoginForm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_components__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_login_selectors__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_login_types__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_accounts_summary_components_PageIntro__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_global_utility_adminConfigUtils__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__login_scss__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__login_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__login_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_login_components_Cognito__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_login_cognito_actions__ = __webpack_require__(62);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};












var ErrorView = function (props) {
    var socialLoginDesc = 'social';
    if (props.socialLogin.user) {
        switch (props.socialLogin.user.channel) {
            // First two cases are dead code - the COGNITO_SUCCESS
            // reducer will always set this to 'cognito'.
            case 'google':
                socialLoginDesc = 'Google';
                break;
            case 'facebook':
                socialLoginDesc = 'Facebook';
                break;
            default:
                socialLoginDesc = 'social';
        }
    }
    var loginInstructions = "<p>Please use one of the options below to link your account.<br />You'll only have to do this once.</p>";
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "purgatory-view" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h3", { className: "" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], { id: "login.notfound", description: "Message showing successful social but account not found", defaultMessage: 'Great! Just one more step.' })),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedHTMLMessage */], { id: "login.notfoundMessage", description: "Instructions to finish login", defaultMessage: loginInstructions }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", onClick: function () { return Object(__WEBPACK_IMPORTED_MODULE_11__src_app_login_cognito_actions__["d" /* cognitoLogout */])(props.myloLogin, props.myloConfig); }, className: "" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], { id: "app.cancel", description: "Cancel", defaultMessage: "Return to Sign In" })))));
};
var LoginForm = /** @class */ (function (_super) {
    __extends(LoginForm, _super);
    function LoginForm(props) {
        return _super.call(this, props) || this;
    }
    // 'Choose one of these to sign in.'
    // 'Or choose one of these to sign in.'
    LoginForm.prototype.render = function () {
        var signInData = Object(__WEBPACK_IMPORTED_MODULE_8__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(this.props.adminConfig, this.props.clientConfig, 'SignIn');
        var _a = this.props, socialEmail = _a.socialEmail, auth = _a.auth, myloLogin = _a.myloLogin, myloConfig = _a.myloConfig;
        var isPurgatoryView = this.props.auth.omsAuth.isFailure && socialEmail;
        var chooseVerbiage = isPurgatoryView
            ? 'login.subheadingone'
            : 'login.subheadingtwo';
        var liveChatData = Object(__WEBPACK_IMPORTED_MODULE_8__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(this.props.adminConfig, this.props.clientConfig, 'LiveChat');
        var viewChat = function () {
            window.open(liveChatData.ChatUrl, 'LiveChat', 'height=250,width=250');
        };
        var handleKeyPress = function (e) {
            var x = e.which || e.keyCode;
            // tslint:disable-next-line:no-unused-expression
            (x === 13 || x === 32) && viewChat();
        };
        var enabledSoftLogins = [];
        if (signInData.AccountNumberPostalCodeEnabled) {
            enabledSoftLogins.push(__WEBPACK_IMPORTED_MODULE_5__src_app_login_types__["a" /* LoginTabs */].accountPostalCode);
        }
        if (signInData.EmailPostalCodeEnabled) {
            enabledSoftLogins.push(__WEBPACK_IMPORTED_MODULE_5__src_app_login_types__["a" /* LoginTabs */].emailPostalCode);
        }
        if (signInData.NameAddressEnabled) {
            enabledSoftLogins.push(__WEBPACK_IMPORTED_MODULE_5__src_app_login_types__["a" /* LoginTabs */].nameAndAddress);
        }
        function createMarkup(nodeItem) {
            return { __html: nodeItem };
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "login-view text-center" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["e" /* Container */], { id: "main", className: "main-long" },
                    !isPurgatoryView && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], { className: "mb-4 justify-content-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { sm: 12, md: 12, lg: 8 },
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__src_app_accounts_summary_components_PageIntro__["a" /* default */], __assign({}, this.props))))),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], { className: "justify-content-center" }, (signInData.EmailPasswordEnabled) && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { sm: 12, md: 12, lg: 8 },
                        isPurgatoryView && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorView, { resetlookup: __WEBPACK_IMPORTED_MODULE_11__src_app_login_cognito_actions__["d" /* cognitoLogout */], email: socialEmail, socialLogin: auth.socialLogin, myloLogin: myloLogin, myloConfig: myloConfig })),
                        !isPurgatoryView && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__src_app_login_components_Cognito__["a" /* Cognito */], { authData: this.props.clientConfig.clientConfig.ciamAuthData, signInData: signInData, onSuccess: __WEBPACK_IMPORTED_MODULE_11__src_app_login_cognito_actions__["c" /* actionCreators */].cognitoSuccess, mylo: this.props.mylo }))))),
                    (signInData.EmailPostalCodeEnabled || signInData.AccountNumberPostalCodeEnabled || signInData.NameAddressEnabled) && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], { className: "social-signin justify-content-center" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { sm: 12, md: 12, lg: 8 },
                            !isPurgatoryView && signInData.EmailPasswordEnabled && !signInData.MyloOnlyEnabled && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { id: "LoginViewSocial" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], { id: chooseVerbiage, description: "Change heading for pergatory view", defaultMessage: (!signInData.EmailPasswordEnabled ? 'Please sign in below:' : 'or sign in as a guest:') }))),
                            this.props.clientConfig.configLoading && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "loading-container" },
                                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-spinner fa-spin fa-3x fa-fw" }))),
                            this.props.clientConfig && (isPurgatoryView || (!isPurgatoryView && !signInData.MyloOnlyEnabled)) && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__src_app_login_components__["d" /* WeakLogin */], { auth: auth, signInData: signInData, openTab: isPurgatoryView ? __WEBPACK_IMPORTED_MODULE_5__src_app_login_types__["a" /* LoginTabs */].emailPostalCode : null, isPurgatory: isPurgatoryView ? true : false }))))),
                    (signInData.ContactCustomerServiceEnabled) && (signInData.ContactCustomerServiceAttempts) &&
                        (signInData.ContactCustomerServiceAttempts <= this.props.signinAttempts) && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "pb-3 contact-customer-service" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { dangerouslySetInnerHTML: createMarkup(signInData.ContactCustomerServiceText) }))))),
            liveChatData.ChatEnabled &&
                liveChatData.EnabledRoutes.filter(function (item) { return item.title === 'Sign In'; })
                    .length !== 0 && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "livechat-card" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { className: "nav-link", tabIndex: 0, role: "button", onKeyPress: function (e) { return handleKeyPress(e); }, onClick: function () { return viewChat(); } },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "nav-text" }, "Live Chat"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "ml-1 fa fa-comments-o" }))))));
    };
    return LoginForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var mapStateToProps = function (state) {
    return {
        clientConfig: state.clientConfig,
        adminConfig: state.adminConfig,
        auth: state.auth,
        socialEmail: Object(__WEBPACK_IMPORTED_MODULE_3__src_app_login_selectors__["b" /* getSocialEmail */])(state),
        myloLogin: state.auth.weakLogin.identityId !== 'initialid',
        myloConfig: state.clientConfig.clientConfig.myloConfig,
        signinAttempts: state.userState.signinAttempts,
        mylo: Object(__WEBPACK_IMPORTED_MODULE_3__src_app_login_selectors__["a" /* getMylo */])(state),
        ageCheckPassed: state.userState.ageCheckPassed
    };
};
var Login = Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps)(LoginForm);


/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdminConfigTableItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildEngageRedirectUrl; });
/* unused harmony export getSuspendPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getRenewPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRenewGiftPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPaymentPage; });
/* unused harmony export getReturnPage */
/* unused harmony export getTransferPage */
/* unused harmony export getRefundPage */
/* unused harmony export getCancelPage */
/* unused harmony export getUpdatePaymentOptionPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getEmailGiftCardPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_global_utility_constants__ = __webpack_require__(453);

var getAdminConfigTableItem = function (adminConfig, clientConfig, tableName, overrideMagCode) {
    var tableItem = {};
    var magCode = overrideMagCode
        ? overrideMagCode
        : clientConfig.clientConfig.magCode;
    if (adminConfig && adminConfig.adminConfig) {
        if (adminConfig.adminConfig[magCode]) {
            tableItem = adminConfig.adminConfig[magCode][tableName];
            if (Object.keys(tableItem).length === 0 &&
                tableItem.constructor === Object) {
                tableItem = adminConfig.adminConfig['*'][tableName];
            }
        }
        else {
            if (adminConfig.adminConfig['*']) {
                tableItem = adminConfig.adminConfig['*'][tableName];
            }
        }
    }
    return tableItem;
};
var buildEngageRedirectUrl = function (availableActions, currentRecord, billToAddress, jumpPageId) {
    // Need the base url and the remote login pageid at minimum.
    var redirectUrl = availableActions.Preferences.baseUrl;
    var remoteLoginPageId = availableActions.Preferences.remoteLoginPageId;
    var remoteLoginMagCode = availableActions.Preferences.remoteLoginMagCode;
    if (!redirectUrl || !remoteLoginPageId) {
        return '';
    }
    if (!remoteLoginMagCode) {
        remoteLoginMagCode = availableActions.ProdId;
    }
    if (redirectUrl.charAt(redirectUrl.length - 1) !== '/') {
        redirectUrl = redirectUrl + '/';
    }
    // Care Type (cdsCare or eCare)
    var careType = availableActions.Preferences.careType;
    if (careType === __WEBPACK_IMPORTED_MODULE_0__src_app_global_utility_constants__["c" /* CARE_TYPES */].ECARE) {
        redirectUrl = redirectUrl + 'servlet/ECareRemoteLoginGateway';
    }
    else {
        redirectUrl = redirectUrl + 'servlet/RemoteLoginGateway';
    }
    // mag code
    redirectUrl = redirectUrl + '?cds_mag_code=' + remoteLoginMagCode;
    // remote login page
    redirectUrl = redirectUrl + '&cds_page_id=' + remoteLoginPageId;
    // jump page (optional)
    if (jumpPageId) {
        redirectUrl = redirectUrl + '&cds_jump_page_id=' + jumpPageId;
    }
    // account number
    var accountNbr = '';
    if (currentRecord.isGift && currentRecord.isRecipient) {
        accountNbr = currentRecord.orderItems[0].shipToAccountNumber;
    }
    else {
        accountNbr = currentRecord.billToAccountNumber;
    }
    redirectUrl = redirectUrl + '&cds_account_number=' + accountNbr;
    // query type.  A = Account Number.  Z = Account/Zip (for eCare)
    var queryType = '';
    if (careType === __WEBPACK_IMPORTED_MODULE_0__src_app_global_utility_constants__["c" /* CARE_TYPES */].ECARE) {
        queryType = 'Z';
    }
    else {
        queryType = 'A';
    }
    redirectUrl = redirectUrl + '&cds_query_type=' + queryType;
    if (careType === __WEBPACK_IMPORTED_MODULE_0__src_app_global_utility_constants__["c" /* CARE_TYPES */].ECARE) {
        // zip code only for eCare logins
        redirectUrl = redirectUrl + '&cds_zip=' + billToAddress.postalCode;
    }
    // lookup type (single or multi)
    var lookupType = '';
    if (availableActions.Preferences.lookupType === 'multi') {
        lookupType = 'M';
    }
    else {
        lookupType = 'S';
    }
    redirectUrl = redirectUrl + '&cds_login_type=' + lookupType;
    // return url for error conditions
    if (availableActions.Preferences.returnUrl) {
        var returnUrl = availableActions.Preferences.returnUrl;
        if (!returnUrl.startsWith('http')) {
            returnUrl = window.location.origin +
                (returnUrl.charAt(0) !== '/' ? '/' + returnUrl : returnUrl);
        }
        redirectUrl = redirectUrl + '&cds_return_url=' + returnUrl;
    }
    return redirectUrl;
};
var getSuspendPage = function (availableActions) {
    var param = '';
    if (availableActions.Preferences.suspendUrl) {
        param = availableActions.Preferences.suspendUrl;
    }
    return param;
};
var getRenewPage = function (availableActions) {
    var param = '';
    if (availableActions.Preferences.renewSubUrl) {
        param = availableActions.Preferences.renewSubUrl;
    }
    return param;
};
var getRenewGiftPage = function (availableActions) {
    var param = '';
    if (availableActions.Preferences.renewGiftUrl) {
        param = availableActions.Preferences.renewGiftUrl;
    }
    return param;
};
var getPaymentPage = function (availableActions, order) {
    var param = '';
    if ((order.isDonor || order.isRecipient) && availableActions.Preferences.makeGiftPaymentUrl) {
        param = availableActions.Preferences.makeGiftPaymentUrl;
    }
    else if (availableActions.Preferences.makePaymentUrl) {
        param = availableActions.Preferences.makePaymentUrl;
    }
    return param;
};
var getReturnPage = function (availableActions) {
    var param = '';
    if (availableActions.Preferences.returnUrl) {
        param = availableActions.Preferences.returnUrl;
    }
    return param;
};
var getTransferPage = function (availableActions) {
    var param = '';
    if (availableActions.Preferences.transferUrl) {
        param = availableActions.Preferences.transferUrl;
    }
    return param;
};
var getRefundPage = function (availableActions) {
    var param = '';
    if (availableActions.Preferences.refundUrl) {
        param = availableActions.Preferences.refundUrl;
    }
    return param;
};
var getCancelPage = function (availableActions) {
    var param = '';
    if (availableActions.Preferences.cancelUrl) {
        param = availableActions.Preferences.cancelUrl;
    }
    return param;
};
var getUpdatePaymentOptionPage = function (availableActions) {
    var param = '';
    if (availableActions.Preferences.updatePaymentUrl) {
        param = availableActions.Preferences.updatePaymentUrl;
    }
    return param;
};
var getEmailGiftCardPage = function (availableActions) {
    var param = '';
    if (availableActions.Preferences.emailGiftCardUrl) {
        param = availableActions.Preferences.emailGiftCardUrl;
    }
    return param;
};


/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginTabs; });
var LoginTabs;
(function (LoginTabs) {
    LoginTabs["accountPostalCode"] = "accountNumberPostalCode";
    LoginTabs["emailPostalCode"] = "emailPostalCode";
    LoginTabs["nameAndAddress"] = "nameAddress";
})(LoginTabs || (LoginTabs = {}));


/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cognito; });
/* unused harmony export MyloLogout */
/* unused harmony export CognitoLogout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CognitoSuccessComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CognitoLogoutComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MyloLogoutComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_amazon_cognito_auth_js__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_login_cognito_actions__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_header_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(45);








var Cognito = function (props) {
    var onFailure = function (err) {
        // TODO implementation
        console.log(err);
    };
    var authData = props.authData, signInData = props.signInData, mylo = props.mylo;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, signInData.EmailPasswordEnabled && (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "email-password-enabled" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sign-up" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-primary", onClick: function () { return mylo.viewPopup('signup', { urlParams: { display: 'SSP' } }); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], { id: "app.signup", description: "Sign up button", defaultMessage: 'Create an Account' }))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "sign-in" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-light", onClick: function () { return mylo.viewPopup('login', { urlParams: { display: 'SSP' } }); } },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], { id: "app.securelogin", description: "Secure Login button", defaultMessage: 'Sign In' })))))));
};
var MyloLogout = function (props) {
    window.opener.location.href = "/logout";
    window.close();
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null);
};
var CognitoLogout = function (props) {
    props.logout();
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Redirect"], { to: "/" });
};
var CognitoSuccess = function (props) {
    var authData = props.authData, onSuccess = props.onSuccess;
    var cognitoAuth = new __WEBPACK_IMPORTED_MODULE_1_amazon_cognito_auth_js__["a" /* CognitoAuth */](authData);
    var onFailure = function (err) {
        console.log(err);
    };
    cognitoAuth.userhandler = { onSuccess: onSuccess, onFailure: onFailure };
    cognitoAuth.parseCognitoWebResponse(window.location.href);
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Redirect"], { to: "/accounts/summary" });
};
var mapState = function (state) { return ({
    authData: state.clientConfig.clientConfig.ciamAuthData,
}); };
var mapDispatch = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
        onSuccess: __WEBPACK_IMPORTED_MODULE_3__src_app_login_cognito_actions__["c" /* actionCreators */].cognitoSuccess,
    }, dispatch);
};
var mapLogoutState = function (state) { return ({
    state: state,
}); };
var mapLogoutDispatch = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
        logout: __WEBPACK_IMPORTED_MODULE_4__src_app_header_actions__["b" /* actionCreators */].userLogout,
    }, dispatch);
};
var mapMyloLogoutState = function (state) { return ({
    state: state,
}); };
var mapMyloLogoutDispatch = function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
        logout: __WEBPACK_IMPORTED_MODULE_4__src_app_header_actions__["b" /* actionCreators */].userLogout,
    }, dispatch);
};
var CognitoSuccessComponent = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapState, mapDispatch)(CognitoSuccess);
var CognitoLogoutComponent = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapLogoutState, mapLogoutDispatch)(CognitoLogout);
var MyloLogoutComponent = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapMyloLogoutState, mapMyloLogoutDispatch)(MyloLogout);


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icomoon.da80b293.eot";

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1454);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(71)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./header.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-oneOf-2-1!../../../node_modules/sass-loader/lib/loader.js??postcss!./header.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STATUS_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SUBSCRIPTION_STATUSES; });
/* unused harmony export CREDIT_CARD_MAP */
/* unused harmony export SYSTEM_CODES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CARE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INTELLISEL_TRANSACTION_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHIP_METHOD_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALT_PAY_TYPES; });
var ACTIONS = {
    PAY_NOW: 'Pay Now',
    RENEW: 'Renew Now',
    CANCELUNPAID: 'CancelUnpaid',
    CANCELPAID: 'CancelPaid',
    RESUME: 'Resume',
    RETURN: 'Return',
    TRACK: 'Track'
};
var STATUS_MAP = {
    'canceled': {
        title: 'Canceled',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'cancelled': {
        title: 'Canceled',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'suspended': {
        title: 'Suspended',
        className: 'text-danger',
        primaryAction: 'Resume'
    },
    'expired': {
        title: 'Expired',
        className: 'text-danger',
        primaryAction: 'None'
    },
    'expired-renew': {
        title: 'Expired',
        className: 'warning-dark',
        primaryAction: ACTIONS.RENEW
    },
    'pastdue': {
        title: 'Payment Due',
        className: 'text-danger',
        primaryAction: ACTIONS.PAY_NOW
    },
    'active': {
        title: 'Active',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'active-renew': {
        title: 'Active',
        className: 'text-dark',
        primaryAction: ACTIONS.RENEW
    },
    'renewing_soon': {
        title: 'Active',
        className: 'text-dark',
        primaryAction: ACTIONS.RENEW
    },
    'future': {
        title: 'Future',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'gift': {
        title: 'Gift',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'suspended over credit limit': {
        title: 'Suspended over credit limit',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'unpaid': {
        title: 'Unpaid',
        className: 'text-danger',
        primaryAction: ACTIONS.PAY_NOW
    },
    'on hold': {
        title: 'On Hold',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'awaiting payment': {
        title: 'Awaiting Payment',
        className: 'text-danger',
        primaryAction: ACTIONS.PAY_NOW
    },
    'completed': {
        title: 'Completed',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'partially canceled': {
        title: 'Partially Canceled',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'partially returned': {
        title: 'Partially Returned',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'payment method needs updated': {
        title: 'Payment Method Needs Updated',
        className: 'text-danger',
        primaryAction: 'None'
    },
    'returned': {
        title: 'Returned',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'transferred': {
        title: 'Transferred',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'undeliverable': {
        title: 'Undeliverable',
        className: 'text-danger',
        primaryAction: 'None'
    },
    'enqueue': {
        title: 'Future',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'issued': {
        title: 'Awaiting Activation',
        className: 'text-dark',
        primaryAction: 'None'
    },
    'revoked': {
        title: 'Revoked',
        className: 'text-danger',
        primaryAction: 'None'
    },
    'redeemed': {
        title: 'Activated',
        className: 'text-dark',
        primaryAction: 'None'
    },
};
var SUBSCRIPTION_STATUSES = {
    EXPIRED: 'expired',
    PAST_DUE: 'pastdue',
    RENEWING_SOON: 'renewing_soon',
    ACTIVE: 'active',
    SUSPENDED: 'suspended',
    CANCELED: 'canceled',
    FUTURE_START: 'future',
    NSD: 'gift',
    SUSPENDED_OVER_CREDIT_LIMIT: 'suspended over credit limit',
    UNPAID: 'unpaid',
    ON_HOLD: 'on hold',
    AWAITING_PAYMENT: 'awaiting payment',
    COMPLETED: 'completed',
    PARTIALLY_CANCELED: 'partially canceled',
    PARTIALLY_RETURNED: 'partially returned',
    PAYMENT_METHOD_NEEDS_UPDATED: 'payment method needs updated',
    RETURNED: 'returned',
    TRANSFERRED: 'transferred',
    UNDELIVERABLE: 'undeliverable',
    NONE: 'None'
};
var CREDIT_CARD_MAP = {
    MC: 'Master Card',
    AMEX: 'AMEX',
    VISA: 'VISA',
};
var SYSTEM_CODES = {
    SERVPF: 'servpf',
    SERV: 'serv',
    EHUB: 'ehub',
};
var CARE_TYPES = {
    CDSCARE: 'cdsCare',
    ECARE: 'eCare'
};
var INTELLISEL_TRANSACTION_CODES = {
    ACCT_SUMMARY: 'account-summary',
    COFA_CONF: 'change-address-confirmation',
    COFE_CONF: 'change-email-confirmation',
    CANCEL_CONF: 'cancel-confirmation',
    COFA_RECIP_CONF: 'gift-change-address-confirmation',
    PAYMENT_CONF: 'payment-confirmation',
    UNPAID_SAVECANCEL_SERV: 'SERV-credit-cancel',
    PAID_SAVECANCEL_SERV: 'SERV-paid-cancel',
};
var SHIP_METHOD_MAP = {
    'ups': {
        title: 'UPS',
        trackingUrl: 'http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums='
    },
    'usps': {
        title: 'USPS',
        trackingUrl: 'https://tools.usps.com/go/TrackConfirmAction_input?qtc_tLabels1='
    },
    'fedex': {
        title: 'FedEx',
        trackingUrl: 'http://www.fedex.com/Tracking?action=track&tracknumbers='
    },
    'airborne': {
        title: 'Airborne',
        trackingUrl: ''
    },
    'canada post': {
        title: 'Canada Post',
        trackingUrl: ''
    },
    'ltl/over the road': {
        title: 'LTL/Over the Road',
        trackingUrl: ''
    },
    'dhl': {
        title: 'DHL',
        trackingUrl: ''
    },
    'unknown/not specified': {
        title: 'Unknown/Not Specified',
        trackingUrl: ''
    }
};
var ALT_PAY_TYPES = {
    PP: 'PPAL',
    AP: 'APPY',
    AM: 'AZPY'
};


/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(45);


var ErrorMessageView = function (_a) {
    var onReset = _a.onReset, history = _a.history;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-boundary-main" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-message" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", { className: "alert-red" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("i", { className: "fa fa-exclamation-triangle title mr-2" }),
                "There was an unexpected error on this page. "),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h5", null, "Please click below and try again."),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "pointer link-text h5", onClick: function () {
                    history.push('/accounts/summary');
                    // onReset();
                } }, "Go to Home Page"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "h5 ml-1 mr-1" }, "\u2014 or \u2014"),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "pointer link-text h5", onClick: function () {
                    onReset();
                    history.push('/accounts/customer-service');
                } }, "Contact Customer Service"))));
};
var ErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(ErrorMessageView);


/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_global_utility_adminConfigUtils__ = __webpack_require__(42);



var PageIntro = function (props) {
    var pageIntroTable = Object(__WEBPACK_IMPORTED_MODULE_2__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(props.adminConfig, props.clientConfig, 'PageIntro');
    var currentRouteArray = props.location.pathname.split('/');
    var routeIndex = currentRouteArray.length - 1;
    var currentRoute = currentRouteArray[routeIndex];
    while (!isNaN(currentRoute)) {
        routeIndex = routeIndex - 1;
        currentRoute = currentRouteArray[routeIndex];
    }
    var pageIntro;
    if (pageIntroTable.PageIntroductions) {
        pageIntro = pageIntroTable.PageIntroductions.find(function (intro) {
            return intro.route === currentRoute || intro.altRoute === currentRoute;
        });
    }
    function createMarkup(nodeItem) {
        return { __html: nodeItem };
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "page-intro-ct" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "page-intro-label" }, pageIntro && !pageIntro.hideLabel ? pageIntro.label : ''),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "page-intro-desc", dangerouslySetInnerHTML: createMarkup(pageIntro ? pageIntro.description : '') })));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(PageIntro));


/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResponseView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_global_components_error_messages_default_error_message__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_global_utility_adminConfigUtils__ = __webpack_require__(42);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var SuccessView = function (customMessage) {
    var defaultCfmMessage = 'Thank You!';
    var defaultCfmMessage2 = ' We have received your message and will reply shortly...normally within 2 business days.';
    var cfmMessge = customMessage.customMessage ? customMessage.customMessage : defaultCfmMessage2;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12 },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], { id: 'address.congratulations', description: 'congratulation message', defaultMessage: defaultCfmMessage })),
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], { id: 'address.congratulations', description: 'congratulation message', defaultMessage: cfmMessge })))));
};
var ResponseViewComponent = /** @class */ (function (_super) {
    __extends(ResponseViewComponent, _super);
    function ResponseViewComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResponseViewComponent.prototype.render = function () {
        var _a = this.props, onExit = _a.onExit, sendEmailData = _a.sendEmailData;
        var customerServiceAdminData = Object(__WEBPACK_IMPORTED_MODULE_5__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(this.props.adminConfig, this.props.clientConfig, 'CustomerService', sendEmailData.sendEmailResult.success ? sendEmailData.sendEmailResult.payload.selectedProdIdAlias : null);
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "email-response-view" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], null,
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "small-text mb-2" }),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "mb-4" },
                        sendEmailData && sendEmailData && sendEmailData.sendEmailResult.success && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SuccessView, { customMessage: customerServiceAdminData.ThankYouMessage }),
                        sendEmailData && sendEmailData.sendEmailResult && !sendEmailData.sendEmailResult.success && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__src_app_global_components_error_messages_default_error_message__["a" /* ErrorMessage */], { onReset: onExit })))),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["o" /* Row */], { className: "mt-auto" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_reactstrap__["d" /* Col */], { xs: 12, sm: 12, md: 12 },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "d-flex justify-content-end" },
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("button", { className: "btn btn-secondary", type: "button", onClick: onExit },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], { id: 'app.cancel', description: 'close button text', defaultMessage: 'Close' })))))));
    };
    return ResponseViewComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state) {
    return {
        adminConfig: state.adminConfig,
        clientConfig: state.clientConfig,
        sendEmailData: state.account.customerServiceEmailData,
    };
};
var ResponseView = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(ResponseViewComponent);


/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvalidRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(45);


var View = function (props) {
    var history = props.history;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "error-page-view" },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "jumbotron text-center pt-4" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h1", null,
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "fa fa-exclamation-triangle" }),
                    " Oops. Page does not exist."))),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "body-content" },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "text-center" },
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("h4", null, "What happened?"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: "lead" }, "You reached a url which does not exist. Click below to go back to Home Page"),
                    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("a", { href: "#", className: "btn btn-default btn-lg text-center", onClick: function () {
                                history.push('/');
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: "green" }, "Go to Home Page"))))))));
};
var InvalidRoute = Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["withRouter"])(View);


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(471);
module.exports = __webpack_require__(504);


/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(472);

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(474).enable();
  window.Promise = __webpack_require__(476);
}
window.matchMedia = window.matchMedia || function() {
  return {
      matches : false,
      addListener : function() {},
      removeListener: function() {}
  };
};
// fetch() polyfill for making API calls.
__webpack_require__(477);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(46);

__webpack_require__(478);
__webpack_require__(479)

Array.prototype.includes = __webpack_require__(480);

if (!String.prototype.startsWith) {
	String.prototype.startsWith = function(search, pos) {
		return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
	};
}

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_LOGOUT; });
/* unused harmony export USER_LOGOUT_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_store__ = __webpack_require__(51);
var USER_LOGOUT = 'USER_LOGOUT';
var USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';


var notificationLogoutSuccess = {
    title: 'Sign Out Successful',
    message: 'You have been signed out of your account.',
    position: 'bl',
    autoDismiss: 0,
};
var actionCreators = {
    userLogout: function () {
        return {
            type: USER_LOGOUT,
            payload: null,
        };
    },
    userLogoutSuccess: function () {
        // history.push('/');
        return {
            type: USER_LOGOUT_SUCCESS,
            payload: null,
        };
    },
    userLogoutSuccessNotification: function () {
        __WEBPACK_IMPORTED_MODULE_1__src_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_notification_system_redux__["success"])(notificationLogoutSuccess));
    },
};


/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_registerServiceWorker__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_en__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_fr__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dates_lib_css_datepicker_css__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dates_lib_css_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dates_lib_css_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select_dist_react_select_css__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_store__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_main_Main__ = __webpack_require__(1381);




// add i18n react-intl modules





// import './app/_styles/index.scss';


Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_5_react_intl_locale_data_en___default.a.concat(__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_fr___default.a));
var locale = (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    // tslint:disable-next-line:no-string-literal
    window.navigator['userLanguage'] ||
    'en-US';
var messages;
try {
    messages = __webpack_require__(1548)("./" + locale + ".json");
    messages = messages.messages;
}
catch (err) {
    console.log(err);
}
var Root = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux__["Provider"], { store: __WEBPACK_IMPORTED_MODULE_9__src_store__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* IntlProvider */], { defaultLocale: "en-US", locale: locale, messages: messages },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__src_app_main_Main__["a" /* Main */], null))));
Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["render"])(Root, document.getElementById('root'));
Object(__WEBPACK_IMPORTED_MODULE_0__src_registerServiceWorker__["a" /* default */])();


/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// tslint:disable:no-console
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the 'N+1' visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register() {
    if ("production" === 'production' && 'serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        var publicUrl = new URL("", window.location.toString());
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
            return;
        }
        window.addEventListener('load', function () {
            var swUrl = "" + "/service-worker.js";
            if (!isLocalhost) {
                // Is not local host. Just register service worker
                registerValidSW(swUrl);
            }
            else {
                // This is running on localhost. Lets check if a service worker still exists or not.
                checkValidServiceWorker(swUrl);
            }
        });
    }
}
function registerValidSW(swUrl) {
    navigator.serviceWorker
        .register(swUrl)
        .then(function (registration) {
        registration.onupdatefound = function () {
            var installingWorker = registration.installing;
            if (installingWorker) {
                installingWorker.onstatechange = function () {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            // At this point, the old content will have been purged and
                            // the fresh content will have been added to the cache.
                            // It's the perfect time to display a 'New content is
                            // available; please refresh.' message in your web app.
                            console.log('New content is available; please refresh.');
                        }
                        else {
                            // At this point, everything has been precached.
                            // It's the perfect time to display a
                            // 'Content is cached for offline use.' message.
                            console.log('Content is cached for offline use.');
                        }
                    }
                };
            }
        };
    })
        .catch(function (error) {
        console.error('Error during service worker registration:', error);
    });
}
function checkValidServiceWorker(swUrl) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl)
        .then(function (response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        if (response.status === 404 ||
            response.headers.get('content-type').indexOf('javascript') === -1) {
            // No service worker found. Probably a different app. Reload the page.
            navigator.serviceWorker.ready.then(function (registration) {
                registration.unregister().then(function () {
                    window.location.reload();
                });
            });
        }
        else {
            // Service worker found. Proceed as normal.
            registerValidSW(swUrl);
        }
    })
        .catch(function () {
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(function (registration) {
            registration.unregister();
        });
    }
}


/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export history */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_global_utility_persistedStorage__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_redux__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory__);




// import { routerMiddleware } from 'react-router-redux';
// tslint:disable-next-line:no-submodule-imports

var history = __WEBPACK_IMPORTED_MODULE_4_history_createBrowserHistory___default()();
var initialState = Object(__WEBPACK_IMPORTED_MODULE_2__src_app_global_utility_persistedStorage__["b" /* loadSessionState */])();
var composeEnhancers = ("production" === 'development' &&
    window &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    __WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];
var epicMiddleware = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["b" /* createEpicMiddleware */])();
// tslint:disable-next-line:no-shadowed-variable
function configureStore(initialState) {
    // configure middlewares
    // const middlewares = [createEpicMiddleware(rootEpic)];
    // compose enhancers
    var enhancer = composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(epicMiddleware));
    var stores = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_3__src_app_redux__["b" /* rootReducer */], initialState, enhancer);
    epicMiddleware.run(__WEBPACK_IMPORTED_MODULE_3__src_app_redux__["a" /* rootEpic */]);
    // create store
    return stores;
}
// pass an optional param to rehydrate state on app start
var store = configureStore(initialState);
store.subscribe(function () {
    Object(__WEBPACK_IMPORTED_MODULE_2__src_app_global_utility_persistedStorage__["c" /* saveSessionState */])(store.getState());
});
// console.log('init state ', initialState);
// export store singleton instance
/* harmony default export */ __webpack_exports__["a"] = (store);


/***/ }),

/***/ 535:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COGNITO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COGNITO_REFRESH; });
/* unused harmony export COGNITO_REFRESH_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return actionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cognitoLogout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mylo_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mylo_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mylo_js__);

var COGNITO_SUCCESS = 'COGNITO_SUCCESS';
var COGNITO_REFRESH = 'COGNITO_REFRESH';
var COGNITO_REFRESH_SUCCESS = 'COGNITO_REFRESH_SUCCESS';
var actionCreators = {
    cognitoSuccess: function (payload) { return ({
        type: COGNITO_SUCCESS,
        payload: payload,
    }); },
    cognitoRefresh: function (payload) { return ({
        type: COGNITO_REFRESH,
        payload: payload,
    }); },
    cognitoRefreshSuccess: function (payload) {
        payload.history.push('/accounts/summary');
        return {
            type: COGNITO_REFRESH_SUCCESS,
            payload: payload,
        };
    },
};
var cognitoLogout = function (myloLogin, myloConfig) {
    if (myloLogin) {
        var mylo = new __WEBPACK_IMPORTED_MODULE_0_mylo_js___default.a(myloConfig);
        mylo.viewPopup('logout');
    }
    else {
        window.location.href = '/logout';
    }
};


/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_redux_root_reducer__ = __webpack_require__(660);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_redux_root_reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_redux_root_epic__ = __webpack_require__(977);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_app_redux_root_epic__["a"]; });




/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export appReducer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rootReducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_main_reducers__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_login_reducers__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_intellisel_reducer__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_redux_reducers__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_notification_system_redux__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_notification_system_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_notification_system_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_user_reducers__ = __webpack_require__(976);








var appReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    auth: __WEBPACK_IMPORTED_MODULE_3__src_app_login_reducers__["a" /* reducer */],
    clientConfig: __WEBPACK_IMPORTED_MODULE_1__src_app_main_reducers__["b" /* clientConfig */],
    adminConfig: __WEBPACK_IMPORTED_MODULE_1__src_app_main_reducers__["a" /* adminConfig */],
    form: __WEBPACK_IMPORTED_MODULE_2_redux_form__["e" /* reducer */],
    account: __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_redux_reducers__["a" /* reducer */],
    intellisel: __WEBPACK_IMPORTED_MODULE_4__src_app_intellisel_reducer__["a" /* reducer */],
    notifications: __WEBPACK_IMPORTED_MODULE_6_react_notification_system_redux__["reducer"],
    userState: __WEBPACK_IMPORTED_MODULE_7__src_app_user_reducers__["a" /* reducer */]
});
var rootReducer = function (state, action) {
    if (action.type === 'USER_LOGOUT') {
        state = {
            clientConfig: state.clientConfig,
            adminConfig: state.adminConfig,
        };
    }
    return appReducer(state, action);
};


/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* unused harmony export adminInitialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clientConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adminConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__ = __webpack_require__(192);


var initialState = {
    clientConfig: {},
};
var adminInitialState = {
    adminConfig: {},
};
var clientConfig = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    clientConfig: function (state, _a) {
        if (state === void 0) { state = initialState.clientConfig; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["c" /* CLIENT_CONFIG_SUCCESS */]:
                return payload.clientConfig;
            default:
                return state;
        }
    },
    configLoading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["b" /* CLIENT_CONFIG_LOADING */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["a" /* CLIENT_CONFIG_FAILURE */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["c" /* CLIENT_CONFIG_SUCCESS */]:
                return false;
            default:
                return state;
        }
    },
    configFailure: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["a" /* CLIENT_CONFIG_FAILURE */]:
                return true;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["c" /* CLIENT_CONFIG_SUCCESS */]:
                return false;
            default:
                return state;
        }
    },
    errorMessage: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["a" /* CLIENT_CONFIG_FAILURE */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["c" /* CLIENT_CONFIG_SUCCESS */]:
                return null;
            default:
                return state;
        }
    },
    configLoaded: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["b" /* CLIENT_CONFIG_LOADING */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["a" /* CLIENT_CONFIG_FAILURE */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["c" /* CLIENT_CONFIG_SUCCESS */]:
                return true;
            default:
                return state;
        }
    },
});
var adminConfig = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    adminConfig: function (state, _a) {
        if (state === void 0) { state = adminInitialState.adminConfig; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_main_actions__["c" /* CLIENT_CONFIG_SUCCESS */]:
                return payload.adminConfig;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_social_reducer__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_reducer__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_login_weak_accountpostalcode_reducer__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_emailpostalcode_reducer__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_login_weak_nameaddress_reducer__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_login_oms_reducers__ = __webpack_require__(839);







var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    socialLogin: __WEBPACK_IMPORTED_MODULE_1__src_app_login_social_reducer__["a" /* reducer */],
    weakLogin: __WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_reducer__["a" /* reducer */],
    accountPostalCode: __WEBPACK_IMPORTED_MODULE_3__src_app_login_weak_accountpostalcode_reducer__["a" /* reducer */],
    omsAuth: __WEBPACK_IMPORTED_MODULE_6__src_app_login_oms_reducers__["a" /* reducer */],
    emailPostalCode: __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_emailpostalcode_reducer__["a" /* reducer */],
    nameAddress: __WEBPACK_IMPORTED_MODULE_5__src_app_login_weak_nameaddress_reducer__["a" /* reducer */],
});


/***/ }),

/***/ 834:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_cognito_actions__ = __webpack_require__(62);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            default:
                return state;
        }
    },
    user: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_login_cognito_actions__["b" /* COGNITO_SUCCESS */]:
                return __assign({}, action.payload, { email: getEmailFromIdToken(action.payload.idToken), channel: 'cognito' });
            default:
                return state;
        }
    },
});
var getEmailFromIdToken = function (token) {
    var idToken = token.jwtToken;
    var tokenParts = idToken.split('.');
    var tokenPayload = tokenParts[1];
    var decodedIdToken = atob(tokenPayload);
    return JSON.parse(decodedIdToken).email;
};


/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(6);


var reducer = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({
    identityId: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_actions__["e" /* UNAUTH_IAM_KEYS_SUCCESS */]:
                return action.payload.identityId;
            default:
                return state;
        }
    },
    credentials: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_actions__["a" /* AUTH_IAM_KEYS_SUCCESS */]:
                return action.payload.credentials;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_accountpostalcode_actions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(6);


var reducer = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({
    accountNumber: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_accountpostalcode_actions__["a" /* ACCT_POSTAL_CODE_LOGIN_INITIATE */]:
                return action.payload.accountNumber;
            default:
                return state;
        }
    },
    postalCode: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_accountpostalcode_actions__["a" /* ACCT_POSTAL_CODE_LOGIN_INITIATE */]:
                return action.payload.postalCode;
            default:
                return state;
        }
    },
    captureEmail: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_accountpostalcode_actions__["a" /* ACCT_POSTAL_CODE_LOGIN_INITIATE */]:
                return action.payload.captureEmail;
            default:
                return state;
        }
    },
    emailOptIn: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_accountpostalcode_actions__["a" /* ACCT_POSTAL_CODE_LOGIN_INITIATE */]:
                return action.payload.emailOptIn;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_emailpostalcode_actions__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(6);


var reducer = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({
    email: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_emailpostalcode_actions__["a" /* EMAIL_POSTAL_CODE_LOGIN_INITIATE */]:
                return action.payload.email;
            default:
                return state;
        }
    },
    postalCode: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_emailpostalcode_actions__["a" /* EMAIL_POSTAL_CODE_LOGIN_INITIATE */]:
                return action.payload.postalCode;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(6);


var reducer = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({
    firstName: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                return action.payload.firstName;
            default:
                return state;
        }
    },
    lastName: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                return action.payload.lastName;
            default:
                return state;
        }
    },
    address1: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                return action.payload.address1;
            default:
                return state;
        }
    },
    address2: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                if (action.payload.address2) {
                    // address2 is optional
                    return action.payload.address2;
                }
                else {
                    return state;
                }
            default:
                return state;
        }
    },
    city: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                return action.payload.city;
            default:
                return state;
        }
    },
    state: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                return action.payload.state;
            default:
                return state;
        }
    },
    postalCode: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                return action.payload.postalCode;
            default:
                return state;
        }
    },
    country: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                return action.payload.country;
            default:
                return state;
        }
    },
    captureEmail: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                return action.payload.captureEmail;
            default:
                return state;
        }
    },
    emailOptIn: function (state, action) {
        if (state === void 0) { state = ''; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]:
                return action.payload.emailOptIn;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_oms_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_header_actions__ = __webpack_require__(50);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({
    isLoginSuccessful: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return true;
            case __WEBPACK_IMPORTED_MODULE_2__src_app_header_actions__["a" /* USER_LOGOUT */]:
                return false;
            default:
                return state;
        }
    },
    authenticating: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_oms_actions__["c" /* OMS_LOOKUP_FAILURE */]:
            case '@@INIT':
                return false;
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_oms_actions__["b" /* OMS_IS_AUTHENTICATING */]:
                return action.payload;
            default:
                return state;
        }
    },
    isFailure: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_2__src_app_header_actions__["a" /* USER_LOGOUT */]:
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_oms_actions__["a" /* INITIATE_OMS_LOOKUP */]:
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_oms_actions__["c" /* OMS_LOOKUP_FAILURE */]:
                return true;
            default:
                return state;
        }
    },
    credentials: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_0__src_app_login_oms_actions__["e" /* SET_CREDENTIALS */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_2__src_app_header_actions__["a" /* USER_LOGOUT */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 848:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(114);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* INTELLISEL_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* INTELLISEL_ERROR */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* INTELLISEL_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    intelliselOffers: function (state, action) {
        if (state === void 0) { state = {}; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* INTELLISEL_SUCCESS */]:
                var newpayload = __assign({}, state);
                newpayload[action.payload.transactionCode] = action.payload.response;
                return newpayload;
            default:
                return state;
        }
    }
});


/***/ }),

/***/ 849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary_reducer__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders_reducer__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_accounts_customers_reducer__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_accounts_gifts_reducer__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_payment_methods_reducer__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_reducer__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_accounts_suspend_reducer__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_accounts_resume_reducer__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_customer_service_reducer__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_accounts_series_update_reducer__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_accounts_stopcharge_reducer__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_accounts_stopautorenew_reducer__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_app_accounts_updatepayment_reducer__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_app_accounts_payments_reducer__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_app_accounts_startautorenew_reducer__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_app_accounts_refundstorecredit_reducer__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_app_accounts_resin_order_reducer__ = __webpack_require__(975);


















var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    summary: __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_summary_reducer__["a" /* reducer */],
    orderData: __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_orders_reducer__["a" /* reducer */],
    customerData: __WEBPACK_IMPORTED_MODULE_3__src_app_accounts_customers_reducer__["a" /* reducer */],
    associatedGiftAccountsMap: __WEBPACK_IMPORTED_MODULE_4__src_app_accounts_gifts_reducer__["a" /* reducer */],
    paymentMethodsData: __WEBPACK_IMPORTED_MODULE_5__src_app_accounts_payment_methods_reducer__["a" /* reducer */],
    issuesData: __WEBPACK_IMPORTED_MODULE_6__src_app_accounts_issues_reducer__["a" /* reducer */],
    suspendData: __WEBPACK_IMPORTED_MODULE_7__src_app_accounts_suspend_reducer__["a" /* reducer */],
    resumeData: __WEBPACK_IMPORTED_MODULE_8__src_app_accounts_resume_reducer__["a" /* reducer */],
    customerServiceEmailData: __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_customer_service_reducer__["a" /* reducer */],
    seriesUpdateData: __WEBPACK_IMPORTED_MODULE_10__src_app_accounts_series_update_reducer__["a" /* reducer */],
    stopChargeData: __WEBPACK_IMPORTED_MODULE_11__src_app_accounts_stopcharge_reducer__["a" /* reducer */],
    stopAutoRenewData: __WEBPACK_IMPORTED_MODULE_12__src_app_accounts_stopautorenew_reducer__["a" /* reducer */],
    updatePaymentData: __WEBPACK_IMPORTED_MODULE_13__src_app_accounts_updatepayment_reducer__["a" /* reducer */],
    paymentsData: __WEBPACK_IMPORTED_MODULE_14__src_app_accounts_payments_reducer__["a" /* reducer */],
    startAutoRenewData: __WEBPACK_IMPORTED_MODULE_15__src_app_accounts_startautorenew_reducer__["a" /* reducer */],
    refundStoreCreditData: __WEBPACK_IMPORTED_MODULE_16__src_app_accounts_refundstorecredit_reducer__["a" /* reducer */],
    resinOrderData: __WEBPACK_IMPORTED_MODULE_17__src_app_accounts_resin_order_reducer__["a" /* reducer */],
});


/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_elements_scss__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_elements_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__form_elements_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_components_form_elements_checkbox__ = __webpack_require__(1412);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_app_global_components_form_elements_checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_global_components_form_elements_radio_buttons__ = __webpack_require__(1413);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__src_app_global_components_form_elements_radio_buttons__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_global_components_form_elements_simple_select__ = __webpack_require__(1414);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__src_app_global_components_form_elements_simple_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_global_components_form_elements_simpler_select__ = __webpack_require__(1416);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__src_app_global_components_form_elements_simpler_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements_text_input__ = __webpack_require__(1417);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__src_app_global_components_form_elements_text_input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_global_components_form_elements_checkbox_group__ = __webpack_require__(1418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_global_components_form_elements_read_only__ = __webpack_require__(1419);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_global_components_form_elements_text_area__ = __webpack_require__(1420);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__src_app_global_components_form_elements_text_area__["a"]; });











/***/ }),

/***/ 960:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__ = __webpack_require__(251);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__src_app_accounts_orders_actions__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_orders_reducer__ = __webpack_require__(393);
/* unused harmony namespace reexport */
// public API




/***/ }),

/***/ 961:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_summary__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_accounts_preferences_actions__ = __webpack_require__(261);




var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    customers: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return action.payload.customers;
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_summary__["k" /* EMAIL_SAVE_SUCCESS */]:
                var customers = void 0;
                var response = action.payload;
                var newEmail_1 = response.email;
                if (state) {
                    customers = state.map(function (cust) {
                        cust.email = newEmail_1;
                        return cust;
                    });
                }
                return customers;
            case __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_summary__["d" /* ACCOUNT_SAVE_SUCCESS */]:
                return state;
            case __WEBPACK_IMPORTED_MODULE_3__src_app_accounts_preferences_actions__["b" /* SAVE_PREFERENCES_SUCCESS */]:
                var permissionSaveCustomer = void 0;
                var permissionSaveCustomers = void 0;
                var permissionUpdateResponse_1 = action.payload.response;
                if (state) {
                    permissionSaveCustomers = state;
                    permissionSaveCustomer = permissionSaveCustomers.find(function (cust) {
                        return (permissionUpdateResponse_1.accountNumber === cust.accountNumber &&
                            permissionUpdateResponse_1.prodIdAlias === cust.prodIdAlias);
                    });
                    for (var key in permissionUpdateResponse_1) {
                        if (key) {
                            var value = permissionUpdateResponse_1[key];
                            if (key !== 'accountNumber' &&
                                key !== 'prodIdAlias' &&
                                key !== 'email') {
                                permissionSaveCustomer.permissions[key] = value ? 'Y' : 'N'; // map back to boolean for state
                            }
                        }
                    }
                }
                return permissionSaveCustomers;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 962:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__ = __webpack_require__(14);


var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    associatedGiftAccounts: function (state, action) {
        if (state === void 0) { state = {}; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return action.payload.associatedGiftAccounts;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__ = __webpack_require__(14);


var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    paymentMethods: function (state, action) {
        if (state === void 0) { state = []; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return action.payload.paymentMethods;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 964:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__ = __webpack_require__(254);


var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    entitledIssuesLoading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["d" /* GET_ENTITLED_ISSUES_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["a" /* GET_ENTITLED_ISSUES_ERROR */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["b" /* GET_ENTITLED_ISSUES_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    entitledIssues: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["d" /* GET_ENTITLED_ISSUES_SUCCESS */]:
                return action.payload.entitledIssues;
            default:
                return state;
        }
    },
    missedDamagedLoading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["n" /* SUBSCRIPTION_EXTENSION_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["k" /* SUBSCRIPTION_EXTENSION_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["i" /* REPLACEMENT_ISSUE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["f" /* REPLACEMENT_ISSUE_ERROR */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["l" /* SUBSCRIPTION_EXTENSION_LOADING */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["g" /* REPLACEMENT_ISSUE_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    missedDamagedResult: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["k" /* SUBSCRIPTION_EXTENSION_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["n" /* SUBSCRIPTION_EXTENSION_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["i" /* REPLACEMENT_ISSUE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["f" /* REPLACEMENT_ISSUE_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["j" /* SUBSCRIPTION_EXTENSION_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_issues_actions__["e" /* MISSED_DAMAGED_CANCEL */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["d" /* GET_ISSUES_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["a" /* GET_ISSUES_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["f" /* SUSPEND_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["i" /* SUSPEND_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["b" /* GET_ISSUES_LOADING */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["g" /* SUSPEND_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    issues: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["d" /* GET_ISSUES_SUCCESS */]:
                return action.payload;
            default:
                return state;
        }
    },
    suspendSavedResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["i" /* SUSPEND_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["f" /* SUSPEND_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["e" /* SUSPEND_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_suspend_actions__["h" /* SUSPEND_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resume_actions__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resume_actions__["b" /* RESUME_ERROR */]:
            // case RESUME_SUCCESS:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resume_actions__["a" /* RESUME_CANCEL */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resume_actions__["d" /* RESUME_START */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resume_actions__["c" /* RESUME_LOADING */]:
                return true;
            default:
                return state;
        }
    },
    resumeSavedResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resume_actions__["e" /* RESUME_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resume_actions__["b" /* RESUME_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resume_actions__["a" /* RESUME_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resume_actions__["d" /* RESUME_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__ = __webpack_require__(115);


var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["b" /* SEND_CUSTSERV_EMAIL_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["e" /* SEND_CUSTSERV_EMAIL_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["a" /* SEND_CUSTSERV_EMAIL_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["g" /* SEND_EXCEPTION_EMAIL_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["j" /* SEND_EXCEPTION_EMAIL_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["f" /* SEND_EXCEPTION_EMAIL_CANCEL */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["d" /* SEND_CUSTSERV_EMAIL_START */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["c" /* SEND_CUSTSERV_EMAIL_LOADING */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["i" /* SEND_EXCEPTION_EMAIL_START */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["h" /* SEND_EXCEPTION_EMAIL_LOADING */]:
                return true;
            default:
                return state;
        }
    },
    sendEmailResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["e" /* SEND_CUSTSERV_EMAIL_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["b" /* SEND_CUSTSERV_EMAIL_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["j" /* SEND_EXCEPTION_EMAIL_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["g" /* SEND_EXCEPTION_EMAIL_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["a" /* SEND_CUSTSERV_EMAIL_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["d" /* SEND_CUSTSERV_EMAIL_START */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["f" /* SEND_EXCEPTION_EMAIL_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_customer_service_actions__["i" /* SEND_EXCEPTION_EMAIL_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_series_update_actions__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_series_update_actions__["b" /* SERIES_UPDATE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_series_update_actions__["d" /* SERIES_UPDATE_START */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_series_update_actions__["c" /* SERIES_UPDATE_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    seriesUpdateSavedResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_series_update_actions__["e" /* SERIES_UPDATE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_series_update_actions__["b" /* SERIES_UPDATE_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_series_update_actions__["a" /* SERIES_UPDATE_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_series_update_actions__["d" /* SERIES_UPDATE_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopcharge_actions__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopcharge_actions__["b" /* STOPCHARGE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopcharge_actions__["d" /* STOPCHARGE_START */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopcharge_actions__["c" /* STOPCHARGE_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    stopChargeResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopcharge_actions__["e" /* STOPCHARGE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopcharge_actions__["b" /* STOPCHARGE_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopcharge_actions__["a" /* STOPCHARGE_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopcharge_actions__["d" /* STOPCHARGE_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 970:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopautorenew_actions__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopautorenew_actions__["b" /* STOP_AUTO_RENEW_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopautorenew_actions__["d" /* STOP_AUTO_RENEW_START */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopautorenew_actions__["c" /* STOP_AUTO_RENEW_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    stopAutoRenewSavedResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopautorenew_actions__["e" /* STOP_AUTO_RENEW_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopautorenew_actions__["b" /* STOP_AUTO_RENEW_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopautorenew_actions__["a" /* STOP_AUTO_RENEW_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_stopautorenew_actions__["d" /* STOP_AUTO_RENEW_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__["b" /* UPDATE_PAYMENT_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__["d" /* UPDATE_PAYMENT_START */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__["c" /* UPDATE_PAYMENT_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    updatePaymentResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__["e" /* UPDATE_PAYMENT_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__["b" /* UPDATE_PAYMENT_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__["a" /* UPDATE_PAYMENT_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_updatepayment_actions__["d" /* UPDATE_PAYMENT_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_payments_actions__ = __webpack_require__(258);


var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_payments_actions__["e" /* PAYMENTS_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_payments_actions__["b" /* PAYMENTS_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_payments_actions__["a" /* PAYMENTS_CANCEL */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_payments_actions__["c" /* PAYMENTS_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    paymentsResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_payments_actions__["e" /* PAYMENTS_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_payments_actions__["b" /* PAYMENTS_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_payments_actions__["a" /* PAYMENTS_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_payments_actions__["d" /* PAYMENTS_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_startautorenew_actions__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_startautorenew_actions__["b" /* START_AUTO_RENEW_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_startautorenew_actions__["d" /* START_AUTO_RENEW_START */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_startautorenew_actions__["c" /* START_AUTO_RENEW_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    startAutoRenewSavedResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_startautorenew_actions__["e" /* START_AUTO_RENEW_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_startautorenew_actions__["b" /* START_AUTO_RENEW_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_startautorenew_actions__["a" /* START_AUTO_RENEW_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_startautorenew_actions__["d" /* START_AUTO_RENEW_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_refundstorecredit_actions__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    loading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_refundstorecredit_actions__["b" /* REFUND_STORE_CREDIT_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_refundstorecredit_actions__["d" /* REFUND_STORE_CREDIT_START */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_refundstorecredit_actions__["c" /* REFUND_STORE_CREDIT_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    refundStoreCreditSavedResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_refundstorecredit_actions__["e" /* REFUND_STORE_CREDIT_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_refundstorecredit_actions__["b" /* REFUND_STORE_CREDIT_ERROR */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_refundstorecredit_actions__["a" /* REFUND_STORE_CREDIT_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_refundstorecredit_actions__["d" /* REFUND_STORE_CREDIT_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__ = __webpack_require__(14);



var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    resinOrderLoading: function (state, action) {
        if (state === void 0) { state = false; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["b" /* RESIN_ORDER_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["i" /* RESIN_SPECULATIVE_SUCCESS */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["g" /* RESIN_SPECULATIVE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_2__src_app_login_oms_actions__["d" /* OMS_LOOKUP_SUCCESS */]:
                return false;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["c" /* RESIN_ORDER_LOADING */]:
                return action.payload;
            default:
                return state;
        }
    },
    resinOrderResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["b" /* RESIN_ORDER_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["e" /* RESIN_ORDER_SUCCESS */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["a" /* RESIN_ORDER_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["d" /* RESIN_ORDER_START */]:
                return null;
            default:
                return state;
        }
    },
    resinSpeculativeResult: function (state, action) {
        if (state === void 0) { state = null; }
        switch (action.type) {
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["g" /* RESIN_SPECULATIVE_ERROR */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["i" /* RESIN_SPECULATIVE_SUCCESS */]:
                return action.payload;
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["f" /* RESIN_SPECULATIVE_CANCEL */]:
            case __WEBPACK_IMPORTED_MODULE_1__src_app_accounts_resin_order_actions__["h" /* RESIN_SPECULATIVE_START */]:
                return null;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_oms_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header_actions__ = __webpack_require__(50);




var initialState = {
    viewAllOrders: false,
    viewAllGifts: false,
    viewAllUnredeemedGifts: false,
    viewAllSubs: false,
    signinAttempts: 0,
    leftNavOpen: false,
    ageCheckPassed: false,
    loginAccountNumber: '',
    loginPostalCode: '',
    idpAccountInfo: {
        sub: '',
        email: '',
        username: '',
    },
};
var reducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    viewAllOrders: function (state, _a) {
        if (state === void 0) { state = initialState.viewAllOrders; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["g" /* VIEW_ALL_ORDERS */]:
                return payload.payload;
            default:
                return state;
        }
    },
    viewAllGifts: function (state, _a) {
        if (state === void 0) { state = initialState.viewAllGifts; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["f" /* VIEW_ALL_GIFTS */]:
                return payload.payload;
            default:
                return state;
        }
    },
    viewAllUnredeemedGifts: function (state, _a) {
        if (state === void 0) { state = initialState.viewAllUnredeemedGifts; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* VIEW_ALL_UNREDEEMED_GIFTS */]:
                return payload.payload;
            default:
                return state;
        }
    },
    viewAllSubs: function (state, _a) {
        if (state === void 0) { state = initialState.viewAllSubs; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["h" /* VIEW_ALL_SUBS */]:
                return payload.payload;
            default:
                return state;
        }
    },
    signinAttempts: function (state, _a) {
        if (state === void 0) { state = initialState.signinAttempts; }
        var type = _a.type;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_2__login_oms_actions__["c" /* OMS_LOOKUP_FAILURE */]:
                return state + 1;
            case __WEBPACK_IMPORTED_MODULE_3__header_actions__["a" /* USER_LOGOUT */]:
                return 0;
            default:
                return state;
        }
    },
    leftNavOpen: function (state, _a) {
        if (state === void 0) { state = initialState.leftNavOpen; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* LEFT_NAV_OPEN */]:
                return payload.payload;
            default:
                return state;
        }
    },
    ageCheckPassed: function (state, _a) {
        if (state === void 0) { state = initialState.ageCheckPassed; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* AGE_CHECK_PASSED */]:
                return payload.payload;
            default:
                return state;
        }
    },
    loginAccountNumber: function (state, _a) {
        if (state === void 0) { state = initialState.loginAccountNumber; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* LOGIN_ACCOUNT_NUMBER */]:
                return payload.payload;
            default:
                return state;
        }
    },
    loginPostalCode: function (state, _a) {
        if (state === void 0) { state = initialState.loginPostalCode; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["e" /* LOGIN_POSTAL_CODE */]:
                return payload.payload;
            default:
                return state;
        }
    },
    idpAccountInfo: function (state, _a) {
        if (state === void 0) { state = initialState.idpAccountInfo; }
        var type = _a.type, payload = _a.payload;
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* IDP_ACCOUNT_INFO */]:
                return payload.payload;
            default:
                return state;
        }
    },
});


/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rootEpic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_epics__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_redux_epics__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_notifications_epics__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_intellisel_epics__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_login_cognito_epics__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_eventLogging_epics__ = __webpack_require__(1373);







var rootEpic = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_2__src_app_accounts_redux_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_3__src_app_notifications_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_5__src_app_login_cognito_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_4__src_app_intellisel_epics__["a" /* epics */], __WEBPACK_IMPORTED_MODULE_6__src_app_eventLogging_epics__["a" /* epics */]);


/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_epics__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_accountpostalcode_epics__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_login_weak_emailpostalcode_epics__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_nameaddress_epics__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_login_weak_epics__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_app_main_epics__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_app_header_epics__ = __webpack_require__(1352);








var epics = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["a" /* combineEpics */])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_oms_epics__["a" /* omsAuthentication */], __WEBPACK_IMPORTED_MODULE_6__src_app_main_epics__["a" /* configEpic */], __WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_accountpostalcode_epics__["a" /* acctPostalCodeLoginInitiate */], __WEBPACK_IMPORTED_MODULE_5__src_app_login_weak_epics__["e" /* getUnauthIdentityId */], __WEBPACK_IMPORTED_MODULE_5__src_app_login_weak_epics__["b" /* doUnauthLookup */], __WEBPACK_IMPORTED_MODULE_5__src_app_login_weak_epics__["a" /* doAuthLookup */], __WEBPACK_IMPORTED_MODULE_5__src_app_login_weak_epics__["c" /* fetchCustomer */], __WEBPACK_IMPORTED_MODULE_7__src_app_header_epics__["a" /* clearAWSCreds */], __WEBPACK_IMPORTED_MODULE_3__src_app_login_weak_emailpostalcode_epics__["a" /* emailPostalCodeLoginInitiate */], __WEBPACK_IMPORTED_MODULE_4__src_app_login_weak_nameaddress_epics__["a" /* nameAddressLoginInitiate */], __WEBPACK_IMPORTED_MODULE_5__src_app_login_weak_epics__["d" /* findSecuredUserEpic */]);


/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return omsAuthentication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_app_header_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_login_oms_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_observable_concat__);










var omsAuthentication = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_4__src_app_login_oms_actions__["a" /* INITIATE_OMS_LOOKUP */]), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var _b;
        var payload = _a.payload;
        var accountNumber = payload.accountNumber;
        var postalCode = payload.postalCode;
        var token = payload.token;
        var provider = payload.provider;
        var clientConfig = state$.value.clientConfig.clientConfig;
        var productExcludes = payload.productExcludes;
        var resinAccounts = payload.resinAccounts;
        var idpAccountInfo = payload.idpAccountInfo;
        var credentialsObject = {
            IdentityPoolId: clientConfig.identityPoolId,
            Logins: (_b = {},
                _b[provider] = token,
                _b),
        };
        __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global__["CognitoIdentityCredentials"](credentialsObject);
        __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global__["config"].region = clientConfig.Region; // Find ONE place to do this
        var reqPayload = {};
        var postBody = {};
        reqPayload = {
            acctNbr: accountNumber,
            postalCode: postalCode,
            productExcludes: productExcludes.toString(),
        };
        postBody = {
            filterType: "AccountCodeAndPostalCode" /* accountNumberPostalCode */,
            magCode: clientConfig.magCode,
            globalCode: clientConfig.globalCode,
            payload: reqPayload,
            resinAccountNumbers: resinAccounts,
            idpAccountInfo: idpAccountInfo,
        };
        var client = new __WEBPACK_IMPORTED_MODULE_1__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_5_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: '/GC-call-globalcustomer',
            requestmethod: 'POST',
            region: clientConfig.Region,
            requestbody: postBody,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        sessionStorage.setItem('loginData', JSON.stringify(postBody));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_8_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.isSuccess) === 'true';
            if (isSuccess) {
                __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: 'Login by Registered Mylo User',
                    action: 'Successful',
                    label: answer.customers[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_4__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupSuccess(answer);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: 'Login by Registered Mylo User',
                    action: 'Unsuccessful',
                    label: clientConfig.magCode
                });
                return __WEBPACK_IMPORTED_MODULE_4__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(answer);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_2__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: 'Login by Registered Mylo User',
                action: 'Unknown error',
                label: clientConfig.magCode
            });
            /// if msg contains Invalid login token" then fire logout action with different notifcation.
            if (err && err.message.includes('Invalid login token')) {
                __WEBPACK_IMPORTED_MODULE_4__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Session Timeout');
                return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_3__src_app_header_actions__["b" /* actionCreators */].userLogout());
            }
            else {
                __WEBPACK_IMPORTED_MODULE_4__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Unknown error');
                return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_4__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(err));
            }
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_9_rxjs_observable_concat__["concat"])(source$, Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_4__src_app_login_oms_actions__["f" /* actionCreators */].omsSetCredentials(credentialsObject)));
    }));
};


/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acctPostalCodeLoginInitiate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_accountpostalcode_actions__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__);





var acctPostalCodeLoginInitiate = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_accountpostalcode_actions__["a" /* ACCT_POSTAL_CODE_LOGIN_INITIATE */]), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var _b = _a.payload, accountNumber = _b.accountNumber, postalCode = _b.postalCode, captureEmail = _b.captureEmail, emailOptIn = _b.emailOptIn, productExcludes = _b.productExcludes;
        var payload = {
            acctNbr: accountNumber,
            postalCode: postalCode,
            emailOptIn: emailOptIn,
            email: captureEmail,
            productExcludes: productExcludes.toString(),
        };
        var clientConfig = state$.value.clientConfig.clientConfig;
        var wsgPayload = {
            magCode: clientConfig.magCode,
            globalCode: clientConfig.globalCode,
            filterType: "AccountCodeAndPostalCode" /* accountNumberPostalCode */,
            payload: payload,
        };
        var credentials = state$.value.auth.omsAuth.credentials;
        var observable;
        if (credentials && credentials.Logins) {
            wsgPayload.idpAccountInfo = state$.value.userState.idpAccountInfo;
            observable = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__["f" /* actionCreators */].authIamKeysSuccess(credentials, wsgPayload));
        }
        else {
            observable = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__["f" /* actionCreators */].unauthGetIamKeys(wsgPayload));
        }
        return observable;
    }));
};


/***/ }),

/***/ 981:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailPostalCodeLoginInitiate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_emailpostalcode_actions__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__);





var emailPostalCodeLoginInitiate = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_emailpostalcode_actions__["a" /* EMAIL_POSTAL_CODE_LOGIN_INITIATE */]), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var _b = _a.payload, email = _b.email, postalCode = _b.postalCode, productExcludes = _b.productExcludes;
        var clientConfig = state$.value.clientConfig.clientConfig;
        var wsgPayload = {
            magCode: clientConfig.magCode,
            globalCode: clientConfig.globalCode,
            filterType: "EmailAndPostalCode" /* emailPostalCode */,
            payload: {
                email: email,
                postalCode: postalCode,
                productExcludes: productExcludes.toString(),
            },
        };
        var credentials = state$.value.auth.omsAuth.credentials;
        var observable;
        if (credentials && credentials.Logins) {
            wsgPayload.idpAccountInfo = state$.value.userState.idpAccountInfo;
            observable = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__["f" /* actionCreators */].authIamKeysSuccess(credentials, wsgPayload));
        }
        else {
            observable = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__["f" /* actionCreators */].unauthGetIamKeys(wsgPayload));
        }
        return observable;
    }));
};


/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nameAddressLoginInitiate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_global_constants__ = __webpack_require__(158);






var nameAddressLoginInitiate = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_0__src_app_login_weak_nameaddress_actions__["a" /* NAME_ADDRESS_LOGIN_INITIATE */]), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        // find default postal code value for countries that don't have any.
        var country = __WEBPACK_IMPORTED_MODULE_5__src_app_global_constants__["c" /* countriesWithNoPostalCodes */].find(function (item) { return item.value === payload.country; });
        var postalCode = payload.postalCode || (country ? country.postalCode : '');
        var wsgPayload = {
            magCode: clientConfig.magCode,
            globalCode: clientConfig.globalCode,
            filterType: "NameAndAddress" /* nameAddress */,
            payload: {
                name: (payload.firstName + ' ' + payload.lastName),
                firstName: payload.firstName,
                lastName: payload.lastName,
                address1: payload.address1,
                address2: payload.address2,
                city: payload.city,
                state: payload.state,
                postalCode: postalCode,
                country: payload.country,
                email: payload.captureEmail,
                emailOptIn: payload.emailOptIn,
                productExcludes: payload.productExcludes.toString(),
            },
        };
        var credentials = state$.value.auth.omsAuth.credentials;
        var observable;
        if (credentials && credentials.Logins) {
            wsgPayload.idpAccountInfo = state$.value.userState.idpAccountInfo;
            observable = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__["f" /* actionCreators */].authIamKeysSuccess(credentials, wsgPayload));
        }
        else {
            observable = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_2__src_app_login_weak_actions__["f" /* actionCreators */].unauthGetIamKeys(wsgPayload));
        }
        return observable;
    }));
};


/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUnauthIdentityId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return doUnauthLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return doAuthLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return findSecuredUserEpic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_concat__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_aws_sdk_clients_cognitoidentity__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_aws_sdk_clients_cognitoidentity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_aws_sdk_clients_cognitoidentity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_app_accounts_summary_actions__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_apiUtils__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_app_login_errors__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_analytics_googleAnalytics_actions__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_internal_observable_from__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_internal_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_rxjs_internal_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_app_header_actions__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_app_accounts_selectors__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_app_global_utility_adminConfigUtils__ = __webpack_require__(42);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;



















var AWS = __webpack_require__(27);
var GC_CUSTOMER_PATH = '/GC-call-globalcustomer';
var getUnauthIdentityId = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["d" /* UNAUTH_GET_IAM_KEYS */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        return __awaiter(_this, void 0, void 0, function () {
            var clientConfig, cognitoidentity, params, theId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        clientConfig = state$.value.clientConfig.clientConfig;
                        __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].region = clientConfig.Region;
                        cognitoidentity = new __WEBPACK_IMPORTED_MODULE_6_aws_sdk_clients_cognitoidentity___default.a();
                        params = {
                            IdentityPoolId: clientConfig.identityPoolId,
                        };
                        theId = 'initialid';
                        return [4 /*yield*/, cognitoidentity.getId(params, function (err, data) {
                                if (err) {
                                    __WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["f" /* actionCreators */].unauthIamKeysSuccess('', {
                                        filterType: payload.filterType,
                                        globalCode: clientConfig.globalCode,
                                        magCode: payload.magCode,
                                    });
                                    return theId;
                                }
                                else {
                                    // console.log(data); // successful response
                                    theId = data.IdentityId;
                                    return theId;
                                }
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["f" /* actionCreators */].unauthIamKeysSuccess(theId, payload)];
                }
            });
        });
    }));
};
var doUnauthLookup = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["e" /* UNAUTH_IAM_KEYS_SUCCESS */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].setAuthenticating(true));
        var credentialsObject = {
            IdentityPoolId: clientConfig.identityPoolId,
            IdentityId: payload.IdentityId,
        };
        var lookupType;
        if (payload.wsgPayload.payload.acctNbr) {
            lookupType = 'Login by Account Number and Postal Code';
        }
        else if (payload.wsgPayload.payload.name) {
            lookupType = 'Login by Name and Address';
        }
        else {
            lookupType = 'Login by Email and Postal Code';
        }
        __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["CognitoIdentityCredentials"](credentialsObject);
        if (__WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials) {
            var creds = __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials;
            creds.clearCachedId();
        }
        if (clientConfig.resinEnabled === 'true') {
            payload.wsgPayload.payload.resinClientIds = Object(__WEBPACK_IMPORTED_MODULE_15__src_app_accounts_selectors__["o" /* getResinClientIdsForGlobalCodeFromAdminConfig */])(state$.value) || [];
        }
        var client = new __WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: GC_CUSTOMER_PATH,
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: payload.wsgPayload,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        sessionStorage.setItem('loginData', JSON.stringify(payload.wsgPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_13_rxjs_internal_observable_from__["from"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.isSuccess) === 'true';
            if (isSuccess) {
                var signInData = Object(__WEBPACK_IMPORTED_MODULE_16__src_app_global_utility_adminConfigUtils__["b" /* getAdminConfigTableItem */])(state$.value.adminConfig, state$.value.clientConfig, 'SignIn');
                if (signInData.RequireSecureSignin && answer.customers[0].recRegId) {
                    return __WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["f" /* actionCreators */].findMyloUser(answer);
                }
                else {
                    __WEBPACK_IMPORTED_MODULE_12__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                        category: lookupType,
                        action: 'Successful',
                        label: answer.customers[0].prodIdAlias
                    });
                    return __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupSuccess(answer);
                }
            }
            else {
                __WEBPACK_IMPORTED_MODULE_12__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: lookupType,
                    action: 'Unsuccessful',
                    label: clientConfig.magCode,
                });
                var msg;
                try {
                    msg = __WEBPACK_IMPORTED_MODULE_11__src_app_login_errors__["a" /* errorMessageMap */].get(answer.globalcustomer['0'].recReg.errors['0'].code);
                }
                catch (error) {
                    msg = 'Account lookup failure: Please retry.';
                }
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(msg);
                return __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(['Lookup Failure']);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_12__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: lookupType,
                action: 'Unknown Error',
                label: clientConfig.magCode,
            });
            /// if error msg contains "Invalid login token" then fire logout action with different notifcation.
            if (err && err.message.includes('Invalid login token')) {
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Session Timeout');
                return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_14__src_app_header_actions__["b" /* actionCreators */].userLogout());
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Unknown error');
                return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(err));
            }
        }));
        if (payload.wsgPayload.payload.email.length > 0 && payload.wsgPayload.payload.emailOptIn) {
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_concat__["concat"])(loading, source$, Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsSetCredentials(credentialsObject)), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_summary_actions__["r" /* actionCreators */].autoCofeSaveStart({ email: payload.wsgPayload.payload.email,
                emailOptIn: payload.wsgPayload.payload.emailOptIn ? 'Y' : ' ',
                prodIdAlias: payload.wsgPayload.magCode,
                googleAnalyticsCategory: 'Add Email From Sign In',
            })));
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_concat__["concat"])(loading, source$, Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsSetCredentials(credentialsObject)));
        }
    }));
};
var doAuthLookup = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["a" /* AUTH_IAM_KEYS_SUCCESS */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["c" /* filter */])(function (action) { return action.payload !== ''; }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].setAuthenticating(true));
        var credentialsObject = payload.credentials;
        var lookupType;
        if (payload.wsgPayload.payload.acctNbr) {
            lookupType = 'Login by Account Number and Postal Code';
        }
        else if (payload.wsgPayload.payload.name) {
            lookupType = 'Login by Name and Address';
        }
        else {
            lookupType = 'Login by Email and Postal Code';
        }
        __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["CognitoIdentityCredentials"](credentialsObject);
        if (clientConfig.resinEnabled === 'true') {
            payload.wsgPayload.payload.resinClientIds = Object(__WEBPACK_IMPORTED_MODULE_15__src_app_accounts_selectors__["o" /* getResinClientIdsForGlobalCodeFromAdminConfig */])(state$.value) || [];
        }
        var client = new __WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: GC_CUSTOMER_PATH,
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: payload.wsgPayload,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        sessionStorage.setItem('loginData', JSON.stringify(payload.wsgPayload));
        var source$ = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.isSuccess) === 'true';
            if (isSuccess) {
                __WEBPACK_IMPORTED_MODULE_12__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: lookupType,
                    action: 'Successful',
                    label: answer.customers[0].prodIdAlias
                });
                return __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupSuccess(answer);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_12__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: lookupType,
                    action: 'Unsuccessful',
                    label: clientConfig.magCode,
                });
                var msg;
                try {
                    msg = __WEBPACK_IMPORTED_MODULE_11__src_app_login_errors__["a" /* errorMessageMap */].get(answer.globalcustomer['0'].recReg.errors['0'].code);
                }
                catch (error) {
                    msg = 'Account lookup failure: Please retry.';
                }
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(msg);
                return __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(['Lookup Failure']);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            __WEBPACK_IMPORTED_MODULE_12__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                category: lookupType,
                action: 'Unknown Error',
                label: clientConfig.magCode,
            });
            /// if error msg contains "Invalid login token" then fire logout action with different notifcation.
            if (err && err.message.includes('Invalid login token')) {
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Session Timeout');
                return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_14__src_app_header_actions__["b" /* actionCreators */].userLogout());
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Unknown error');
                return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(err));
            }
        }));
        if (payload.wsgPayload.payload.email.length > 0 && payload.wsgPayload.payload.emailOptIn) {
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_concat__["concat"])(loading, source$, Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsSetCredentials(credentialsObject)), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_summary_actions__["r" /* actionCreators */].autoCofeSaveStart({
                email: payload.wsgPayload.payload.email,
                emailOptIn: payload.wsgPayload.payload.emailOptIn ? 'Y' : ' ',
                prodIdAlias: payload.wsgPayload.magCode,
                googleAnalyticsCategory: 'Add Email From Sign In',
            })));
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_concat__["concat"])(loading, source$, Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsSetCredentials(credentialsObject)));
        }
    }));
};
var fetchCustomer = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["c" /* REFETCH_CUSTOMER_DATA */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["f" /* mergeMap */])(function () {
        var clientConfig = state$.value.clientConfig.clientConfig;
        __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].region = clientConfig.Region;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_9__src_app_accounts_summary_actions__["r" /* actionCreators */].accountSaveLoading(true));
        var payload = JSON.parse(sessionStorage.getItem('loginData'));
        if (!__WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials) {
            var creds = state$.value.auth.omsAuth.credentials;
            __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["CognitoIdentityCredentials"](creds);
        }
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: GC_CUSTOMER_PATH,
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: payload,
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var client = new __WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var $source = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            var isSuccess = String(answer.isSuccess) === 'true';
            if (isSuccess) {
                return __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupSuccess(answer);
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure([answer]);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            /// if error msg contains "Invalid login token" then fire logout action with different notifcation.
            if (err && err.message.includes('Invalid login token')) {
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Session Timeout');
                return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_14__src_app_header_actions__["b" /* actionCreators */].userLogout());
            }
            else {
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification(err ? err.message : 'Unknown error');
                return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(err));
            }
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_concat__["concat"])(loading, $source);
    }));
};
var findSecuredUserEpic = function (action$, state$) {
    return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["c" /* ofType */])(__WEBPACK_IMPORTED_MODULE_1__src_app_login_weak_actions__["b" /* FIND_SECURED_USER */]), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["i" /* switchMap */])(function (_a) {
        var payload = _a.payload;
        var clientConfig = state$.value.clientConfig.clientConfig;
        var loading = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].setAuthenticating(true));
        var regRegId = payload.customers[0].recRegId;
        var credentialsObject = {
            IdentityPoolId: clientConfig.identityPoolId,
            IdentityId: payload.IdentityId,
        };
        var setCreds = Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsSetCredentials(credentialsObject));
        AWS.config.region = clientConfig.Region;
        __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials = new __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["CognitoIdentityCredentials"](credentialsObject);
        var apiConfig = {
            creds: __WEBPACK_IMPORTED_MODULE_7_aws_sdk_global__["config"].credentials,
            url: clientConfig.url,
            path: '/mylo',
            region: clientConfig.Region,
            requestmethod: 'POST',
            requestbody: {
                globalCode: clientConfig.globalCode,
                recRegId: regRegId
            },
            parms: {},
            additionalParms: {
                headers: {
                    'x-session-id': clientConfig.uuid
                },
            },
        };
        var client = new __WEBPACK_IMPORTED_MODULE_10__src_app_global_utility_apiUtils__["a" /* ApiClient */]();
        var observableStream = Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_fromPromise__["fromPromise"])(client.callApiGateway(apiConfig)).pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["e" /* map */])(function (answer) {
            // in new epic if recregid lookup succeeds, redirect to login w/msg and disable soft login (change userstate)
            // in new epic if recregid lookup fails then call omsLookupSuccess
            if (answer[0] && answer[0].RecRegId) {
                __WEBPACK_IMPORTED_MODULE_12__src_app_analytics_googleAnalytics_actions__["a" /* actionCreators */].createGAEvent({
                    category: 'Guest User - Requires Secure Sign In',
                    action: 'Unsuccessful',
                    label: clientConfig.magCode,
                });
                __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailureNotification('Guest sign in is unavailable because you previously secured your account. Use the “Sign In” option to access your account.');
                var response = { isSuccess: false, prodId: '', accountsMap: {}, customers: [], orders: [], associatedGiftAccounts: {} };
                return __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(response);
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupSuccess(payload);
            }
        }), Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["a" /* catchError */])(function (err) {
            var response = { isSuccess: false, prodId: '', accountsMap: {}, customers: [], orders: [], associatedGiftAccounts: {} };
            return Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_8__src_app_login_oms_actions__["f" /* actionCreators */].omsLookupFailure(response));
        }));
        return Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_concat__["concat"])(loading, setCreds, observableStream);
    }));
};


/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export USER_NOT_FOUND */
/* unused harmony export USER_NOT_FOUND_DUPLICATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorMessageMap; });
var USER_NOT_FOUND = 'USER_NOT_FOUND';
var USER_NOT_FOUND_DUPLICATE = 'USER_NOT_FOUND_DUPLICATE';
var locale = (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    // tslint:disable-next-line:no-string-literal
    window.navigator['userLanguage'] ||
    'en-US';
var loc = locale.substring(0, locale.indexOf('-'));
var notfound = loc !== 'fr'
    ? 'We could not find your account. Please try another sign in method'
    : 'Nous n`avons pas pu trouver votre compte. Veuillez essayer une autre méthode de connexion';
var multipleaccounts = loc !== 'fr'
    ? 'More than one account matched this email. Please try another sign in method'
    : 'Plus d`un compte correspond à ce courriel. Veuillez essayer une autre méthode de connexion';
var errorMessageMap = new Map();
errorMessageMap.set(USER_NOT_FOUND, notfound);
errorMessageMap.set(USER_NOT_FOUND_DUPLICATE, multipleaccounts);


/***/ })

},[470]);


// WEBPACK FOOTER //
// static/js/main.6cb8fc11.js